
//generated by "http://ourserver/htmlform.js"

type singleDecoder<A> = (prop:string)=>A
type objectDecoder<A,B> = (prop:A)=>B

type singleEncoder<A> = (prop:A)=>string
type objectEncoder<A> = (prop:A)=>JsonFw

export type JsonFw = {[x: string]: string | string[] | JsonFw | JsonFw[]}
type FizJSONObject = JsonFw

type FizFile = File|Blob|string

const 
  methods = {},

  inline = function<A>(target :A , ... from :JsonFw[] ):A{
    from.forEach(oneFrom=>{
      Object.assign(target,oneFrom)
    })
    return target;
  },
  nothingtodo = function<A>(val :A) : A{
    return val;
  },
  notimplementedyet = function(){
    throw new Error("Not implemented yet");
  },
  nullableDecoder = function<A>(sub :singleDecoder<A>){
    return function(value :string|null|undefined) :A|null|undefined{
      if(value===undefined || value===null){
        return null;
      }
      return sub(value);
    };
  },
  nullableEncoder = function<A>(sub :singleEncoder<A>){
    return function(value :A|null|undefined) :string|null|undefined{
      if(value===undefined || value===null){
        return null;
      }
      return sub(value);
    };
  },
  decodeboolean:singleDecoder<boolean> = function(value :string){
    return (value === "true");
  },
  encodeboolean = function(value:boolean){
    return value?"true":"false";
  },
  decodenumber:singleDecoder<number> = function(value :string) :number{
    return Number(value);
  },
  decodeNumber = nullableDecoder(decodenumber),
  encodenumber =  function(number :number){
    return number.toString();
  },
  encodeNumber = nullableEncoder(encodenumber),
  decodeString : ((s:string)=>string) = nothingtodo,
  encodeString = nothingtodo,
  decodeDate = function(iso8601 :string) {
    if(iso8601===undefined || iso8601===null){
      return undefined;
    }
    return new Date(iso8601);
  },
  encodeDate = function(date :Date|undefined|null){
    if(date===undefined || date===null){
      return undefined;
    }
    return date.toISOString();   
  },
  //FIXME should eval the json
  decodeFizJSONObject = nothingtodo,
  encodeFizJSONObject = nothingtodo,
  decodeMap = function(keyDecoder,valueDecoder){
    if(keyDecoder===nothingtodo && valueDecoder===nothingtodo) return nothingtodo;
    return function(value){
      var result = {},key,val;
      if(value===null || value===undefined){
        return value;
      }
      for(key in value){
        val = value[key];
        result[keyDecoder(key)] = val===null?null:valueDecoder(val);
      }
      return result;
    };  
  },
  encodeMap = function(keyEncoder,valueEncoder){
    if(keyEncoder===nothingtodo && valueEncoder===nothingtodo) return nothingtodo;
    return function(value){
      var result = {},key,val;
      for(key in value){
        result[keyEncoder(key)] = valueEncoder(value[key]);
      }
      return result;
    };  
  },
  decodeArray = function<A,B>(valueDecoder :(src:A)=>B) : (src:A[])=>B[]{
    if((valueDecoder as unknown) === nothingtodo) return nothingtodo as (src:A[])=>B[];
    
    return function(value : A[]){ //TODO find a way to not use any here maybe with decodeSimpleArray & decodeComplexeArray
      if(value===null || value===undefined){
        return undefined;
      }
      var result :B[] = []
      for(var i=0;i<value.length;i++){
        var item = value[i];
        if(item!==null){
          result[i] = valueDecoder(item);
        }
      }
      return result;
    };  
  },    
  encodeArray = function (valueEncoder){
    //no nothingtodo check here because of $empty
    return function(value){
      var i,res = {};
      if(value===null || value===undefined){
        return value;
      }
      if(!Array.isArray(value)){
        //we do not throw error here for backward compatibily
        console.log("bad param",value,new Error());
        return valueEncoder(value);
      }
      if(value.length===0){
        return "$empty";
      }
      for(i in value){
        res[i] = valueEncoder(value[i]);
      }
      return res;
    }; 
  },
  decodeFizFile = nothingtodo,
  encodeFizFile = nothingtodo,
  enumsValue = {},
  decodeEnum = function(value){
    if(value===null || value===undefined){
      return value;
    }
    var res;
    if(res = enumsValue[value]){
      return res;
    }else{
      return enumsValue[value] = value;
    }
  },
  encodeEnum = nothingtodo,
  decodeBoolean = nullableDecoder(decodeboolean),
  encodeBoolean = nullableEncoder(encodeboolean),
  decodeMetaId = decodeString,
  encodeMetaId = encodeString,
  decodeTimeZone = decodeString,
  encodeTimeZone = encodeString,
	
  decodeDynamic : objectDecoder<JsonFw,unknown> = function(json :JsonFw){
    if(json instanceof Array){
      return decodeArray(decodeDynamic)(json);
    }else if(typeof json === 'object'){
      if(json.FiZClassId===undefined){
        return decodeMap(decodeString,decodeDynamic)(json);
      }else{
        var 
          type = types[json.FiZClassId as string]||ServerError;
        return new type(json);
      }  
    }else{
      return json;
    }
  },
  encodeDynamic = function(json){
    return notimplementedyet();
  };
  
  function decodeStructure(valueDecoder){
    return function rootDecode(json: any){
      if(json.ex){
        throw decodeDynamic(json.ex.ex);
      }  
      if(json.un){
        throw decodeDynamic(json.un.un);
      }  
      if(json.r){
        return valueDecoder(json.r.r); 
      }
      return valueDecoder(json.feed);
    };
    
  }
  function registerMethod(api : string,argumentsName :(string|{name?:string,encode:objectEncoder<any>})[],decoder : objectDecoder<JsonFw,any>,https = undefined){
    methods[api] = {
        api:api,
        argumentsName : argumentsName,
        decoder:decoder,
        https:https
      }
  }
    
  class ServerBeanPrototype{
    constructor(json : JsonFw){
    }
    onDecode(json : JsonFw){
    }
    cloneWith(datas :Partial<typeof this>){
      function EXT(){};
      EXT.prototype = this;
      return Object.assign(new EXT(),datas)
    }
  }
  
  class ServerError extends ServerBeanPrototype{
    code :string 
    message :string
    constructor(json :JsonFw){
      super(json);
      Object.assign(this,json);
      this.code = json.FiZClassId as string;
      this.toString = function(){ return this.code+" "+this.message;};
      this.onDecode(json);
    }
  }


//deprecated we should not keep it but no choice
  function decodeFizApiModelRightException(json){return json;}

type AccessTokenBeanJSON = {
  access_token : string
  accountId : string
  expires_in : string
  loginInfos : AccountLoginInfoJSON
  mac_algorithm : string | undefined 
  mac_key : string | undefined 
  token_type : string
}

export class AccessTokenBean extends ServerBeanPrototype{

  access_token : string
  accountId : string
  expires_in : number
  loginInfos : AccountLoginInfo
  mac_algorithm : string
  mac_key : string
  token_type : string

  constructor(json :AccessTokenBeanJSON){
    super(json);
    this.access_token = (json.access_token);
    this.accountId = (json.accountId);
    this.expires_in = decodenumber(json.expires_in);
    this.loginInfos = decodeAccountLoginInfo(json.loginInfos);
    this.mac_algorithm = (json.mac_algorithm);
    this.mac_key = (json.mac_key);
    this.token_type = decodeEnum(json.token_type);

    this.onDecode(json);
  }
}

function decodeAccessTokenBean(json :AccessTokenBeanJSON){
  return json===undefined?undefined:new AccessTokenBean(json)
}

function encodeAccessTokenBean(obj : AccessTokenBean) :AccessTokenBeanJSON {
    if(obj==null) return undefined
    return inline({
      access_token : (obj.access_token),
      accountId : (obj.accountId),
      expires_in : encodenumber(obj.expires_in),
      loginInfos : encodeAccountLoginInfo(obj.loginInfos),
      mac_algorithm : (obj.mac_algorithm),
      mac_key : (obj.mac_key),
      token_type : encodeEnum(obj.token_type),
    } as AccessTokenBeanJSON)
}

type AccountBeanJSON = {
  accountId : string
  creationDate : string | undefined 
  deleted : string
  identifiers : Array<IAccountIdentifierJSON>
  lastLoginDate : string | undefined 
  name : string
  termsChecked : string
  termsOrangeFamilyPlaceChecked : string
  termsProximusFamilyChecked : string | undefined 
}

export class AccountBean extends ServerBeanPrototype{

  accountId : number
  creationDate : Date
  deleted : boolean
  identifiers : Array<IAccountIdentifier>
  lastLoginDate : Date
  name : string
  termsChecked : boolean
  termsOrangeFamilyPlaceChecked : boolean
  termsProximusFamilyChecked : boolean

  constructor(json :AccountBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.creationDate = decodeDate(json.creationDate);
    this.deleted = decodeboolean(json.deleted);
    this.identifiers = decodeArray(decodeIAccountIdentifier)(json.identifiers);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.name = (json.name);
    this.termsChecked = decodeboolean(json.termsChecked);
    this.termsOrangeFamilyPlaceChecked = decodeboolean(json.termsOrangeFamilyPlaceChecked);
    this.termsProximusFamilyChecked = decodeBoolean(json.termsProximusFamilyChecked);

    this.onDecode(json);
  }
}

function decodeAccountBean(json :AccountBeanJSON){
  return json===undefined?undefined:new AccountBean(json)
}

function encodeAccountBean(obj : AccountBean) :AccountBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      creationDate : encodeDate(obj.creationDate),
      deleted : encodeboolean(obj.deleted),
      identifiers : encodeArray(encodeIAccountIdentifier)(obj.identifiers),
      lastLoginDate : encodeDate(obj.lastLoginDate),
      name : (obj.name),
      termsChecked : encodeboolean(obj.termsChecked),
      termsOrangeFamilyPlaceChecked : encodeboolean(obj.termsOrangeFamilyPlaceChecked),
      termsProximusFamilyChecked : encodeBoolean(obj.termsProximusFamilyChecked),
    } as AccountBeanJSON)
}

type AccountIdentifierBeanJSON = {
  id : string
  type : string
  validated : string
  value : string
  verifiedPartner : string | undefined 
}

export class AccountIdentifierBean extends ServerBeanPrototype{

  id : number
  type : string
  validated : boolean
  value : string
  verifiedPartner : string

  constructor(json :AccountIdentifierBeanJSON){
    super(json);
    this.id = decodeNumber(json.id);
    this.type = decodeEnum(json.type);
    this.validated = decodeBoolean(json.validated);
    this.value = (json.value);
    this.verifiedPartner = decodeEnum(json.verifiedPartner);

    this.onDecode(json);
  }
}

function decodeAccountIdentifierBean(json :AccountIdentifierBeanJSON){
  return json===undefined?undefined:new AccountIdentifierBean(json)
}

function encodeAccountIdentifierBean(obj : AccountIdentifierBean) :AccountIdentifierBeanJSON {
    if(obj==null) return undefined
    return inline({
      id : encodeNumber(obj.id),
      type : encodeEnum(obj.type),
      validated : encodeBoolean(obj.validated),
      value : (obj.value),
      verifiedPartner : encodeEnum(obj.verifiedPartner),
    } as AccountIdentifierBeanJSON)
}

type AccountIdentifierInfoJSON = {
  countryCode : string | undefined 
  originalValue : string | undefined 
  type : string
  value : string | undefined 
}

export class AccountIdentifierInfo extends ServerBeanPrototype{

  countryCode : string
  originalValue : string
  type : string
  value : string

  constructor(json :AccountIdentifierInfoJSON){
    super(json);
    this.countryCode = (json.countryCode);
    this.originalValue = (json.originalValue);
    this.type = decodeEnum(json.type);
    this.value = (json.value);

    this.onDecode(json);
  }
}

function decodeAccountIdentifierInfo(json :AccountIdentifierInfoJSON){
  return json===undefined?undefined:new AccountIdentifierInfo(json)
}

function encodeAccountIdentifierInfo(obj : AccountIdentifierInfo) :AccountIdentifierInfoJSON {
    if(obj==null) return undefined
    return inline({
      countryCode : (obj.countryCode),
      originalValue : (obj.originalValue),
      type : encodeEnum(obj.type),
      value : (obj.value),
    } as AccountIdentifierInfoJSON)
}

type AccountLoginInfoJSON = {
  accountId : string
  genericAutologinToken : string | undefined 
  hasFamily : string
  termsChecked : string
  termsOrangeFamilyPlaceChecked : string
  termsProximusFamilyChecked : string
  tokenCsrf : string | undefined 
  webApiUrl : string | undefined 
}

export class AccountLoginInfo extends ServerBeanPrototype{

  accountId : number
  genericAutologinToken : string
  hasFamily : boolean
  termsChecked : boolean
  termsOrangeFamilyPlaceChecked : boolean
  termsProximusFamilyChecked : boolean
  tokenCsrf : string
  webApiUrl : string

  constructor(json :AccountLoginInfoJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.genericAutologinToken = (json.genericAutologinToken);
    this.hasFamily = decodeboolean(json.hasFamily);
    this.termsChecked = decodeboolean(json.termsChecked);
    this.termsOrangeFamilyPlaceChecked = decodeboolean(json.termsOrangeFamilyPlaceChecked);
    this.termsProximusFamilyChecked = decodeboolean(json.termsProximusFamilyChecked);
    this.tokenCsrf = (json.tokenCsrf);
    this.webApiUrl = (json.webApiUrl);

    this.onDecode(json);
  }
}

function decodeAccountLoginInfo(json :AccountLoginInfoJSON){
  return json===undefined?undefined:new AccountLoginInfo(json)
}

function encodeAccountLoginInfo(obj : AccountLoginInfo) :AccountLoginInfoJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      genericAutologinToken : (obj.genericAutologinToken),
      hasFamily : encodeboolean(obj.hasFamily),
      termsChecked : encodeboolean(obj.termsChecked),
      termsOrangeFamilyPlaceChecked : encodeboolean(obj.termsOrangeFamilyPlaceChecked),
      termsProximusFamilyChecked : encodeboolean(obj.termsProximusFamilyChecked),
      tokenCsrf : (obj.tokenCsrf),
      webApiUrl : (obj.webApiUrl),
    } as AccountLoginInfoJSON)
}

type AccountSecurityBeanJSON = {
  hasPassword : string
}

export class AccountSecurityBean extends ServerBeanPrototype{

  hasPassword : boolean

  constructor(json :AccountSecurityBeanJSON){
    super(json);
    this.hasPassword = decodeboolean(json.hasPassword);

    this.onDecode(json);
  }
}

function decodeAccountSecurityBean(json :AccountSecurityBeanJSON){
  return json===undefined?undefined:new AccountSecurityBean(json)
}

function encodeAccountSecurityBean(obj : AccountSecurityBean) :AccountSecurityBeanJSON {
    if(obj==null) return undefined
    return inline({
      hasPassword : encodeboolean(obj.hasPassword),
    } as AccountSecurityBeanJSON)
}

type AccountStateBeanJSON = {
  accountId : string
  blockedPopup : ApplicationBlockedPopupBeanJSON | undefined 
  credits : Array<ICreditJSON> | undefined 
  deviceId : string | undefined 
  locale : string | undefined 
  premium : PremiumRightBeanJSON
  premiumPopup : PremiumPopupBeanJSON | undefined 
  programmaticAds : ProgrammaticAdsBeanJSON
  purchaselyActivated : string
  sourceIpType : string | undefined 
  timeZone : string | undefined 
}

export class AccountStateBean extends ServerBeanPrototype{

  accountId : string
  blockedPopup : ApplicationBlockedPopupBean
  credits : Array<ICredit>
  deviceId : string
  locale : string
  premium : PremiumRightBean
  premiumPopup : PremiumPopupBean
  programmaticAds : ProgrammaticAdsBean
  purchaselyActivated : boolean
  sourceIpType : string
  timeZone : string

  constructor(json :AccountStateBeanJSON){
    super(json);
    this.accountId = (json.accountId);
    this.blockedPopup = decodeApplicationBlockedPopupBean(json.blockedPopup);
    this.credits = decodeArray(decodeICredit)(json.credits);
    this.deviceId = (json.deviceId);
    this.locale = (json.locale);
    this.premium = decodePremiumRightBean(json.premium);
    this.premiumPopup = decodePremiumPopupBean(json.premiumPopup);
    this.programmaticAds = decodeProgrammaticAdsBean(json.programmaticAds);
    this.purchaselyActivated = decodeboolean(json.purchaselyActivated);
    this.sourceIpType = decodeEnum(json.sourceIpType);
    this.timeZone = (json.timeZone);

    this.onDecode(json);
  }
}

function decodeAccountStateBean(json :AccountStateBeanJSON){
  return json===undefined?undefined:new AccountStateBean(json)
}

function encodeAccountStateBean(obj : AccountStateBean) :AccountStateBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : (obj.accountId),
      blockedPopup : encodeApplicationBlockedPopupBean(obj.blockedPopup),
      credits : encodeArray(encodeICredit)(obj.credits),
      deviceId : (obj.deviceId),
      locale : (obj.locale),
      premium : encodePremiumRightBean(obj.premium),
      premiumPopup : encodePremiumPopupBean(obj.premiumPopup),
      programmaticAds : encodeProgrammaticAdsBean(obj.programmaticAds),
      purchaselyActivated : encodeboolean(obj.purchaselyActivated),
      sourceIpType : encodeEnum(obj.sourceIpType),
      timeZone : (obj.timeZone),
    } as AccountStateBeanJSON)
}

type ApplicationBlockedPopupBeanJSON = {
  buttonAction : string
  buttonTitle : string
  buttonUrl : string | undefined 
  image : string | undefined 
  skippable : string
  text : string
  title : string | undefined 
}

export class ApplicationBlockedPopupBean extends ServerBeanPrototype{

  buttonAction : string
  buttonTitle : string
  buttonUrl : string
  image : string
  skippable : boolean
  text : string
  title : string

  constructor(json :ApplicationBlockedPopupBeanJSON){
    super(json);
    this.buttonAction = decodeEnum(json.buttonAction);
    this.buttonTitle = (json.buttonTitle);
    this.buttonUrl = (json.buttonUrl);
    this.image = (json.image);
    this.skippable = decodeboolean(json.skippable);
    this.text = (json.text);
    this.title = (json.title);

    this.onDecode(json);
  }
}

function decodeApplicationBlockedPopupBean(json :ApplicationBlockedPopupBeanJSON){
  return json===undefined?undefined:new ApplicationBlockedPopupBean(json)
}

function encodeApplicationBlockedPopupBean(obj : ApplicationBlockedPopupBean) :ApplicationBlockedPopupBeanJSON {
    if(obj==null) return undefined
    return inline({
      buttonAction : encodeEnum(obj.buttonAction),
      buttonTitle : (obj.buttonTitle),
      buttonUrl : (obj.buttonUrl),
      image : (obj.image),
      skippable : encodeboolean(obj.skippable),
      text : (obj.text),
      title : (obj.title),
    } as ApplicationBlockedPopupBeanJSON)
}

type CoverUriConfigurableBeanJSON = {
  darkMode : string
  lightMode : string
}

export class CoverUriConfigurableBean extends ServerBeanPrototype{

  darkMode : string
  lightMode : string

  constructor(json :CoverUriConfigurableBeanJSON){
    super(json);
    this.darkMode = (json.darkMode);
    this.lightMode = (json.lightMode);

    this.onDecode(json);
  }
}

function decodeCoverUriConfigurableBean(json :CoverUriConfigurableBeanJSON){
  return json===undefined?undefined:new CoverUriConfigurableBean(json)
}

function encodeCoverUriConfigurableBean(obj : CoverUriConfigurableBean) :CoverUriConfigurableBeanJSON {
    if(obj==null) return undefined
    return inline({
      darkMode : (obj.darkMode),
      lightMode : (obj.lightMode),
    } as CoverUriConfigurableBeanJSON)
}

type CoverUriPhoneAndTabletBeanJSON = {
  phone : CoverUriConfigurableBeanJSON
  tablet : CoverUriConfigurableBeanJSON
}

export class CoverUriPhoneAndTabletBean extends ServerBeanPrototype{

  phone : CoverUriConfigurableBean
  tablet : CoverUriConfigurableBean

  constructor(json :CoverUriPhoneAndTabletBeanJSON){
    super(json);
    this.phone = decodeCoverUriConfigurableBean(json.phone);
    this.tablet = decodeCoverUriConfigurableBean(json.tablet);

    this.onDecode(json);
  }
}

function decodeCoverUriPhoneAndTabletBean(json :CoverUriPhoneAndTabletBeanJSON){
  return json===undefined?undefined:new CoverUriPhoneAndTabletBean(json)
}

function encodeCoverUriPhoneAndTabletBean(obj : CoverUriPhoneAndTabletBean) :CoverUriPhoneAndTabletBeanJSON {
    if(obj==null) return undefined
    return inline({
      phone : encodeCoverUriConfigurableBean(obj.phone),
      tablet : encodeCoverUriConfigurableBean(obj.tablet),
    } as CoverUriPhoneAndTabletBeanJSON)
}

type DeepLinkAccessTokenJSON = {
  accessToken : AccessTokenBeanJSON
  redirectUrl : string
}

export class DeepLinkAccessToken extends ServerBeanPrototype{

  accessToken : AccessTokenBean
  redirectUrl : string

  constructor(json :DeepLinkAccessTokenJSON){
    super(json);
    this.accessToken = decodeAccessTokenBean(json.accessToken);
    this.redirectUrl = (json.redirectUrl);

    this.onDecode(json);
  }
}

function decodeDeepLinkAccessToken(json :DeepLinkAccessTokenJSON){
  return json===undefined?undefined:new DeepLinkAccessToken(json)
}

function encodeDeepLinkAccessToken(obj : DeepLinkAccessToken) :DeepLinkAccessTokenJSON {
    if(obj==null) return undefined
    return inline({
      accessToken : encodeAccessTokenBean(obj.accessToken),
      redirectUrl : (obj.redirectUrl),
    } as DeepLinkAccessTokenJSON)
}

type ExtendedFamilyMemberBeanJSON = {
  account : IAccountJSON | undefined 
  accountId : string | undefined 
  addresses : Array<IAddressJSON> | undefined 
  birthDate : string | undefined 
  birthDateNoYear : string | undefined 
  color : string | undefined 
  creationDate : string | undefined 
  customRole : string | undefined 
  deleted : string
  devices : Array<IDeviceJSON> | undefined 
  fWPremiumMemberSubscriber : string | undefined 
  familyId : string
  firstName : string | undefined 
  gender : string | undefined 
  identifiers : Array<IAccountIdentifierJSON>
  isAccountDeleted : string | undefined 
  isFirstFamily : string | undefined 
  isloggedaccount : string
  joinDate : string | undefined 
  lastLoginDate : string | undefined 
  lastName : string | undefined 
  locale : string | undefined 
  location : ILocationJSON | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  name : string
  panicButtonActivated : string | undefined 
  pictureDefault : string | undefined 
  profileFamilyId : string | undefined 
  right : string
  role : string | undefined 
  termsChecked : string
  termsOrangeFamilyPlaceChecked : string
  termsProximusFamilyChecked : string | undefined 
  timeZone : string | undefined 
}

export class ExtendedFamilyMemberBean extends ServerBeanPrototype{

  account : IAccount
  accountId : number
  addresses : Array<IAddress>
  birthDate : Date
  birthDateNoYear : boolean
  color : string
  creationDate : Date
  customRole : string
  deleted : boolean
  devices : Array<IDevice>
  fWPremiumMemberSubscriber : boolean
  familyId : string
  firstName : string
  gender : string
  identifiers : Array<IAccountIdentifier>
  isAccountDeleted : boolean
  isFirstFamily : boolean
  isloggedaccount : boolean
  joinDate : Date
  lastLoginDate : Date
  lastName : string
  locale : string
  location : ILocation
  medias : Array<IMedia>
  metaId : string
  name : string
  panicButtonActivated : boolean
  pictureDefault : boolean
  profileFamilyId : number
  right : string
  role : string
  termsChecked : boolean
  termsOrangeFamilyPlaceChecked : boolean
  termsProximusFamilyChecked : boolean
  timeZone : string

  constructor(json :ExtendedFamilyMemberBeanJSON){
    super(json);
    this.account = decodeIAccount(json.account);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.color = (json.color);
    this.creationDate = decodeDate(json.creationDate);
    this.customRole = (json.customRole);
    this.deleted = decodeboolean(json.deleted);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.fWPremiumMemberSubscriber = decodeBoolean(json.fWPremiumMemberSubscriber);
    this.familyId = (json.familyId);
    this.firstName = (json.firstName);
    this.gender = decodeEnum(json.gender);
    this.identifiers = decodeArray(decodeIAccountIdentifier)(json.identifiers);
    this.isAccountDeleted = decodeBoolean(json.isAccountDeleted);
    this.isFirstFamily = decodeBoolean(json.isFirstFamily);
    this.isloggedaccount = decodeBoolean(json.isloggedaccount);
    this.joinDate = decodeDate(json.joinDate);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.lastName = (json.lastName);
    this.locale = (json.locale);
    this.location = decodeILocation(json.location);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.panicButtonActivated = decodeBoolean(json.panicButtonActivated);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.profileFamilyId = decodeNumber(json.profileFamilyId);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);
    this.termsChecked = decodeboolean(json.termsChecked);
    this.termsOrangeFamilyPlaceChecked = decodeboolean(json.termsOrangeFamilyPlaceChecked);
    this.termsProximusFamilyChecked = decodeBoolean(json.termsProximusFamilyChecked);
    this.timeZone = (json.timeZone);

    this.onDecode(json);
  }
}

function decodeExtendedFamilyMemberBean(json :ExtendedFamilyMemberBeanJSON){
  return json===undefined?undefined:new ExtendedFamilyMemberBean(json)
}

function encodeExtendedFamilyMemberBean(obj : ExtendedFamilyMemberBean) :ExtendedFamilyMemberBeanJSON {
    if(obj==null) return undefined
    return inline({
      account : encodeIAccount(obj.account),
      accountId : encodeNumber(obj.accountId),
      addresses : encodeArray(encodeIAddress)(obj.addresses),
      birthDate : encodeDate(obj.birthDate),
      birthDateNoYear : encodeBoolean(obj.birthDateNoYear),
      color : (obj.color),
      creationDate : encodeDate(obj.creationDate),
      customRole : (obj.customRole),
      deleted : encodeboolean(obj.deleted),
      devices : encodeArray(encodeIDevice)(obj.devices),
      fWPremiumMemberSubscriber : encodeBoolean(obj.fWPremiumMemberSubscriber),
      familyId : (obj.familyId),
      firstName : (obj.firstName),
      gender : encodeEnum(obj.gender),
      identifiers : encodeArray(encodeIAccountIdentifier)(obj.identifiers),
      isAccountDeleted : encodeBoolean(obj.isAccountDeleted),
      isFirstFamily : encodeBoolean(obj.isFirstFamily),
      isloggedaccount : encodeBoolean(obj.isloggedaccount),
      joinDate : encodeDate(obj.joinDate),
      lastLoginDate : encodeDate(obj.lastLoginDate),
      lastName : (obj.lastName),
      locale : (obj.locale),
      location : encodeILocation(obj.location),
      medias : undefined,
      metaId : (obj.metaId),
      name : (obj.name),
      panicButtonActivated : encodeBoolean(obj.panicButtonActivated),
      pictureDefault : encodeBoolean(obj.pictureDefault),
      profileFamilyId : encodeNumber(obj.profileFamilyId),
      right : encodeEnum(obj.right),
      role : encodeEnum(obj.role),
      termsChecked : encodeboolean(obj.termsChecked),
      termsOrangeFamilyPlaceChecked : encodeboolean(obj.termsOrangeFamilyPlaceChecked),
      termsProximusFamilyChecked : encodeBoolean(obj.termsProximusFamilyChecked),
      timeZone : (obj.timeZone),
    } as ExtendedFamilyMemberBeanJSON)
}

type FamilyBeanJSON = {
  coverDefault : string | undefined 
  coverMedias : Array<IMediaJSON> | undefined 
  coverUri : string | undefined 
  family_id : string
  medias : Array<IMediaJSON> | undefined 
  members : Array<IFamilyMemberJSON>
  metaId : string | undefined 
  name : string
  pictureDefault : string | undefined 
  pictureUri : string | undefined 
}

export class FamilyBean extends ServerBeanPrototype{

  coverDefault : boolean
  coverMedias : Array<IMedia>
  coverUri : string
  family_id : number
  medias : Array<IMedia>
  members : Array<IFamilyMember>
  metaId : string
  name : string
  pictureDefault : boolean
  pictureUri : string

  constructor(json :FamilyBeanJSON){
    super(json);
    this.coverDefault = decodeBoolean(json.coverDefault);
    this.coverMedias = decodeArray(decodeIMedia)(json.coverMedias);
    this.coverUri = (json.coverUri);
    this.family_id = decodeNumber(json.family_id);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.members = decodeArray(decodeIFamilyMember)(json.members);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.pictureUri = (json.pictureUri);

    this.onDecode(json);
  }
}

function decodeFamilyBean(json :FamilyBeanJSON){
  return json===undefined?undefined:new FamilyBean(json)
}

function encodeFamilyBean(obj : FamilyBean) :FamilyBeanJSON {
    if(obj==null) return undefined
    return inline({
      coverDefault : encodeBoolean(obj.coverDefault),
      coverMedias : encodeArray(encodeIMedia)(obj.coverMedias),
      coverUri : (obj.coverUri),
      family_id : encodeNumber(obj.family_id),
      medias : undefined,
      members : encodeArray(encodeIFamilyMember)(obj.members),
      metaId : (obj.metaId),
      name : (obj.name),
      pictureDefault : encodeBoolean(obj.pictureDefault),
      pictureUri : (obj.pictureUri),
    } as FamilyBeanJSON)
}

type FamilyMemberBeanJSON = {
  account : IAccountJSON
  customRole : string | undefined 
  familyId : string
  isFirstFamily : string | undefined 
  joinDate : string | undefined 
  lastLoginDate : string | undefined 
  metaId : string | undefined 
  right : string
  role : string | undefined 
}

export class FamilyMemberBean extends ServerBeanPrototype{

  account : IAccount
  customRole : string
  familyId : string
  isFirstFamily : boolean
  joinDate : Date
  lastLoginDate : Date
  metaId : string
  right : string
  role : string

  constructor(json :FamilyMemberBeanJSON){
    super(json);
    this.account = decodeIAccount(json.account);
    this.customRole = (json.customRole);
    this.familyId = (json.familyId);
    this.isFirstFamily = decodeBoolean(json.isFirstFamily);
    this.joinDate = decodeDate(json.joinDate);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.metaId = (json.metaId);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);

    this.onDecode(json);
  }
}

function decodeFamilyMemberBean(json :FamilyMemberBeanJSON){
  return json===undefined?undefined:new FamilyMemberBean(json)
}

function encodeFamilyMemberBean(obj : FamilyMemberBean) :FamilyMemberBeanJSON {
    if(obj==null) return undefined
    return inline({
      account : encodeIAccount(obj.account),
      customRole : (obj.customRole),
      familyId : (obj.familyId),
      isFirstFamily : encodeBoolean(obj.isFirstFamily),
      joinDate : encodeDate(obj.joinDate),
      lastLoginDate : encodeDate(obj.lastLoginDate),
      metaId : (obj.metaId),
      right : encodeEnum(obj.right),
      role : encodeEnum(obj.role),
    } as FamilyMemberBeanJSON)
}

type ForgotPasswordResponseBeanJSON = {
  infoSentTo : IProfileJSON | undefined 
  requestedIdentifier : string
}

export class ForgotPasswordResponseBean extends ServerBeanPrototype{

  infoSentTo : IProfile
  requestedIdentifier : string

  constructor(json :ForgotPasswordResponseBeanJSON){
    super(json);
    this.infoSentTo = decodeIProfile(json.infoSentTo);
    this.requestedIdentifier = (json.requestedIdentifier);

    this.onDecode(json);
  }
}

function decodeForgotPasswordResponseBean(json :ForgotPasswordResponseBeanJSON){
  return json===undefined?undefined:new ForgotPasswordResponseBean(json)
}

function encodeForgotPasswordResponseBean(obj : ForgotPasswordResponseBean) :ForgotPasswordResponseBeanJSON {
    if(obj==null) return undefined
    return inline({
      infoSentTo : encodeIProfile(obj.infoSentTo),
      requestedIdentifier : (obj.requestedIdentifier),
    } as ForgotPasswordResponseBeanJSON)
}

type InvitationBeanJSON = {
  accountId : string
  creationdate : string
  customRole : string | undefined 
  editable : string | undefined 
  familyId : string
  firstname : string | undefined 
  invitationStatus : string
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  originalSms : string | undefined 
  ownerId : string
  pictureDefault : string | undefined 
  pictureURIs : Array<string> | undefined 
  reminderSet : string
  right : string
  role : string
  token : ITokenJSON | undefined 
  tokenId : string
}

export class InvitationBean extends ServerBeanPrototype{

  accountId : number
  creationdate : Date
  customRole : string
  editable : boolean
  familyId : string
  firstname : string
  invitationStatus : string
  medias : Array<IMedia>
  metaId : string
  originalSms : string
  ownerId : number
  pictureDefault : boolean
  pictureURIs : Array<string>
  reminderSet : boolean
  right : string
  role : string
  token : IToken
  tokenId : number

  constructor(json :InvitationBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.creationdate = decodeDate(json.creationdate);
    this.customRole = (json.customRole);
    this.editable = decodeBoolean(json.editable);
    this.familyId = (json.familyId);
    this.firstname = (json.firstname);
    this.invitationStatus = decodeEnum(json.invitationStatus);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.originalSms = (json.originalSms);
    this.ownerId = decodeNumber(json.ownerId);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.pictureURIs = decodeArray(decodeString)(json.pictureURIs);
    this.reminderSet = decodeboolean(json.reminderSet);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);
    this.token = decodeIToken(json.token);
    this.tokenId = decodeNumber(json.tokenId);

    this.onDecode(json);
  }
}

function decodeInvitationBean(json :InvitationBeanJSON){
  return json===undefined?undefined:new InvitationBean(json)
}

function encodeInvitationBean(obj : InvitationBean) :InvitationBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      creationdate : encodeDate(obj.creationdate),
      customRole : (obj.customRole),
      editable : encodeBoolean(obj.editable),
      familyId : (obj.familyId),
      firstname : (obj.firstname),
      invitationStatus : encodeEnum(obj.invitationStatus),
      medias : undefined,
      metaId : (obj.metaId),
      originalSms : (obj.originalSms),
      ownerId : encodeNumber(obj.ownerId),
      pictureDefault : encodeBoolean(obj.pictureDefault),
      pictureURIs : encodeArray(encodeString)(obj.pictureURIs),
      reminderSet : encodeboolean(obj.reminderSet),
      right : encodeEnum(obj.right),
      role : encodeEnum(obj.role),
      token : encodeIToken(obj.token),
      tokenId : encodeNumber(obj.tokenId),
    } as InvitationBeanJSON)
}

type InvitationReceivedBeanJSON = {
  blockingStatus : string
  coverDefault : string | undefined 
  coverMedias : Array<IMediaJSON> | undefined 
  coverURI : string
  familyName : string
  invitation : IInvitationJSON
  inviterName : string
  medias : Array<IMediaJSON> | undefined 
  pictureDefault : string | undefined 
}

export class InvitationReceivedBean extends ServerBeanPrototype{

  blockingStatus : string
  coverDefault : boolean
  coverMedias : Array<IMedia>
  coverURI : string
  familyName : string
  invitation : IInvitation
  inviterName : string
  medias : Array<IMedia>
  pictureDefault : boolean

  constructor(json :InvitationReceivedBeanJSON){
    super(json);
    this.blockingStatus = decodeEnum(json.blockingStatus);
    this.coverDefault = decodeBoolean(json.coverDefault);
    this.coverMedias = decodeArray(decodeIMedia)(json.coverMedias);
    this.coverURI = (json.coverURI);
    this.familyName = (json.familyName);
    this.invitation = decodeIInvitation(json.invitation);
    this.inviterName = (json.inviterName);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.pictureDefault = decodeBoolean(json.pictureDefault);

    this.onDecode(json);
  }
}

function decodeInvitationReceivedBean(json :InvitationReceivedBeanJSON){
  return json===undefined?undefined:new InvitationReceivedBean(json)
}

function encodeInvitationReceivedBean(obj : InvitationReceivedBean) :InvitationReceivedBeanJSON {
    if(obj==null) return undefined
    return inline({
      blockingStatus : encodeEnum(obj.blockingStatus),
      coverDefault : encodeBoolean(obj.coverDefault),
      coverMedias : encodeArray(encodeIMedia)(obj.coverMedias),
      coverURI : (obj.coverURI),
      familyName : (obj.familyName),
      invitation : encodeIInvitation(obj.invitation),
      inviterName : (obj.inviterName),
      medias : undefined,
      pictureDefault : encodeBoolean(obj.pictureDefault),
    } as InvitationReceivedBeanJSON)
}

type InvitationSendingBeanJSON = {
  invitation : IInvitationJSON | undefined 
  invitationLink : string | undefined 
}

export class InvitationSendingBean extends ServerBeanPrototype{

  invitation : IInvitation
  invitationLink : string

  constructor(json :InvitationSendingBeanJSON){
    super(json);
    this.invitation = decodeIInvitation(json.invitation);
    this.invitationLink = (json.invitationLink);

    this.onDecode(json);
  }
}

function decodeInvitationSendingBean(json :InvitationSendingBeanJSON){
  return json===undefined?undefined:new InvitationSendingBean(json)
}

function encodeInvitationSendingBean(obj : InvitationSendingBean) :InvitationSendingBeanJSON {
    if(obj==null) return undefined
    return inline({
      invitation : encodeIInvitation(obj.invitation),
      invitationLink : (obj.invitationLink),
    } as InvitationSendingBeanJSON)
}

type PremiumPopupBeanJSON = {
  androidYearlyBasePlanId : string | undefined 
  androidYearlyOfferId : string | undefined 
  androidYearlySku : string | undefined 
  atLaunchResetDate : string
  content : PremiumPopupConfigurableContentBeanJSON
  id : string
  iosYearlyRedeemCode : string | undefined 
  iosYearlySku : string | undefined 
  type : string
}

export class PremiumPopupBean extends ServerBeanPrototype{

  androidYearlyBasePlanId : string
  androidYearlyOfferId : string
  androidYearlySku : string
  atLaunchResetDate : Date
  content : PremiumPopupConfigurableContentBean
  id : string
  iosYearlyRedeemCode : string
  iosYearlySku : string
  type : string

  constructor(json :PremiumPopupBeanJSON){
    super(json);
    this.androidYearlyBasePlanId = (json.androidYearlyBasePlanId);
    this.androidYearlyOfferId = (json.androidYearlyOfferId);
    this.androidYearlySku = (json.androidYearlySku);
    this.atLaunchResetDate = decodeDate(json.atLaunchResetDate);
    this.content = decodePremiumPopupConfigurableContentBean(json.content);
    this.id = (json.id);
    this.iosYearlyRedeemCode = (json.iosYearlyRedeemCode);
    this.iosYearlySku = (json.iosYearlySku);
    this.type = decodeEnum(json.type);

    this.onDecode(json);
  }
}

function decodePremiumPopupBean(json :PremiumPopupBeanJSON){
  return json===undefined?undefined:new PremiumPopupBean(json)
}

function encodePremiumPopupBean(obj : PremiumPopupBean) :PremiumPopupBeanJSON {
    if(obj==null) return undefined
    return inline({
      androidYearlyBasePlanId : (obj.androidYearlyBasePlanId),
      androidYearlyOfferId : (obj.androidYearlyOfferId),
      androidYearlySku : (obj.androidYearlySku),
      atLaunchResetDate : encodeDate(obj.atLaunchResetDate),
      content : encodePremiumPopupConfigurableContentBean(obj.content),
      id : (obj.id),
      iosYearlyRedeemCode : (obj.iosYearlyRedeemCode),
      iosYearlySku : (obj.iosYearlySku),
      type : encodeEnum(obj.type),
    } as PremiumPopupBeanJSON)
}

type PremiumPopupConfigurableContentBeanJSON = {
  bannerCover : CoverUriPhoneAndTabletBeanJSON
  bannerText : string
  bannerTitle : string
  buttonText : string
  colorAccent : string
  countdownDate : string | undefined 
  cover : CoverUriPhoneAndTabletBeanJSON
  description : string
  tagText : string
  title : string
}

export class PremiumPopupConfigurableContentBean extends ServerBeanPrototype{

  bannerCover : CoverUriPhoneAndTabletBean
  bannerText : string
  bannerTitle : string
  buttonText : string
  colorAccent : string
  countdownDate : Date
  cover : CoverUriPhoneAndTabletBean
  description : string
  tagText : string
  title : string

  constructor(json :PremiumPopupConfigurableContentBeanJSON){
    super(json);
    this.bannerCover = decodeCoverUriPhoneAndTabletBean(json.bannerCover);
    this.bannerText = (json.bannerText);
    this.bannerTitle = (json.bannerTitle);
    this.buttonText = (json.buttonText);
    this.colorAccent = (json.colorAccent);
    this.countdownDate = decodeDate(json.countdownDate);
    this.cover = decodeCoverUriPhoneAndTabletBean(json.cover);
    this.description = (json.description);
    this.tagText = (json.tagText);
    this.title = (json.title);

    this.onDecode(json);
  }
}

function decodePremiumPopupConfigurableContentBean(json :PremiumPopupConfigurableContentBeanJSON){
  return json===undefined?undefined:new PremiumPopupConfigurableContentBean(json)
}

function encodePremiumPopupConfigurableContentBean(obj : PremiumPopupConfigurableContentBean) :PremiumPopupConfigurableContentBeanJSON {
    if(obj==null) return undefined
    return inline({
      bannerCover : encodeCoverUriPhoneAndTabletBean(obj.bannerCover),
      bannerText : (obj.bannerText),
      bannerTitle : (obj.bannerTitle),
      buttonText : (obj.buttonText),
      colorAccent : (obj.colorAccent),
      countdownDate : encodeDate(obj.countdownDate),
      cover : encodeCoverUriPhoneAndTabletBean(obj.cover),
      description : (obj.description),
      tagText : (obj.tagText),
      title : (obj.title),
    } as PremiumPopupConfigurableContentBeanJSON)
}

type ProfileBeanJSON = {
  accountId : string | undefined 
  addresses : Array<IAddressJSON> | undefined 
  birthDate : string | undefined 
  birthDateNoYear : string | undefined 
  color : string | undefined 
  devices : Array<IDeviceJSON> | undefined 
  firstName : string | undefined 
  gender : string | undefined 
  isAccountDeleted : string | undefined 
  lastName : string | undefined 
  locale : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  pictureDefault : string | undefined 
  profileFamilyId : string | undefined 
  timeZone : string | undefined 
}

export class ProfileBean extends ServerBeanPrototype{

  accountId : number
  addresses : Array<IAddress>
  birthDate : Date
  birthDateNoYear : boolean
  color : string
  devices : Array<IDevice>
  firstName : string
  gender : string
  isAccountDeleted : boolean
  lastName : string
  locale : string
  medias : Array<IMedia>
  metaId : string
  pictureDefault : boolean
  profileFamilyId : number
  timeZone : string

  constructor(json :ProfileBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.color = (json.color);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.firstName = (json.firstName);
    this.gender = decodeEnum(json.gender);
    this.isAccountDeleted = decodeBoolean(json.isAccountDeleted);
    this.lastName = (json.lastName);
    this.locale = (json.locale);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.profileFamilyId = decodeNumber(json.profileFamilyId);
    this.timeZone = (json.timeZone);

    this.onDecode(json);
  }
}

function decodeProfileBean(json :ProfileBeanJSON){
  return json===undefined?undefined:new ProfileBean(json)
}

function encodeProfileBean(obj : ProfileBean) :ProfileBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      addresses : encodeArray(encodeIAddress)(obj.addresses),
      birthDate : encodeDate(obj.birthDate),
      birthDateNoYear : encodeBoolean(obj.birthDateNoYear),
      color : (obj.color),
      devices : encodeArray(encodeIDevice)(obj.devices),
      firstName : (obj.firstName),
      gender : encodeEnum(obj.gender),
      isAccountDeleted : encodeBoolean(obj.isAccountDeleted),
      lastName : (obj.lastName),
      locale : (obj.locale),
      medias : undefined,
      metaId : (obj.metaId),
      pictureDefault : encodeBoolean(obj.pictureDefault),
      profileFamilyId : encodeNumber(obj.profileFamilyId),
      timeZone : (obj.timeZone),
    } as ProfileBeanJSON)
}

type ProgrammaticAdsBeanJSON = {
  active : string
}

export class ProgrammaticAdsBean extends ServerBeanPrototype{

  active : boolean

  constructor(json :ProgrammaticAdsBeanJSON){
    super(json);
    this.active = decodeboolean(json.active);

    this.onDecode(json);
  }
}

function decodeProgrammaticAdsBean(json :ProgrammaticAdsBeanJSON){
  return json===undefined?undefined:new ProgrammaticAdsBean(json)
}

function encodeProgrammaticAdsBean(obj : ProgrammaticAdsBean) :ProgrammaticAdsBeanJSON {
    if(obj==null) return undefined
    return inline({
      active : encodeboolean(obj.active),
    } as ProgrammaticAdsBeanJSON)
}

type TokenAndAccountLogInfoBeanJSON = {
  logInfo : AccountLoginInfoJSON | undefined 
  redirectUrl : string
}

export class TokenAndAccountLogInfoBean extends ServerBeanPrototype{

  logInfo : AccountLoginInfo
  redirectUrl : string

  constructor(json :TokenAndAccountLogInfoBeanJSON){
    super(json);
    this.logInfo = decodeAccountLoginInfo(json.logInfo);
    this.redirectUrl = (json.redirectUrl);

    this.onDecode(json);
  }
}

function decodeTokenAndAccountLogInfoBean(json :TokenAndAccountLogInfoBeanJSON){
  return json===undefined?undefined:new TokenAndAccountLogInfoBean(json)
}

function encodeTokenAndAccountLogInfoBean(obj : TokenAndAccountLogInfoBean) :TokenAndAccountLogInfoBeanJSON {
    if(obj==null) return undefined
    return inline({
      logInfo : encodeAccountLoginInfo(obj.logInfo),
      redirectUrl : (obj.redirectUrl),
    } as TokenAndAccountLogInfoBeanJSON)
}

type TokenBeanJSON = {
  accountId : string | undefined 
  accountIdentifierId : string | undefined 
  clickMaxCount : string | undefined 
  clickcount : string
  clientPartnerType : string | undefined 
  creationDate : string
  email : string | undefined 
  expirationDate : string | undefined 
  familyId : string | undefined 
  persistentNameRef : string | undefined 
  sms : string | undefined 
  smsInternational : string | undefined 
  tokenId : string
  tokenRefMetaId : string | undefined 
  type : string
}

export class TokenBean extends ServerBeanPrototype{

  accountId : number
  accountIdentifierId : number
  clickMaxCount : number
  clickcount : number
  clientPartnerType : string
  creationDate : Date
  email : string
  expirationDate : Date
  familyId : number
  persistentNameRef : string
  sms : string
  smsInternational : boolean
  tokenId : number
  tokenRefMetaId : string
  type : string

  constructor(json :TokenBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.accountIdentifierId = decodeNumber(json.accountIdentifierId);
    this.clickMaxCount = decodeNumber(json.clickMaxCount);
    this.clickcount = decodenumber(json.clickcount);
    this.clientPartnerType = decodeEnum(json.clientPartnerType);
    this.creationDate = decodeDate(json.creationDate);
    this.email = (json.email);
    this.expirationDate = decodeDate(json.expirationDate);
    this.familyId = decodeNumber(json.familyId);
    this.persistentNameRef = (json.persistentNameRef);
    this.sms = (json.sms);
    this.smsInternational = decodeBoolean(json.smsInternational);
    this.tokenId = decodenumber(json.tokenId);
    this.tokenRefMetaId = (json.tokenRefMetaId);
    this.type = decodeEnum(json.type);

    this.onDecode(json);
  }
}

function decodeTokenBean(json :TokenBeanJSON){
  return json===undefined?undefined:new TokenBean(json)
}

function encodeTokenBean(obj : TokenBean) :TokenBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      accountIdentifierId : encodeNumber(obj.accountIdentifierId),
      clickMaxCount : encodeNumber(obj.clickMaxCount),
      clickcount : encodenumber(obj.clickcount),
      clientPartnerType : encodeEnum(obj.clientPartnerType),
      creationDate : encodeDate(obj.creationDate),
      email : (obj.email),
      expirationDate : encodeDate(obj.expirationDate),
      familyId : encodeNumber(obj.familyId),
      persistentNameRef : (obj.persistentNameRef),
      sms : (obj.sms),
      smsInternational : encodeBoolean(obj.smsInternational),
      tokenId : encodenumber(obj.tokenId),
      tokenRefMetaId : (obj.tokenRefMetaId),
      type : encodeEnum(obj.type),
    } as TokenBeanJSON)
}

type AddressBeanJSON = {
  addressId : string | undefined 
  geocodedAddress : GeocodedAddressJSON
  metaId : string | undefined 
  placeType : string | undefined 
}

export class AddressBean extends ServerBeanPrototype{

  addressId : string
  geocodedAddress : GeocodedAddress
  metaId : string
  placeType : string

  constructor(json :AddressBeanJSON){
    super(json);
    this.addressId = (json.addressId);
    this.geocodedAddress = decodeGeocodedAddress(json.geocodedAddress);
    this.metaId = (json.metaId);
    this.placeType = decodeEnum(json.placeType);

    this.onDecode(json);
  }
}

function decodeAddressBean(json :AddressBeanJSON){
  return json===undefined?undefined:new AddressBean(json)
}

function encodeAddressBean(obj : AddressBean) :AddressBeanJSON {
    if(obj==null) return undefined
    return inline({
      addressId : (obj.addressId),
      geocodedAddress : encodeGeocodedAddress(obj.geocodedAddress),
      metaId : (obj.metaId),
      placeType : encodeEnum(obj.placeType),
    } as AddressBeanJSON)
}

type ContactBeanJSON = {
  accountId : string | undefined 
  addresses : Array<IAddressJSON> | undefined 
  birthDate : string | undefined 
  birthDateNoYear : string | undefined 
  comments : Array<ICommentJSON> | undefined 
  devices : Array<IDeviceJSON> | undefined 
  editable : string | undefined 
  familyId : string | undefined 
  firstName : string | undefined 
  function : string | undefined 
  gender : string | undefined 
  lastName : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  note : string | undefined 
  pictureDefault : string | undefined 
}

export class ContactBean extends ServerBeanPrototype{

  accountId : number
  addresses : Array<IAddress>
  birthDate : Date
  birthDateNoYear : boolean
  comments : Array<IComment>
  devices : Array<IDevice>
  editable : boolean
  familyId : string
  firstName : string
  function : string
  gender : string
  lastName : string
  medias : Array<IMedia>
  metaId : string
  note : string
  pictureDefault : boolean

  constructor(json :ContactBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.editable = decodeBoolean(json.editable);
    this.familyId = (json.familyId);
    this.firstName = (json.firstName);
    this.function = (json.function);
    this.gender = decodeEnum(json.gender);
    this.lastName = (json.lastName);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.note = (json.note);
    this.pictureDefault = decodeBoolean(json.pictureDefault);

    this.onDecode(json);
  }
}

function decodeContactBean(json :ContactBeanJSON){
  return json===undefined?undefined:new ContactBean(json)
}

function encodeContactBean(obj : ContactBean) :ContactBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      addresses : encodeArray(encodeIAddress)(obj.addresses),
      birthDate : encodeDate(obj.birthDate),
      birthDateNoYear : encodeBoolean(obj.birthDateNoYear),
      comments : undefined,
      devices : encodeArray(encodeIDevice)(obj.devices),
      editable : undefined,
      familyId : undefined,
      firstName : (obj.firstName),
      function : (obj.function),
      gender : encodeEnum(obj.gender),
      lastName : (obj.lastName),
      medias : undefined,
      metaId : (obj.metaId),
      note : (obj.note),
      pictureDefault : undefined,
    } as ContactBeanJSON)
}

type ContactSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<IContactJSON>
}

export class ContactSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<IContact>

  constructor(json :ContactSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeIContact)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeContactSyncBean(json :ContactSyncBeanJSON){
  return json===undefined?undefined:new ContactSyncBean(json)
}

function encodeContactSyncBean(obj : ContactSyncBean) :ContactSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeIContact)(obj.updatedCreated),
    } as ContactSyncBeanJSON)
}

type DeviceBeanJSON = {
  deviceId : string | undefined 
  deviceType : string
  value : string
}

export class DeviceBean extends ServerBeanPrototype{

  deviceId : string
  deviceType : string
  value : string

  constructor(json :DeviceBeanJSON){
    super(json);
    this.deviceId = (json.deviceId);
    this.deviceType = decodeEnum(json.deviceType);
    this.value = (json.value);

    this.onDecode(json);
  }
}

function decodeDeviceBean(json :DeviceBeanJSON){
  return json===undefined?undefined:new DeviceBean(json)
}

function encodeDeviceBean(obj : DeviceBean) :DeviceBeanJSON {
    if(obj==null) return undefined
    return inline({
      deviceId : (obj.deviceId),
      deviceType : encodeEnum(obj.deviceType),
      value : (obj.value),
    } as DeviceBeanJSON)
}

type VcardImportPreviewBeanJSON = {
  content : Array<ContactBeanJSON>
  count : string
  created : string
  error : string
  ignored : string
  updated : string
}

export class VcardImportPreviewBean extends ServerBeanPrototype{

  content : Array<ContactBean>
  count : number
  created : number
  error : number
  ignored : number
  updated : number

  constructor(json :VcardImportPreviewBeanJSON){
    super(json);
    this.content = decodeArray(decodeContactBean)(json.content);
    this.count = decodenumber(json.count);
    this.created = decodenumber(json.created);
    this.error = decodenumber(json.error);
    this.ignored = decodenumber(json.ignored);
    this.updated = decodenumber(json.updated);

    this.onDecode(json);
  }
}

function decodeVcardImportPreviewBean(json :VcardImportPreviewBeanJSON){
  return json===undefined?undefined:new VcardImportPreviewBean(json)
}

function encodeVcardImportPreviewBean(obj : VcardImportPreviewBean) :VcardImportPreviewBeanJSON {
    if(obj==null) return undefined
    return inline({
      content : encodeArray(encodeContactBean)(obj.content),
      count : encodenumber(obj.count),
      created : encodenumber(obj.created),
      error : encodenumber(obj.error),
      ignored : encodenumber(obj.ignored),
      updated : encodenumber(obj.updated),
    } as VcardImportPreviewBeanJSON)
}

type AdminRightBeanJSON = {
  administrators : Array<string>
  others : Array<string>
}

export class AdminRightBean extends ServerBeanPrototype{

  administrators : Array<number>
  others : Array<number>

  constructor(json :AdminRightBeanJSON){
    super(json);
    this.administrators = decodeArray(decodeNumber)(json.administrators);
    this.others = decodeArray(decodeNumber)(json.others);

    this.onDecode(json);
  }
}

function decodeAdminRightBean(json :AdminRightBeanJSON){
  return json===undefined?undefined:new AdminRightBean(json)
}

function encodeAdminRightBean(obj : AdminRightBean) :AdminRightBeanJSON {
    if(obj==null) return undefined
    return inline({
      administrators : encodeArray(encodeNumber)(obj.administrators),
      others : encodeArray(encodeNumber)(obj.others),
    } as AdminRightBeanJSON)
}

type InboundEmailPreferenceJSON = {
  accountId : string
  familyId : string
  timezone : string
}

export class InboundEmailPreference extends ServerBeanPrototype{

  accountId : number
  familyId : number
  timezone : string

  constructor(json :InboundEmailPreferenceJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.familyId = decodeNumber(json.familyId);
    this.timezone = (json.timezone);

    this.onDecode(json);
  }
}

function decodeInboundEmailPreference(json :InboundEmailPreferenceJSON){
  return json===undefined?undefined:new InboundEmailPreference(json)
}

function encodeInboundEmailPreference(obj : InboundEmailPreference) :InboundEmailPreferenceJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      familyId : encodeNumber(obj.familyId),
      timezone : (obj.timezone),
    } as InboundEmailPreferenceJSON)
}

type ApiKeyBeanJSON = {
  accessRightRuleset : string
  apiKeyClientType : string
  clientId : string
  clientSecret : string
  forcedPartner : string | undefined 
  name : string | undefined 
  oAuth2PasswordBasedAuthorized : string
  webAnonymousAuthorized : string
  webRedirectUrlPrefix : string | undefined 
}

export class ApiKeyBean extends ServerBeanPrototype{

  accessRightRuleset : string
  apiKeyClientType : string
  clientId : string
  clientSecret : string
  forcedPartner : string
  name : string
  oAuth2PasswordBasedAuthorized : boolean
  webAnonymousAuthorized : boolean
  webRedirectUrlPrefix : string

  constructor(json :ApiKeyBeanJSON){
    super(json);
    this.accessRightRuleset = decodeEnum(json.accessRightRuleset);
    this.apiKeyClientType = decodeEnum(json.apiKeyClientType);
    this.clientId = (json.clientId);
    this.clientSecret = (json.clientSecret);
    this.forcedPartner = decodeEnum(json.forcedPartner);
    this.name = (json.name);
    this.oAuth2PasswordBasedAuthorized = decodeboolean(json.oAuth2PasswordBasedAuthorized);
    this.webAnonymousAuthorized = decodeboolean(json.webAnonymousAuthorized);
    this.webRedirectUrlPrefix = (json.webRedirectUrlPrefix);

    this.onDecode(json);
  }
}

function decodeApiKeyBean(json :ApiKeyBeanJSON){
  return json===undefined?undefined:new ApiKeyBean(json)
}

function encodeApiKeyBean(obj : ApiKeyBean) :ApiKeyBeanJSON {
    if(obj==null) return undefined
    return inline({
      accessRightRuleset : encodeEnum(obj.accessRightRuleset),
      apiKeyClientType : encodeEnum(obj.apiKeyClientType),
      clientId : (obj.clientId),
      clientSecret : (obj.clientSecret),
      forcedPartner : encodeEnum(obj.forcedPartner),
      name : (obj.name),
      oAuth2PasswordBasedAuthorized : encodeboolean(obj.oAuth2PasswordBasedAuthorized),
      webAnonymousAuthorized : encodeboolean(obj.webAnonymousAuthorized),
      webRedirectUrlPrefix : (obj.webRedirectUrlPrefix),
    } as ApiKeyBeanJSON)
}

type PremiumRightBeanJSON = {
  accountIdOfPremiumProvider : string | undefined 
  aiImport : string
  audio : string
  budget : string
  canAcceptInvitation : string | undefined 
  canActivatePanicButton : string | undefined 
  canCreatePlace : string
  canFoundFamily : string
  canInvite : string
  canLinkCalendarByUrl : string
  canLinkGoogleCalendar : string
  canLinkOutlookCalendar : string
  canLinkiOSCalendar : string
  creditIds : Array<string>
  fWPremiumMemberSubscriber : string
  fWPremiumPopup : string
  familyQuota : string
  filer : string
  geoFencingActivated : string | undefined 
  geoLocAutotrackActivated : string | undefined 
  geoLocAvailable : string
  hideSmartCard : string
  mealPlannerFlag : string
  nameOfPremiumProvider : string | undefined 
  orangePremiumPopup : string
  orangePremiumPopupType : string | undefined 
  photoHD : string
  premiumIntroPopupTypeOfPeriod : string | undefined 
  recipeBoxFlag : string
  recipeCustomCategoriesFlag : string
  recipeExportToShoppingListFlag : string
  recipePlanInMealPlanner : string
  recurringTask : string
  specialDays : string
  technicalLimiFamilies : string
  technicalLimitEvent : string
  technicalLimitMembers : string
  technicalLimitTask : string
  technicalLimitTaskCategory : string
  technicalLimitTaskList : string
  timetable : string
  videoAvailable : string
  yourCreditId : string | undefined 
}

export class PremiumRightBean extends ServerBeanPrototype{

  accountIdOfPremiumProvider : number
  aiImport : string
  audio : boolean
  budget : string
  canAcceptInvitation : string
  canActivatePanicButton : string
  canCreatePlace : string
  canFoundFamily : string
  canInvite : string
  canLinkCalendarByUrl : string
  canLinkGoogleCalendar : string
  canLinkOutlookCalendar : string
  canLinkiOSCalendar : string
  creditIds : Array<string>
  fWPremiumMemberSubscriber : boolean
  fWPremiumPopup : boolean
  familyQuota : number
  filer : string
  geoFencingActivated : boolean
  geoLocAutotrackActivated : boolean
  geoLocAvailable : boolean
  hideSmartCard : string
  mealPlannerFlag : string
  nameOfPremiumProvider : string
  orangePremiumPopup : boolean
  orangePremiumPopupType : string
  photoHD : boolean
  premiumIntroPopupTypeOfPeriod : string
  recipeBoxFlag : string
  recipeCustomCategoriesFlag : string
  recipeExportToShoppingListFlag : string
  recipePlanInMealPlanner : string
  recurringTask : string
  specialDays : string
  technicalLimiFamilies : number
  technicalLimitEvent : number
  technicalLimitMembers : number
  technicalLimitTask : number
  technicalLimitTaskCategory : number
  technicalLimitTaskList : number
  timetable : string
  videoAvailable : boolean
  yourCreditId : string

  constructor(json :PremiumRightBeanJSON){
    super(json);
    this.accountIdOfPremiumProvider = decodeNumber(json.accountIdOfPremiumProvider);
    this.aiImport = decodeEnum(json.aiImport);
    this.audio = decodeboolean(json.audio);
    this.budget = decodeEnum(json.budget);
    this.canAcceptInvitation = decodeEnum(json.canAcceptInvitation);
    this.canActivatePanicButton = decodeEnum(json.canActivatePanicButton);
    this.canCreatePlace = decodeEnum(json.canCreatePlace);
    this.canFoundFamily = decodeEnum(json.canFoundFamily);
    this.canInvite = decodeEnum(json.canInvite);
    this.canLinkCalendarByUrl = decodeEnum(json.canLinkCalendarByUrl);
    this.canLinkGoogleCalendar = decodeEnum(json.canLinkGoogleCalendar);
    this.canLinkOutlookCalendar = decodeEnum(json.canLinkOutlookCalendar);
    this.canLinkiOSCalendar = decodeEnum(json.canLinkiOSCalendar);
    this.creditIds = decodeArray(decodeString)(json.creditIds);
    this.fWPremiumMemberSubscriber = decodeboolean(json.fWPremiumMemberSubscriber);
    this.fWPremiumPopup = decodeboolean(json.fWPremiumPopup);
    this.familyQuota = decodenumber(json.familyQuota);
    this.filer = decodeEnum(json.filer);
    this.geoFencingActivated = decodeBoolean(json.geoFencingActivated);
    this.geoLocAutotrackActivated = decodeBoolean(json.geoLocAutotrackActivated);
    this.geoLocAvailable = decodeboolean(json.geoLocAvailable);
    this.hideSmartCard = decodeEnum(json.hideSmartCard);
    this.mealPlannerFlag = decodeEnum(json.mealPlannerFlag);
    this.nameOfPremiumProvider = (json.nameOfPremiumProvider);
    this.orangePremiumPopup = decodeboolean(json.orangePremiumPopup);
    this.orangePremiumPopupType = decodeEnum(json.orangePremiumPopupType);
    this.photoHD = decodeboolean(json.photoHD);
    this.premiumIntroPopupTypeOfPeriod = decodeEnum(json.premiumIntroPopupTypeOfPeriod);
    this.recipeBoxFlag = decodeEnum(json.recipeBoxFlag);
    this.recipeCustomCategoriesFlag = decodeEnum(json.recipeCustomCategoriesFlag);
    this.recipeExportToShoppingListFlag = decodeEnum(json.recipeExportToShoppingListFlag);
    this.recipePlanInMealPlanner = decodeEnum(json.recipePlanInMealPlanner);
    this.recurringTask = decodeEnum(json.recurringTask);
    this.specialDays = decodeEnum(json.specialDays);
    this.technicalLimiFamilies = decodenumber(json.technicalLimiFamilies);
    this.technicalLimitEvent = decodenumber(json.technicalLimitEvent);
    this.technicalLimitMembers = decodenumber(json.technicalLimitMembers);
    this.technicalLimitTask = decodenumber(json.technicalLimitTask);
    this.technicalLimitTaskCategory = decodenumber(json.technicalLimitTaskCategory);
    this.technicalLimitTaskList = decodenumber(json.technicalLimitTaskList);
    this.timetable = decodeEnum(json.timetable);
    this.videoAvailable = decodeboolean(json.videoAvailable);
    this.yourCreditId = (json.yourCreditId);

    this.onDecode(json);
  }
}

function decodePremiumRightBean(json :PremiumRightBeanJSON){
  return json===undefined?undefined:new PremiumRightBean(json)
}

function encodePremiumRightBean(obj : PremiumRightBean) :PremiumRightBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountIdOfPremiumProvider : encodeNumber(obj.accountIdOfPremiumProvider),
      aiImport : encodeEnum(obj.aiImport),
      audio : encodeboolean(obj.audio),
      budget : encodeEnum(obj.budget),
      canAcceptInvitation : encodeEnum(obj.canAcceptInvitation),
      canActivatePanicButton : encodeEnum(obj.canActivatePanicButton),
      canCreatePlace : encodeEnum(obj.canCreatePlace),
      canFoundFamily : encodeEnum(obj.canFoundFamily),
      canInvite : encodeEnum(obj.canInvite),
      canLinkCalendarByUrl : encodeEnum(obj.canLinkCalendarByUrl),
      canLinkGoogleCalendar : encodeEnum(obj.canLinkGoogleCalendar),
      canLinkOutlookCalendar : encodeEnum(obj.canLinkOutlookCalendar),
      canLinkiOSCalendar : encodeEnum(obj.canLinkiOSCalendar),
      creditIds : encodeArray(encodeString)(obj.creditIds),
      fWPremiumMemberSubscriber : encodeboolean(obj.fWPremiumMemberSubscriber),
      fWPremiumPopup : encodeboolean(obj.fWPremiumPopup),
      familyQuota : encodenumber(obj.familyQuota),
      filer : encodeEnum(obj.filer),
      geoFencingActivated : encodeBoolean(obj.geoFencingActivated),
      geoLocAutotrackActivated : encodeBoolean(obj.geoLocAutotrackActivated),
      geoLocAvailable : encodeboolean(obj.geoLocAvailable),
      hideSmartCard : encodeEnum(obj.hideSmartCard),
      mealPlannerFlag : encodeEnum(obj.mealPlannerFlag),
      nameOfPremiumProvider : (obj.nameOfPremiumProvider),
      orangePremiumPopup : encodeboolean(obj.orangePremiumPopup),
      orangePremiumPopupType : encodeEnum(obj.orangePremiumPopupType),
      photoHD : encodeboolean(obj.photoHD),
      premiumIntroPopupTypeOfPeriod : encodeEnum(obj.premiumIntroPopupTypeOfPeriod),
      recipeBoxFlag : encodeEnum(obj.recipeBoxFlag),
      recipeCustomCategoriesFlag : encodeEnum(obj.recipeCustomCategoriesFlag),
      recipeExportToShoppingListFlag : encodeEnum(obj.recipeExportToShoppingListFlag),
      recipePlanInMealPlanner : encodeEnum(obj.recipePlanInMealPlanner),
      recurringTask : encodeEnum(obj.recurringTask),
      specialDays : encodeEnum(obj.specialDays),
      technicalLimiFamilies : encodenumber(obj.technicalLimiFamilies),
      technicalLimitEvent : encodenumber(obj.technicalLimitEvent),
      technicalLimitMembers : encodenumber(obj.technicalLimitMembers),
      technicalLimitTask : encodenumber(obj.technicalLimitTask),
      technicalLimitTaskCategory : encodenumber(obj.technicalLimitTaskCategory),
      technicalLimitTaskList : encodenumber(obj.technicalLimitTaskList),
      timetable : encodeEnum(obj.timetable),
      videoAvailable : encodeboolean(obj.videoAvailable),
      yourCreditId : (obj.yourCreditId),
    } as PremiumRightBeanJSON)
}

type CreditBeanJSON = {
  accountId : string | undefined 
  autoRenewType : string | undefined 
  creationDate : string | undefined 
  creditStatus : string | undefined 
  creditStatusDetail : string | undefined 
  creditType : string | undefined 
  endDate : string | undefined 
  familyIds : Array<string> | undefined 
  metaId : string | undefined 
  paymentCancelDate : string | undefined 
  paymentCancelReason : string | undefined 
  paymentCancelReasonSurvey : string | undefined 
  paymentCancelReasonSurveyCustom : string | undefined 
  paymentDate : string | undefined 
  paymentKey : string | undefined 
  paymentOriginalStatus : string | undefined 
  paymentReceipt : string | undefined 
  paymentSKU : string | undefined 
  paymentStatus : string | undefined 
  paymentStatusActiveDate : string | undefined 
  paymentSubSKU : string | undefined 
  paymentType : string | undefined 
  paymentValue : string | undefined 
  periodType : string | undefined 
  startDate : string | undefined 
  text : string | undefined 
  value : string | undefined 
}

export class CreditBean extends ServerBeanPrototype{

  accountId : number
  autoRenewType : string
  creationDate : Date
  creditStatus : string
  creditStatusDetail : string
  creditType : string
  endDate : Date
  familyIds : Array<number>
  metaId : string
  paymentCancelDate : Date
  paymentCancelReason : number
  paymentCancelReasonSurvey : number
  paymentCancelReasonSurveyCustom : string
  paymentDate : Date
  paymentKey : string
  paymentOriginalStatus : number
  paymentReceipt : string
  paymentSKU : string
  paymentStatus : number
  paymentStatusActiveDate : Date
  paymentSubSKU : string
  paymentType : string
  paymentValue : string
  periodType : string
  startDate : Date
  text : string
  value : number

  constructor(json :CreditBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.autoRenewType = decodeEnum(json.autoRenewType);
    this.creationDate = decodeDate(json.creationDate);
    this.creditStatus = decodeEnum(json.creditStatus);
    this.creditStatusDetail = decodeEnum(json.creditStatusDetail);
    this.creditType = decodeEnum(json.creditType);
    this.endDate = decodeDate(json.endDate);
    this.familyIds = decodeArray(decodeNumber)(json.familyIds);
    this.metaId = (json.metaId);
    this.paymentCancelDate = decodeDate(json.paymentCancelDate);
    this.paymentCancelReason = decodeNumber(json.paymentCancelReason);
    this.paymentCancelReasonSurvey = decodeNumber(json.paymentCancelReasonSurvey);
    this.paymentCancelReasonSurveyCustom = (json.paymentCancelReasonSurveyCustom);
    this.paymentDate = decodeDate(json.paymentDate);
    this.paymentKey = (json.paymentKey);
    this.paymentOriginalStatus = decodeNumber(json.paymentOriginalStatus);
    this.paymentReceipt = (json.paymentReceipt);
    this.paymentSKU = (json.paymentSKU);
    this.paymentStatus = decodeNumber(json.paymentStatus);
    this.paymentStatusActiveDate = decodeDate(json.paymentStatusActiveDate);
    this.paymentSubSKU = (json.paymentSubSKU);
    this.paymentType = decodeEnum(json.paymentType);
    this.paymentValue = (json.paymentValue);
    this.periodType = decodeEnum(json.periodType);
    this.startDate = decodeDate(json.startDate);
    this.text = (json.text);
    this.value = decodeNumber(json.value);

    this.onDecode(json);
  }
}

function decodeCreditBean(json :CreditBeanJSON){
  return json===undefined?undefined:new CreditBean(json)
}

function encodeCreditBean(obj : CreditBean) :CreditBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      autoRenewType : encodeEnum(obj.autoRenewType),
      creationDate : encodeDate(obj.creationDate),
      creditStatus : encodeEnum(obj.creditStatus),
      creditStatusDetail : encodeEnum(obj.creditStatusDetail),
      creditType : encodeEnum(obj.creditType),
      endDate : encodeDate(obj.endDate),
      familyIds : encodeArray(encodeNumber)(obj.familyIds),
      metaId : (obj.metaId),
      paymentCancelDate : encodeDate(obj.paymentCancelDate),
      paymentCancelReason : encodeNumber(obj.paymentCancelReason),
      paymentCancelReasonSurvey : encodeNumber(obj.paymentCancelReasonSurvey),
      paymentCancelReasonSurveyCustom : (obj.paymentCancelReasonSurveyCustom),
      paymentDate : encodeDate(obj.paymentDate),
      paymentKey : (obj.paymentKey),
      paymentOriginalStatus : encodeNumber(obj.paymentOriginalStatus),
      paymentReceipt : (obj.paymentReceipt),
      paymentSKU : (obj.paymentSKU),
      paymentStatus : encodeNumber(obj.paymentStatus),
      paymentStatusActiveDate : encodeDate(obj.paymentStatusActiveDate),
      paymentSubSKU : (obj.paymentSubSKU),
      paymentType : encodeEnum(obj.paymentType),
      paymentValue : (obj.paymentValue),
      periodType : encodeEnum(obj.periodType),
      startDate : encodeDate(obj.startDate),
      text : (obj.text),
      value : encodeNumber(obj.value),
    } as CreditBeanJSON)
}

type ItunesReceiptStatusBeanJSON = {
  trialDurations : {[key:string]:string}
  trialPossible : string
}

export class ItunesReceiptStatusBean extends ServerBeanPrototype{

  trialDurations : Map<string,number>
  trialPossible : boolean

  constructor(json :ItunesReceiptStatusBeanJSON){
    super(json);
    this.trialDurations = decodeMap(decodeString,decodeNumber)(json.trialDurations);
    this.trialPossible = decodeboolean(json.trialPossible);

    this.onDecode(json);
  }
}

function decodeItunesReceiptStatusBean(json :ItunesReceiptStatusBeanJSON){
  return json===undefined?undefined:new ItunesReceiptStatusBean(json)
}

function encodeItunesReceiptStatusBean(obj : ItunesReceiptStatusBean) :ItunesReceiptStatusBeanJSON {
    if(obj==null) return undefined
    return inline({
      trialDurations : encodeMap(encodeString,encodeNumber)(obj.trialDurations),
      trialPossible : encodeboolean(obj.trialPossible),
    } as ItunesReceiptStatusBeanJSON)
}

type PromoCodeBeanJSON = {
  creationDate : string
  expirationDate : string
  lastUsageDate : string | undefined 
  maxUsageNumber : string
  promoCodeCampaign : IPromoCodeCampaignJSON
  usageNumber : string
  value : string
}

export class PromoCodeBean extends ServerBeanPrototype{

  creationDate : Date
  expirationDate : Date
  lastUsageDate : Date
  maxUsageNumber : number
  promoCodeCampaign : IPromoCodeCampaign
  usageNumber : number
  value : string

  constructor(json :PromoCodeBeanJSON){
    super(json);
    this.creationDate = decodeDate(json.creationDate);
    this.expirationDate = decodeDate(json.expirationDate);
    this.lastUsageDate = decodeDate(json.lastUsageDate);
    this.maxUsageNumber = decodenumber(json.maxUsageNumber);
    this.promoCodeCampaign = decodeIPromoCodeCampaign(json.promoCodeCampaign);
    this.usageNumber = decodenumber(json.usageNumber);
    this.value = (json.value);

    this.onDecode(json);
  }
}

function decodePromoCodeBean(json :PromoCodeBeanJSON){
  return json===undefined?undefined:new PromoCodeBean(json)
}

function encodePromoCodeBean(obj : PromoCodeBean) :PromoCodeBeanJSON {
    if(obj==null) return undefined
    return inline({
      creationDate : undefined,
      expirationDate : encodeDate(obj.expirationDate),
      lastUsageDate : undefined,
      maxUsageNumber : encodenumber(obj.maxUsageNumber),
      promoCodeCampaign : encodeIPromoCodeCampaign(obj.promoCodeCampaign),
      usageNumber : undefined,
      value : (obj.value),
    } as PromoCodeBeanJSON)
}

type PromoCodeCampaignBeanJSON = {
  creationDate : string
  creditDurationInDays : string | undefined 
  creditType : string | undefined 
  name : string
}

export class PromoCodeCampaignBean extends ServerBeanPrototype{

  creationDate : Date
  creditDurationInDays : number
  creditType : string
  name : string

  constructor(json :PromoCodeCampaignBeanJSON){
    super(json);
    this.creationDate = decodeDate(json.creationDate);
    this.creditDurationInDays = decodeNumber(json.creditDurationInDays);
    this.creditType = decodeEnum(json.creditType);
    this.name = (json.name);

    this.onDecode(json);
  }
}

function decodePromoCodeCampaignBean(json :PromoCodeCampaignBeanJSON){
  return json===undefined?undefined:new PromoCodeCampaignBean(json)
}

function encodePromoCodeCampaignBean(obj : PromoCodeCampaignBean) :PromoCodeCampaignBeanJSON {
    if(obj==null) return undefined
    return inline({
      creationDate : undefined,
      creditDurationInDays : encodeNumber(obj.creditDurationInDays),
      creditType : encodeEnum(obj.creditType),
      name : (obj.name),
    } as PromoCodeCampaignBeanJSON)
}

type PromoPushBeanJSON = {
  accountId : string
  creationDate : string
  promoPushCampaign : IPromoPushCampaignJSON
  sendDate : string | undefined 
}

export class PromoPushBean extends ServerBeanPrototype{

  accountId : number
  creationDate : Date
  promoPushCampaign : IPromoPushCampaign
  sendDate : Date

  constructor(json :PromoPushBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.creationDate = decodeDate(json.creationDate);
    this.promoPushCampaign = decodeIPromoPushCampaign(json.promoPushCampaign);
    this.sendDate = decodeDate(json.sendDate);

    this.onDecode(json);
  }
}

function decodePromoPushBean(json :PromoPushBeanJSON){
  return json===undefined?undefined:new PromoPushBean(json)
}

function encodePromoPushBean(obj : PromoPushBean) :PromoPushBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      creationDate : encodeDate(obj.creationDate),
      promoPushCampaign : encodeIPromoPushCampaign(obj.promoPushCampaign),
      sendDate : encodeDate(obj.sendDate),
    } as PromoPushBeanJSON)
}

type PromoPushCampaignBeanJSON = {
  active : string | undefined 
  android : string | undefined 
  creationDate : string
  deeplinkClassId : string | undefined 
  deeplinkClickMaxCount : string | undefined 
  deeplinkPartnerType : string | undefined 
  deeplinkRecycle : string | undefined 
  deeplinkValidationTimeHour : string | undefined 
  deeplinkWebUrl : string | undefined 
  iOS : string | undefined 
  launchpadSection : string | undefined 
  name : string
  promoPartnerType : string | undefined 
  pushJson : FizJSONObject | undefined 
  pushPremiumFeatureHighlight : string | undefined 
  pushScreenTarget : string | undefined 
  trackingName : string | undefined 
  url : string | undefined 
}

export class PromoPushCampaignBean extends ServerBeanPrototype{

  active : boolean
  android : boolean
  creationDate : Date
  deeplinkClassId : string
  deeplinkClickMaxCount : number
  deeplinkPartnerType : string
  deeplinkRecycle : boolean
  deeplinkValidationTimeHour : number
  deeplinkWebUrl : string
  iOS : boolean
  launchpadSection : string
  name : string
  promoPartnerType : string
  pushJson : FizJSONObject
  pushPremiumFeatureHighlight : string
  pushScreenTarget : string
  trackingName : string
  url : string

  constructor(json :PromoPushCampaignBeanJSON){
    super(json);
    this.active = decodeBoolean(json.active);
    this.android = decodeBoolean(json.android);
    this.creationDate = decodeDate(json.creationDate);
    this.deeplinkClassId = (json.deeplinkClassId);
    this.deeplinkClickMaxCount = decodeNumber(json.deeplinkClickMaxCount);
    this.deeplinkPartnerType = decodeEnum(json.deeplinkPartnerType);
    this.deeplinkRecycle = decodeBoolean(json.deeplinkRecycle);
    this.deeplinkValidationTimeHour = decodeNumber(json.deeplinkValidationTimeHour);
    this.deeplinkWebUrl = (json.deeplinkWebUrl);
    this.iOS = decodeBoolean(json.iOS);
    this.launchpadSection = decodeEnum(json.launchpadSection);
    this.name = (json.name);
    this.promoPartnerType = decodeEnum(json.promoPartnerType);
    this.pushJson = decodeFizJSONObject(json.pushJson);
    this.pushPremiumFeatureHighlight = (json.pushPremiumFeatureHighlight);
    this.pushScreenTarget = decodeEnum(json.pushScreenTarget);
    this.trackingName = (json.trackingName);
    this.url = (json.url);

    this.onDecode(json);
  }
}

function decodePromoPushCampaignBean(json :PromoPushCampaignBeanJSON){
  return json===undefined?undefined:new PromoPushCampaignBean(json)
}

function encodePromoPushCampaignBean(obj : PromoPushCampaignBean) :PromoPushCampaignBeanJSON {
    if(obj==null) return undefined
    return inline({
      active : encodeBoolean(obj.active),
      android : encodeBoolean(obj.android),
      creationDate : undefined,
      deeplinkClassId : (obj.deeplinkClassId),
      deeplinkClickMaxCount : encodeNumber(obj.deeplinkClickMaxCount),
      deeplinkPartnerType : encodeEnum(obj.deeplinkPartnerType),
      deeplinkRecycle : encodeBoolean(obj.deeplinkRecycle),
      deeplinkValidationTimeHour : encodeNumber(obj.deeplinkValidationTimeHour),
      deeplinkWebUrl : (obj.deeplinkWebUrl),
      iOS : encodeBoolean(obj.iOS),
      launchpadSection : encodeEnum(obj.launchpadSection),
      name : (obj.name),
      promoPartnerType : encodeEnum(obj.promoPartnerType),
      pushJson : encodeFizJSONObject(obj.pushJson),
      pushPremiumFeatureHighlight : (obj.pushPremiumFeatureHighlight),
      pushScreenTarget : encodeEnum(obj.pushScreenTarget),
      trackingName : (obj.trackingName),
      url : (obj.url),
    } as PromoPushCampaignBeanJSON)
}

type PromoPushCampainDetailBeanJSON = {
  accountNb : string
  accountSentNb : string
  accountWithTokenNb : string
  active : string | undefined 
  android : string | undefined 
  creationDate : string
  deeplinkClassId : string | undefined 
  deeplinkClickMaxCount : string | undefined 
  deeplinkPartnerType : string | undefined 
  deeplinkRecycle : string | undefined 
  deeplinkValidationTimeHour : string | undefined 
  deeplinkWebUrl : string | undefined 
  iOS : string | undefined 
  launchpadSection : string | undefined 
  name : string
  promoPartnerType : string | undefined 
  pushJson : FizJSONObject | undefined 
  pushPremiumFeatureHighlight : string | undefined 
  pushScreenTarget : string | undefined 
  trackingName : string | undefined 
  url : string | undefined 
}

export class PromoPushCampainDetailBean extends ServerBeanPrototype{

  accountNb : number
  accountSentNb : number
  accountWithTokenNb : number
  active : boolean
  android : boolean
  creationDate : Date
  deeplinkClassId : string
  deeplinkClickMaxCount : number
  deeplinkPartnerType : string
  deeplinkRecycle : boolean
  deeplinkValidationTimeHour : number
  deeplinkWebUrl : string
  iOS : boolean
  launchpadSection : string
  name : string
  promoPartnerType : string
  pushJson : FizJSONObject
  pushPremiumFeatureHighlight : string
  pushScreenTarget : string
  trackingName : string
  url : string

  constructor(json :PromoPushCampainDetailBeanJSON){
    super(json);
    this.accountNb = decodenumber(json.accountNb);
    this.accountSentNb = decodenumber(json.accountSentNb);
    this.accountWithTokenNb = decodenumber(json.accountWithTokenNb);
    this.active = decodeBoolean(json.active);
    this.android = decodeBoolean(json.android);
    this.creationDate = decodeDate(json.creationDate);
    this.deeplinkClassId = (json.deeplinkClassId);
    this.deeplinkClickMaxCount = decodeNumber(json.deeplinkClickMaxCount);
    this.deeplinkPartnerType = decodeEnum(json.deeplinkPartnerType);
    this.deeplinkRecycle = decodeBoolean(json.deeplinkRecycle);
    this.deeplinkValidationTimeHour = decodeNumber(json.deeplinkValidationTimeHour);
    this.deeplinkWebUrl = (json.deeplinkWebUrl);
    this.iOS = decodeBoolean(json.iOS);
    this.launchpadSection = decodeEnum(json.launchpadSection);
    this.name = (json.name);
    this.promoPartnerType = decodeEnum(json.promoPartnerType);
    this.pushJson = decodeFizJSONObject(json.pushJson);
    this.pushPremiumFeatureHighlight = (json.pushPremiumFeatureHighlight);
    this.pushScreenTarget = decodeEnum(json.pushScreenTarget);
    this.trackingName = (json.trackingName);
    this.url = (json.url);

    this.onDecode(json);
  }
}

function decodePromoPushCampainDetailBean(json :PromoPushCampainDetailBeanJSON){
  return json===undefined?undefined:new PromoPushCampainDetailBean(json)
}

function encodePromoPushCampainDetailBean(obj : PromoPushCampainDetailBean) :PromoPushCampainDetailBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountNb : encodenumber(obj.accountNb),
      accountSentNb : encodenumber(obj.accountSentNb),
      accountWithTokenNb : encodenumber(obj.accountWithTokenNb),
      active : encodeBoolean(obj.active),
      android : encodeBoolean(obj.android),
      creationDate : undefined,
      deeplinkClassId : (obj.deeplinkClassId),
      deeplinkClickMaxCount : encodeNumber(obj.deeplinkClickMaxCount),
      deeplinkPartnerType : encodeEnum(obj.deeplinkPartnerType),
      deeplinkRecycle : encodeBoolean(obj.deeplinkRecycle),
      deeplinkValidationTimeHour : encodeNumber(obj.deeplinkValidationTimeHour),
      deeplinkWebUrl : (obj.deeplinkWebUrl),
      iOS : encodeBoolean(obj.iOS),
      launchpadSection : encodeEnum(obj.launchpadSection),
      name : (obj.name),
      promoPartnerType : encodeEnum(obj.promoPartnerType),
      pushJson : encodeFizJSONObject(obj.pushJson),
      pushPremiumFeatureHighlight : (obj.pushPremiumFeatureHighlight),
      pushScreenTarget : encodeEnum(obj.pushScreenTarget),
      trackingName : (obj.trackingName),
      url : (obj.url),
    } as PromoPushCampainDetailBeanJSON)
}

type SubscriptionTicketBeanJSON = {
  accountState : AccountStateBeanJSON
  receiptValid : string
}

export class SubscriptionTicketBean extends ServerBeanPrototype{

  accountState : AccountStateBean
  receiptValid : boolean

  constructor(json :SubscriptionTicketBeanJSON){
    super(json);
    this.accountState = decodeAccountStateBean(json.accountState);
    this.receiptValid = decodeboolean(json.receiptValid);

    this.onDecode(json);
  }
}

function decodeSubscriptionTicketBean(json :SubscriptionTicketBeanJSON){
  return json===undefined?undefined:new SubscriptionTicketBean(json)
}

function encodeSubscriptionTicketBean(obj : SubscriptionTicketBean) :SubscriptionTicketBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountState : encodeAccountStateBean(obj.accountState),
      receiptValid : encodeboolean(obj.receiptValid),
    } as SubscriptionTicketBeanJSON)
}

type TwoCheckoutPriceBeanJSON = {
  buyUrl : string
  currency : string
  priceFloat : string
  trialDays : string
}

export class TwoCheckoutPriceBean extends ServerBeanPrototype{

  buyUrl : string
  currency : string
  priceFloat : number
  trialDays : number

  constructor(json :TwoCheckoutPriceBeanJSON){
    super(json);
    this.buyUrl = (json.buyUrl);
    this.currency = (json.currency);
    this.priceFloat = decodenumber(json.priceFloat);
    this.trialDays = decodenumber(json.trialDays);

    this.onDecode(json);
  }
}

function decodeTwoCheckoutPriceBean(json :TwoCheckoutPriceBeanJSON){
  return json===undefined?undefined:new TwoCheckoutPriceBean(json)
}

function encodeTwoCheckoutPriceBean(obj : TwoCheckoutPriceBean) :TwoCheckoutPriceBeanJSON {
    if(obj==null) return undefined
    return inline({
      buyUrl : (obj.buyUrl),
      currency : (obj.currency),
      priceFloat : encodenumber(obj.priceFloat),
      trialDays : encodenumber(obj.trialDays),
    } as TwoCheckoutPriceBeanJSON)
}

type TwoCheckoutPricePromoBeanJSON = {
  buyUrl : string
  currency : string
  endDate : string | undefined 
  percent : string
  priceFloat : string
  trialDays : string
}

export class TwoCheckoutPricePromoBean extends ServerBeanPrototype{

  buyUrl : string
  currency : string
  endDate : Date
  percent : number
  priceFloat : number
  trialDays : number

  constructor(json :TwoCheckoutPricePromoBeanJSON){
    super(json);
    this.buyUrl = (json.buyUrl);
    this.currency = (json.currency);
    this.endDate = decodeDate(json.endDate);
    this.percent = decodenumber(json.percent);
    this.priceFloat = decodenumber(json.priceFloat);
    this.trialDays = decodenumber(json.trialDays);

    this.onDecode(json);
  }
}

function decodeTwoCheckoutPricePromoBean(json :TwoCheckoutPricePromoBeanJSON){
  return json===undefined?undefined:new TwoCheckoutPricePromoBean(json)
}

function encodeTwoCheckoutPricePromoBean(obj : TwoCheckoutPricePromoBean) :TwoCheckoutPricePromoBeanJSON {
    if(obj==null) return undefined
    return inline({
      buyUrl : (obj.buyUrl),
      currency : (obj.currency),
      endDate : encodeDate(obj.endDate),
      percent : encodenumber(obj.percent),
      priceFloat : encodenumber(obj.priceFloat),
      trialDays : encodenumber(obj.trialDays),
    } as TwoCheckoutPricePromoBeanJSON)
}

type TwoCheckoutUrlsBean2JSON = {
  monthly : TwoCheckoutPriceBeanJSON
  monthlyPromo : TwoCheckoutPricePromoBeanJSON | undefined 
  yearly : TwoCheckoutPriceBeanJSON
  yearlyPromo : TwoCheckoutPricePromoBeanJSON | undefined 
}

export class TwoCheckoutUrlsBean2 extends ServerBeanPrototype{

  monthly : TwoCheckoutPriceBean
  monthlyPromo : TwoCheckoutPricePromoBean
  yearly : TwoCheckoutPriceBean
  yearlyPromo : TwoCheckoutPricePromoBean

  constructor(json :TwoCheckoutUrlsBean2JSON){
    super(json);
    this.monthly = decodeTwoCheckoutPriceBean(json.monthly);
    this.monthlyPromo = decodeTwoCheckoutPricePromoBean(json.monthlyPromo);
    this.yearly = decodeTwoCheckoutPriceBean(json.yearly);
    this.yearlyPromo = decodeTwoCheckoutPricePromoBean(json.yearlyPromo);

    this.onDecode(json);
  }
}

function decodeTwoCheckoutUrlsBean2(json :TwoCheckoutUrlsBean2JSON){
  return json===undefined?undefined:new TwoCheckoutUrlsBean2(json)
}

function encodeTwoCheckoutUrlsBean2(obj : TwoCheckoutUrlsBean2) :TwoCheckoutUrlsBean2JSON {
    if(obj==null) return undefined
    return inline({
      monthly : encodeTwoCheckoutPriceBean(obj.monthly),
      monthlyPromo : encodeTwoCheckoutPricePromoBean(obj.monthlyPromo),
      yearly : encodeTwoCheckoutPriceBean(obj.yearly),
      yearlyPromo : encodeTwoCheckoutPricePromoBean(obj.yearlyPromo),
    } as TwoCheckoutUrlsBean2JSON)
}

type BudgetBeanJSON = {
  accountId : string | undefined 
  budgetCategoryLimits : {[key:string]:string} | undefined 
  budgetLimit : string | undefined 
  budgetLimitActive : string | undefined 
  budgetLimitCategoryActive : string | undefined 
  currencyCode : string | undefined 
  emoji : string | undefined 
  familyId : string
  mainKPI : string | undefined 
  metaId : string
  name : string | undefined 
  paidUsage : string | undefined 
  recurrencyStartDay : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sharedMemberIds : Array<string> | undefined 
  sharedToAll : string | undefined 
} & RecurrencyDescriptorJSON

export class BudgetBean extends ServerBeanPrototype{

  accountId : number
  budgetCategoryLimits : Map<string,number>
  budgetLimit : number
  budgetLimitActive : boolean
  budgetLimitCategoryActive : boolean
  currencyCode : string
  emoji : string
  familyId : number
  mainKPI : string
  metaId : string
  name : string
  paidUsage : string
  recurrencyDescriptor : RecurrencyDescriptor
  recurrencyStartDay : number
  rights : FizRightBean
  sharedMemberIds : Array<number>
  sharedToAll : boolean

  constructor(json :BudgetBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.budgetCategoryLimits = decodeMap(decodeString,decodeNumber)(json.budgetCategoryLimits);
    this.budgetLimit = decodeNumber(json.budgetLimit);
    this.budgetLimitActive = decodeBoolean(json.budgetLimitActive);
    this.budgetLimitCategoryActive = decodeBoolean(json.budgetLimitCategoryActive);
    this.currencyCode = (json.currencyCode);
    this.emoji = (json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.mainKPI = decodeEnum(json.mainKPI);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.paidUsage = decodeEnum(json.paidUsage);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.recurrencyStartDay = decodeNumber(json.recurrencyStartDay);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);

    this.onDecode(json);
  }
}

function decodeBudgetBean(json :BudgetBeanJSON){
  return json===undefined?undefined:new BudgetBean(json)
}

function encodeBudgetBean(obj : BudgetBean) :BudgetBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      budgetCategoryLimits : encodeMap(encodeString,encodeNumber)(obj.budgetCategoryLimits),
      budgetLimit : encodeNumber(obj.budgetLimit),
      budgetLimitActive : encodeBoolean(obj.budgetLimitActive),
      budgetLimitCategoryActive : encodeBoolean(obj.budgetLimitCategoryActive),
      currencyCode : (obj.currencyCode),
      emoji : (obj.emoji),
      familyId : encodeNumber(obj.familyId),
      mainKPI : encodeEnum(obj.mainKPI),
      metaId : (obj.metaId),
      name : (obj.name),
      paidUsage : encodeEnum(obj.paidUsage),
      recurrencyStartDay : encodeNumber(obj.recurrencyStartDay),
      rights : undefined,
      sharedMemberIds : encodeArray(encodeNumber)(obj.sharedMemberIds),
      sharedToAll : encodeBoolean(obj.sharedToAll),
    } as BudgetBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor))
}

type BudgetCategoryBeanJSON = {
  accountId : string | undefined 
  budgetTransactionType : string | undefined 
  default : string | undefined 
  emoji : string | undefined 
  familyId : string
  hidden : string | undefined 
  locale : string | undefined 
  metaId : string
  name : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sortingIndex : string | undefined 
  systemCategoryId : string | undefined 
}

export class BudgetCategoryBean extends ServerBeanPrototype{

  accountId : number
  budgetTransactionType : string
  default : boolean
  emoji : string
  familyId : number
  hidden : boolean
  locale : string
  metaId : string
  name : string
  rights : FizRightBean
  sortingIndex : number
  systemCategoryId : number

  constructor(json :BudgetCategoryBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.budgetTransactionType = decodeEnum(json.budgetTransactionType);
    this.default = decodeBoolean(json.default);
    this.emoji = (json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.hidden = decodeBoolean(json.hidden);
    this.locale = (json.locale);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.systemCategoryId = decodeNumber(json.systemCategoryId);

    this.onDecode(json);
  }
}

function decodeBudgetCategoryBean(json :BudgetCategoryBeanJSON){
  return json===undefined?undefined:new BudgetCategoryBean(json)
}

function encodeBudgetCategoryBean(obj : BudgetCategoryBean) :BudgetCategoryBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      budgetTransactionType : encodeEnum(obj.budgetTransactionType),
      default : undefined,
      emoji : (obj.emoji),
      familyId : encodeNumber(obj.familyId),
      hidden : encodeBoolean(obj.hidden),
      locale : (obj.locale),
      metaId : (obj.metaId),
      name : (obj.name),
      rights : undefined,
      sortingIndex : encodeNumber(obj.sortingIndex),
      systemCategoryId : undefined,
    } as BudgetCategoryBeanJSON)
}

type BudgetCategoryInputBeanJSON = {
  budgetTransactionType : string | undefined 
  emoji : string | undefined 
  hidden : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
}

export class BudgetCategoryInputBean extends ServerBeanPrototype{

  budgetTransactionType : string
  emoji : string
  hidden : boolean
  metaId : string
  name : string

  constructor(json :BudgetCategoryInputBeanJSON){
    super(json);
    this.budgetTransactionType = decodeEnum(json.budgetTransactionType);
    this.emoji = (json.emoji);
    this.hidden = decodeBoolean(json.hidden);
    this.metaId = (json.metaId);
    this.name = (json.name);

    this.onDecode(json);
  }
}

function decodeBudgetCategoryInputBean(json :BudgetCategoryInputBeanJSON){
  return json===undefined?undefined:new BudgetCategoryInputBean(json)
}

function encodeBudgetCategoryInputBean(obj : BudgetCategoryInputBean) :BudgetCategoryInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      budgetTransactionType : encodeEnum(obj.budgetTransactionType),
      emoji : (obj.emoji),
      hidden : encodeBoolean(obj.hidden),
      metaId : (obj.metaId),
      name : (obj.name),
    } as BudgetCategoryInputBeanJSON)
}

type BudgetCategorySyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<BudgetCategoryBeanJSON>
}

export class BudgetCategorySyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<BudgetCategoryBean>

  constructor(json :BudgetCategorySyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeBudgetCategoryBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeBudgetCategorySyncBean(json :BudgetCategorySyncBeanJSON){
  return json===undefined?undefined:new BudgetCategorySyncBean(json)
}

function encodeBudgetCategorySyncBean(obj : BudgetCategorySyncBean) :BudgetCategorySyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeBudgetCategoryBean)(obj.updatedCreated),
    } as BudgetCategorySyncBeanJSON)
}

type BudgetInputBeanJSON = {
  budgetCategoryLimits : {[key:string]:string} | undefined 
  budgetLimit : string | undefined 
  budgetLimitActive : string | undefined 
  budgetLimitCategoryActive : string | undefined 
  currencyCode : string | undefined 
  emoji : string | undefined 
  mainKPI : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
  paidUsage : string | undefined 
  recurrencyStartDay : string | undefined 
  sharedMemberIds : Array<string> | undefined 
  sharedToAll : string | undefined 
} & RecurrencyDescriptorJSON

export class BudgetInputBean extends ServerBeanPrototype{

  budgetCategoryLimits : Map<string,number>
  budgetLimit : number
  budgetLimitActive : boolean
  budgetLimitCategoryActive : boolean
  currencyCode : string
  emoji : string
  mainKPI : string
  metaId : string
  name : string
  paidUsage : string
  recurrencyDescriptor : RecurrencyDescriptor
  recurrencyStartDay : number
  sharedMemberIds : Array<number>
  sharedToAll : boolean

  constructor(json :BudgetInputBeanJSON){
    super(json);
    this.budgetCategoryLimits = decodeMap(decodeString,decodeNumber)(json.budgetCategoryLimits);
    this.budgetLimit = decodeNumber(json.budgetLimit);
    this.budgetLimitActive = decodeBoolean(json.budgetLimitActive);
    this.budgetLimitCategoryActive = decodeBoolean(json.budgetLimitCategoryActive);
    this.currencyCode = (json.currencyCode);
    this.emoji = (json.emoji);
    this.mainKPI = decodeEnum(json.mainKPI);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.paidUsage = decodeEnum(json.paidUsage);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.recurrencyStartDay = decodeNumber(json.recurrencyStartDay);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);

    this.onDecode(json);
  }
}

function decodeBudgetInputBean(json :BudgetInputBeanJSON){
  return json===undefined?undefined:new BudgetInputBean(json)
}

function encodeBudgetInputBean(obj : BudgetInputBean) :BudgetInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      budgetCategoryLimits : encodeMap(encodeString,encodeNumber)(obj.budgetCategoryLimits),
      budgetLimit : encodeNumber(obj.budgetLimit),
      budgetLimitActive : encodeBoolean(obj.budgetLimitActive),
      budgetLimitCategoryActive : encodeBoolean(obj.budgetLimitCategoryActive),
      currencyCode : (obj.currencyCode),
      emoji : (obj.emoji),
      mainKPI : encodeEnum(obj.mainKPI),
      metaId : (obj.metaId),
      name : (obj.name),
      paidUsage : encodeEnum(obj.paidUsage),
      recurrencyStartDay : encodeNumber(obj.recurrencyStartDay),
      sharedMemberIds : encodeArray(encodeNumber)(obj.sharedMemberIds),
      sharedToAll : encodeBoolean(obj.sharedToAll),
    } as BudgetInputBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor))
}

type BudgetSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<BudgetBeanJSON>
}

export class BudgetSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<BudgetBean>

  constructor(json :BudgetSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeBudgetBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeBudgetSyncBean(json :BudgetSyncBeanJSON){
  return json===undefined?undefined:new BudgetSyncBean(json)
}

function encodeBudgetSyncBean(obj : BudgetSyncBean) :BudgetSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeBudgetBean)(obj.updatedCreated),
    } as BudgetSyncBeanJSON)
}

type BudgetTransactionBeanJSON = {
  accountId : string | undefined 
  amount : string | undefined 
  budgetCategoryId : string | undefined 
  budgetId : string | undefined 
  budgetTransactionType : string | undefined 
  familyId : string
  lastAction : string | undefined 
  lastActionAuthor : string | undefined 
  lastActionDate : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string
  note : string | undefined 
  paidOccurence : Array<string> | undefined 
  paymentMethodId : string | undefined 
  recurrencyExceptionOfId : string | undefined 
  relatedAccountId : string | undefined 
  reminderList : Array<IReminderJSON> | undefined 
  rights : FizRightBeanJSON | undefined 
  startDate : string | undefined 
  title : string | undefined 
} & RecurrencyDescriptorJSON

export class BudgetTransactionBean extends ServerBeanPrototype{

  accountId : number
  amount : number
  budgetCategoryId : string
  budgetId : string
  budgetTransactionType : string
  familyId : number
  lastAction : string
  lastActionAuthor : number
  lastActionDate : Date
  medias : Array<IMedia>
  metaId : string
  note : string
  paidOccurence : Array<number>
  paymentMethodId : string
  recurrencyDescriptor : RecurrencyDescriptor
  recurrencyExceptionOfId : string
  relatedAccountId : number
  reminderList : Array<IReminder>
  rights : FizRightBean
  startDate : Date
  title : string

  constructor(json :BudgetTransactionBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.amount = decodeNumber(json.amount);
    this.budgetCategoryId = (json.budgetCategoryId);
    this.budgetId = (json.budgetId);
    this.budgetTransactionType = decodeEnum(json.budgetTransactionType);
    this.familyId = decodeNumber(json.familyId);
    this.lastAction = decodeEnum(json.lastAction);
    this.lastActionAuthor = decodeNumber(json.lastActionAuthor);
    this.lastActionDate = decodeDate(json.lastActionDate);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.note = (json.note);
    this.paidOccurence = decodeArray(decodeNumber)(json.paidOccurence);
    this.paymentMethodId = (json.paymentMethodId);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.recurrencyExceptionOfId = (json.recurrencyExceptionOfId);
    this.relatedAccountId = decodeNumber(json.relatedAccountId);
    this.reminderList = decodeArray(decodeIReminder)(json.reminderList);
    this.rights = decodeFizRightBean(json.rights);
    this.startDate = decodeDate(json.startDate);
    this.title = (json.title);

    this.onDecode(json);
  }
}

function decodeBudgetTransactionBean(json :BudgetTransactionBeanJSON){
  return json===undefined?undefined:new BudgetTransactionBean(json)
}

function encodeBudgetTransactionBean(obj : BudgetTransactionBean) :BudgetTransactionBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      amount : encodeNumber(obj.amount),
      budgetCategoryId : (obj.budgetCategoryId),
      budgetId : (obj.budgetId),
      budgetTransactionType : encodeEnum(obj.budgetTransactionType),
      familyId : encodeNumber(obj.familyId),
      lastAction : undefined,
      lastActionAuthor : undefined,
      lastActionDate : undefined,
      medias : undefined,
      metaId : (obj.metaId),
      note : (obj.note),
      paidOccurence : encodeArray(encodeNumber)(obj.paidOccurence),
      paymentMethodId : (obj.paymentMethodId),
      recurrencyExceptionOfId : undefined,
      relatedAccountId : encodeNumber(obj.relatedAccountId),
      reminderList : encodeArray(encodeIReminder)(obj.reminderList),
      rights : undefined,
      startDate : encodeDate(obj.startDate),
      title : (obj.title),
    } as BudgetTransactionBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor))
}

type BudgetTransactionInputBeanJSON = {
  amount : string | undefined 
  budgetCategoryId : string | undefined 
  budgetId : string | undefined 
  budgetTransactionType : string | undefined 
  metaId : string | undefined 
  note : string | undefined 
  paidOccurence : Array<string> | undefined 
  paymentMethodId : string | undefined 
  recurrencyExceptionOfId : string | undefined 
  relatedAccountId : string | undefined 
  reminderList : Array<IReminderJSON> | undefined 
  startDate : string | undefined 
  title : string | undefined 
} & RecurrencyDescriptorJSON

export class BudgetTransactionInputBean extends ServerBeanPrototype{

  amount : number
  budgetCategoryId : string
  budgetId : string
  budgetTransactionType : string
  metaId : string
  note : string
  paidOccurence : Array<number>
  paymentMethodId : string
  recurrencyDescriptor : RecurrencyDescriptor
  recurrencyExceptionOfId : string
  relatedAccountId : number
  reminderList : Array<IReminder>
  startDate : Date
  title : string

  constructor(json :BudgetTransactionInputBeanJSON){
    super(json);
    this.amount = decodeNumber(json.amount);
    this.budgetCategoryId = (json.budgetCategoryId);
    this.budgetId = (json.budgetId);
    this.budgetTransactionType = decodeEnum(json.budgetTransactionType);
    this.metaId = (json.metaId);
    this.note = (json.note);
    this.paidOccurence = decodeArray(decodeNumber)(json.paidOccurence);
    this.paymentMethodId = (json.paymentMethodId);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.recurrencyExceptionOfId = (json.recurrencyExceptionOfId);
    this.relatedAccountId = decodeNumber(json.relatedAccountId);
    this.reminderList = decodeArray(decodeIReminder)(json.reminderList);
    this.startDate = decodeDate(json.startDate);
    this.title = (json.title);

    this.onDecode(json);
  }
}

function decodeBudgetTransactionInputBean(json :BudgetTransactionInputBeanJSON){
  return json===undefined?undefined:new BudgetTransactionInputBean(json)
}

function encodeBudgetTransactionInputBean(obj : BudgetTransactionInputBean) :BudgetTransactionInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      amount : encodeNumber(obj.amount),
      budgetCategoryId : (obj.budgetCategoryId),
      budgetId : (obj.budgetId),
      budgetTransactionType : encodeEnum(obj.budgetTransactionType),
      metaId : (obj.metaId),
      note : (obj.note),
      paidOccurence : encodeArray(encodeNumber)(obj.paidOccurence),
      paymentMethodId : (obj.paymentMethodId),
      recurrencyExceptionOfId : undefined,
      relatedAccountId : encodeNumber(obj.relatedAccountId),
      reminderList : encodeArray(encodeIReminder)(obj.reminderList),
      startDate : encodeDate(obj.startDate),
      title : (obj.title),
    } as BudgetTransactionInputBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor))
}

type BudgetTransactionSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<BudgetTransactionBeanJSON>
}

export class BudgetTransactionSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<BudgetTransactionBean>

  constructor(json :BudgetTransactionSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeBudgetTransactionBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeBudgetTransactionSyncBean(json :BudgetTransactionSyncBeanJSON){
  return json===undefined?undefined:new BudgetTransactionSyncBean(json)
}

function encodeBudgetTransactionSyncBean(obj : BudgetTransactionSyncBean) :BudgetTransactionSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeBudgetTransactionBean)(obj.updatedCreated),
    } as BudgetTransactionSyncBeanJSON)
}

type PaymentMethodBeanJSON = {
  accountId : string | undefined 
  default : string | undefined 
  emoji : string | undefined 
  familyId : string
  hidden : string | undefined 
  locale : string | undefined 
  metaId : string
  name : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sortingIndex : string | undefined 
  systemCategoryId : string | undefined 
}

export class PaymentMethodBean extends ServerBeanPrototype{

  accountId : number
  default : boolean
  emoji : string
  familyId : number
  hidden : boolean
  locale : string
  metaId : string
  name : string
  rights : FizRightBean
  sortingIndex : number
  systemCategoryId : number

  constructor(json :PaymentMethodBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.default = decodeBoolean(json.default);
    this.emoji = (json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.hidden = decodeBoolean(json.hidden);
    this.locale = (json.locale);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.systemCategoryId = decodeNumber(json.systemCategoryId);

    this.onDecode(json);
  }
}

function decodePaymentMethodBean(json :PaymentMethodBeanJSON){
  return json===undefined?undefined:new PaymentMethodBean(json)
}

function encodePaymentMethodBean(obj : PaymentMethodBean) :PaymentMethodBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      default : undefined,
      emoji : (obj.emoji),
      familyId : encodeNumber(obj.familyId),
      hidden : encodeBoolean(obj.hidden),
      locale : (obj.locale),
      metaId : (obj.metaId),
      name : (obj.name),
      rights : undefined,
      sortingIndex : encodeNumber(obj.sortingIndex),
      systemCategoryId : undefined,
    } as PaymentMethodBeanJSON)
}

type PaymentMethodInputBeanJSON = {
  emoji : string | undefined 
  hidden : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
}

export class PaymentMethodInputBean extends ServerBeanPrototype{

  emoji : string
  hidden : boolean
  metaId : string
  name : string

  constructor(json :PaymentMethodInputBeanJSON){
    super(json);
    this.emoji = (json.emoji);
    this.hidden = decodeBoolean(json.hidden);
    this.metaId = (json.metaId);
    this.name = (json.name);

    this.onDecode(json);
  }
}

function decodePaymentMethodInputBean(json :PaymentMethodInputBeanJSON){
  return json===undefined?undefined:new PaymentMethodInputBean(json)
}

function encodePaymentMethodInputBean(obj : PaymentMethodInputBean) :PaymentMethodInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      emoji : (obj.emoji),
      hidden : encodeBoolean(obj.hidden),
      metaId : (obj.metaId),
      name : (obj.name),
    } as PaymentMethodInputBeanJSON)
}

type PaymentMethodSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<PaymentMethodBeanJSON>
}

export class PaymentMethodSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<PaymentMethodBean>

  constructor(json :PaymentMethodSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodePaymentMethodBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodePaymentMethodSyncBean(json :PaymentMethodSyncBeanJSON){
  return json===undefined?undefined:new PaymentMethodSyncBean(json)
}

function encodePaymentMethodSyncBean(obj : PaymentMethodSyncBean) :PaymentMethodSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodePaymentMethodBean)(obj.updatedCreated),
    } as PaymentMethodSyncBeanJSON)
}

type CommentBeanJSON = {
  accountId : string
  bestMoment : string | undefined 
  commentId : string
  creationDate : string
  metaId : string | undefined 
  mood : string | undefined 
  moodMap : {[key:string]:Array<string>} | undefined 
  moodStarShortcut : string | undefined 
  rights : FizRightBeanJSON | undefined 
  text : string
  updatedDate : string | undefined 
}

export class CommentBean extends ServerBeanPrototype{

  accountId : number
  bestMoment : boolean
  commentId : string
  creationDate : Date
  metaId : string
  mood : string
  moodMap : Map<number,Array<string>>
  moodStarShortcut : boolean
  rights : FizRightBean
  text : string
  updatedDate : Date

  constructor(json :CommentBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.commentId = (json.commentId);
    this.creationDate = decodeDate(json.creationDate);
    this.metaId = (json.metaId);
    this.mood = decodeEnum(json.mood);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.rights = decodeFizRightBean(json.rights);
    this.text = (json.text);
    this.updatedDate = decodeDate(json.updatedDate);

    this.onDecode(json);
  }
}

function decodeCommentBean(json :CommentBeanJSON){
  return json===undefined?undefined:new CommentBean(json)
}

function encodeCommentBean(obj : CommentBean) :CommentBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      bestMoment : undefined,
      commentId : (obj.commentId),
      creationDate : encodeDate(obj.creationDate),
      metaId : (obj.metaId),
      mood : encodeEnum(obj.mood),
      moodMap : undefined,
      moodStarShortcut : undefined,
      rights : encodeFizRightBean(obj.rights),
      text : (obj.text),
      updatedDate : encodeDate(obj.updatedDate),
    } as CommentBeanJSON)
}

type CommentResultBeanJSON<IWallMessageJSON> = {
  comment : ICommentJSON
  object : IHasMetaIdJSON
}

export class CommentResultBean<IWallMessage> extends ServerBeanPrototype{

  comment : IComment
  object : IHasMetaId

  constructor(json :CommentResultBeanJSON<any> ,decodeIWallMessage : objectDecoder<any,IWallMessage>){
    super(json);
    this.comment = decodeIComment(json.comment);
    this.object = decodeDynamic(json.object) as IHasMetaId;

    this.onDecode(json);
  }
}

//this code need to be reviewed
function decodeCommentResultBean<JSON,BEAN>(decodeIWallMessage :objectDecoder<JSON,BEAN>){
  return function(json :CommentResultBeanJSON<JSON>){
    return json===undefined?undefined:new CommentResultBean<BEAN>(json,decodeIWallMessage)
  }
}

function encodeCommentResultBean<IWallMessage>(encodeIWallMessage : objectEncoder<IWallMessage>){
  return function(obj :CommentResultBean<IWallMessage>){
    if(obj==null) return undefined
    return inline({
      comment : encodeIComment(obj.comment),
      object : encodeDynamic(obj.object),
    } as CommentResultBeanJSON<IWallMessageJSON>)
  }
}

type FizRightBeanJSON = {
  canDelete : string | undefined 
  canUpdate : string | undefined 
}

export class FizRightBean extends ServerBeanPrototype{

  canDelete : boolean
  canUpdate : boolean

  constructor(json :FizRightBeanJSON){
    super(json);
    this.canDelete = decodeBoolean(json.canDelete);
    this.canUpdate = decodeBoolean(json.canUpdate);

    this.onDecode(json);
  }
}

function decodeFizRightBean(json :FizRightBeanJSON){
  return json===undefined?undefined:new FizRightBean(json)
}

function encodeFizRightBean(obj : FizRightBean) :FizRightBeanJSON {
    if(obj==null) return undefined
    return inline({
      canDelete : encodeBoolean(obj.canDelete),
      canUpdate : encodeBoolean(obj.canUpdate),
    } as FizRightBeanJSON)
}

type PaginatedCollectionJSON<IApiKeyJSON> = {
  count : string | undefined 
  datas : Array<IApiKeyJSON>
  nextPageId : string | undefined 
  remain : string | undefined 
  size : string
  start : string
}

export class PaginatedCollection<IApiKey> extends ServerBeanPrototype{

  count : number
  datas : Array<IApiKey>
  nextPageId : string
  remain : number
  size : number
  start : number

  constructor(json :PaginatedCollectionJSON<any> ,decodeIApiKey : objectDecoder<any,IApiKey>){
    super(json);
    this.count = decodeNumber(json.count);
    this.datas = decodeArray(decodeIApiKey)(json.datas);
    this.nextPageId = (json.nextPageId);
    this.remain = decodeNumber(json.remain);
    this.size = decodeNumber(json.size);
    this.start = decodeNumber(json.start);

    this.onDecode(json);
  }
}

//this code need to be reviewed
function decodePaginatedCollection<JSON,BEAN>(decodeIApiKey :objectDecoder<JSON,BEAN>){
  return function(json :PaginatedCollectionJSON<JSON>){
    return json===undefined?undefined:new PaginatedCollection<BEAN>(json,decodeIApiKey)
  }
}

function encodePaginatedCollection<IApiKey>(encodeIApiKey : objectEncoder<IApiKey>){
  return function(obj :PaginatedCollection<IApiKey>){
    if(obj==null) return undefined
    return inline({
      count : encodeNumber(obj.count),
      datas : encodeArray(encodeIApiKey)(obj.datas),
      nextPageId : (obj.nextPageId),
      remain : encodeNumber(obj.remain),
      size : encodeNumber(obj.size),
      start : encodeNumber(obj.start),
    } as PaginatedCollectionJSON<IApiKeyJSON>)
  }
}

type PaginationRequestJSON = {
  count : string | undefined 
  itemId : string | undefined 
}

export class PaginationRequest extends ServerBeanPrototype{

  count : number
  itemId : string

  constructor(json :PaginationRequestJSON){
    super(json);
    this.count = decodeNumber(json.count);
    this.itemId = (json.itemId);

    this.onDecode(json);
  }
}

function decodePaginationRequest(json :PaginationRequestJSON){
  return json===undefined?undefined:new PaginationRequest(json)
}

function encodePaginationRequest(obj : PaginationRequest) :PaginationRequestJSON {
    if(obj==null) return undefined
    return inline({
      count : encodeNumber(obj.count),
      itemId : (obj.itemId),
    } as PaginationRequestJSON)
}

type SimplePaginatedCollectionJSON<IPromoCodeJSON> = {
  count : string | undefined 
  datas : Array<IPromoCodeJSON>
  nextPageId : string | undefined 
  size : string | undefined 
  start : string | undefined 
}

export class SimplePaginatedCollection<IPromoCode> extends ServerBeanPrototype{

  count : number
  datas : Array<IPromoCode>
  nextPageId : string
  size : number
  start : number

  constructor(json :SimplePaginatedCollectionJSON<any> ,decodeIPromoCode : objectDecoder<any,IPromoCode>){
    super(json);
    this.count = decodeNumber(json.count);
    this.datas = decodeArray(decodeIPromoCode)(json.datas);
    this.nextPageId = (json.nextPageId);
    this.size = decodeNumber(json.size);
    this.start = decodeNumber(json.start);

    this.onDecode(json);
  }
}

//this code need to be reviewed
function decodeSimplePaginatedCollection<JSON,BEAN>(decodeIPromoCode :objectDecoder<JSON,BEAN>){
  return function(json :SimplePaginatedCollectionJSON<JSON>){
    return json===undefined?undefined:new SimplePaginatedCollection<BEAN>(json,decodeIPromoCode)
  }
}

function encodeSimplePaginatedCollection<IPromoCode>(encodeIPromoCode : objectEncoder<IPromoCode>){
  return function(obj :SimplePaginatedCollection<IPromoCode>){
    if(obj==null) return undefined
    return inline({
      count : encodeNumber(obj.count),
      datas : encodeArray(encodeIPromoCode)(obj.datas),
      nextPageId : (obj.nextPageId),
      size : encodeNumber(obj.size),
      start : encodeNumber(obj.start),
    } as SimplePaginatedCollectionJSON<IPromoCodeJSON>)
  }
}

type SimplePaginationRequestJSON = {
  count : string | undefined 
  pageId : string | undefined 
}

export class SimplePaginationRequest extends ServerBeanPrototype{

  count : number
  pageId : string

  constructor(json :SimplePaginationRequestJSON){
    super(json);
    this.count = decodeNumber(json.count);
    this.pageId = (json.pageId);

    this.onDecode(json);
  }
}

function decodeSimplePaginationRequest(json :SimplePaginationRequestJSON){
  return json===undefined?undefined:new SimplePaginationRequest(json)
}

function encodeSimplePaginationRequest(obj : SimplePaginationRequest) :SimplePaginationRequestJSON {
    if(obj==null) return undefined
    return inline({
      count : encodeNumber(obj.count),
      pageId : (obj.pageId),
    } as SimplePaginationRequestJSON)
}

type TokenUrlBeanJSON = {
  expirationDate : string | undefined 
  link : string
}

export class TokenUrlBean extends ServerBeanPrototype{

  expirationDate : Date
  link : string

  constructor(json :TokenUrlBeanJSON){
    super(json);
    this.expirationDate = decodeDate(json.expirationDate);
    this.link = (json.link);

    this.onDecode(json);
  }
}

function decodeTokenUrlBean(json :TokenUrlBeanJSON){
  return json===undefined?undefined:new TokenUrlBean(json)
}

function encodeTokenUrlBean(obj : TokenUrlBean) :TokenUrlBeanJSON {
    if(obj==null) return undefined
    return inline({
      expirationDate : encodeDate(obj.expirationDate),
      link : (obj.link),
    } as TokenUrlBeanJSON)
}

type DeviceConfigBeanJSON = {
  MCC : string | undefined 
  MNC : string | undefined 
  applicationVersion : string | undefined 
  buildTimestamp : string | undefined 
  deviceId : string
  languageSystem : string | undefined 
  metaId : string | undefined 
  modelType : string | undefined 
  nativeAppId : string | undefined 
  notificationTokenId : string | undefined 
  partnerType : string | undefined 
  systemName : string | undefined 
  systemVersion : string | undefined 
}

export class DeviceConfigBean extends ServerBeanPrototype{

  MCC : string
  MNC : string
  applicationVersion : string
  buildTimestamp : number
  deviceId : string
  languageSystem : string
  metaId : string
  modelType : string
  nativeAppId : string
  notificationTokenId : string
  partnerType : string
  systemName : string
  systemVersion : string

  constructor(json :DeviceConfigBeanJSON){
    super(json);
    this.MCC = (json.MCC);
    this.MNC = (json.MNC);
    this.applicationVersion = (json.applicationVersion);
    this.buildTimestamp = decodeNumber(json.buildTimestamp);
    this.deviceId = (json.deviceId);
    this.languageSystem = (json.languageSystem);
    this.metaId = (json.metaId);
    this.modelType = decodeEnum(json.modelType);
    this.nativeAppId = (json.nativeAppId);
    this.notificationTokenId = (json.notificationTokenId);
    this.partnerType = decodeEnum(json.partnerType);
    this.systemName = (json.systemName);
    this.systemVersion = (json.systemVersion);

    this.onDecode(json);
  }
}

function decodeDeviceConfigBean(json :DeviceConfigBeanJSON){
  return json===undefined?undefined:new DeviceConfigBean(json)
}

function encodeDeviceConfigBean(obj : DeviceConfigBean) :DeviceConfigBeanJSON {
    if(obj==null) return undefined
    return inline({
      MCC : (obj.MCC),
      MNC : (obj.MNC),
      applicationVersion : (obj.applicationVersion),
      buildTimestamp : encodeNumber(obj.buildTimestamp),
      deviceId : (obj.deviceId),
      languageSystem : (obj.languageSystem),
      metaId : (obj.metaId),
      modelType : encodeEnum(obj.modelType),
      nativeAppId : (obj.nativeAppId),
      notificationTokenId : (obj.notificationTokenId),
      partnerType : encodeEnum(obj.partnerType),
      systemName : (obj.systemName),
      systemVersion : (obj.systemVersion),
    } as DeviceConfigBeanJSON)
}

type AttendeeBeanJSON = {
  accountId : string
  attendeeResponse : string | undefined 
  attendeeStatus : string | undefined 
}

export class AttendeeBean extends ServerBeanPrototype{

  accountId : number
  attendeeResponse : string
  attendeeStatus : string

  constructor(json :AttendeeBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.attendeeResponse = decodeEnum(json.attendeeResponse);
    this.attendeeStatus = decodeEnum(json.attendeeStatus);

    this.onDecode(json);
  }
}

function decodeAttendeeBean(json :AttendeeBeanJSON){
  return json===undefined?undefined:new AttendeeBean(json)
}

function encodeAttendeeBean(obj : AttendeeBean) :AttendeeBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      attendeeResponse : encodeEnum(obj.attendeeResponse),
      attendeeStatus : encodeEnum(obj.attendeeStatus),
    } as AttendeeBeanJSON)
}

type CalendarBeanJSON = {
  activated : string
  calendars : Array<CalendarBeanJSON> | undefined 
  color : string | undefined 
  countryCode : string | undefined 
  countryLang : string | undefined 
  errorCode : string | undefined 
  errorMessage : string | undefined 
  familyId : string | undefined 
  icalAble : string | undefined 
  location : string | undefined 
  metaId : string
  mine : string | undefined 
  name : string | undefined 
  nameEditable : string | undefined 
  referenceId : string | undefined 
  reminderActivated : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sharedByAccountId : string | undefined 
  sharedMemberIds : Array<string> | undefined 
  sharedToAll : string | undefined 
  subtitle : string | undefined 
  type : string | undefined 
  url : string | undefined 
  useEventColor : string | undefined 
  useEventColorEditable : string
}

export class CalendarBean extends ServerBeanPrototype{

  activated : boolean
  calendars : Array<CalendarBean>
  color : string
  countryCode : string
  countryLang : string
  errorCode : string
  errorMessage : string
  familyId : string
  icalAble : boolean
  location : string
  metaId : string
  mine : boolean
  name : string
  nameEditable : boolean
  referenceId : string
  reminderActivated : boolean
  rights : FizRightBean
  sharedByAccountId : number
  sharedMemberIds : Array<number>
  sharedToAll : boolean
  subtitle : string
  type : string
  url : string
  useEventColor : boolean
  useEventColorEditable : boolean

  constructor(json :CalendarBeanJSON){
    super(json);
    this.activated = decodeboolean(json.activated);
    this.calendars = decodeArray(decodeCalendarBean)(json.calendars);
    this.color = (json.color);
    this.countryCode = (json.countryCode);
    this.countryLang = (json.countryLang);
    this.errorCode = (json.errorCode);
    this.errorMessage = (json.errorMessage);
    this.familyId = (json.familyId);
    this.icalAble = decodeBoolean(json.icalAble);
    this.location = (json.location);
    this.metaId = (json.metaId);
    this.mine = decodeBoolean(json.mine);
    this.name = (json.name);
    this.nameEditable = decodeBoolean(json.nameEditable);
    this.referenceId = (json.referenceId);
    this.reminderActivated = decodeBoolean(json.reminderActivated);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedByAccountId = decodeNumber(json.sharedByAccountId);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.subtitle = (json.subtitle);
    this.type = decodeEnum(json.type);
    this.url = (json.url);
    this.useEventColor = decodeBoolean(json.useEventColor);
    this.useEventColorEditable = decodeboolean(json.useEventColorEditable);

    this.onDecode(json);
  }
}

function decodeCalendarBean(json :CalendarBeanJSON){
  return json===undefined?undefined:new CalendarBean(json)
}

function encodeCalendarBean(obj : CalendarBean) :CalendarBeanJSON {
    if(obj==null) return undefined
    return inline({
      activated : encodeboolean(obj.activated),
      calendars : undefined,
      color : (obj.color),
      countryCode : undefined,
      countryLang : undefined,
      errorCode : (obj.errorCode),
      errorMessage : (obj.errorMessage),
      familyId : (obj.familyId),
      icalAble : undefined,
      location : (obj.location),
      metaId : (obj.metaId),
      mine : encodeBoolean(obj.mine),
      name : (obj.name),
      nameEditable : undefined,
      referenceId : (obj.referenceId),
      reminderActivated : encodeBoolean(obj.reminderActivated),
      rights : encodeFizRightBean(obj.rights),
      sharedByAccountId : encodeNumber(obj.sharedByAccountId),
      sharedMemberIds : encodeArray(encodeNumber)(obj.sharedMemberIds),
      sharedToAll : encodeBoolean(obj.sharedToAll),
      subtitle : (obj.subtitle),
      type : undefined,
      url : undefined,
      useEventColor : encodeBoolean(obj.useEventColor),
      useEventColorEditable : undefined,
    } as CalendarBeanJSON)
}

type CalendarGroupBeanJSON = {
  budgets : Array<CalendarBeanJSON>
  external : Array<CalendarBeanJSON>
  families : Array<CalendarBeanJSON>
  google : CalendarBeanJSON | undefined 
  googles : Array<GoogleCredentialBeanJSON>
  mine : Array<CalendarBeanJSON>
  outlook : CalendarBeanJSON | undefined 
  outlooks : Array<OutlookCredentialBeanJSON>
  suggestions : Array<CalendarSuggestionBeanJSON>
  timetables : Array<CalendarTimetableBeanJSON>
}

export class CalendarGroupBean extends ServerBeanPrototype{

  budgets : Array<CalendarBean>
  external : Array<CalendarBean>
  families : Array<CalendarBean>
  google : CalendarBean
  googles : Array<GoogleCredentialBean>
  mine : Array<CalendarBean>
  outlook : CalendarBean
  outlooks : Array<OutlookCredentialBean>
  suggestions : Array<CalendarSuggestionBean>
  timetables : Array<CalendarTimetableBean>

  constructor(json :CalendarGroupBeanJSON){
    super(json);
    this.budgets = decodeArray(decodeCalendarBean)(json.budgets);
    this.external = decodeArray(decodeCalendarBean)(json.external);
    this.families = decodeArray(decodeCalendarBean)(json.families);
    this.google = decodeCalendarBean(json.google);
    this.googles = decodeArray(decodeGoogleCredentialBean)(json.googles);
    this.mine = decodeArray(decodeCalendarBean)(json.mine);
    this.outlook = decodeCalendarBean(json.outlook);
    this.outlooks = decodeArray(decodeOutlookCredentialBean)(json.outlooks);
    this.suggestions = decodeArray(decodeCalendarSuggestionBean)(json.suggestions);
    this.timetables = decodeArray(decodeCalendarTimetableBean)(json.timetables);

    this.onDecode(json);
  }
}

function decodeCalendarGroupBean(json :CalendarGroupBeanJSON){
  return json===undefined?undefined:new CalendarGroupBean(json)
}

function encodeCalendarGroupBean(obj : CalendarGroupBean) :CalendarGroupBeanJSON {
    if(obj==null) return undefined
    return inline({
      budgets : encodeArray(encodeCalendarBean)(obj.budgets),
      external : encodeArray(encodeCalendarBean)(obj.external),
      families : encodeArray(encodeCalendarBean)(obj.families),
      google : encodeCalendarBean(obj.google),
      googles : encodeArray(encodeGoogleCredentialBean)(obj.googles),
      mine : encodeArray(encodeCalendarBean)(obj.mine),
      outlook : encodeCalendarBean(obj.outlook),
      outlooks : encodeArray(encodeOutlookCredentialBean)(obj.outlooks),
      suggestions : encodeArray(encodeCalendarSuggestionBean)(obj.suggestions),
      timetables : encodeArray(encodeCalendarTimetableBean)(obj.timetables),
    } as CalendarGroupBeanJSON)
}

type CalendarSharedBeanJSON = {
  calendar : CalendarBeanJSON
  syncBean : EventSyncBeanJSON
}

export class CalendarSharedBean extends ServerBeanPrototype{

  calendar : CalendarBean
  syncBean : EventSyncBean

  constructor(json :CalendarSharedBeanJSON){
    super(json);
    this.calendar = decodeDynamic(json.calendar) as CalendarBean;
    this.syncBean = decodeEventSyncBean(json.syncBean);

    this.onDecode(json);
  }
}

function decodeCalendarSharedBean(json :CalendarSharedBeanJSON){
  return json===undefined?undefined:new CalendarSharedBean(json)
}

function encodeCalendarSharedBean(obj : CalendarSharedBean) :CalendarSharedBeanJSON {
    if(obj==null) return undefined
    return inline({
      calendar : encodeDynamic(obj.calendar),
      syncBean : encodeEventSyncBean(obj.syncBean),
    } as CalendarSharedBeanJSON)
}

type CalendarSubscriptionResponseBeanJSON = {
  createdMetaId : Array<string>
}

export class CalendarSubscriptionResponseBean extends ServerBeanPrototype{

  createdMetaId : Array<string>

  constructor(json :CalendarSubscriptionResponseBeanJSON){
    super(json);
    this.createdMetaId = decodeArray(decodeString)(json.createdMetaId);

    this.onDecode(json);
  }
}

function decodeCalendarSubscriptionResponseBean(json :CalendarSubscriptionResponseBeanJSON){
  return json===undefined?undefined:new CalendarSubscriptionResponseBean(json)
}

function encodeCalendarSubscriptionResponseBean(obj : CalendarSubscriptionResponseBean) :CalendarSubscriptionResponseBeanJSON {
    if(obj==null) return undefined
    return inline({
      createdMetaId : encodeArray(encodeString)(obj.createdMetaId),
    } as CalendarSubscriptionResponseBeanJSON)
}

type CalendarSuggestionBeanJSON = {
  calendarIds : Array<string>
  countryCode : string
  countryLang : string | undefined 
}

export class CalendarSuggestionBean extends ServerBeanPrototype{

  calendarIds : Array<string>
  countryCode : string
  countryLang : string

  constructor(json :CalendarSuggestionBeanJSON){
    super(json);
    this.calendarIds = decodeArray(decodeString)(json.calendarIds);
    this.countryCode = (json.countryCode);
    this.countryLang = (json.countryLang);

    this.onDecode(json);
  }
}

function decodeCalendarSuggestionBean(json :CalendarSuggestionBeanJSON){
  return json===undefined?undefined:new CalendarSuggestionBean(json)
}

function encodeCalendarSuggestionBean(obj : CalendarSuggestionBean) :CalendarSuggestionBeanJSON {
    if(obj==null) return undefined
    return inline({
      calendarIds : encodeArray(encodeString)(obj.calendarIds),
      countryCode : (obj.countryCode),
      countryLang : (obj.countryLang),
    } as CalendarSuggestionBeanJSON)
}

type CalendarTimetableBeanJSON = {
  activated : string
  calendars : Array<CalendarBeanJSON> | undefined 
  color : string | undefined 
  countryCode : string | undefined 
  countryLang : string | undefined 
  errorCode : string | undefined 
  errorMessage : string | undefined 
  familyId : string | undefined 
  icalAble : string | undefined 
  location : string | undefined 
  metaId : string
  mine : string | undefined 
  name : string | undefined 
  nameEditable : string | undefined 
  referenceId : string | undefined 
  reminderActivated : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sharedByAccountId : string | undefined 
  sharedMemberIds : Array<string> | undefined 
  sharedToAll : string | undefined 
  subtitle : string | undefined 
  timetable : TimetableBeanJSON
  type : string | undefined 
  url : string | undefined 
  useEventColor : string | undefined 
  useEventColorEditable : string
}

export class CalendarTimetableBean extends ServerBeanPrototype{

  activated : boolean
  calendars : Array<CalendarBean>
  color : string
  countryCode : string
  countryLang : string
  errorCode : string
  errorMessage : string
  familyId : string
  icalAble : boolean
  location : string
  metaId : string
  mine : boolean
  name : string
  nameEditable : boolean
  referenceId : string
  reminderActivated : boolean
  rights : FizRightBean
  sharedByAccountId : number
  sharedMemberIds : Array<number>
  sharedToAll : boolean
  subtitle : string
  timetable : TimetableBean
  type : string
  url : string
  useEventColor : boolean
  useEventColorEditable : boolean

  constructor(json :CalendarTimetableBeanJSON){
    super(json);
    this.activated = decodeboolean(json.activated);
    this.calendars = decodeArray(decodeCalendarBean)(json.calendars);
    this.color = (json.color);
    this.countryCode = (json.countryCode);
    this.countryLang = (json.countryLang);
    this.errorCode = (json.errorCode);
    this.errorMessage = (json.errorMessage);
    this.familyId = (json.familyId);
    this.icalAble = decodeBoolean(json.icalAble);
    this.location = (json.location);
    this.metaId = (json.metaId);
    this.mine = decodeBoolean(json.mine);
    this.name = (json.name);
    this.nameEditable = decodeBoolean(json.nameEditable);
    this.referenceId = (json.referenceId);
    this.reminderActivated = decodeBoolean(json.reminderActivated);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedByAccountId = decodeNumber(json.sharedByAccountId);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.subtitle = (json.subtitle);
    this.timetable = decodeTimetableBean(json.timetable);
    this.type = decodeEnum(json.type);
    this.url = (json.url);
    this.useEventColor = decodeBoolean(json.useEventColor);
    this.useEventColorEditable = decodeboolean(json.useEventColorEditable);

    this.onDecode(json);
  }
}

function decodeCalendarTimetableBean(json :CalendarTimetableBeanJSON){
  return json===undefined?undefined:new CalendarTimetableBean(json)
}

function encodeCalendarTimetableBean(obj : CalendarTimetableBean) :CalendarTimetableBeanJSON {
    if(obj==null) return undefined
    return inline({
      activated : encodeboolean(obj.activated),
      calendars : undefined,
      color : (obj.color),
      countryCode : undefined,
      countryLang : undefined,
      errorCode : (obj.errorCode),
      errorMessage : (obj.errorMessage),
      familyId : (obj.familyId),
      icalAble : undefined,
      location : (obj.location),
      metaId : (obj.metaId),
      mine : encodeBoolean(obj.mine),
      name : (obj.name),
      nameEditable : undefined,
      referenceId : (obj.referenceId),
      reminderActivated : encodeBoolean(obj.reminderActivated),
      rights : encodeFizRightBean(obj.rights),
      sharedByAccountId : encodeNumber(obj.sharedByAccountId),
      sharedMemberIds : encodeArray(encodeNumber)(obj.sharedMemberIds),
      sharedToAll : encodeBoolean(obj.sharedToAll),
      subtitle : (obj.subtitle),
      timetable : encodeTimetableBean(obj.timetable),
      type : undefined,
      url : undefined,
      useEventColor : encodeBoolean(obj.useEventColor),
      useEventColorEditable : undefined,
    } as CalendarTimetableBeanJSON)
}

type EventBeanJSON = {
  accountId : string
  allDay : string
  attendeeIds : Array<string>
  bestMoment : string | undefined 
  birthDateNoYear : string | undefined 
  calendarId : string
  color : string | undefined 
  colorInfo : ColorBeanJSON | undefined 
  comments : Array<ICommentJSON> | undefined 
  description : string | undefined 
  editable : string | undefined 
  emoji : string | undefined 
  endDate : string | undefined 
  eventId : string
  eventMasterId : string
  eventType : string | undefined 
  externalImportId : string | undefined 
  familyId : string
  lastAction : string | undefined 
  lastActionAuthor : string | undefined 
  lastActionDate : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  modifDate : string
  moodMap : {[key:string]:Array<string>} | undefined 
  moodStarShortcut : string | undefined 
  occurenceIndex : string | undefined 
  placeId : string | undefined 
  private : string
  recurrencyExceptionOfId : string | undefined 
  refPersonId : string | undefined 
  refPersonName : string | undefined 
  reminder : IReminderJSON | undefined 
  reminderList : Array<IReminderJSON>
  startDate : string
  taskListId : string | undefined 
  text : string | undefined 
  timeZone : string | undefined 
  toAll : string
  where : string | undefined 
} & RecurrencyDescriptorJSON

export class EventBean extends ServerBeanPrototype{

  accountId : number
  allDay : boolean
  attendeeIds : Array<number>
  bestMoment : boolean
  birthDateNoYear : boolean
  calendarId : string
  color : string
  colorInfo : ColorBean
  comments : Array<IComment>
  description : string
  editable : boolean
  emoji : string
  endDate : Date
  eventId : string
  eventMasterId : string
  eventType : string
  externalImportId : string
  familyId : string
  lastAction : string
  lastActionAuthor : number
  lastActionDate : Date
  medias : Array<IMedia>
  metaId : string
  modifDate : Date
  moodMap : Map<number,Array<string>>
  moodStarShortcut : boolean
  occurenceIndex : number
  placeId : string
  private : boolean
  recurrencyDescriptor : RecurrencyDescriptor
  recurrencyExceptionOfId : string
  refPersonId : string
  refPersonName : string
  reminder : IReminder
  reminderList : Array<IReminder>
  startDate : Date
  taskListId : string
  text : string
  timeZone : string
  toAll : boolean
  where : string

  constructor(json :EventBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.allDay = decodeBoolean(json.allDay);
    this.attendeeIds = decodeArray(decodeNumber)(json.attendeeIds);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.calendarId = (json.calendarId);
    this.color = (json.color);
    this.colorInfo = decodeColorBean(json.colorInfo);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.description = (json.description);
    this.editable = decodeBoolean(json.editable);
    this.emoji = (json.emoji);
    this.endDate = decodeDate(json.endDate);
    this.eventId = (json.eventId);
    this.eventMasterId = (json.eventMasterId);
    this.eventType = decodeEnum(json.eventType);
    this.externalImportId = (json.externalImportId);
    this.familyId = (json.familyId);
    this.lastAction = decodeEnum(json.lastAction);
    this.lastActionAuthor = decodeNumber(json.lastActionAuthor);
    this.lastActionDate = decodeDate(json.lastActionDate);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.modifDate = decodeDate(json.modifDate);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.occurenceIndex = decodeNumber(json.occurenceIndex);
    this.placeId = (json.placeId);
    this.private = decodeboolean(json.private);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.recurrencyExceptionOfId = (json.recurrencyExceptionOfId);
    this.refPersonId = (json.refPersonId);
    this.refPersonName = (json.refPersonName);
    this.reminder = decodeIReminder(json.reminder);
    this.reminderList = decodeArray(decodeIReminder)(json.reminderList);
    this.startDate = decodeDate(json.startDate);
    this.taskListId = (json.taskListId);
    this.text = (json.text);
    this.timeZone = (json.timeZone);
    this.toAll = decodeboolean(json.toAll);
    this.where = (json.where);

    this.onDecode(json);
  }
}

function decodeEventBean(json :EventBeanJSON){
  return json===undefined?undefined:new EventBean(json)
}

function encodeEventBean(obj : EventBean) :EventBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      allDay : encodeBoolean(obj.allDay),
      attendeeIds : encodeArray(encodeNumber)(obj.attendeeIds),
      bestMoment : undefined,
      birthDateNoYear : encodeBoolean(obj.birthDateNoYear),
      calendarId : (obj.calendarId),
      color : (obj.color),
      colorInfo : encodeColorBean(obj.colorInfo),
      comments : undefined,
      description : (obj.description),
      editable : encodeBoolean(obj.editable),
      emoji : (obj.emoji),
      endDate : encodeDate(obj.endDate),
      eventId : (obj.eventId),
      eventMasterId : (obj.eventMasterId),
      eventType : encodeEnum(obj.eventType),
      externalImportId : (obj.externalImportId),
      familyId : (obj.familyId),
      lastAction : undefined,
      lastActionAuthor : undefined,
      lastActionDate : undefined,
      medias : undefined,
      metaId : (obj.metaId),
      modifDate : encodeDate(obj.modifDate),
      moodMap : undefined,
      moodStarShortcut : undefined,
      occurenceIndex : encodeNumber(obj.occurenceIndex),
      placeId : (obj.placeId),
      private : encodeboolean(obj.private),
      recurrencyExceptionOfId : undefined,
      refPersonId : (obj.refPersonId),
      refPersonName : (obj.refPersonName),
      reminder : encodeIReminder(obj.reminder),
      reminderList : encodeArray(encodeIReminder)(obj.reminderList),
      startDate : encodeDate(obj.startDate),
      taskListId : (obj.taskListId),
      text : (obj.text),
      timeZone : (obj.timeZone),
      toAll : encodeboolean(obj.toAll),
      where : (obj.where),
    } as EventBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor))
}

type EventInputBeanJSON = {
  allDay : string | undefined 
  attendee : Array<IAttendeeJSON> | undefined 
  birthDateNoYear : string | undefined 
  calendarId : string | undefined 
  color : string | undefined 
  colorId : string | undefined 
  description : string | undefined 
  emoji : string | undefined 
  endDate : string | undefined 
  isToAll : string | undefined 
  metaId : string | undefined 
  picture : Array<string> | undefined 
  placeId : string | undefined 
  private : string | undefined 
  reminder : IReminderJSON | undefined 
  reminderList : Array<IReminderJSON> | undefined 
  startDate : string | undefined 
  taskListId : string | undefined 
  text : string | undefined 
  timeZone : string | undefined 
  type : string | undefined 
  where : string | undefined 
} & RecurrencyDescriptorJSON

export class EventInputBean extends ServerBeanPrototype{

  allDay : boolean
  attendee : Array<IAttendee>
  birthDateNoYear : boolean
  calendarId : string
  color : string
  colorId : string
  description : string
  emoji : string
  endDate : Date
  isToAll : boolean
  metaId : string
  picture : Array<FizFile>
  placeId : string
  private : boolean
  recurrencyDescriptor : RecurrencyDescriptor
  reminder : IReminder
  reminderList : Array<IReminder>
  startDate : Date
  taskListId : string
  text : string
  timeZone : string
  type : string
  where : string

  constructor(json :EventInputBeanJSON){
    super(json);
    this.allDay = decodeBoolean(json.allDay);
    this.attendee = decodeArray(decodeIAttendee)(json.attendee);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.calendarId = (json.calendarId);
    this.color = (json.color);
    this.colorId = (json.colorId);
    this.description = (json.description);
    this.emoji = (json.emoji);
    this.endDate = decodeDate(json.endDate);
    this.isToAll = decodeBoolean(json.isToAll);
    this.metaId = (json.metaId);
    this.picture = decodeArray(decodeFizFile)(json.picture);
    this.placeId = (json.placeId);
    this.private = decodeBoolean(json.private);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.reminder = decodeIReminder(json.reminder);
    this.reminderList = decodeArray(decodeIReminder)(json.reminderList);
    this.startDate = decodeDate(json.startDate);
    this.taskListId = (json.taskListId);
    this.text = (json.text);
    this.timeZone = (json.timeZone);
    this.type = decodeEnum(json.type);
    this.where = (json.where);

    this.onDecode(json);
  }
}

function decodeEventInputBean(json :EventInputBeanJSON){
  return json===undefined?undefined:new EventInputBean(json)
}

function encodeEventInputBean(obj : EventInputBean) :EventInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      allDay : encodeBoolean(obj.allDay),
      attendee : encodeArray(encodeIAttendee)(obj.attendee),
      birthDateNoYear : encodeBoolean(obj.birthDateNoYear),
      calendarId : (obj.calendarId),
      color : (obj.color),
      colorId : (obj.colorId),
      description : (obj.description),
      emoji : (obj.emoji),
      endDate : encodeDate(obj.endDate),
      isToAll : encodeBoolean(obj.isToAll),
      metaId : (obj.metaId),
      picture : encodeArray(encodeFizFile)(obj.picture),
      placeId : (obj.placeId),
      private : encodeBoolean(obj.private),
      reminder : encodeIReminder(obj.reminder),
      reminderList : encodeArray(encodeIReminder)(obj.reminderList),
      startDate : encodeDate(obj.startDate),
      taskListId : (obj.taskListId),
      text : (obj.text),
      timeZone : (obj.timeZone),
      type : encodeEnum(obj.type),
      where : (obj.where),
    } as EventInputBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor))
}

type EventListAndCalendarJSON = {
  events : Array<IEventJSON>
  selectedCalendars : {[key:string]:CalendarBeanJSON}
}

export class EventListAndCalendar extends ServerBeanPrototype{

  events : Array<IEvent>
  selectedCalendars : Map<string,CalendarBean>

  constructor(json :EventListAndCalendarJSON){
    super(json);
    this.events = decodeArray(decodeIEvent)(json.events);
    this.selectedCalendars = decodeDynamic(json.selectedCalendars) as Map<string,CalendarBean>;

    this.onDecode(json);
  }
}

function decodeEventListAndCalendar(json :EventListAndCalendarJSON){
  return json===undefined?undefined:new EventListAndCalendar(json)
}

function encodeEventListAndCalendar(obj : EventListAndCalendar) :EventListAndCalendarJSON {
    if(obj==null) return undefined
    return inline({
      events : encodeArray(encodeIEvent)(obj.events),
      selectedCalendars : encodeDynamic(obj.selectedCalendars),
    } as EventListAndCalendarJSON)
}

type EventSyncBeanJSON = {
  calendarId : string | undefined 
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<IEventJSON>
}

export class EventSyncBean extends ServerBeanPrototype{

  calendarId : string
  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<IEvent>

  constructor(json :EventSyncBeanJSON){
    super(json);
    this.calendarId = (json.calendarId);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeIEvent)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeEventSyncBean(json :EventSyncBeanJSON){
  return json===undefined?undefined:new EventSyncBean(json)
}

function encodeEventSyncBean(obj : EventSyncBean) :EventSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      calendarId : (obj.calendarId),
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeIEvent)(obj.updatedCreated),
    } as EventSyncBeanJSON)
}

type IcalImportPreviewBeanJSON = {
  content : Array<EventInputBeanJSON>
  count : string
  created : string
  error : string
  ignored : string
  limit : string | undefined 
  rightFlag : string
  updated : string
}

export class IcalImportPreviewBean extends ServerBeanPrototype{

  content : Array<EventInputBean>
  count : number
  created : number
  error : number
  ignored : number
  limit : number
  rightFlag : string
  updated : number

  constructor(json :IcalImportPreviewBeanJSON){
    super(json);
    this.content = decodeArray(decodeEventInputBean)(json.content);
    this.count = decodenumber(json.count);
    this.created = decodenumber(json.created);
    this.error = decodenumber(json.error);
    this.ignored = decodenumber(json.ignored);
    this.limit = decodeNumber(json.limit);
    this.rightFlag = decodeEnum(json.rightFlag);
    this.updated = decodenumber(json.updated);

    this.onDecode(json);
  }
}

function decodeIcalImportPreviewBean(json :IcalImportPreviewBeanJSON){
  return json===undefined?undefined:new IcalImportPreviewBean(json)
}

function encodeIcalImportPreviewBean(obj : IcalImportPreviewBean) :IcalImportPreviewBeanJSON {
    if(obj==null) return undefined
    return inline({
      content : encodeArray(encodeEventInputBean)(obj.content),
      count : encodenumber(obj.count),
      created : encodenumber(obj.created),
      error : encodenumber(obj.error),
      ignored : encodenumber(obj.ignored),
      limit : encodeNumber(obj.limit),
      rightFlag : encodeEnum(obj.rightFlag),
      updated : encodenumber(obj.updated),
    } as IcalImportPreviewBeanJSON)
}

type IcalImportResultBeanJSON = {
  count : string
  created : string
  error : string
  ignored : string
  updated : string
}

export class IcalImportResultBean extends ServerBeanPrototype{

  count : number
  created : number
  error : number
  ignored : number
  updated : number

  constructor(json :IcalImportResultBeanJSON){
    super(json);
    this.count = decodenumber(json.count);
    this.created = decodenumber(json.created);
    this.error = decodenumber(json.error);
    this.ignored = decodenumber(json.ignored);
    this.updated = decodenumber(json.updated);

    this.onDecode(json);
  }
}

function decodeIcalImportResultBean(json :IcalImportResultBeanJSON){
  return json===undefined?undefined:new IcalImportResultBean(json)
}

function encodeIcalImportResultBean(obj : IcalImportResultBean) :IcalImportResultBeanJSON {
    if(obj==null) return undefined
    return inline({
      count : encodenumber(obj.count),
      created : encodenumber(obj.created),
      error : encodenumber(obj.error),
      ignored : encodenumber(obj.ignored),
      updated : encodenumber(obj.updated),
    } as IcalImportResultBeanJSON)
}

type RecurrencyDescriptorJSON = {
  byDay : string | undefined 
  byMonthDay : string | undefined 
  endOccurence : string | undefined 
  exdate : Array<string> | undefined 
  rdate : Array<string> | undefined 
  recurrency : string | undefined 
  recurrencyDeletedOccurence : Array<string> | undefined 
  recurrencyEndDate : string | undefined 
  recurrencyInterval : string | undefined 
  rrule : string | undefined 
}

export class RecurrencyDescriptor extends ServerBeanPrototype{

  byDay : string
  byMonthDay : string
  endOccurence : number
  exdate : Array<Date>
  rdate : Array<Date>
  recurrency : string
  recurrencyDeletedOccurence : Array<number>
  recurrencyEndDate : Date
  recurrencyInterval : number
  rrule : string

  constructor(json :RecurrencyDescriptorJSON){
    super(json);
    this.byDay = (json.byDay);
    this.byMonthDay = (json.byMonthDay);
    this.endOccurence = decodeNumber(json.endOccurence);
    this.exdate = decodeArray(decodeDate)(json.exdate);
    this.rdate = decodeArray(decodeDate)(json.rdate);
    this.recurrency = decodeEnum(json.recurrency);
    this.recurrencyDeletedOccurence = decodeArray(decodeNumber)(json.recurrencyDeletedOccurence);
    this.recurrencyEndDate = decodeDate(json.recurrencyEndDate);
    this.recurrencyInterval = decodeNumber(json.recurrencyInterval);
    this.rrule = (json.rrule);

    this.onDecode(json);
  }
}

function decodeRecurrencyDescriptor(json :RecurrencyDescriptorJSON){
  return json===undefined?undefined:new RecurrencyDescriptor(json)
}

function encodeRecurrencyDescriptor(obj : RecurrencyDescriptor) :RecurrencyDescriptorJSON {
    if(obj==null) return undefined
    return inline({
      byDay : (obj.byDay),
      byMonthDay : (obj.byMonthDay),
      endOccurence : encodeNumber(obj.endOccurence),
      exdate : encodeArray(encodeDate)(obj.exdate),
      rdate : encodeArray(encodeDate)(obj.rdate),
      recurrency : encodeEnum(obj.recurrency),
      recurrencyDeletedOccurence : undefined,
      recurrencyEndDate : encodeDate(obj.recurrencyEndDate),
      recurrencyInterval : encodeNumber(obj.recurrencyInterval),
      rrule : (obj.rrule),
    } as RecurrencyDescriptorJSON)
}

type ReminderBeanJSON = {
  localId : string | undefined 
  reminderType : string | undefined 
  reminderUnit : string | undefined 
  reminderValue : string | undefined 
}

export class ReminderBean extends ServerBeanPrototype{

  localId : number
  reminderType : string
  reminderUnit : string
  reminderValue : number

  constructor(json :ReminderBeanJSON){
    super(json);
    this.localId = decodeNumber(json.localId);
    this.reminderType = decodeEnum(json.reminderType);
    this.reminderUnit = decodeEnum(json.reminderUnit);
    this.reminderValue = decodeNumber(json.reminderValue);

    this.onDecode(json);
  }
}

function decodeReminderBean(json :ReminderBeanJSON){
  return json===undefined?undefined:new ReminderBean(json)
}

function encodeReminderBean(obj : ReminderBean) :ReminderBeanJSON {
    if(obj==null) return undefined
    return inline({
      localId : encodeNumber(obj.localId),
      reminderType : encodeEnum(obj.reminderType),
      reminderUnit : encodeEnum(obj.reminderUnit),
      reminderValue : encodeNumber(obj.reminderValue),
    } as ReminderBeanJSON)
}

type TimetableBeanJSON = {
  accountId : string
  allDay : string | undefined 
  calendarFirstDayOfWeek : string | undefined 
  creationDate : string
  dailyBriefNothingPlannedActivated : string | undefined 
  dailyBriefPushActivated : string | undefined 
  defaultReminderType : string | undefined 
  defaultReminderUnit : string | undefined 
  defaultReminderValue : string | undefined 
  emoji : string | undefined 
  endDate : string | undefined 
  familyId : string
  finishDate : string | undefined 
  firstOccurrenceOffset : string | undefined 
  icalSubscriptionUrl : string | undefined 
  metaId : string
  name : string | undefined 
  reminderActivated : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sharedMemberIds : Array<string> | undefined 
  sharedToAll : string | undefined 
  showWeekends : string | undefined 
  startDate : string | undefined 
} & RecurrencyDescriptorJSON

export class TimetableBean extends ServerBeanPrototype{

  accountId : number
  allDay : boolean
  calendarFirstDayOfWeek : number
  creationDate : Date
  dailyBriefNothingPlannedActivated : boolean
  dailyBriefPushActivated : boolean
  defaultReminderType : string
  defaultReminderUnit : string
  defaultReminderValue : number
  emoji : string
  endDate : Date
  familyId : number
  finishDate : Date
  firstOccurrenceOffset : number
  icalSubscriptionUrl : string
  metaId : string
  name : string
  recurrencyDescriptor : RecurrencyDescriptor
  reminderActivated : boolean
  rights : FizRightBean
  sharedMemberIds : Array<number>
  sharedToAll : boolean
  showWeekends : boolean
  startDate : Date

  constructor(json :TimetableBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.allDay = decodeBoolean(json.allDay);
    this.calendarFirstDayOfWeek = decodeNumber(json.calendarFirstDayOfWeek);
    this.creationDate = decodeDate(json.creationDate);
    this.dailyBriefNothingPlannedActivated = decodeBoolean(json.dailyBriefNothingPlannedActivated);
    this.dailyBriefPushActivated = decodeBoolean(json.dailyBriefPushActivated);
    this.defaultReminderType = decodeEnum(json.defaultReminderType);
    this.defaultReminderUnit = decodeEnum(json.defaultReminderUnit);
    this.defaultReminderValue = decodeNumber(json.defaultReminderValue);
    this.emoji = (json.emoji);
    this.endDate = decodeDate(json.endDate);
    this.familyId = decodeNumber(json.familyId);
    this.finishDate = decodeDate(json.finishDate);
    this.firstOccurrenceOffset = decodeNumber(json.firstOccurrenceOffset);
    this.icalSubscriptionUrl = (json.icalSubscriptionUrl);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.reminderActivated = decodeBoolean(json.reminderActivated);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.showWeekends = decodeBoolean(json.showWeekends);
    this.startDate = decodeDate(json.startDate);

    this.onDecode(json);
  }
}

function decodeTimetableBean(json :TimetableBeanJSON){
  return json===undefined?undefined:new TimetableBean(json)
}

function encodeTimetableBean(obj : TimetableBean) :TimetableBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      allDay : encodeBoolean(obj.allDay),
      calendarFirstDayOfWeek : encodeNumber(obj.calendarFirstDayOfWeek),
      creationDate : encodeDate(obj.creationDate),
      dailyBriefNothingPlannedActivated : encodeBoolean(obj.dailyBriefNothingPlannedActivated),
      dailyBriefPushActivated : encodeBoolean(obj.dailyBriefPushActivated),
      defaultReminderType : encodeEnum(obj.defaultReminderType),
      defaultReminderUnit : encodeEnum(obj.defaultReminderUnit),
      defaultReminderValue : encodeNumber(obj.defaultReminderValue),
      emoji : (obj.emoji),
      endDate : encodeDate(obj.endDate),
      familyId : encodeNumber(obj.familyId),
      finishDate : encodeDate(obj.finishDate),
      firstOccurrenceOffset : encodeNumber(obj.firstOccurrenceOffset),
      icalSubscriptionUrl : (obj.icalSubscriptionUrl),
      metaId : (obj.metaId),
      name : (obj.name),
      reminderActivated : encodeBoolean(obj.reminderActivated),
      rights : undefined,
      sharedMemberIds : encodeArray(encodeNumber)(obj.sharedMemberIds),
      sharedToAll : encodeBoolean(obj.sharedToAll),
      showWeekends : encodeBoolean(obj.showWeekends),
      startDate : encodeDate(obj.startDate),
    } as TimetableBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor))
}

type TimetableInputBeanJSON = {
  allDay : string | undefined 
  calendarFirstDayOfWeek : string | undefined 
  dailyBriefNothingPlannedActivated : string | undefined 
  dailyBriefPushActivated : string | undefined 
  defaultReminderType : string | undefined 
  defaultReminderUnit : string | undefined 
  defaultReminderValue : string | undefined 
  emoji : string | undefined 
  endDate : string | undefined 
  finishDate : string | undefined 
  firstOccurrenceOffset : string | undefined 
  icalSubscriptionUrl : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
  reminderActivated : string | undefined 
  sharedMemberIds : Array<string> | undefined 
  sharedToAll : string | undefined 
  showWeekends : string | undefined 
  startDate : string | undefined 
} & RecurrencyDescriptorJSON

export class TimetableInputBean extends ServerBeanPrototype{

  allDay : boolean
  calendarFirstDayOfWeek : number
  dailyBriefNothingPlannedActivated : boolean
  dailyBriefPushActivated : boolean
  defaultReminderType : string
  defaultReminderUnit : string
  defaultReminderValue : number
  emoji : string
  endDate : Date
  finishDate : Date
  firstOccurrenceOffset : number
  icalSubscriptionUrl : string
  metaId : string
  name : string
  recurrencyDescriptor : RecurrencyDescriptor
  reminderActivated : boolean
  sharedMemberIds : Array<number>
  sharedToAll : boolean
  showWeekends : boolean
  startDate : Date

  constructor(json :TimetableInputBeanJSON){
    super(json);
    this.allDay = decodeBoolean(json.allDay);
    this.calendarFirstDayOfWeek = decodeNumber(json.calendarFirstDayOfWeek);
    this.dailyBriefNothingPlannedActivated = decodeBoolean(json.dailyBriefNothingPlannedActivated);
    this.dailyBriefPushActivated = decodeBoolean(json.dailyBriefPushActivated);
    this.defaultReminderType = decodeEnum(json.defaultReminderType);
    this.defaultReminderUnit = decodeEnum(json.defaultReminderUnit);
    this.defaultReminderValue = decodeNumber(json.defaultReminderValue);
    this.emoji = (json.emoji);
    this.endDate = decodeDate(json.endDate);
    this.finishDate = decodeDate(json.finishDate);
    this.firstOccurrenceOffset = decodeNumber(json.firstOccurrenceOffset);
    this.icalSubscriptionUrl = (json.icalSubscriptionUrl);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.reminderActivated = decodeBoolean(json.reminderActivated);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.showWeekends = decodeBoolean(json.showWeekends);
    this.startDate = decodeDate(json.startDate);

    this.onDecode(json);
  }
}

function decodeTimetableInputBean(json :TimetableInputBeanJSON){
  return json===undefined?undefined:new TimetableInputBean(json)
}

function encodeTimetableInputBean(obj : TimetableInputBean) :TimetableInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      allDay : encodeBoolean(obj.allDay),
      calendarFirstDayOfWeek : encodeNumber(obj.calendarFirstDayOfWeek),
      dailyBriefNothingPlannedActivated : encodeBoolean(obj.dailyBriefNothingPlannedActivated),
      dailyBriefPushActivated : encodeBoolean(obj.dailyBriefPushActivated),
      defaultReminderType : encodeEnum(obj.defaultReminderType),
      defaultReminderUnit : encodeEnum(obj.defaultReminderUnit),
      defaultReminderValue : encodeNumber(obj.defaultReminderValue),
      emoji : (obj.emoji),
      endDate : encodeDate(obj.endDate),
      finishDate : encodeDate(obj.finishDate),
      firstOccurrenceOffset : encodeNumber(obj.firstOccurrenceOffset),
      icalSubscriptionUrl : (obj.icalSubscriptionUrl),
      metaId : (obj.metaId),
      name : (obj.name),
      reminderActivated : encodeBoolean(obj.reminderActivated),
      sharedMemberIds : encodeArray(encodeNumber)(obj.sharedMemberIds),
      sharedToAll : encodeBoolean(obj.sharedToAll),
      showWeekends : encodeBoolean(obj.showWeekends),
      startDate : encodeDate(obj.startDate),
    } as TimetableInputBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor))
}

type TimetableSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<TimetableBeanJSON>
}

export class TimetableSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<TimetableBean>

  constructor(json :TimetableSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeTimetableBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeTimetableSyncBean(json :TimetableSyncBeanJSON){
  return json===undefined?undefined:new TimetableSyncBean(json)
}

function encodeTimetableSyncBean(obj : TimetableSyncBean) :TimetableSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeTimetableBean)(obj.updatedCreated),
    } as TimetableSyncBeanJSON)
}

type ExternalImportBeanJSON = {
  accountId : string | undefined 
  created : string | undefined 
  creationDate : string | undefined 
  importType : string
  metaId : string
  updated : string | undefined 
}

export class ExternalImportBean extends ServerBeanPrototype{

  accountId : number
  created : number
  creationDate : Date
  importType : string
  metaId : string
  updated : number

  constructor(json :ExternalImportBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.created = decodeNumber(json.created);
    this.creationDate = decodeDate(json.creationDate);
    this.importType = decodeEnum(json.importType);
    this.metaId = (json.metaId);
    this.updated = decodeNumber(json.updated);

    this.onDecode(json);
  }
}

function decodeExternalImportBean(json :ExternalImportBeanJSON){
  return json===undefined?undefined:new ExternalImportBean(json)
}

function encodeExternalImportBean(obj : ExternalImportBean) :ExternalImportBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      created : encodeNumber(obj.created),
      creationDate : encodeDate(obj.creationDate),
      importType : encodeEnum(obj.importType),
      metaId : (obj.metaId),
      updated : encodeNumber(obj.updated),
    } as ExternalImportBeanJSON)
}

type ExternalImportSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<ExternalImportBeanJSON>
}

export class ExternalImportSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<ExternalImportBean>

  constructor(json :ExternalImportSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeExternalImportBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeExternalImportSyncBean(json :ExternalImportSyncBeanJSON){
  return json===undefined?undefined:new ExternalImportSyncBean(json)
}

function encodeExternalImportSyncBean(obj : ExternalImportSyncBean) :ExternalImportSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeExternalImportBean)(obj.updatedCreated),
    } as ExternalImportSyncBeanJSON)
}

type FileSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<IMediaJSON>
}

export class FileSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<IMedia>

  constructor(json :FileSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeIMedia)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeFileSyncBean(json :FileSyncBeanJSON){
  return json===undefined?undefined:new FileSyncBean(json)
}

function encodeFileSyncBean(obj : FileSyncBean) :FileSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeIMedia)(obj.updatedCreated),
    } as FileSyncBeanJSON)
}

type FilerInputBeanJSON = {
  color : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
  parentFolderId : string | undefined 
}

export class FilerInputBean extends ServerBeanPrototype{

  color : string
  metaId : string
  name : string
  parentFolderId : string

  constructor(json :FilerInputBeanJSON){
    super(json);
    this.color = (json.color);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.parentFolderId = (json.parentFolderId);

    this.onDecode(json);
  }
}

function decodeFilerInputBean(json :FilerInputBeanJSON){
  return json===undefined?undefined:new FilerInputBean(json)
}

function encodeFilerInputBean(obj : FilerInputBean) :FilerInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      color : (obj.color),
      metaId : (obj.metaId),
      name : (obj.name),
      parentFolderId : (obj.parentFolderId),
    } as FilerInputBeanJSON)
}

type FolderBeanJSON = {
  accountId : string | undefined 
  color : string | undefined 
  emoji : string | undefined 
  familyId : string
  filerDisplayMode : string | undefined 
  filerModifDate : string
  filerSorting : string | undefined 
  metaId : string
  name : string | undefined 
  parentFolderId : string | undefined 
  rights : FizRightBeanJSON
  sharedMemberIds : Array<string> | undefined 
  sharedToAll : string | undefined 
}

export class FolderBean extends ServerBeanPrototype{

  accountId : number
  color : string
  emoji : string
  familyId : number
  filerDisplayMode : string
  filerModifDate : Date
  filerSorting : string
  metaId : string
  name : string
  parentFolderId : string
  rights : FizRightBean
  sharedMemberIds : Array<number>
  sharedToAll : boolean

  constructor(json :FolderBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.color = (json.color);
    this.emoji = (json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.filerDisplayMode = decodeEnum(json.filerDisplayMode);
    this.filerModifDate = decodeDate(json.filerModifDate);
    this.filerSorting = decodeEnum(json.filerSorting);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.parentFolderId = (json.parentFolderId);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);

    this.onDecode(json);
  }
}

function decodeFolderBean(json :FolderBeanJSON){
  return json===undefined?undefined:new FolderBean(json)
}

function encodeFolderBean(obj : FolderBean) :FolderBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      color : (obj.color),
      emoji : (obj.emoji),
      familyId : encodeNumber(obj.familyId),
      filerDisplayMode : encodeEnum(obj.filerDisplayMode),
      filerModifDate : undefined,
      filerSorting : encodeEnum(obj.filerSorting),
      metaId : (obj.metaId),
      name : (obj.name),
      parentFolderId : (obj.parentFolderId),
      rights : undefined,
      sharedMemberIds : encodeArray(encodeNumber)(obj.sharedMemberIds),
      sharedToAll : encodeBoolean(obj.sharedToAll),
    } as FolderBeanJSON)
}

type FolderInputBeanJSON = {
  color : string | undefined 
  emoji : string | undefined 
  filerDisplayMode : string | undefined 
  filerSorting : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
  parentFolderId : string | undefined 
  sharedMemberIds : Array<string> | undefined 
  sharedToAll : string | undefined 
}

export class FolderInputBean extends ServerBeanPrototype{

  color : string
  emoji : string
  filerDisplayMode : string
  filerSorting : string
  metaId : string
  name : string
  parentFolderId : string
  sharedMemberIds : Array<number>
  sharedToAll : boolean

  constructor(json :FolderInputBeanJSON){
    super(json);
    this.color = (json.color);
    this.emoji = (json.emoji);
    this.filerDisplayMode = decodeEnum(json.filerDisplayMode);
    this.filerSorting = decodeEnum(json.filerSorting);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.parentFolderId = (json.parentFolderId);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);

    this.onDecode(json);
  }
}

function decodeFolderInputBean(json :FolderInputBeanJSON){
  return json===undefined?undefined:new FolderInputBean(json)
}

function encodeFolderInputBean(obj : FolderInputBean) :FolderInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      color : (obj.color),
      emoji : (obj.emoji),
      filerDisplayMode : encodeEnum(obj.filerDisplayMode),
      filerSorting : encodeEnum(obj.filerSorting),
      metaId : (obj.metaId),
      name : (obj.name),
      parentFolderId : (obj.parentFolderId),
      sharedMemberIds : encodeArray(encodeNumber)(obj.sharedMemberIds),
      sharedToAll : encodeBoolean(obj.sharedToAll),
    } as FolderInputBeanJSON)
}

type FolderSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<FolderBeanJSON>
}

export class FolderSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<FolderBean>

  constructor(json :FolderSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeFolderBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeFolderSyncBean(json :FolderSyncBeanJSON){
  return json===undefined?undefined:new FolderSyncBean(json)
}

function encodeFolderSyncBean(obj : FolderSyncBean) :FolderSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeFolderBean)(obj.updatedCreated),
    } as FolderSyncBeanJSON)
}

type GoogleCredentialBeanJSON = {
  credentialId : string
  errorCode : string | undefined 
  errorMessage : string | undefined 
  linkable : Array<GoogleLinkableCalendarBeanJSON> | undefined 
  linked : Array<CalendarBeanJSON>
  name : string | undefined 
}

export class GoogleCredentialBean extends ServerBeanPrototype{

  credentialId : string
  errorCode : string
  errorMessage : string
  linkable : Array<GoogleLinkableCalendarBean>
  linked : Array<CalendarBean>
  name : string

  constructor(json :GoogleCredentialBeanJSON){
    super(json);
    this.credentialId = (json.credentialId);
    this.errorCode = (json.errorCode);
    this.errorMessage = (json.errorMessage);
    this.linkable = decodeArray(decodeGoogleLinkableCalendarBean)(json.linkable);
    this.linked = decodeArray(decodeCalendarBean)(json.linked);
    this.name = (json.name);

    this.onDecode(json);
  }
}

function decodeGoogleCredentialBean(json :GoogleCredentialBeanJSON){
  return json===undefined?undefined:new GoogleCredentialBean(json)
}

function encodeGoogleCredentialBean(obj : GoogleCredentialBean) :GoogleCredentialBeanJSON {
    if(obj==null) return undefined
    return inline({
      credentialId : (obj.credentialId),
      errorCode : (obj.errorCode),
      errorMessage : (obj.errorMessage),
      linkable : encodeArray(encodeGoogleLinkableCalendarBean)(obj.linkable),
      linked : encodeArray(encodeCalendarBean)(obj.linked),
      name : (obj.name),
    } as GoogleCredentialBeanJSON)
}

type GoogleLinkableCalendarBeanJSON = {
  color : string
  googleId : string
  linked : string
  name : string
}

export class GoogleLinkableCalendarBean extends ServerBeanPrototype{

  color : string
  googleId : string
  linked : boolean
  name : string

  constructor(json :GoogleLinkableCalendarBeanJSON){
    super(json);
    this.color = (json.color);
    this.googleId = (json.googleId);
    this.linked = decodeboolean(json.linked);
    this.name = (json.name);

    this.onDecode(json);
  }
}

function decodeGoogleLinkableCalendarBean(json :GoogleLinkableCalendarBeanJSON){
  return json===undefined?undefined:new GoogleLinkableCalendarBean(json)
}

function encodeGoogleLinkableCalendarBean(obj : GoogleLinkableCalendarBean) :GoogleLinkableCalendarBeanJSON {
    if(obj==null) return undefined
    return inline({
      color : (obj.color),
      googleId : (obj.googleId),
      linked : encodeboolean(obj.linked),
      name : (obj.name),
    } as GoogleLinkableCalendarBeanJSON)
}

type MessageSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<IIMMessageJSON>
}

export class MessageSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<IIMMessage>

  constructor(json :MessageSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeIIMMessage)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeMessageSyncBean(json :MessageSyncBeanJSON){
  return json===undefined?undefined:new MessageSyncBean(json)
}

function encodeMessageSyncBean(obj : MessageSyncBean) :MessageSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeIIMMessage)(obj.updatedCreated),
    } as MessageSyncBeanJSON)
}

type SyncRequestJSON = {
  date : string | undefined 
  itemId : string
  syncToken : string | undefined 
}

export class SyncRequest extends ServerBeanPrototype{

  date : Date
  itemId : string
  syncToken : string

  constructor(json :SyncRequestJSON){
    super(json);
    this.date = decodeDate(json.date);
    this.itemId = (json.itemId);
    this.syncToken = (json.syncToken);

    this.onDecode(json);
  }
}

function decodeSyncRequest(json :SyncRequestJSON){
  return json===undefined?undefined:new SyncRequest(json)
}

function encodeSyncRequest(obj : SyncRequest) :SyncRequestJSON {
    if(obj==null) return undefined
    return inline({
      date : encodeDate(obj.date),
      itemId : (obj.itemId),
      syncToken : (obj.syncToken),
    } as SyncRequestJSON)
}

type DashboardTileBeanJSON = {
  active : string | undefined 
  metaId : string
  premium : string
  readonly : string
  sortingExploreIndex : string
  sortingIndex : string
  type : string
}

export class DashboardTileBean extends ServerBeanPrototype{

  active : boolean
  metaId : string
  premium : boolean
  readonly : boolean
  sortingExploreIndex : number
  sortingIndex : number
  type : string

  constructor(json :DashboardTileBeanJSON){
    super(json);
    this.active = decodeBoolean(json.active);
    this.metaId = (json.metaId);
    this.premium = decodeboolean(json.premium);
    this.readonly = decodeboolean(json.readonly);
    this.sortingExploreIndex = decodenumber(json.sortingExploreIndex);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.type = decodeEnum(json.type);

    this.onDecode(json);
  }
}

function decodeDashboardTileBean(json :DashboardTileBeanJSON){
  return json===undefined?undefined:new DashboardTileBean(json)
}

function encodeDashboardTileBean(obj : DashboardTileBean) :DashboardTileBeanJSON {
    if(obj==null) return undefined
    return inline({
      active : encodeBoolean(obj.active),
      metaId : (obj.metaId),
      premium : encodeboolean(obj.premium),
      readonly : encodeboolean(obj.readonly),
      sortingExploreIndex : encodenumber(obj.sortingExploreIndex),
      sortingIndex : encodeNumber(obj.sortingIndex),
      type : encodeEnum(obj.type),
    } as DashboardTileBeanJSON)
}

type DashboardTileInputBeanJSON = {
  active : string | undefined 
  metaId : string
}

export class DashboardTileInputBean extends ServerBeanPrototype{

  active : boolean
  metaId : string

  constructor(json :DashboardTileInputBeanJSON){
    super(json);
    this.active = decodeBoolean(json.active);
    this.metaId = (json.metaId);

    this.onDecode(json);
  }
}

function decodeDashboardTileInputBean(json :DashboardTileInputBeanJSON){
  return json===undefined?undefined:new DashboardTileInputBean(json)
}

function encodeDashboardTileInputBean(obj : DashboardTileInputBean) :DashboardTileInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      active : encodeBoolean(obj.active),
      metaId : (obj.metaId),
    } as DashboardTileInputBeanJSON)
}

type ExploreBeanJSON = {
  covers : Array<LaunchpadActivityBeanJSON>
  exploreSectionNew : string
  familyId : string
  tiles : Array<DashboardTileBeanJSON>
  token : string | undefined 
}

export class ExploreBean extends ServerBeanPrototype{

  covers : Array<LaunchpadActivityBean>
  exploreSectionNew : boolean
  familyId : string
  tiles : Array<DashboardTileBean>
  token : string

  constructor(json :ExploreBeanJSON){
    super(json);
    this.covers = decodeArray(decodeLaunchpadActivityBean)(json.covers);
    this.exploreSectionNew = decodeboolean(json.exploreSectionNew);
    this.familyId = (json.familyId);
    this.tiles = decodeArray(decodeDashboardTileBean)(json.tiles);
    this.token = (json.token);

    this.onDecode(json);
  }
}

function decodeExploreBean(json :ExploreBeanJSON){
  return json===undefined?undefined:new ExploreBean(json)
}

function encodeExploreBean(obj : ExploreBean) :ExploreBeanJSON {
    if(obj==null) return undefined
    return inline({
      covers : encodeArray(encodeLaunchpadActivityBean)(obj.covers),
      exploreSectionNew : encodeboolean(obj.exploreSectionNew),
      familyId : (obj.familyId),
      tiles : encodeArray(encodeDashboardTileBean)(obj.tiles),
      token : (obj.token),
    } as ExploreBeanJSON)
}

type LaunchpadActivityBeanJSON = {
  action : string
  actionBackgroundColor : string | undefined 
  actionIcon : string | undefined 
  actionMetaId : string | undefined 
  actionText : string | undefined 
  color : string
  cover : string
  coverDarkMode : string | undefined 
  darkenCover : string
  items : Array<LaunchpadActivityItemBeanJSON> | undefined 
  screenSeenKeyEnum : string | undefined 
  taggingKey : string | undefined 
  text : string
  title : string | undefined 
  url : string | undefined 
}

export class LaunchpadActivityBean extends ServerBeanPrototype{

  action : string
  actionBackgroundColor : string
  actionIcon : string
  actionMetaId : string
  actionText : string
  color : string
  cover : string
  coverDarkMode : string
  darkenCover : boolean
  items : Array<LaunchpadActivityItemBean>
  screenSeenKeyEnum : string
  taggingKey : string
  text : string
  title : string
  url : string

  constructor(json :LaunchpadActivityBeanJSON){
    super(json);
    this.action = decodeEnum(json.action);
    this.actionBackgroundColor = (json.actionBackgroundColor);
    this.actionIcon = decodeEnum(json.actionIcon);
    this.actionMetaId = (json.actionMetaId);
    this.actionText = (json.actionText);
    this.color = (json.color);
    this.cover = (json.cover);
    this.coverDarkMode = (json.coverDarkMode);
    this.darkenCover = decodeboolean(json.darkenCover);
    this.items = decodeArray(decodeLaunchpadActivityItemBean)(json.items);
    this.screenSeenKeyEnum = (json.screenSeenKeyEnum);
    this.taggingKey = (json.taggingKey);
    this.text = (json.text);
    this.title = (json.title);
    this.url = (json.url);

    this.onDecode(json);
  }
}

function decodeLaunchpadActivityBean(json :LaunchpadActivityBeanJSON){
  return json===undefined?undefined:new LaunchpadActivityBean(json)
}

function encodeLaunchpadActivityBean(obj : LaunchpadActivityBean) :LaunchpadActivityBeanJSON {
    if(obj==null) return undefined
    return inline({
      action : encodeEnum(obj.action),
      actionBackgroundColor : (obj.actionBackgroundColor),
      actionIcon : encodeEnum(obj.actionIcon),
      actionMetaId : (obj.actionMetaId),
      actionText : (obj.actionText),
      color : (obj.color),
      cover : (obj.cover),
      coverDarkMode : (obj.coverDarkMode),
      darkenCover : encodeboolean(obj.darkenCover),
      items : encodeArray(encodeLaunchpadActivityItemBean)(obj.items),
      screenSeenKeyEnum : (obj.screenSeenKeyEnum),
      taggingKey : (obj.taggingKey),
      text : (obj.text),
      title : (obj.title),
      url : (obj.url),
    } as LaunchpadActivityBeanJSON)
}

type LaunchpadActivityItemBeanJSON = {
  color : string | undefined 
  text : string | undefined 
  title : string | undefined 
}

export class LaunchpadActivityItemBean extends ServerBeanPrototype{

  color : string
  text : string
  title : string

  constructor(json :LaunchpadActivityItemBeanJSON){
    super(json);
    this.color = (json.color);
    this.text = (json.text);
    this.title = (json.title);

    this.onDecode(json);
  }
}

function decodeLaunchpadActivityItemBean(json :LaunchpadActivityItemBeanJSON){
  return json===undefined?undefined:new LaunchpadActivityItemBean(json)
}

function encodeLaunchpadActivityItemBean(obj : LaunchpadActivityItemBean) :LaunchpadActivityItemBeanJSON {
    if(obj==null) return undefined
    return inline({
      color : (obj.color),
      text : (obj.text),
      title : (obj.title),
    } as LaunchpadActivityItemBeanJSON)
}

type LaunchpadBeanJSON = {
  activities : Array<LaunchpadActivityBeanJSON> | undefined 
  contactCount : string
  contactSectionNew : string
  eventDayCount : string
  eventMonthCount : string
  eventSectionNew : string
  eventWeekCount : string
  exploreSectionNew : string
  familyId : string
  familyMemberCount : string
  familyPendingInvitationCount : string
  familySectionNew : string
  fileCount : string
  filerSectionNew : string
  folderCount : string
  gallerySectionNew : string
  listCount : string
  listItemCount : string
  listPendingItemCount : string
  listSectionNew : string
  mapSectionNew : string
  mealDayCount : string
  mealSectionNew : string
  mealWeekCount : string
  messageUnreadCount : string
  pictureCount : string
  placeCount : string
  recipeCount : string
  recipeSectionNew : string
  specialDaysEventTotal : string
  specialDaysEventUpcoming : string
  specialDaysEventUpcoming3Days : string
  specialDaysSectionNew : string
  specialDaysUpcomingEventName : string | undefined 
  tiles : Array<DashboardTileBeanJSON>
  timetableCount : string
  timetableSectionNew : string
  timetableUpcomingEventDate : string | undefined 
  timetableUpcomingEventName : string | undefined 
  token : string | undefined 
  videoCount : string
  weather : WeatherBeanJSON | undefined 
}

export class LaunchpadBean extends ServerBeanPrototype{

  activities : Array<LaunchpadActivityBean>
  contactCount : number
  contactSectionNew : boolean
  eventDayCount : number
  eventMonthCount : number
  eventSectionNew : boolean
  eventWeekCount : number
  exploreSectionNew : boolean
  familyId : string
  familyMemberCount : number
  familyPendingInvitationCount : number
  familySectionNew : boolean
  fileCount : number
  filerSectionNew : boolean
  folderCount : number
  gallerySectionNew : boolean
  listCount : number
  listItemCount : number
  listPendingItemCount : number
  listSectionNew : boolean
  mapSectionNew : boolean
  mealDayCount : number
  mealSectionNew : boolean
  mealWeekCount : number
  messageUnreadCount : number
  pictureCount : number
  placeCount : number
  recipeCount : number
  recipeSectionNew : boolean
  specialDaysEventTotal : number
  specialDaysEventUpcoming : number
  specialDaysEventUpcoming3Days : number
  specialDaysSectionNew : boolean
  specialDaysUpcomingEventName : string
  tiles : Array<DashboardTileBean>
  timetableCount : number
  timetableSectionNew : boolean
  timetableUpcomingEventDate : Date
  timetableUpcomingEventName : string
  token : string
  videoCount : number
  weather : WeatherBean

  constructor(json :LaunchpadBeanJSON){
    super(json);
    this.activities = decodeArray(decodeLaunchpadActivityBean)(json.activities);
    this.contactCount = decodenumber(json.contactCount);
    this.contactSectionNew = decodeboolean(json.contactSectionNew);
    this.eventDayCount = decodenumber(json.eventDayCount);
    this.eventMonthCount = decodenumber(json.eventMonthCount);
    this.eventSectionNew = decodeboolean(json.eventSectionNew);
    this.eventWeekCount = decodenumber(json.eventWeekCount);
    this.exploreSectionNew = decodeboolean(json.exploreSectionNew);
    this.familyId = (json.familyId);
    this.familyMemberCount = decodenumber(json.familyMemberCount);
    this.familyPendingInvitationCount = decodenumber(json.familyPendingInvitationCount);
    this.familySectionNew = decodeboolean(json.familySectionNew);
    this.fileCount = decodenumber(json.fileCount);
    this.filerSectionNew = decodeboolean(json.filerSectionNew);
    this.folderCount = decodenumber(json.folderCount);
    this.gallerySectionNew = decodeboolean(json.gallerySectionNew);
    this.listCount = decodenumber(json.listCount);
    this.listItemCount = decodenumber(json.listItemCount);
    this.listPendingItemCount = decodenumber(json.listPendingItemCount);
    this.listSectionNew = decodeboolean(json.listSectionNew);
    this.mapSectionNew = decodeboolean(json.mapSectionNew);
    this.mealDayCount = decodenumber(json.mealDayCount);
    this.mealSectionNew = decodeboolean(json.mealSectionNew);
    this.mealWeekCount = decodenumber(json.mealWeekCount);
    this.messageUnreadCount = decodenumber(json.messageUnreadCount);
    this.pictureCount = decodenumber(json.pictureCount);
    this.placeCount = decodenumber(json.placeCount);
    this.recipeCount = decodenumber(json.recipeCount);
    this.recipeSectionNew = decodeboolean(json.recipeSectionNew);
    this.specialDaysEventTotal = decodenumber(json.specialDaysEventTotal);
    this.specialDaysEventUpcoming = decodenumber(json.specialDaysEventUpcoming);
    this.specialDaysEventUpcoming3Days = decodenumber(json.specialDaysEventUpcoming3Days);
    this.specialDaysSectionNew = decodeboolean(json.specialDaysSectionNew);
    this.specialDaysUpcomingEventName = (json.specialDaysUpcomingEventName);
    this.tiles = decodeArray(decodeDashboardTileBean)(json.tiles);
    this.timetableCount = decodenumber(json.timetableCount);
    this.timetableSectionNew = decodeboolean(json.timetableSectionNew);
    this.timetableUpcomingEventDate = decodeDate(json.timetableUpcomingEventDate);
    this.timetableUpcomingEventName = (json.timetableUpcomingEventName);
    this.token = (json.token);
    this.videoCount = decodenumber(json.videoCount);
    this.weather = decodeWeatherBean(json.weather);

    this.onDecode(json);
  }
}

function decodeLaunchpadBean(json :LaunchpadBeanJSON){
  return json===undefined?undefined:new LaunchpadBean(json)
}

function encodeLaunchpadBean(obj : LaunchpadBean) :LaunchpadBeanJSON {
    if(obj==null) return undefined
    return inline({
      activities : encodeArray(encodeLaunchpadActivityBean)(obj.activities),
      contactCount : encodenumber(obj.contactCount),
      contactSectionNew : encodeboolean(obj.contactSectionNew),
      eventDayCount : encodenumber(obj.eventDayCount),
      eventMonthCount : encodenumber(obj.eventMonthCount),
      eventSectionNew : encodeboolean(obj.eventSectionNew),
      eventWeekCount : encodenumber(obj.eventWeekCount),
      exploreSectionNew : encodeboolean(obj.exploreSectionNew),
      familyId : (obj.familyId),
      familyMemberCount : encodenumber(obj.familyMemberCount),
      familyPendingInvitationCount : encodenumber(obj.familyPendingInvitationCount),
      familySectionNew : encodeboolean(obj.familySectionNew),
      fileCount : encodenumber(obj.fileCount),
      filerSectionNew : encodeboolean(obj.filerSectionNew),
      folderCount : encodenumber(obj.folderCount),
      gallerySectionNew : encodeboolean(obj.gallerySectionNew),
      listCount : encodenumber(obj.listCount),
      listItemCount : encodenumber(obj.listItemCount),
      listPendingItemCount : encodenumber(obj.listPendingItemCount),
      listSectionNew : encodeboolean(obj.listSectionNew),
      mapSectionNew : encodeboolean(obj.mapSectionNew),
      mealDayCount : encodenumber(obj.mealDayCount),
      mealSectionNew : encodeboolean(obj.mealSectionNew),
      mealWeekCount : encodenumber(obj.mealWeekCount),
      messageUnreadCount : encodenumber(obj.messageUnreadCount),
      pictureCount : encodenumber(obj.pictureCount),
      placeCount : encodenumber(obj.placeCount),
      recipeCount : encodenumber(obj.recipeCount),
      recipeSectionNew : encodeboolean(obj.recipeSectionNew),
      specialDaysEventTotal : encodenumber(obj.specialDaysEventTotal),
      specialDaysEventUpcoming : encodenumber(obj.specialDaysEventUpcoming),
      specialDaysEventUpcoming3Days : encodenumber(obj.specialDaysEventUpcoming3Days),
      specialDaysSectionNew : encodeboolean(obj.specialDaysSectionNew),
      specialDaysUpcomingEventName : (obj.specialDaysUpcomingEventName),
      tiles : encodeArray(encodeDashboardTileBean)(obj.tiles),
      timetableCount : encodenumber(obj.timetableCount),
      timetableSectionNew : encodeboolean(obj.timetableSectionNew),
      timetableUpcomingEventDate : encodeDate(obj.timetableUpcomingEventDate),
      timetableUpcomingEventName : (obj.timetableUpcomingEventName),
      token : (obj.token),
      videoCount : encodenumber(obj.videoCount),
      weather : encodeWeatherBean(obj.weather),
    } as LaunchpadBeanJSON)
}

type LaunchpadConditionBeanJSON = {
  activityCover : string | undefined 
  activitySeenRecently : string | undefined 
  activitySeenToday : string | undefined 
  circleCount : string
  circleCreatedRecently : string
  customAvatar : string
  customFamilyCover : string
  diduknowCoverShowable : string | undefined 
  diduknowCreateCircleShowable : string | undefined 
  diduknowGreetingsShowable : string | undefined 
  diduknowPremiumShowable : string | undefined 
  diduknowProfileShowable : string | undefined 
  eventDayCount : string
  eventMonthCount : string
  eventWeekCount : string
  hasActivity : string | undefined 
  modifiedActivity : string
  modifiedActivityThisMonth : string
  modifiedActivityThisWeek : string
  modifiedActivityToday : string
  nbInvite : string
  nbMember : string
  newLikesInActivity : string
  openingMode : string
  premium : string | undefined 
  showDidYouKnow : string
  storageUsage : string
  todayEvents : Array<LaunchpadEventJSON> | undefined 
  upcomingBirthdays : Array<LaunchpadEventJSON> | undefined 
  upcomingEvents : Array<LaunchpadEventJSON> | undefined 
  upcomingTimetablesEvents : Array<LaunchpadEventJSON> | undefined 
}

export class LaunchpadConditionBean extends ServerBeanPrototype{

  activityCover : string
  activitySeenRecently : boolean
  activitySeenToday : boolean
  circleCount : number
  circleCreatedRecently : boolean
  customAvatar : boolean
  customFamilyCover : boolean
  diduknowCoverShowable : boolean
  diduknowCreateCircleShowable : boolean
  diduknowGreetingsShowable : boolean
  diduknowPremiumShowable : boolean
  diduknowProfileShowable : boolean
  eventDayCount : number
  eventMonthCount : number
  eventWeekCount : number
  hasActivity : boolean
  modifiedActivity : boolean
  modifiedActivityThisMonth : boolean
  modifiedActivityThisWeek : boolean
  modifiedActivityToday : boolean
  nbInvite : number
  nbMember : number
  newLikesInActivity : boolean
  openingMode : string
  premium : boolean
  showDidYouKnow : boolean
  storageUsage : number
  todayEvents : Array<LaunchpadEvent>
  upcomingBirthdays : Array<LaunchpadEvent>
  upcomingEvents : Array<LaunchpadEvent>
  upcomingTimetablesEvents : Array<LaunchpadEvent>

  constructor(json :LaunchpadConditionBeanJSON){
    super(json);
    this.activityCover = (json.activityCover);
    this.activitySeenRecently = decodeBoolean(json.activitySeenRecently);
    this.activitySeenToday = decodeBoolean(json.activitySeenToday);
    this.circleCount = decodenumber(json.circleCount);
    this.circleCreatedRecently = decodeboolean(json.circleCreatedRecently);
    this.customAvatar = decodeboolean(json.customAvatar);
    this.customFamilyCover = decodeboolean(json.customFamilyCover);
    this.diduknowCoverShowable = decodeBoolean(json.diduknowCoverShowable);
    this.diduknowCreateCircleShowable = decodeBoolean(json.diduknowCreateCircleShowable);
    this.diduknowGreetingsShowable = decodeBoolean(json.diduknowGreetingsShowable);
    this.diduknowPremiumShowable = decodeBoolean(json.diduknowPremiumShowable);
    this.diduknowProfileShowable = decodeBoolean(json.diduknowProfileShowable);
    this.eventDayCount = decodenumber(json.eventDayCount);
    this.eventMonthCount = decodenumber(json.eventMonthCount);
    this.eventWeekCount = decodenumber(json.eventWeekCount);
    this.hasActivity = decodeBoolean(json.hasActivity);
    this.modifiedActivity = decodeboolean(json.modifiedActivity);
    this.modifiedActivityThisMonth = decodeboolean(json.modifiedActivityThisMonth);
    this.modifiedActivityThisWeek = decodeboolean(json.modifiedActivityThisWeek);
    this.modifiedActivityToday = decodeboolean(json.modifiedActivityToday);
    this.nbInvite = decodenumber(json.nbInvite);
    this.nbMember = decodenumber(json.nbMember);
    this.newLikesInActivity = decodeboolean(json.newLikesInActivity);
    this.openingMode = decodeEnum(json.openingMode);
    this.premium = decodeBoolean(json.premium);
    this.showDidYouKnow = decodeboolean(json.showDidYouKnow);
    this.storageUsage = decodenumber(json.storageUsage);
    this.todayEvents = decodeArray(decodeLaunchpadEvent)(json.todayEvents);
    this.upcomingBirthdays = decodeArray(decodeLaunchpadEvent)(json.upcomingBirthdays);
    this.upcomingEvents = decodeArray(decodeLaunchpadEvent)(json.upcomingEvents);
    this.upcomingTimetablesEvents = decodeArray(decodeLaunchpadEvent)(json.upcomingTimetablesEvents);

    this.onDecode(json);
  }
}

function decodeLaunchpadConditionBean(json :LaunchpadConditionBeanJSON){
  return json===undefined?undefined:new LaunchpadConditionBean(json)
}

function encodeLaunchpadConditionBean(obj : LaunchpadConditionBean) :LaunchpadConditionBeanJSON {
    if(obj==null) return undefined
    return inline({
      activityCover : (obj.activityCover),
      activitySeenRecently : encodeBoolean(obj.activitySeenRecently),
      activitySeenToday : encodeBoolean(obj.activitySeenToday),
      circleCount : encodenumber(obj.circleCount),
      circleCreatedRecently : encodeboolean(obj.circleCreatedRecently),
      customAvatar : encodeboolean(obj.customAvatar),
      customFamilyCover : encodeboolean(obj.customFamilyCover),
      diduknowCoverShowable : encodeBoolean(obj.diduknowCoverShowable),
      diduknowCreateCircleShowable : encodeBoolean(obj.diduknowCreateCircleShowable),
      diduknowGreetingsShowable : encodeBoolean(obj.diduknowGreetingsShowable),
      diduknowPremiumShowable : encodeBoolean(obj.diduknowPremiumShowable),
      diduknowProfileShowable : encodeBoolean(obj.diduknowProfileShowable),
      eventDayCount : encodenumber(obj.eventDayCount),
      eventMonthCount : encodenumber(obj.eventMonthCount),
      eventWeekCount : encodenumber(obj.eventWeekCount),
      hasActivity : encodeBoolean(obj.hasActivity),
      modifiedActivity : encodeboolean(obj.modifiedActivity),
      modifiedActivityThisMonth : encodeboolean(obj.modifiedActivityThisMonth),
      modifiedActivityThisWeek : encodeboolean(obj.modifiedActivityThisWeek),
      modifiedActivityToday : encodeboolean(obj.modifiedActivityToday),
      nbInvite : encodenumber(obj.nbInvite),
      nbMember : encodenumber(obj.nbMember),
      newLikesInActivity : encodeboolean(obj.newLikesInActivity),
      openingMode : encodeEnum(obj.openingMode),
      premium : encodeBoolean(obj.premium),
      showDidYouKnow : encodeboolean(obj.showDidYouKnow),
      storageUsage : encodenumber(obj.storageUsage),
      todayEvents : encodeArray(encodeLaunchpadEvent)(obj.todayEvents),
      upcomingBirthdays : encodeArray(encodeLaunchpadEvent)(obj.upcomingBirthdays),
      upcomingEvents : encodeArray(encodeLaunchpadEvent)(obj.upcomingEvents),
      upcomingTimetablesEvents : encodeArray(encodeLaunchpadEvent)(obj.upcomingTimetablesEvents),
    } as LaunchpadConditionBeanJSON)
}

type LaunchpadEventJSON = {
  allDay : string | undefined 
  color : string | undefined 
  endDate : string | undefined 
  eventId : string | undefined 
  firstname : string | undefined 
  startDate : string | undefined 
  text : string | undefined 
  where : string | undefined 
}

export class LaunchpadEvent extends ServerBeanPrototype{

  allDay : boolean
  color : string
  endDate : Date
  eventId : string
  firstname : string
  startDate : Date
  text : string
  where : string

  constructor(json :LaunchpadEventJSON){
    super(json);
    this.allDay = decodeBoolean(json.allDay);
    this.color = (json.color);
    this.endDate = decodeDate(json.endDate);
    this.eventId = (json.eventId);
    this.firstname = (json.firstname);
    this.startDate = decodeDate(json.startDate);
    this.text = (json.text);
    this.where = (json.where);

    this.onDecode(json);
  }
}

function decodeLaunchpadEvent(json :LaunchpadEventJSON){
  return json===undefined?undefined:new LaunchpadEvent(json)
}

function encodeLaunchpadEvent(obj : LaunchpadEvent) :LaunchpadEventJSON {
    if(obj==null) return undefined
    return inline({
      allDay : encodeBoolean(obj.allDay),
      color : (obj.color),
      endDate : encodeDate(obj.endDate),
      eventId : (obj.eventId),
      firstname : (obj.firstname),
      startDate : encodeDate(obj.startDate),
      text : (obj.text),
      where : (obj.where),
    } as LaunchpadEventJSON)
}

type WeatherBeanJSON = {
  celciusFloat : string
  city : string
  date : string
  icon : string | undefined 
  tempAsString : string
  weather : string
}

export class WeatherBean extends ServerBeanPrototype{

  celciusFloat : number
  city : string
  date : Date
  icon : string
  tempAsString : string
  weather : string

  constructor(json :WeatherBeanJSON){
    super(json);
    this.celciusFloat = decodeNumber(json.celciusFloat);
    this.city = (json.city);
    this.date = decodeDate(json.date);
    this.icon = (json.icon);
    this.tempAsString = (json.tempAsString);
    this.weather = decodeEnum(json.weather);

    this.onDecode(json);
  }
}

function decodeWeatherBean(json :WeatherBeanJSON){
  return json===undefined?undefined:new WeatherBean(json)
}

function encodeWeatherBean(obj : WeatherBean) :WeatherBeanJSON {
    if(obj==null) return undefined
    return inline({
      celciusFloat : encodeNumber(obj.celciusFloat),
      city : (obj.city),
      date : encodeDate(obj.date),
      icon : (obj.icon),
      tempAsString : (obj.tempAsString),
      weather : encodeEnum(obj.weather),
    } as WeatherBeanJSON)
}

type CleanResultBeanJSON = {
  dbDeleteCount : string
  deletedCount : string
  memoryFree : string
}

export class CleanResultBean extends ServerBeanPrototype{

  dbDeleteCount : number
  deletedCount : number
  memoryFree : number

  constructor(json :CleanResultBeanJSON){
    super(json);
    this.dbDeleteCount = decodenumber(json.dbDeleteCount);
    this.deletedCount = decodenumber(json.deletedCount);
    this.memoryFree = decodenumber(json.memoryFree);

    this.onDecode(json);
  }
}

function decodeCleanResultBean(json :CleanResultBeanJSON){
  return json===undefined?undefined:new CleanResultBean(json)
}

function encodeCleanResultBean(obj : CleanResultBean) :CleanResultBeanJSON {
    if(obj==null) return undefined
    return inline({
      dbDeleteCount : encodenumber(obj.dbDeleteCount),
      deletedCount : encodenumber(obj.deletedCount),
      memoryFree : encodenumber(obj.memoryFree),
    } as CleanResultBeanJSON)
}

type CategoryBeanJSON = {
  accountId : string | undefined 
  categorySystem : string | undefined 
  emoji : string | undefined 
  familyId : string
  listed : string
  metaId : string
  name : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sortingIndex : string
}

export class CategoryBean extends ServerBeanPrototype{

  accountId : number
  categorySystem : string
  emoji : string
  familyId : number
  listed : boolean
  metaId : string
  name : string
  rights : FizRightBean
  sortingIndex : number

  constructor(json :CategoryBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.categorySystem = decodeEnum(json.categorySystem);
    this.emoji = (json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.listed = decodeboolean(json.listed);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndex = decodeNumber(json.sortingIndex);

    this.onDecode(json);
  }
}

function decodeCategoryBean(json :CategoryBeanJSON){
  return json===undefined?undefined:new CategoryBean(json)
}

function encodeCategoryBean(obj : CategoryBean) :CategoryBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      categorySystem : encodeEnum(obj.categorySystem),
      emoji : (obj.emoji),
      familyId : encodeNumber(obj.familyId),
      listed : encodeboolean(obj.listed),
      metaId : (obj.metaId),
      name : (obj.name),
      rights : undefined,
      sortingIndex : encodeNumber(obj.sortingIndex),
    } as CategoryBeanJSON)
}

type CategoryInputBeanJSON = {
  emoji : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
}

export class CategoryInputBean extends ServerBeanPrototype{

  emoji : string
  metaId : string
  name : string

  constructor(json :CategoryInputBeanJSON){
    super(json);
    this.emoji = (json.emoji);
    this.metaId = (json.metaId);
    this.name = (json.name);

    this.onDecode(json);
  }
}

function decodeCategoryInputBean(json :CategoryInputBeanJSON){
  return json===undefined?undefined:new CategoryInputBean(json)
}

function encodeCategoryInputBean(obj : CategoryInputBean) :CategoryInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      emoji : (obj.emoji),
      metaId : (obj.metaId),
      name : (obj.name),
    } as CategoryInputBeanJSON)
}

type DishBeanJSON = {
  accountId : string
  date : string
  familyId : string | undefined 
  metaId : string
  name : string | undefined 
  recipeId : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sortingIndex : string
  type : string
}

export class DishBean extends ServerBeanPrototype{

  accountId : number
  date : string
  familyId : string
  metaId : string
  name : string
  recipeId : string
  rights : FizRightBean
  sortingIndex : number
  type : string

  constructor(json :DishBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.date = (json.date);
    this.familyId = (json.familyId);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.recipeId = (json.recipeId);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndex = decodenumber(json.sortingIndex);
    this.type = decodeEnum(json.type);

    this.onDecode(json);
  }
}

function decodeDishBean(json :DishBeanJSON){
  return json===undefined?undefined:new DishBean(json)
}

function encodeDishBean(obj : DishBean) :DishBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      date : (obj.date),
      familyId : (obj.familyId),
      metaId : (obj.metaId),
      name : (obj.name),
      recipeId : (obj.recipeId),
      rights : undefined,
      sortingIndex : encodenumber(obj.sortingIndex),
      type : encodeEnum(obj.type),
    } as DishBeanJSON)
}

type DishRangeBeanJSON = {
  from : string
  list : Array<DishBeanJSON>
  mealList : Array<MealBeanJSON>
  recipeList : Array<RecipeBeanJSON>
  to : string
}

export class DishRangeBean extends ServerBeanPrototype{

  from : string
  list : Array<DishBean>
  mealList : Array<MealBean>
  recipeList : Array<RecipeBean>
  to : string

  constructor(json :DishRangeBeanJSON){
    super(json);
    this.from = (json.from);
    this.list = decodeArray(decodeDishBean)(json.list);
    this.mealList = decodeArray(decodeMealBean)(json.mealList);
    this.recipeList = decodeArray(decodeRecipeBean)(json.recipeList);
    this.to = (json.to);

    this.onDecode(json);
  }
}

function decodeDishRangeBean(json :DishRangeBeanJSON){
  return json===undefined?undefined:new DishRangeBean(json)
}

function encodeDishRangeBean(obj : DishRangeBean) :DishRangeBeanJSON {
    if(obj==null) return undefined
    return inline({
      from : (obj.from),
      list : encodeArray(encodeDishBean)(obj.list),
      mealList : encodeArray(encodeMealBean)(obj.mealList),
      recipeList : encodeArray(encodeRecipeBean)(obj.recipeList),
      to : (obj.to),
    } as DishRangeBeanJSON)
}

type DishSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<DishBeanJSON>
}

export class DishSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<DishBean>

  constructor(json :DishSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeDishBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeDishSyncBean(json :DishSyncBeanJSON){
  return json===undefined?undefined:new DishSyncBean(json)
}

function encodeDishSyncBean(obj : DishSyncBean) :DishSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeDishBean)(obj.updatedCreated),
    } as DishSyncBeanJSON)
}

type IAGenerateRecipeParametersJSON = {
  cuisineType : string
  directions : string
  proteinType : string
  units : string
}

export class IAGenerateRecipeParameters extends ServerBeanPrototype{

  cuisineType : string
  directions : string
  proteinType : string
  units : string

  constructor(json :IAGenerateRecipeParametersJSON){
    super(json);
    this.cuisineType = (json.cuisineType);
    this.directions = (json.directions);
    this.proteinType = (json.proteinType);
    this.units = (json.units);

    this.onDecode(json);
  }
}

function decodeIAGenerateRecipeParameters(json :IAGenerateRecipeParametersJSON){
  return json===undefined?undefined:new IAGenerateRecipeParameters(json)
}

function encodeIAGenerateRecipeParameters(obj : IAGenerateRecipeParameters) :IAGenerateRecipeParametersJSON {
    if(obj==null) return undefined
    return inline({
      cuisineType : (obj.cuisineType),
      directions : (obj.directions),
      proteinType : (obj.proteinType),
      units : (obj.units),
    } as IAGenerateRecipeParametersJSON)
}

type MealBeanJSON = {
  accountId : string
  date : string | undefined 
  familyId : string | undefined 
  metaId : string | undefined 
  note : string | undefined 
  rights : FizRightBeanJSON | undefined 
  serves : string | undefined 
  type : string | undefined 
}

export class MealBean extends ServerBeanPrototype{

  accountId : number
  date : string
  familyId : string
  metaId : string
  note : string
  rights : FizRightBean
  serves : number
  type : string

  constructor(json :MealBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.date = (json.date);
    this.familyId = (json.familyId);
    this.metaId = (json.metaId);
    this.note = (json.note);
    this.rights = decodeFizRightBean(json.rights);
    this.serves = decodeNumber(json.serves);
    this.type = decodeEnum(json.type);

    this.onDecode(json);
  }
}

function decodeMealBean(json :MealBeanJSON){
  return json===undefined?undefined:new MealBean(json)
}

function encodeMealBean(obj : MealBean) :MealBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      date : (obj.date),
      familyId : (obj.familyId),
      metaId : (obj.metaId),
      note : (obj.note),
      rights : undefined,
      serves : encodeNumber(obj.serves),
      type : encodeEnum(obj.type),
    } as MealBeanJSON)
}

type MealInputBeanJSON = {
  date : string | undefined 
  metaId : string | undefined 
  note : string | undefined 
  serves : string | undefined 
  type : string | undefined 
}

export class MealInputBean extends ServerBeanPrototype{

  date : string
  metaId : string
  note : string
  serves : number
  type : string

  constructor(json :MealInputBeanJSON){
    super(json);
    this.date = (json.date);
    this.metaId = (json.metaId);
    this.note = (json.note);
    this.serves = decodeNumber(json.serves);
    this.type = decodeEnum(json.type);

    this.onDecode(json);
  }
}

function decodeMealInputBean(json :MealInputBeanJSON){
  return json===undefined?undefined:new MealInputBean(json)
}

function encodeMealInputBean(obj : MealInputBean) :MealInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      date : (obj.date),
      metaId : (obj.metaId),
      note : (obj.note),
      serves : encodeNumber(obj.serves),
      type : encodeEnum(obj.type),
    } as MealInputBeanJSON)
}

type MealPlannerSharedBeanJSON = {
  range : DishRangeBeanJSON
  settings : MealSettingsBeanJSON
}

export class MealPlannerSharedBean extends ServerBeanPrototype{

  range : DishRangeBean
  settings : MealSettingsBean

  constructor(json :MealPlannerSharedBeanJSON){
    super(json);
    this.range = decodeDishRangeBean(json.range);
    this.settings = decodeMealSettingsBean(json.settings);

    this.onDecode(json);
  }
}

function decodeMealPlannerSharedBean(json :MealPlannerSharedBeanJSON){
  return json===undefined?undefined:new MealPlannerSharedBean(json)
}

function encodeMealPlannerSharedBean(obj : MealPlannerSharedBean) :MealPlannerSharedBeanJSON {
    if(obj==null) return undefined
    return inline({
      range : encodeDishRangeBean(obj.range),
      settings : encodeMealSettingsBean(obj.settings),
    } as MealPlannerSharedBeanJSON)
}

type MealSettingsBeanJSON = {
  canClear : string | undefined 
  columns : Array<MealSettingsColumnBeanJSON> | undefined 
  defaultAddMealToListId : string | undefined 
  familyId : string | undefined 
  showWeekEnd : string | undefined 
  viewCalendar : string | undefined 
}

export class MealSettingsBean extends ServerBeanPrototype{

  canClear : boolean
  columns : Array<MealSettingsColumnBean>
  defaultAddMealToListId : string
  familyId : string
  showWeekEnd : boolean
  viewCalendar : boolean

  constructor(json :MealSettingsBeanJSON){
    super(json);
    this.canClear = decodeBoolean(json.canClear);
    this.columns = decodeArray(decodeMealSettingsColumnBean)(json.columns);
    this.defaultAddMealToListId = (json.defaultAddMealToListId);
    this.familyId = (json.familyId);
    this.showWeekEnd = decodeBoolean(json.showWeekEnd);
    this.viewCalendar = decodeBoolean(json.viewCalendar);

    this.onDecode(json);
  }
}

function decodeMealSettingsBean(json :MealSettingsBeanJSON){
  return json===undefined?undefined:new MealSettingsBean(json)
}

function encodeMealSettingsBean(obj : MealSettingsBean) :MealSettingsBeanJSON {
    if(obj==null) return undefined
    return inline({
      canClear : undefined,
      columns : encodeArray(encodeMealSettingsColumnBean)(obj.columns),
      defaultAddMealToListId : (obj.defaultAddMealToListId),
      familyId : (obj.familyId),
      showWeekEnd : encodeBoolean(obj.showWeekEnd),
      viewCalendar : encodeBoolean(obj.viewCalendar),
    } as MealSettingsBeanJSON)
}

type MealSettingsColumnBeanJSON = {
  display : string
  emoji : string | undefined 
  name : string | undefined 
  timeSlot : string | undefined 
  type : string
}

export class MealSettingsColumnBean extends ServerBeanPrototype{

  display : boolean
  emoji : string
  name : string
  timeSlot : string
  type : string

  constructor(json :MealSettingsColumnBeanJSON){
    super(json);
    this.display = decodeboolean(json.display);
    this.emoji = (json.emoji);
    this.name = (json.name);
    this.timeSlot = (json.timeSlot);
    this.type = decodeEnum(json.type);

    this.onDecode(json);
  }
}

function decodeMealSettingsColumnBean(json :MealSettingsColumnBeanJSON){
  return json===undefined?undefined:new MealSettingsColumnBean(json)
}

function encodeMealSettingsColumnBean(obj : MealSettingsColumnBean) :MealSettingsColumnBeanJSON {
    if(obj==null) return undefined
    return inline({
      display : encodeboolean(obj.display),
      emoji : (obj.emoji),
      name : (obj.name),
      timeSlot : (obj.timeSlot),
      type : encodeEnum(obj.type),
    } as MealSettingsColumnBeanJSON)
}

type MealSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<MealBeanJSON>
}

export class MealSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<MealBean>

  constructor(json :MealSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeMealBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeMealSyncBean(json :MealSyncBeanJSON){
  return json===undefined?undefined:new MealSyncBean(json)
}

function encodeMealSyncBean(obj : MealSyncBean) :MealSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeMealBean)(obj.updatedCreated),
    } as MealSyncBeanJSON)
}

type RecipeBeanJSON = {
  accountId : string
  bestMoment : string
  cookTime : string | undefined 
  creationDate : string
  description : string | undefined 
  externalId : string | undefined 
  familyId : string | undefined 
  ingredients : string | undefined 
  ingredientsList : Array<RecipeIngredientBeanJSON> | undefined 
  instructions : string | undefined 
  isFavorite : string
  isMealSuggestion : string | undefined 
  isRecipe : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  moodMap : {[key:string]:Array<string>}
  moodStarShortcut : string
  name : string | undefined 
  prepTime : string | undefined 
  recipeCategories : Array<string> | undefined 
  recipeCategoryIdList : Array<string> | undefined 
  rights : FizRightBeanJSON | undefined 
  serves : string | undefined 
  sortingIndex : string | undefined 
  url : string | undefined 
}

export class RecipeBean extends ServerBeanPrototype{

  accountId : number
  bestMoment : boolean
  cookTime : number
  creationDate : Date
  description : string
  externalId : string
  familyId : string
  ingredients : string
  ingredientsList : Array<RecipeIngredientBean>
  instructions : string
  isFavorite : boolean
  isMealSuggestion : boolean
  isRecipe : boolean
  medias : Array<IMedia>
  metaId : string
  moodMap : Map<number,Array<string>>
  moodStarShortcut : boolean
  name : string
  prepTime : number
  recipeCategories : Array<string>
  recipeCategoryIdList : Array<string>
  rights : FizRightBean
  serves : number
  sortingIndex : number
  url : string

  constructor(json :RecipeBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.cookTime = decodeNumber(json.cookTime);
    this.creationDate = decodeDate(json.creationDate);
    this.description = (json.description);
    this.externalId = (json.externalId);
    this.familyId = (json.familyId);
    this.ingredients = (json.ingredients);
    this.ingredientsList = decodeArray(decodeRecipeIngredientBean)(json.ingredientsList);
    this.instructions = (json.instructions);
    this.isFavorite = decodeboolean(json.isFavorite);
    this.isMealSuggestion = decodeBoolean(json.isMealSuggestion);
    this.isRecipe = decodeBoolean(json.isRecipe);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.name = (json.name);
    this.prepTime = decodeNumber(json.prepTime);
    this.recipeCategories = decodeArray(decodeString)(json.recipeCategories);
    this.recipeCategoryIdList = decodeArray(decodeString)(json.recipeCategoryIdList);
    this.rights = decodeFizRightBean(json.rights);
    this.serves = decodeNumber(json.serves);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.url = (json.url);

    this.onDecode(json);
  }
}

function decodeRecipeBean(json :RecipeBeanJSON){
  return json===undefined?undefined:new RecipeBean(json)
}

function encodeRecipeBean(obj : RecipeBean) :RecipeBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      bestMoment : encodeBoolean(obj.bestMoment),
      cookTime : encodeNumber(obj.cookTime),
      creationDate : encodeDate(obj.creationDate),
      description : (obj.description),
      externalId : undefined,
      familyId : (obj.familyId),
      ingredients : (obj.ingredients),
      ingredientsList : encodeArray(encodeRecipeIngredientBean)(obj.ingredientsList),
      instructions : (obj.instructions),
      isFavorite : encodeboolean(obj.isFavorite),
      isMealSuggestion : encodeBoolean(obj.isMealSuggestion),
      isRecipe : encodeBoolean(obj.isRecipe),
      medias : undefined,
      metaId : (obj.metaId),
      moodMap : encodeMap(encodeNumber,encodeArray(encodeEnum))(obj.moodMap),
      moodStarShortcut : encodeBoolean(obj.moodStarShortcut),
      name : (obj.name),
      prepTime : encodeNumber(obj.prepTime),
      recipeCategories : encodeArray(encodeString)(obj.recipeCategories),
      recipeCategoryIdList : encodeArray(encodeString)(obj.recipeCategoryIdList),
      rights : undefined,
      serves : encodeNumber(obj.serves),
      sortingIndex : encodeNumber(obj.sortingIndex),
      url : (obj.url),
    } as RecipeBeanJSON)
}

type RecipeExternalBeanJSON = {
  cookTime : string | undefined 
  description : string | undefined 
  displaySectionList : Array<string> | undefined 
  images : Array<OpenGraphMediaJSON>
  ingredients : string | undefined 
  ingredientsList : Array<RecipeIngredientBeanJSON> | undefined 
  instructions : string | undefined 
  isMealSuggestion : string | undefined 
  isRecipe : string | undefined 
  listId : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
  prepTime : string | undefined 
  recipeCategories : Array<string> | undefined 
  recipeCategoryIdList : Array<string> | undefined 
  serves : string | undefined 
  sortingIndex : string | undefined 
  url : string | undefined 
}

export class RecipeExternalBean extends ServerBeanPrototype{

  cookTime : number
  description : string
  displaySectionList : Array<string>
  images : Array<OpenGraphMedia>
  ingredients : string
  ingredientsList : Array<RecipeIngredientBean>
  instructions : string
  isMealSuggestion : boolean
  isRecipe : boolean
  listId : string
  metaId : string
  name : string
  prepTime : number
  recipeCategories : Array<string>
  recipeCategoryIdList : Array<string>
  serves : number
  sortingIndex : number
  url : string

  constructor(json :RecipeExternalBeanJSON){
    super(json);
    this.cookTime = decodeNumber(json.cookTime);
    this.description = (json.description);
    this.displaySectionList = decodeArray(decodeEnum)(json.displaySectionList);
    this.images = decodeArray(decodeOpenGraphMedia)(json.images);
    this.ingredients = (json.ingredients);
    this.ingredientsList = decodeArray(decodeRecipeIngredientBean)(json.ingredientsList);
    this.instructions = (json.instructions);
    this.isMealSuggestion = decodeBoolean(json.isMealSuggestion);
    this.isRecipe = decodeBoolean(json.isRecipe);
    this.listId = (json.listId);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.prepTime = decodeNumber(json.prepTime);
    this.recipeCategories = decodeArray(decodeString)(json.recipeCategories);
    this.recipeCategoryIdList = decodeArray(decodeString)(json.recipeCategoryIdList);
    this.serves = decodeNumber(json.serves);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.url = (json.url);

    this.onDecode(json);
  }
}

function decodeRecipeExternalBean(json :RecipeExternalBeanJSON){
  return json===undefined?undefined:new RecipeExternalBean(json)
}

function encodeRecipeExternalBean(obj : RecipeExternalBean) :RecipeExternalBeanJSON {
    if(obj==null) return undefined
    return inline({
      cookTime : encodeNumber(obj.cookTime),
      description : (obj.description),
      displaySectionList : undefined,
      images : encodeArray(encodeOpenGraphMedia)(obj.images),
      ingredients : (obj.ingredients),
      ingredientsList : encodeArray(encodeRecipeIngredientBean)(obj.ingredientsList),
      instructions : (obj.instructions),
      isMealSuggestion : encodeBoolean(obj.isMealSuggestion),
      isRecipe : encodeBoolean(obj.isRecipe),
      listId : undefined,
      metaId : (obj.metaId),
      name : (obj.name),
      prepTime : encodeNumber(obj.prepTime),
      recipeCategories : encodeArray(encodeString)(obj.recipeCategories),
      recipeCategoryIdList : encodeArray(encodeString)(obj.recipeCategoryIdList),
      serves : encodeNumber(obj.serves),
      sortingIndex : encodeNumber(obj.sortingIndex),
      url : (obj.url),
    } as RecipeExternalBeanJSON)
}

type RecipeExternalSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<RecipeExternalBeanJSON>
}

export class RecipeExternalSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<RecipeExternalBean>

  constructor(json :RecipeExternalSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeRecipeExternalBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeRecipeExternalSyncBean(json :RecipeExternalSyncBeanJSON){
  return json===undefined?undefined:new RecipeExternalSyncBean(json)
}

function encodeRecipeExternalSyncBean(obj : RecipeExternalSyncBean) :RecipeExternalSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeRecipeExternalBean)(obj.updatedCreated),
    } as RecipeExternalSyncBeanJSON)
}

type RecipeIngredientBeanJSON = {
  complementData : string | undefined 
  metaId : string | undefined 
  name : string
  quantity : string | undefined 
  unit : string | undefined 
}

export class RecipeIngredientBean extends ServerBeanPrototype{

  complementData : string
  metaId : string
  name : string
  quantity : string
  unit : string

  constructor(json :RecipeIngredientBeanJSON){
    super(json);
    this.complementData = (json.complementData);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.quantity = (json.quantity);
    this.unit = (json.unit);

    this.onDecode(json);
  }
}

function decodeRecipeIngredientBean(json :RecipeIngredientBeanJSON){
  return json===undefined?undefined:new RecipeIngredientBean(json)
}

function encodeRecipeIngredientBean(obj : RecipeIngredientBean) :RecipeIngredientBeanJSON {
    if(obj==null) return undefined
    return inline({
      complementData : (obj.complementData),
      metaId : (obj.metaId),
      name : (obj.name),
      quantity : (obj.quantity),
      unit : (obj.unit),
    } as RecipeIngredientBeanJSON)
}

type RecipeInputBeanJSON = {
  cookTime : string | undefined 
  description : string | undefined 
  ingredients : string | undefined 
  ingredientsList : Array<RecipeIngredientBeanJSON> | undefined 
  instructions : string | undefined 
  isMealSuggestion : string | undefined 
  isRecipe : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
  prepTime : string | undefined 
  recipeCategories : Array<string> | undefined 
  recipeCategoryIdList : Array<string> | undefined 
  serves : string | undefined 
  sortingIndex : string | undefined 
  url : string | undefined 
}

export class RecipeInputBean extends ServerBeanPrototype{

  cookTime : number
  description : string
  ingredients : string
  ingredientsList : Array<RecipeIngredientBean>
  instructions : string
  isMealSuggestion : boolean
  isRecipe : boolean
  metaId : string
  name : string
  prepTime : number
  recipeCategories : Array<string>
  recipeCategoryIdList : Array<string>
  serves : number
  sortingIndex : number
  url : string

  constructor(json :RecipeInputBeanJSON){
    super(json);
    this.cookTime = decodeNumber(json.cookTime);
    this.description = (json.description);
    this.ingredients = (json.ingredients);
    this.ingredientsList = decodeArray(decodeRecipeIngredientBean)(json.ingredientsList);
    this.instructions = (json.instructions);
    this.isMealSuggestion = decodeBoolean(json.isMealSuggestion);
    this.isRecipe = decodeBoolean(json.isRecipe);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.prepTime = decodeNumber(json.prepTime);
    this.recipeCategories = decodeArray(decodeString)(json.recipeCategories);
    this.recipeCategoryIdList = decodeArray(decodeString)(json.recipeCategoryIdList);
    this.serves = decodeNumber(json.serves);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.url = (json.url);

    this.onDecode(json);
  }
}

function decodeRecipeInputBean(json :RecipeInputBeanJSON){
  return json===undefined?undefined:new RecipeInputBean(json)
}

function encodeRecipeInputBean(obj : RecipeInputBean) :RecipeInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      cookTime : encodeNumber(obj.cookTime),
      description : (obj.description),
      ingredients : (obj.ingredients),
      ingredientsList : encodeArray(encodeRecipeIngredientBean)(obj.ingredientsList),
      instructions : (obj.instructions),
      isMealSuggestion : encodeBoolean(obj.isMealSuggestion),
      isRecipe : encodeBoolean(obj.isRecipe),
      metaId : (obj.metaId),
      name : (obj.name),
      prepTime : encodeNumber(obj.prepTime),
      recipeCategories : encodeArray(encodeString)(obj.recipeCategories),
      recipeCategoryIdList : encodeArray(encodeString)(obj.recipeCategoryIdList),
      serves : encodeNumber(obj.serves),
      sortingIndex : encodeNumber(obj.sortingIndex),
      url : (obj.url),
    } as RecipeInputBeanJSON)
}

type RecipePuByUrlResultBeanJSON = {
  og : OpenGraphDataBeanJSON | undefined 
  recipe : RecipeBeanJSON | undefined 
}

export class RecipePuByUrlResultBean extends ServerBeanPrototype{

  og : OpenGraphDataBean
  recipe : RecipeBean

  constructor(json :RecipePuByUrlResultBeanJSON){
    super(json);
    this.og = decodeOpenGraphDataBean(json.og);
    this.recipe = decodeRecipeBean(json.recipe);

    this.onDecode(json);
  }
}

function decodeRecipePuByUrlResultBean(json :RecipePuByUrlResultBeanJSON){
  return json===undefined?undefined:new RecipePuByUrlResultBean(json)
}

function encodeRecipePuByUrlResultBean(obj : RecipePuByUrlResultBean) :RecipePuByUrlResultBeanJSON {
    if(obj==null) return undefined
    return inline({
      og : encodeOpenGraphDataBean(obj.og),
      recipe : encodeRecipeBean(obj.recipe),
    } as RecipePuByUrlResultBeanJSON)
}

type RecipeSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<RecipeBeanJSON>
}

export class RecipeSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<RecipeBean>

  constructor(json :RecipeSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeRecipeBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeRecipeSyncBean(json :RecipeSyncBeanJSON){
  return json===undefined?undefined:new RecipeSyncBean(json)
}

function encodeRecipeSyncBean(obj : RecipeSyncBean) :RecipeSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeRecipeBean)(obj.updatedCreated),
    } as RecipeSyncBeanJSON)
}

type ShoppingIngredientInputBeanJSON = {
  dishMetaId : string
  ingredientList : Array<string> | undefined 
}

export class ShoppingIngredientInputBean extends ServerBeanPrototype{

  dishMetaId : string
  ingredientList : Array<string>

  constructor(json :ShoppingIngredientInputBeanJSON){
    super(json);
    this.dishMetaId = (json.dishMetaId);
    this.ingredientList = decodeArray(decodeString)(json.ingredientList);

    this.onDecode(json);
  }
}

function decodeShoppingIngredientInputBean(json :ShoppingIngredientInputBeanJSON){
  return json===undefined?undefined:new ShoppingIngredientInputBean(json)
}

function encodeShoppingIngredientInputBean(obj : ShoppingIngredientInputBean) :ShoppingIngredientInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      dishMetaId : (obj.dishMetaId),
      ingredientList : encodeArray(encodeString)(obj.ingredientList),
    } as ShoppingIngredientInputBeanJSON)
}

type MediaBeanJSON = {
  accountId : string | undefined 
  bestMoment : string
  color : string | undefined 
  creationDate : string | undefined 
  datasize : string | undefined 
  durationMs : string | undefined 
  familyId : string | undefined 
  filerModifDate : string | undefined 
  mediaId : string | undefined 
  metaId : string | undefined 
  mimeType : string | undefined 
  moodMap : {[key:string]:Array<string>} | undefined 
  name : string | undefined 
  parentFolderId : string | undefined 
  pictureUrl : string
  pointedBy : string | undefined 
  pointedByWhat : string | undefined 
  readystate : string | undefined 
  resolutionX : string | undefined 
  resolutionY : string | undefined 
  rights : FizRightBeanJSON
}

export class MediaBean extends ServerBeanPrototype{

  accountId : number
  bestMoment : boolean
  color : string
  creationDate : Date
  datasize : number
  durationMs : number
  familyId : string
  filerModifDate : Date
  mediaId : string
  metaId : string
  mimeType : string
  moodMap : Map<number,Array<string>>
  name : string
  parentFolderId : string
  pictureUrl : string
  pointedBy : string
  pointedByWhat : string
  readystate : string
  resolutionX : number
  resolutionY : number
  rights : FizRightBean

  constructor(json :MediaBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeboolean(json.bestMoment);
    this.color = (json.color);
    this.creationDate = decodeDate(json.creationDate);
    this.datasize = decodeNumber(json.datasize);
    this.durationMs = decodeNumber(json.durationMs);
    this.familyId = (json.familyId);
    this.filerModifDate = decodeDate(json.filerModifDate);
    this.mediaId = (json.mediaId);
    this.metaId = (json.metaId);
    this.mimeType = (json.mimeType);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.name = (json.name);
    this.parentFolderId = (json.parentFolderId);
    this.pictureUrl = (json.pictureUrl);
    this.pointedBy = (json.pointedBy);
    this.pointedByWhat = decodeEnum(json.pointedByWhat);
    this.readystate = decodeEnum(json.readystate);
    this.resolutionX = decodeNumber(json.resolutionX);
    this.resolutionY = decodeNumber(json.resolutionY);
    this.rights = decodeFizRightBean(json.rights);

    this.onDecode(json);
  }
}

function decodeMediaBean(json :MediaBeanJSON){
  return json===undefined?undefined:new MediaBean(json)
}

function encodeMediaBean(obj : MediaBean) :MediaBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      bestMoment : encodeboolean(obj.bestMoment),
      color : (obj.color),
      creationDate : encodeDate(obj.creationDate),
      datasize : encodeNumber(obj.datasize),
      durationMs : encodeNumber(obj.durationMs),
      familyId : (obj.familyId),
      filerModifDate : undefined,
      mediaId : (obj.mediaId),
      metaId : (obj.metaId),
      mimeType : (obj.mimeType),
      moodMap : encodeMap(encodeNumber,encodeArray(encodeEnum))(obj.moodMap),
      name : (obj.name),
      parentFolderId : (obj.parentFolderId),
      pictureUrl : (obj.pictureUrl),
      pointedBy : (obj.pointedBy),
      pointedByWhat : encodeEnum(obj.pointedByWhat),
      readystate : encodeEnum(obj.readystate),
      resolutionX : encodeNumber(obj.resolutionX),
      resolutionY : encodeNumber(obj.resolutionY),
      rights : undefined,
    } as MediaBeanJSON)
}

type MediaFilterFrontImageJSON = {
  accountId : string | undefined 
  familyId : string
  frontMedia : IMediaJSON | undefined 
  metaId : string
  number : string
  numberPictures : string
  numberVideos : string
  pictureUrl : string | undefined 
  type : string
}

export class MediaFilterFrontImage extends ServerBeanPrototype{

  accountId : number
  familyId : string
  frontMedia : IMedia
  metaId : string
  number : number
  numberPictures : number
  numberVideos : number
  pictureUrl : string
  type : string

  constructor(json :MediaFilterFrontImageJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.familyId = (json.familyId);
    this.frontMedia = decodeIMedia(json.frontMedia);
    this.metaId = (json.metaId);
    this.number = decodenumber(json.number);
    this.numberPictures = decodenumber(json.numberPictures);
    this.numberVideos = decodenumber(json.numberVideos);
    this.pictureUrl = (json.pictureUrl);
    this.type = decodeEnum(json.type);

    this.onDecode(json);
  }
}

function decodeMediaFilterFrontImage(json :MediaFilterFrontImageJSON){
  return json===undefined?undefined:new MediaFilterFrontImage(json)
}

function encodeMediaFilterFrontImage(obj : MediaFilterFrontImage) :MediaFilterFrontImageJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      familyId : (obj.familyId),
      frontMedia : encodeIMedia(obj.frontMedia),
      metaId : (obj.metaId),
      number : encodenumber(obj.number),
      numberPictures : encodenumber(obj.numberPictures),
      numberVideos : encodenumber(obj.numberVideos),
      pictureUrl : (obj.pictureUrl),
      type : encodeEnum(obj.type),
    } as MediaFilterFrontImageJSON)
}

type MediaListBeanJSON = {
  accountId : string | undefined 
  familyId : string | undefined 
} & PaginatedCollectionJSON<IMediaJSON>

export class MediaListBean extends ServerBeanPrototype{

  accountId : number
  familyId : string
  mediaList : PaginatedCollection<IMedia>

  constructor(json :MediaListBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.familyId = (json.familyId);
    this.mediaList = decodePaginatedCollection(decodeIMedia)(json);

    this.onDecode(json);
  }
}

function decodeMediaListBean(json :MediaListBeanJSON){
  return json===undefined?undefined:new MediaListBean(json)
}

function encodeMediaListBean(obj : MediaListBean) :MediaListBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      familyId : (obj.familyId),
    } as MediaListBeanJSON, encodePaginatedCollection(encodeIMedia)(obj.mediaList))
}

type MediaQuotaJSON = {
  color : string
  familyId : string | undefined 
  familyQuota : string
  familyRemain : string
  familyUsed : string
  rightFlag : string
  usedByOwner : {[key:string]:string}
}

export class MediaQuota extends ServerBeanPrototype{

  color : string
  familyId : string
  familyQuota : number
  familyRemain : number
  familyUsed : number
  rightFlag : string
  usedByOwner : Map<number,number>

  constructor(json :MediaQuotaJSON){
    super(json);
    this.color = (json.color);
    this.familyId = (json.familyId);
    this.familyQuota = decodenumber(json.familyQuota);
    this.familyRemain = decodenumber(json.familyRemain);
    this.familyUsed = decodenumber(json.familyUsed);
    this.rightFlag = decodeEnum(json.rightFlag);
    this.usedByOwner = decodeMap(decodeNumber,decodeNumber)(json.usedByOwner);

    this.onDecode(json);
  }
}

function decodeMediaQuota(json :MediaQuotaJSON){
  return json===undefined?undefined:new MediaQuota(json)
}

function encodeMediaQuota(obj : MediaQuota) :MediaQuotaJSON {
    if(obj==null) return undefined
    return inline({
      color : (obj.color),
      familyId : (obj.familyId),
      familyQuota : encodenumber(obj.familyQuota),
      familyRemain : encodenumber(obj.familyRemain),
      familyUsed : encodenumber(obj.familyUsed),
      rightFlag : encodeEnum(obj.rightFlag),
      usedByOwner : encodeMap(encodeNumber,encodeNumber)(obj.usedByOwner),
    } as MediaQuotaJSON)
}

type OutlookCredentialBeanJSON = {
  credentialId : string
  errorCode : string | undefined 
  errorMessage : string | undefined 
  linkable : Array<OutlookLinkableCalendarBeanJSON> | undefined 
  linked : Array<CalendarBeanJSON>
  name : string | undefined 
}

export class OutlookCredentialBean extends ServerBeanPrototype{

  credentialId : string
  errorCode : string
  errorMessage : string
  linkable : Array<OutlookLinkableCalendarBean>
  linked : Array<CalendarBean>
  name : string

  constructor(json :OutlookCredentialBeanJSON){
    super(json);
    this.credentialId = (json.credentialId);
    this.errorCode = (json.errorCode);
    this.errorMessage = (json.errorMessage);
    this.linkable = decodeArray(decodeOutlookLinkableCalendarBean)(json.linkable);
    this.linked = decodeArray(decodeCalendarBean)(json.linked);
    this.name = (json.name);

    this.onDecode(json);
  }
}

function decodeOutlookCredentialBean(json :OutlookCredentialBeanJSON){
  return json===undefined?undefined:new OutlookCredentialBean(json)
}

function encodeOutlookCredentialBean(obj : OutlookCredentialBean) :OutlookCredentialBeanJSON {
    if(obj==null) return undefined
    return inline({
      credentialId : (obj.credentialId),
      errorCode : (obj.errorCode),
      errorMessage : (obj.errorMessage),
      linkable : encodeArray(encodeOutlookLinkableCalendarBean)(obj.linkable),
      linked : encodeArray(encodeCalendarBean)(obj.linked),
      name : (obj.name),
    } as OutlookCredentialBeanJSON)
}

type OutlookLinkableCalendarBeanJSON = {
  color : string
  linked : string
  name : string
  outlookId : string
}

export class OutlookLinkableCalendarBean extends ServerBeanPrototype{

  color : string
  linked : boolean
  name : string
  outlookId : string

  constructor(json :OutlookLinkableCalendarBeanJSON){
    super(json);
    this.color = (json.color);
    this.linked = decodeboolean(json.linked);
    this.name = (json.name);
    this.outlookId = (json.outlookId);

    this.onDecode(json);
  }
}

function decodeOutlookLinkableCalendarBean(json :OutlookLinkableCalendarBeanJSON){
  return json===undefined?undefined:new OutlookLinkableCalendarBean(json)
}

function encodeOutlookLinkableCalendarBean(obj : OutlookLinkableCalendarBean) :OutlookLinkableCalendarBeanJSON {
    if(obj==null) return undefined
    return inline({
      color : (obj.color),
      linked : encodeboolean(obj.linked),
      name : (obj.name),
      outlookId : (obj.outlookId),
    } as OutlookLinkableCalendarBeanJSON)
}

type GeocodedAddressJSON = {
  accuracy : string | undefined 
  attribute0Country : string | undefined 
  attribute1State : string | undefined 
  attribute2Town : string | undefined 
  attribute3ZipCode : string | undefined 
  attribute4Line : string | undefined 
  formattedAddress : string | undefined 
  latitudeE6 : string | undefined 
  longitudeE6 : string | undefined 
  radius : string | undefined 
}

export class GeocodedAddress extends ServerBeanPrototype{

  accuracy : number
  attribute0Country : string
  attribute1State : string
  attribute2Town : string
  attribute3ZipCode : string
  attribute4Line : string
  formattedAddress : string
  latitudeE6 : number
  longitudeE6 : number
  radius : number

  constructor(json :GeocodedAddressJSON){
    super(json);
    this.accuracy = decodeNumber(json.accuracy);
    this.attribute0Country = (json.attribute0Country);
    this.attribute1State = (json.attribute1State);
    this.attribute2Town = (json.attribute2Town);
    this.attribute3ZipCode = (json.attribute3ZipCode);
    this.attribute4Line = (json.attribute4Line);
    this.formattedAddress = (json.formattedAddress);
    this.latitudeE6 = decodeNumber(json.latitudeE6);
    this.longitudeE6 = decodeNumber(json.longitudeE6);
    this.radius = decodeNumber(json.radius);

    this.onDecode(json);
  }
}

function decodeGeocodedAddress(json :GeocodedAddressJSON){
  return json===undefined?undefined:new GeocodedAddress(json)
}

function encodeGeocodedAddress(obj : GeocodedAddress) :GeocodedAddressJSON {
    if(obj==null) return undefined
    return inline({
      accuracy : encodeNumber(obj.accuracy),
      attribute0Country : (obj.attribute0Country),
      attribute1State : (obj.attribute1State),
      attribute2Town : (obj.attribute2Town),
      attribute3ZipCode : (obj.attribute3ZipCode),
      attribute4Line : (obj.attribute4Line),
      formattedAddress : (obj.formattedAddress),
      latitudeE6 : encodeNumber(obj.latitudeE6),
      longitudeE6 : encodeNumber(obj.longitudeE6),
      radius : encodeNumber(obj.radius),
    } as GeocodedAddressJSON)
}

type LocationBeanJSON = {
  accountId : string
  address : GeocodedAddressJSON | undefined 
  authRequestPending : string
  authorized : string
  authorizedEndDate : string | undefined 
  deviceFlag : LocationDeviceFlagsJSON | undefined 
  familyId : string
  geolocSharing : string | undefined 
  geolocSharingEndDate : string | undefined 
  lastLocationDeviceId : string | undefined 
  lastPositionUpdateDate : string | undefined 
  lastRefreshRequestSentDate : string | undefined 
  locationState : string | undefined 
  mapURI : string | undefined 
  modifDate : string
  moveType : string
  placeId : string | undefined 
  wallMessage : IWallMessageJSON | undefined 
  wallMessageId : string | undefined 
}

export class LocationBean extends ServerBeanPrototype{

  accountId : number
  address : GeocodedAddress
  authRequestPending : string
  authorized : string
  authorizedEndDate : Date
  deviceFlag : LocationDeviceFlags
  familyId : string
  geolocSharing : string
  geolocSharingEndDate : Date
  lastLocationDeviceId : string
  lastPositionUpdateDate : Date
  lastRefreshRequestSentDate : Date
  locationState : string
  mapURI : string
  modifDate : Date
  moveType : string
  placeId : string
  wallMessage : IWallMessage
  wallMessageId : string

  constructor(json :LocationBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.address = decodeGeocodedAddress(json.address);
    this.authRequestPending = decodeEnum(json.authRequestPending);
    this.authorized = decodeEnum(json.authorized);
    this.authorizedEndDate = decodeDate(json.authorizedEndDate);
    this.deviceFlag = decodeLocationDeviceFlags(json.deviceFlag);
    this.familyId = (json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.geolocSharingEndDate = decodeDate(json.geolocSharingEndDate);
    this.lastLocationDeviceId = (json.lastLocationDeviceId);
    this.lastPositionUpdateDate = decodeDate(json.lastPositionUpdateDate);
    this.lastRefreshRequestSentDate = decodeDate(json.lastRefreshRequestSentDate);
    this.locationState = decodeEnum(json.locationState);
    this.mapURI = (json.mapURI);
    this.modifDate = decodeDate(json.modifDate);
    this.moveType = decodeEnum(json.moveType);
    this.placeId = (json.placeId);
    this.wallMessage = decodeIWallMessage(json.wallMessage);
    this.wallMessageId = (json.wallMessageId);

    this.onDecode(json);
  }
}

function decodeLocationBean(json :LocationBeanJSON){
  return json===undefined?undefined:new LocationBean(json)
}

function encodeLocationBean(obj : LocationBean) :LocationBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      address : encodeGeocodedAddress(obj.address),
      authRequestPending : encodeEnum(obj.authRequestPending),
      authorized : encodeEnum(obj.authorized),
      authorizedEndDate : encodeDate(obj.authorizedEndDate),
      deviceFlag : encodeLocationDeviceFlags(obj.deviceFlag),
      familyId : (obj.familyId),
      geolocSharing : encodeEnum(obj.geolocSharing),
      geolocSharingEndDate : encodeDate(obj.geolocSharingEndDate),
      lastLocationDeviceId : (obj.lastLocationDeviceId),
      lastPositionUpdateDate : encodeDate(obj.lastPositionUpdateDate),
      lastRefreshRequestSentDate : encodeDate(obj.lastRefreshRequestSentDate),
      locationState : encodeEnum(obj.locationState),
      mapURI : (obj.mapURI),
      modifDate : encodeDate(obj.modifDate),
      moveType : encodeEnum(obj.moveType),
      placeId : (obj.placeId),
      wallMessage : encodeIWallMessage(obj.wallMessage),
      wallMessageId : (obj.wallMessageId),
    } as LocationBeanJSON)
}

type LocationDeviceFlagsJSON = {
  locationDeviceId : string | undefined 
  locationServiceActive : string | undefined 
}

export class LocationDeviceFlags extends ServerBeanPrototype{

  locationDeviceId : string
  locationServiceActive : boolean

  constructor(json :LocationDeviceFlagsJSON){
    super(json);
    this.locationDeviceId = (json.locationDeviceId);
    this.locationServiceActive = decodeBoolean(json.locationServiceActive);

    this.onDecode(json);
  }
}

function decodeLocationDeviceFlags(json :LocationDeviceFlagsJSON){
  return json===undefined?undefined:new LocationDeviceFlags(json)
}

function encodeLocationDeviceFlags(obj : LocationDeviceFlags) :LocationDeviceFlagsJSON {
    if(obj==null) return undefined
    return inline({
      locationDeviceId : (obj.locationDeviceId),
      locationServiceActive : encodeBoolean(obj.locationServiceActive),
    } as LocationDeviceFlagsJSON)
}

type PlaceBeanJSON = {
  accountId : string
  address : GeocodedAddressJSON | undefined 
  contactId : string | undefined 
  editable : string | undefined 
  fWGeofencingIn : string | undefined 
  fWGeofencingOut : string | undefined 
  familyId : string
  geofencingActive : string | undefined 
  isTemporary : string
  mapURI : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  name : string
  placeId : string
  placeType : string | undefined 
  text : string | undefined 
  wifiMAC : string | undefined 
  wifiSSID : string | undefined 
}

export class PlaceBean extends ServerBeanPrototype{

  accountId : number
  address : GeocodedAddress
  contactId : string
  editable : boolean
  fWGeofencingIn : boolean
  fWGeofencingOut : boolean
  familyId : string
  geofencingActive : boolean
  isTemporary : boolean
  mapURI : string
  medias : Array<IMedia>
  metaId : string
  name : string
  placeId : string
  placeType : string
  text : string
  wifiMAC : string
  wifiSSID : string

  constructor(json :PlaceBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.address = decodeGeocodedAddress(json.address);
    this.contactId = (json.contactId);
    this.editable = decodeBoolean(json.editable);
    this.fWGeofencingIn = decodeBoolean(json.fWGeofencingIn);
    this.fWGeofencingOut = decodeBoolean(json.fWGeofencingOut);
    this.familyId = (json.familyId);
    this.geofencingActive = decodeBoolean(json.geofencingActive);
    this.isTemporary = decodeboolean(json.isTemporary);
    this.mapURI = (json.mapURI);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.placeId = (json.placeId);
    this.placeType = decodeEnum(json.placeType);
    this.text = (json.text);
    this.wifiMAC = (json.wifiMAC);
    this.wifiSSID = (json.wifiSSID);

    this.onDecode(json);
  }
}

function decodePlaceBean(json :PlaceBeanJSON){
  return json===undefined?undefined:new PlaceBean(json)
}

function encodePlaceBean(obj : PlaceBean) :PlaceBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      address : encodeGeocodedAddress(obj.address),
      contactId : (obj.contactId),
      editable : encodeBoolean(obj.editable),
      fWGeofencingIn : encodeBoolean(obj.fWGeofencingIn),
      fWGeofencingOut : encodeBoolean(obj.fWGeofencingOut),
      familyId : (obj.familyId),
      geofencingActive : encodeBoolean(obj.geofencingActive),
      isTemporary : encodeboolean(obj.isTemporary),
      mapURI : (obj.mapURI),
      medias : undefined,
      metaId : (obj.metaId),
      name : (obj.name),
      placeId : (obj.placeId),
      placeType : encodeEnum(obj.placeType),
      text : (obj.text),
      wifiMAC : (obj.wifiMAC),
      wifiSSID : (obj.wifiSSID),
    } as PlaceBeanJSON)
}

type PlaceGeofencingBeanJSON = {
  familyId : string
  geolocSharing : string | undefined 
  in : string
  metaId : string | undefined 
  out : string
  place : IPlaceJSON | undefined 
  placeId : string
  publisherId : string
  rightFlag : string
  subscriberId : string
}

export class PlaceGeofencingBean extends ServerBeanPrototype{

  familyId : string
  geolocSharing : string
  in : boolean
  metaId : string
  out : boolean
  place : IPlace
  placeId : string
  publisherId : number
  rightFlag : string
  subscriberId : number

  constructor(json :PlaceGeofencingBeanJSON){
    super(json);
    this.familyId = (json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.in = decodeboolean(json.in);
    this.metaId = (json.metaId);
    this.out = decodeboolean(json.out);
    this.place = decodeIPlace(json.place);
    this.placeId = (json.placeId);
    this.publisherId = decodeNumber(json.publisherId);
    this.rightFlag = decodeEnum(json.rightFlag);
    this.subscriberId = decodeNumber(json.subscriberId);

    this.onDecode(json);
  }
}

function decodePlaceGeofencingBean(json :PlaceGeofencingBeanJSON){
  return json===undefined?undefined:new PlaceGeofencingBean(json)
}

function encodePlaceGeofencingBean(obj : PlaceGeofencingBean) :PlaceGeofencingBeanJSON {
    if(obj==null) return undefined
    return inline({
      familyId : (obj.familyId),
      geolocSharing : encodeEnum(obj.geolocSharing),
      in : encodeboolean(obj.in),
      metaId : (obj.metaId),
      out : encodeboolean(obj.out),
      place : encodeIPlace(obj.place),
      placeId : (obj.placeId),
      publisherId : encodeNumber(obj.publisherId),
      rightFlag : encodeEnum(obj.rightFlag),
      subscriberId : encodeNumber(obj.subscriberId),
    } as PlaceGeofencingBeanJSON)
}

type PlaceNearbyResultJSON = {
  nearbyPlaces : Array<IPlaceJSON>
  otherPlaces : Array<IPlaceJSON>
}

export class PlaceNearbyResult extends ServerBeanPrototype{

  nearbyPlaces : Array<IPlace>
  otherPlaces : Array<IPlace>

  constructor(json :PlaceNearbyResultJSON){
    super(json);
    this.nearbyPlaces = decodeArray(decodeIPlace)(json.nearbyPlaces);
    this.otherPlaces = decodeArray(decodeIPlace)(json.otherPlaces);

    this.onDecode(json);
  }
}

function decodePlaceNearbyResult(json :PlaceNearbyResultJSON){
  return json===undefined?undefined:new PlaceNearbyResult(json)
}

function encodePlaceNearbyResult(obj : PlaceNearbyResult) :PlaceNearbyResultJSON {
    if(obj==null) return undefined
    return inline({
      nearbyPlaces : encodeArray(encodeIPlace)(obj.nearbyPlaces),
      otherPlaces : encodeArray(encodeIPlace)(obj.otherPlaces),
    } as PlaceNearbyResultJSON)
}

type PlaceSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<IPlaceJSON>
}

export class PlaceSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<IPlace>

  constructor(json :PlaceSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeIPlace)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodePlaceSyncBean(json :PlaceSyncBeanJSON){
  return json===undefined?undefined:new PlaceSyncBean(json)
}

function encodePlaceSyncBean(obj : PlaceSyncBean) :PlaceSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeIPlace)(obj.updatedCreated),
    } as PlaceSyncBeanJSON)
}

type BroadcastSignalMessageJSON = {
  payload : IBroadcastableJSON | undefined 
  signalStringVal : string | undefined 
  signalType : string
}

export class BroadcastSignalMessage extends ServerBeanPrototype{

  payload : IBroadcastable
  signalStringVal : string
  signalType : string

  constructor(json :BroadcastSignalMessageJSON){
    super(json);
    this.payload = decodeDynamic(json.payload) as IBroadcastable;
    this.signalStringVal = (json.signalStringVal);
    this.signalType = decodeEnum(json.signalType);

    this.onDecode(json);
  }
}

function decodeBroadcastSignalMessage(json :BroadcastSignalMessageJSON){
  return json===undefined?undefined:new BroadcastSignalMessage(json)
}

function encodeBroadcastSignalMessage(obj : BroadcastSignalMessage) :BroadcastSignalMessageJSON {
    if(obj==null) return undefined
    return inline({
      payload : encodeDynamic(obj.payload),
      signalStringVal : (obj.signalStringVal),
      signalType : encodeEnum(obj.signalType),
    } as BroadcastSignalMessageJSON)
}

type CacheInvalidatedMessageBeanJSON = {
  classname : string
  ownerId : string
}

export class CacheInvalidatedMessageBean extends ServerBeanPrototype{

  classname : string
  ownerId : number

  constructor(json :CacheInvalidatedMessageBeanJSON){
    super(json);
    this.classname = (json.classname);
    this.ownerId = decodeNumber(json.ownerId);

    this.onDecode(json);
  }
}

function decodeCacheInvalidatedMessageBean(json :CacheInvalidatedMessageBeanJSON){
  return json===undefined?undefined:new CacheInvalidatedMessageBean(json)
}

function encodeCacheInvalidatedMessageBean(obj : CacheInvalidatedMessageBean) :CacheInvalidatedMessageBeanJSON {
    if(obj==null) return undefined
    return inline({
      classname : (obj.classname),
      ownerId : encodeNumber(obj.ownerId),
    } as CacheInvalidatedMessageBeanJSON)
}

type DatabaseHealthStatusBeanJSON = {
  databases : {[key:string]:DatabaseHealthStatusValueJSON}
}

export class DatabaseHealthStatusBean extends ServerBeanPrototype{

  databases : Map<string,DatabaseHealthStatusValue>

  constructor(json :DatabaseHealthStatusBeanJSON){
    super(json);
    this.databases = decodeMap(decodeString,decodeDatabaseHealthStatusValue)(json.databases);

    this.onDecode(json);
  }
}

function decodeDatabaseHealthStatusBean(json :DatabaseHealthStatusBeanJSON){
  return json===undefined?undefined:new DatabaseHealthStatusBean(json)
}

function encodeDatabaseHealthStatusBean(obj : DatabaseHealthStatusBean) :DatabaseHealthStatusBeanJSON {
    if(obj==null) return undefined
    return inline({
      databases : encodeMap(encodeString,encodeDatabaseHealthStatusValue)(obj.databases),
    } as DatabaseHealthStatusBeanJSON)
}

type DatabaseHealthStatusValueJSON = {
  standBy : string
}

export class DatabaseHealthStatusValue extends ServerBeanPrototype{

  standBy : boolean

  constructor(json :DatabaseHealthStatusValueJSON){
    super(json);
    this.standBy = decodeboolean(json.standBy);

    this.onDecode(json);
  }
}

function decodeDatabaseHealthStatusValue(json :DatabaseHealthStatusValueJSON){
  return json===undefined?undefined:new DatabaseHealthStatusValue(json)
}

function encodeDatabaseHealthStatusValue(obj : DatabaseHealthStatusValue) :DatabaseHealthStatusValueJSON {
    if(obj==null) return undefined
    return inline({
      standBy : encodeboolean(obj.standBy),
    } as DatabaseHealthStatusValueJSON)
}

type PingPongPayloadBeanJSON = {
  clusterConnectedNodeIdList : Array<string>
  databaseStatus : DatabaseHealthStatusBeanJSON
  electorNumber : string | undefined 
  leader : string
  leaderServerId : string | undefined 
}

export class PingPongPayloadBean extends ServerBeanPrototype{

  clusterConnectedNodeIdList : Array<string>
  databaseStatus : DatabaseHealthStatusBean
  electorNumber : number
  leader : boolean
  leaderServerId : string

  constructor(json :PingPongPayloadBeanJSON){
    super(json);
    this.clusterConnectedNodeIdList = decodeArray(decodeString)(json.clusterConnectedNodeIdList);
    this.databaseStatus = decodeDatabaseHealthStatusBean(json.databaseStatus);
    this.electorNumber = decodeNumber(json.electorNumber);
    this.leader = decodeboolean(json.leader);
    this.leaderServerId = (json.leaderServerId);

    this.onDecode(json);
  }
}

function decodePingPongPayloadBean(json :PingPongPayloadBeanJSON){
  return json===undefined?undefined:new PingPongPayloadBean(json)
}

function encodePingPongPayloadBean(obj : PingPongPayloadBean) :PingPongPayloadBeanJSON {
    if(obj==null) return undefined
    return inline({
      clusterConnectedNodeIdList : encodeArray(encodeString)(obj.clusterConnectedNodeIdList),
      databaseStatus : encodeDatabaseHealthStatusBean(obj.databaseStatus),
      electorNumber : encodeNumber(obj.electorNumber),
      leader : encodeboolean(obj.leader),
      leaderServerId : (obj.leaderServerId),
    } as PingPongPayloadBeanJSON)
}

type PromoPushExtraPayloadJSON = {
  ct : string | undefined 
  sec : string | undefined 
  ta : string | undefined 
  url : string | undefined 
}

export class PromoPushExtraPayload extends ServerBeanPrototype{

  ct : string
  sec : string
  ta : string
  url : string

  constructor(json :PromoPushExtraPayloadJSON){
    super(json);
    this.ct = (json.ct);
    this.sec = decodeEnum(json.sec);
    this.ta = decodeEnum(json.ta);
    this.url = (json.url);

    this.onDecode(json);
  }
}

function decodePromoPushExtraPayload(json :PromoPushExtraPayloadJSON){
  return json===undefined?undefined:new PromoPushExtraPayload(json)
}

function encodePromoPushExtraPayload(obj : PromoPushExtraPayload) :PromoPushExtraPayloadJSON {
    if(obj==null) return undefined
    return inline({
      ct : (obj.ct),
      sec : encodeEnum(obj.sec),
      ta : encodeEnum(obj.ta),
      url : (obj.url),
    } as PromoPushExtraPayloadJSON)
}

type PushMessageBeanJSON = {
  accountId : string | undefined 
  authorIcon : string | undefined 
  deviceId : string
  extraInfo : string | undefined 
  extraJson : string | undefined 
  familyId : string | undefined 
  image : string | undefined 
  message : string
  messageType : string
  metaId : string | undefined 
  shadowMessageType : string | undefined 
  subtitle : string | undefined 
  targetId : string | undefined 
  title : string | undefined 
} & GeocodedAddressJSON

export class PushMessageBean extends ServerBeanPrototype{

  accountId : number
  authorIcon : string
  deviceId : string
  extraInfo : string
  extraJson : string
  familyId : string
  geocodedAddress : GeocodedAddress
  image : string
  message : string
  messageType : string
  metaId : string
  shadowMessageType : string
  subtitle : string
  targetId : string
  title : string

  constructor(json :PushMessageBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.authorIcon = (json.authorIcon);
    this.deviceId = (json.deviceId);
    this.extraInfo = (json.extraInfo);
    this.extraJson = (json.extraJson);
    this.familyId = (json.familyId);
    this.geocodedAddress = decodeGeocodedAddress(json);
    this.image = (json.image);
    this.message = (json.message);
    this.messageType = decodeEnum(json.messageType);
    this.metaId = (json.metaId);
    this.shadowMessageType = decodeEnum(json.shadowMessageType);
    this.subtitle = (json.subtitle);
    this.targetId = (json.targetId);
    this.title = (json.title);

    this.onDecode(json);
  }
}

function decodePushMessageBean(json :PushMessageBeanJSON){
  return json===undefined?undefined:new PushMessageBean(json)
}

function encodePushMessageBean(obj : PushMessageBean) :PushMessageBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      authorIcon : (obj.authorIcon),
      deviceId : (obj.deviceId),
      extraInfo : (obj.extraInfo),
      extraJson : (obj.extraJson),
      familyId : (obj.familyId),
      image : (obj.image),
      message : (obj.message),
      messageType : encodeEnum(obj.messageType),
      metaId : (obj.metaId),
      shadowMessageType : encodeEnum(obj.shadowMessageType),
      subtitle : (obj.subtitle),
      targetId : (obj.targetId),
      title : (obj.title),
    } as PushMessageBeanJSON, encodeGeocodedAddress(obj.geocodedAddress))
}

type WebSocketPushMessageJSON = {
  accountId : string | undefined 
  push : PushMessageBeanJSON | undefined 
  type : string | undefined 
}

export class WebSocketPushMessage extends ServerBeanPrototype{

  accountId : number
  push : PushMessageBean
  type : string

  constructor(json :WebSocketPushMessageJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.push = decodePushMessageBean(json.push);
    this.type = (json.type);

    this.onDecode(json);
  }
}

function decodeWebSocketPushMessage(json :WebSocketPushMessageJSON){
  return json===undefined?undefined:new WebSocketPushMessage(json)
}

function encodeWebSocketPushMessage(obj : WebSocketPushMessage) :WebSocketPushMessageJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      push : encodePushMessageBean(obj.push),
      type : (obj.type),
    } as WebSocketPushMessageJSON)
}

type AiInboxResponseBeanJSON = {
  alternative : string | undefined 
  available : string
  current : string | undefined 
  domain : string
}

export class AiInboxResponseBean extends ServerBeanPrototype{

  alternative : string
  available : boolean
  current : string
  domain : string

  constructor(json :AiInboxResponseBeanJSON){
    super(json);
    this.alternative = (json.alternative);
    this.available = decodeboolean(json.available);
    this.current = (json.current);
    this.domain = (json.domain);

    this.onDecode(json);
  }
}

function decodeAiInboxResponseBean(json :AiInboxResponseBeanJSON){
  return json===undefined?undefined:new AiInboxResponseBean(json)
}

function encodeAiInboxResponseBean(obj : AiInboxResponseBean) :AiInboxResponseBeanJSON {
    if(obj==null) return undefined
    return inline({
      alternative : (obj.alternative),
      available : encodeboolean(obj.available),
      current : (obj.current),
      domain : (obj.domain),
    } as AiInboxResponseBeanJSON)
}

type SettingsBeanJSON = {
  accountId : string | undefined 
  geoTrackingHistory : string | undefined 
  metaId : string | undefined 
  promoAccept : string | undefined 
  pushByEmail : string | undefined 
  pushForBestMoment : string | undefined 
  pushForBudget : string | undefined 
  pushForCheckin : string | undefined 
  pushForComment : string | undefined 
  pushForEvent : string | undefined 
  pushForFiler : string | undefined 
  pushForMessage : string | undefined 
  pushForPicture : string | undefined 
  pushForSpecialDays : string | undefined 
  pushForStatus : string | undefined 
  pushForTask : string | undefined 
  pushForTimetable : string | undefined 
  pushGlobal : string | undefined 
  reminderNotificationEnabled : string | undefined 
}

export class SettingsBean extends ServerBeanPrototype{

  accountId : number
  geoTrackingHistory : boolean
  metaId : string
  promoAccept : boolean
  pushByEmail : string
  pushForBestMoment : boolean
  pushForBudget : boolean
  pushForCheckin : boolean
  pushForComment : boolean
  pushForEvent : boolean
  pushForFiler : boolean
  pushForMessage : boolean
  pushForPicture : boolean
  pushForSpecialDays : boolean
  pushForStatus : boolean
  pushForTask : boolean
  pushForTimetable : boolean
  pushGlobal : boolean
  reminderNotificationEnabled : boolean

  constructor(json :SettingsBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.geoTrackingHistory = decodeBoolean(json.geoTrackingHistory);
    this.metaId = (json.metaId);
    this.promoAccept = decodeBoolean(json.promoAccept);
    this.pushByEmail = decodeEnum(json.pushByEmail);
    this.pushForBestMoment = decodeBoolean(json.pushForBestMoment);
    this.pushForBudget = decodeBoolean(json.pushForBudget);
    this.pushForCheckin = decodeBoolean(json.pushForCheckin);
    this.pushForComment = decodeBoolean(json.pushForComment);
    this.pushForEvent = decodeBoolean(json.pushForEvent);
    this.pushForFiler = decodeBoolean(json.pushForFiler);
    this.pushForMessage = decodeBoolean(json.pushForMessage);
    this.pushForPicture = decodeBoolean(json.pushForPicture);
    this.pushForSpecialDays = decodeBoolean(json.pushForSpecialDays);
    this.pushForStatus = decodeBoolean(json.pushForStatus);
    this.pushForTask = decodeBoolean(json.pushForTask);
    this.pushForTimetable = decodeBoolean(json.pushForTimetable);
    this.pushGlobal = decodeBoolean(json.pushGlobal);
    this.reminderNotificationEnabled = decodeBoolean(json.reminderNotificationEnabled);

    this.onDecode(json);
  }
}

function decodeSettingsBean(json :SettingsBeanJSON){
  return json===undefined?undefined:new SettingsBean(json)
}

function encodeSettingsBean(obj : SettingsBean) :SettingsBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      geoTrackingHistory : encodeBoolean(obj.geoTrackingHistory),
      metaId : (obj.metaId),
      promoAccept : encodeBoolean(obj.promoAccept),
      pushByEmail : encodeEnum(obj.pushByEmail),
      pushForBestMoment : encodeBoolean(obj.pushForBestMoment),
      pushForBudget : encodeBoolean(obj.pushForBudget),
      pushForCheckin : encodeBoolean(obj.pushForCheckin),
      pushForComment : encodeBoolean(obj.pushForComment),
      pushForEvent : encodeBoolean(obj.pushForEvent),
      pushForFiler : encodeBoolean(obj.pushForFiler),
      pushForMessage : encodeBoolean(obj.pushForMessage),
      pushForPicture : encodeBoolean(obj.pushForPicture),
      pushForSpecialDays : encodeBoolean(obj.pushForSpecialDays),
      pushForStatus : encodeBoolean(obj.pushForStatus),
      pushForTask : encodeBoolean(obj.pushForTask),
      pushForTimetable : encodeBoolean(obj.pushForTimetable),
      pushGlobal : encodeBoolean(obj.pushGlobal),
      reminderNotificationEnabled : encodeBoolean(obj.reminderNotificationEnabled),
    } as SettingsBeanJSON)
}

type SettingsPerFamilyBeanJSON = {
  accountId : string | undefined 
  calendarFirstDayOfWeek : string | undefined 
  calendarWeekNb : string | undefined 
  dailyBriefHourOfDelivery : string | undefined 
  dailyBriefNothingPlannedActivated : string | undefined 
  dailyBriefPushActivated : string | undefined 
  defaultReminderType : string | undefined 
  defaultReminderUnit : string | undefined 
  defaultReminderValue : string | undefined 
  editable : string | undefined 
  familyId : string | undefined 
  geolocSharing : string | undefined 
  mealplannerFirstDayOfWeek : string | undefined 
  showDidYouKnow : string | undefined 
  showDishes : string | undefined 
  showSmartCard : string | undefined 
}

export class SettingsPerFamilyBean extends ServerBeanPrototype{

  accountId : number
  calendarFirstDayOfWeek : number
  calendarWeekNb : boolean
  dailyBriefHourOfDelivery : number
  dailyBriefNothingPlannedActivated : boolean
  dailyBriefPushActivated : boolean
  defaultReminderType : string
  defaultReminderUnit : string
  defaultReminderValue : number
  editable : boolean
  familyId : string
  geolocSharing : string
  mealplannerFirstDayOfWeek : number
  showDidYouKnow : boolean
  showDishes : boolean
  showSmartCard : boolean

  constructor(json :SettingsPerFamilyBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.calendarFirstDayOfWeek = decodeNumber(json.calendarFirstDayOfWeek);
    this.calendarWeekNb = decodeBoolean(json.calendarWeekNb);
    this.dailyBriefHourOfDelivery = decodeNumber(json.dailyBriefHourOfDelivery);
    this.dailyBriefNothingPlannedActivated = decodeBoolean(json.dailyBriefNothingPlannedActivated);
    this.dailyBriefPushActivated = decodeBoolean(json.dailyBriefPushActivated);
    this.defaultReminderType = decodeEnum(json.defaultReminderType);
    this.defaultReminderUnit = decodeEnum(json.defaultReminderUnit);
    this.defaultReminderValue = decodeNumber(json.defaultReminderValue);
    this.editable = decodeBoolean(json.editable);
    this.familyId = (json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.mealplannerFirstDayOfWeek = decodeNumber(json.mealplannerFirstDayOfWeek);
    this.showDidYouKnow = decodeBoolean(json.showDidYouKnow);
    this.showDishes = decodeBoolean(json.showDishes);
    this.showSmartCard = decodeBoolean(json.showSmartCard);

    this.onDecode(json);
  }
}

function decodeSettingsPerFamilyBean(json :SettingsPerFamilyBeanJSON){
  return json===undefined?undefined:new SettingsPerFamilyBean(json)
}

function encodeSettingsPerFamilyBean(obj : SettingsPerFamilyBean) :SettingsPerFamilyBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      calendarFirstDayOfWeek : encodeNumber(obj.calendarFirstDayOfWeek),
      calendarWeekNb : encodeBoolean(obj.calendarWeekNb),
      dailyBriefHourOfDelivery : encodeNumber(obj.dailyBriefHourOfDelivery),
      dailyBriefNothingPlannedActivated : encodeBoolean(obj.dailyBriefNothingPlannedActivated),
      dailyBriefPushActivated : encodeBoolean(obj.dailyBriefPushActivated),
      defaultReminderType : encodeEnum(obj.defaultReminderType),
      defaultReminderUnit : encodeEnum(obj.defaultReminderUnit),
      defaultReminderValue : encodeNumber(obj.defaultReminderValue),
      editable : encodeBoolean(obj.editable),
      familyId : (obj.familyId),
      geolocSharing : encodeEnum(obj.geolocSharing),
      mealplannerFirstDayOfWeek : encodeNumber(obj.mealplannerFirstDayOfWeek),
      showDidYouKnow : encodeBoolean(obj.showDidYouKnow),
      showDishes : encodeBoolean(obj.showDishes),
      showSmartCard : encodeBoolean(obj.showSmartCard),
    } as SettingsPerFamilyBeanJSON)
}

type ClusterNodeStatusJSON = {
  clusterMember : string
  connected : string
  databaseStatus : DatabaseHealthStatusBeanJSON | undefined 
  lastMessageReceived : string | undefined 
  lastMessageSent : string | undefined 
  localLeader : string | undefined 
  me : string | undefined 
  serverId : string
  serverNb : string
}

export class ClusterNodeStatus extends ServerBeanPrototype{

  clusterMember : boolean
  connected : boolean
  databaseStatus : DatabaseHealthStatusBean
  lastMessageReceived : Date
  lastMessageSent : Date
  localLeader : boolean
  me : boolean
  serverId : string
  serverNb : number

  constructor(json :ClusterNodeStatusJSON){
    super(json);
    this.clusterMember = decodeboolean(json.clusterMember);
    this.connected = decodeboolean(json.connected);
    this.databaseStatus = decodeDatabaseHealthStatusBean(json.databaseStatus);
    this.lastMessageReceived = decodeDate(json.lastMessageReceived);
    this.lastMessageSent = decodeDate(json.lastMessageSent);
    this.localLeader = decodeBoolean(json.localLeader);
    this.me = decodeBoolean(json.me);
    this.serverId = (json.serverId);
    this.serverNb = decodenumber(json.serverNb);

    this.onDecode(json);
  }
}

function decodeClusterNodeStatus(json :ClusterNodeStatusJSON){
  return json===undefined?undefined:new ClusterNodeStatus(json)
}

function encodeClusterNodeStatus(obj : ClusterNodeStatus) :ClusterNodeStatusJSON {
    if(obj==null) return undefined
    return inline({
      clusterMember : encodeboolean(obj.clusterMember),
      connected : encodeboolean(obj.connected),
      databaseStatus : encodeDatabaseHealthStatusBean(obj.databaseStatus),
      lastMessageReceived : encodeDate(obj.lastMessageReceived),
      lastMessageSent : encodeDate(obj.lastMessageSent),
      localLeader : encodeBoolean(obj.localLeader),
      me : encodeBoolean(obj.me),
      serverId : (obj.serverId),
      serverNb : encodenumber(obj.serverNb),
    } as ClusterNodeStatusJSON)
}

type ClusterStatusJSON = {
  clusterConnected : string
  clusterEnabled : string
  connectionDebugMsg : string
  databaseStatus : DatabaseHealthStatusBeanJSON | undefined 
  lastDbSwitchDebugMsg : string
  lastEffectivelyClusterConnectedChange : string
  lastTimedClusterConnectedChange : string
  localElectedLeader : string | undefined 
  nodeList : Array<ClusterNodeStatusJSON>
  serverId : string
}

export class ClusterStatus extends ServerBeanPrototype{

  clusterConnected : boolean
  clusterEnabled : boolean
  connectionDebugMsg : string
  databaseStatus : DatabaseHealthStatusBean
  lastDbSwitchDebugMsg : string
  lastEffectivelyClusterConnectedChange : Date
  lastTimedClusterConnectedChange : Date
  localElectedLeader : string
  nodeList : Array<ClusterNodeStatus>
  serverId : string

  constructor(json :ClusterStatusJSON){
    super(json);
    this.clusterConnected = decodeboolean(json.clusterConnected);
    this.clusterEnabled = decodeboolean(json.clusterEnabled);
    this.connectionDebugMsg = (json.connectionDebugMsg);
    this.databaseStatus = decodeDatabaseHealthStatusBean(json.databaseStatus);
    this.lastDbSwitchDebugMsg = (json.lastDbSwitchDebugMsg);
    this.lastEffectivelyClusterConnectedChange = decodeDate(json.lastEffectivelyClusterConnectedChange);
    this.lastTimedClusterConnectedChange = decodeDate(json.lastTimedClusterConnectedChange);
    this.localElectedLeader = (json.localElectedLeader);
    this.nodeList = decodeArray(decodeClusterNodeStatus)(json.nodeList);
    this.serverId = (json.serverId);

    this.onDecode(json);
  }
}

function decodeClusterStatus(json :ClusterStatusJSON){
  return json===undefined?undefined:new ClusterStatus(json)
}

function encodeClusterStatus(obj : ClusterStatus) :ClusterStatusJSON {
    if(obj==null) return undefined
    return inline({
      clusterConnected : encodeboolean(obj.clusterConnected),
      clusterEnabled : encodeboolean(obj.clusterEnabled),
      connectionDebugMsg : (obj.connectionDebugMsg),
      databaseStatus : encodeDatabaseHealthStatusBean(obj.databaseStatus),
      lastDbSwitchDebugMsg : (obj.lastDbSwitchDebugMsg),
      lastEffectivelyClusterConnectedChange : encodeDate(obj.lastEffectivelyClusterConnectedChange),
      lastTimedClusterConnectedChange : encodeDate(obj.lastTimedClusterConnectedChange),
      localElectedLeader : (obj.localElectedLeader),
      nodeList : encodeArray(encodeClusterNodeStatus)(obj.nodeList),
      serverId : (obj.serverId),
    } as ClusterStatusJSON)
}

type StatusBeanJSON = {
  accountNumbers : string
  clusterStatus : ClusterStatusJSON
  errorMessage : string | undefined 
  startTime : string
  statusOfServer : string
}

export class StatusBean extends ServerBeanPrototype{

  accountNumbers : number
  clusterStatus : ClusterStatus
  errorMessage : string
  startTime : Date
  statusOfServer : string

  constructor(json :StatusBeanJSON){
    super(json);
    this.accountNumbers = decodeNumber(json.accountNumbers);
    this.clusterStatus = decodeClusterStatus(json.clusterStatus);
    this.errorMessage = (json.errorMessage);
    this.startTime = decodeDate(json.startTime);
    this.statusOfServer = decodeEnum(json.statusOfServer);

    this.onDecode(json);
  }
}

function decodeStatusBean(json :StatusBeanJSON){
  return json===undefined?undefined:new StatusBean(json)
}

function encodeStatusBean(obj : StatusBean) :StatusBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountNumbers : encodeNumber(obj.accountNumbers),
      clusterStatus : encodeClusterStatus(obj.clusterStatus),
      errorMessage : (obj.errorMessage),
      startTime : encodeDate(obj.startTime),
      statusOfServer : encodeEnum(obj.statusOfServer),
    } as StatusBeanJSON)
}

type SmsStubBeanJSON = {
  date : string
  from : string | undefined 
  message : string
  to : string | undefined 
}

export class SmsStubBean extends ServerBeanPrototype{

  date : Date
  from : string
  message : string
  to : string

  constructor(json :SmsStubBeanJSON){
    super(json);
    this.date = decodeDate(json.date);
    this.from = (json.from);
    this.message = (json.message);
    this.to = (json.to);

    this.onDecode(json);
  }
}

function decodeSmsStubBean(json :SmsStubBeanJSON){
  return json===undefined?undefined:new SmsStubBean(json)
}

function encodeSmsStubBean(obj : SmsStubBean) :SmsStubBeanJSON {
    if(obj==null) return undefined
    return inline({
      date : encodeDate(obj.date),
      from : (obj.from),
      message : (obj.message),
      to : (obj.to),
    } as SmsStubBeanJSON)
}

type AssigneeBeanJSON = {
  accountId : string
}

export class AssigneeBean extends ServerBeanPrototype{

  accountId : number

  constructor(json :AssigneeBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);

    this.onDecode(json);
  }
}

function decodeAssigneeBean(json :AssigneeBeanJSON){
  return json===undefined?undefined:new AssigneeBean(json)
}

function encodeAssigneeBean(obj : AssigneeBean) :AssigneeBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
    } as AssigneeBeanJSON)
}

//deprecated we should not keep it but no choice
  function decodeCategoryDescriptor(json){return json;}

type TaskBeanJSON = {
  accountId : string | undefined 
  assignee : Array<AssigneeBeanJSON> | undefined 
  assigneeIds : Array<string> | undefined 
  bestMoment : string | undefined 
  comments : Array<ICommentJSON> | undefined 
  complete : string | undefined 
  completedDate : string | undefined 
  creationDate : string | undefined 
  description : string | undefined 
  dueDate : string | undefined 
  editable : string | undefined 
  familyId : string
  lastAction : string | undefined 
  lastActionAuthor : string | undefined 
  lastActionDate : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  modifDate : string
  moodMap : {[key:string]:Array<string>} | undefined 
  moodStarShortcut : string | undefined 
  refId : string | undefined 
  reminder : IReminderJSON | undefined 
  sortingIndex : string
  taskCategoryId : string | undefined 
  taskId : string | undefined 
  taskListId : string | undefined 
  text : string | undefined 
  toAll : string | undefined 
} & RecurrencyDescriptorJSON

export class TaskBean extends ServerBeanPrototype{

  accountId : number
  assignee : Array<AssigneeBean>
  assigneeIds : Array<number>
  bestMoment : boolean
  comments : Array<IComment>
  complete : boolean
  completedDate : Date
  creationDate : Date
  description : string
  dueDate : Date
  editable : boolean
  familyId : string
  lastAction : string
  lastActionAuthor : number
  lastActionDate : Date
  medias : Array<IMedia>
  metaId : string
  modifDate : Date
  moodMap : Map<number,Array<string>>
  moodStarShortcut : boolean
  recurrencyDescriptor : RecurrencyDescriptor
  refId : string
  reminder : IReminder
  sortingIndex : number
  taskCategoryId : string
  taskId : string
  taskListId : string
  text : string
  toAll : boolean

  constructor(json :TaskBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.assignee = decodeArray(decodeAssigneeBean)(json.assignee);
    this.assigneeIds = decodeArray(decodeNumber)(json.assigneeIds);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.complete = decodeBoolean(json.complete);
    this.completedDate = decodeDate(json.completedDate);
    this.creationDate = decodeDate(json.creationDate);
    this.description = (json.description);
    this.dueDate = decodeDate(json.dueDate);
    this.editable = decodeBoolean(json.editable);
    this.familyId = (json.familyId);
    this.lastAction = decodeEnum(json.lastAction);
    this.lastActionAuthor = decodeNumber(json.lastActionAuthor);
    this.lastActionDate = decodeDate(json.lastActionDate);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.modifDate = decodeDate(json.modifDate);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.refId = (json.refId);
    this.reminder = decodeIReminder(json.reminder);
    this.sortingIndex = decodenumber(json.sortingIndex);
    this.taskCategoryId = (json.taskCategoryId);
    this.taskId = (json.taskId);
    this.taskListId = (json.taskListId);
    this.text = (json.text);
    this.toAll = decodeBoolean(json.toAll);

    this.onDecode(json);
  }
}

function decodeTaskBean(json :TaskBeanJSON){
  return json===undefined?undefined:new TaskBean(json)
}

function encodeTaskBean(obj : TaskBean) :TaskBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : undefined,
      assignee : encodeArray(encodeAssigneeBean)(obj.assignee),
      assigneeIds : encodeArray(encodeNumber)(obj.assigneeIds),
      bestMoment : undefined,
      comments : undefined,
      complete : encodeBoolean(obj.complete),
      completedDate : undefined,
      creationDate : undefined,
      description : (obj.description),
      dueDate : encodeDate(obj.dueDate),
      editable : undefined,
      familyId : undefined,
      lastAction : undefined,
      lastActionAuthor : undefined,
      lastActionDate : undefined,
      medias : undefined,
      metaId : (obj.metaId),
      modifDate : undefined,
      moodMap : undefined,
      moodStarShortcut : undefined,
      refId : (obj.refId),
      reminder : encodeIReminder(obj.reminder),
      sortingIndex : encodenumber(obj.sortingIndex),
      taskCategoryId : (obj.taskCategoryId),
      taskId : (obj.taskId),
      taskListId : (obj.taskListId),
      text : (obj.text),
      toAll : encodeBoolean(obj.toAll),
    } as TaskBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor))
}

type TaskCategoryBeanJSON = {
  accountId : string | undefined 
  emoji : string | undefined 
  familyId : string
  filterTasklistId : string | undefined 
  hiddenByTaskList : Array<string>
  initialSortingIndex : string
  locale : string | undefined 
  metaId : string
  name : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sortingIndexByTaskList : {[key:string]:string}
  systemCategoryId : string | undefined 
  taskListType : string | undefined 
}

export class TaskCategoryBean extends ServerBeanPrototype{

  accountId : number
  emoji : string
  familyId : number
  filterTasklistId : string
  hiddenByTaskList : Array<string>
  initialSortingIndex : number
  locale : string
  metaId : string
  name : string
  rights : FizRightBean
  sortingIndexByTaskList : Map<string,number>
  systemCategoryId : number
  taskListType : string

  constructor(json :TaskCategoryBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.emoji = (json.emoji);
    this.familyId = decodeNumber(json.familyId);
    this.filterTasklistId = (json.filterTasklistId);
    this.hiddenByTaskList = decodeArray(decodeString)(json.hiddenByTaskList);
    this.initialSortingIndex = decodeNumber(json.initialSortingIndex);
    this.locale = (json.locale);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndexByTaskList = decodeMap(decodeString,decodeNumber)(json.sortingIndexByTaskList);
    this.systemCategoryId = decodeNumber(json.systemCategoryId);
    this.taskListType = decodeEnum(json.taskListType);

    this.onDecode(json);
  }
}

function decodeTaskCategoryBean(json :TaskCategoryBeanJSON){
  return json===undefined?undefined:new TaskCategoryBean(json)
}

function encodeTaskCategoryBean(obj : TaskCategoryBean) :TaskCategoryBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      emoji : (obj.emoji),
      familyId : encodeNumber(obj.familyId),
      filterTasklistId : (obj.filterTasklistId),
      hiddenByTaskList : encodeArray(encodeString)(obj.hiddenByTaskList),
      initialSortingIndex : encodeNumber(obj.initialSortingIndex),
      locale : (obj.locale),
      metaId : (obj.metaId),
      name : (obj.name),
      rights : undefined,
      sortingIndexByTaskList : encodeMap(encodeString,encodeNumber)(obj.sortingIndexByTaskList),
      systemCategoryId : undefined,
      taskListType : encodeEnum(obj.taskListType),
    } as TaskCategoryBeanJSON)
}

type TaskCategoryInputBeanJSON = {
  emoji : string | undefined 
  filterTasklistId : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
  taskListType : string | undefined 
}

export class TaskCategoryInputBean extends ServerBeanPrototype{

  emoji : string
  filterTasklistId : string
  metaId : string
  name : string
  taskListType : string

  constructor(json :TaskCategoryInputBeanJSON){
    super(json);
    this.emoji = (json.emoji);
    this.filterTasklistId = (json.filterTasklistId);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.taskListType = decodeEnum(json.taskListType);

    this.onDecode(json);
  }
}

function decodeTaskCategoryInputBean(json :TaskCategoryInputBeanJSON){
  return json===undefined?undefined:new TaskCategoryInputBean(json)
}

function encodeTaskCategoryInputBean(obj : TaskCategoryInputBean) :TaskCategoryInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      emoji : (obj.emoji),
      filterTasklistId : (obj.filterTasklistId),
      metaId : (obj.metaId),
      name : (obj.name),
      taskListType : encodeEnum(obj.taskListType),
    } as TaskCategoryInputBeanJSON)
}

type TaskCategorySyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<TaskCategoryBeanJSON>
}

export class TaskCategorySyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<TaskCategoryBean>

  constructor(json :TaskCategorySyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeTaskCategoryBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeTaskCategorySyncBean(json :TaskCategorySyncBeanJSON){
  return json===undefined?undefined:new TaskCategorySyncBean(json)
}

function encodeTaskCategorySyncBean(obj : TaskCategorySyncBean) :TaskCategorySyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeTaskCategoryBean)(obj.updatedCreated),
    } as TaskCategorySyncBeanJSON)
}

type TaskInputBeanJSON = {
  assignee : Array<string> | undefined 
  description : string | undefined 
  dueDate : string | undefined 
  metaId : string | undefined 
  refId : string | undefined 
  reminder : IReminderJSON | undefined 
  taskCategoryId : string | undefined 
  taskId : string | undefined 
  taskListId : string | undefined 
  text : string | undefined 
  toAll : string | undefined 
} & RecurrencyDescriptorJSON

export class TaskInputBean extends ServerBeanPrototype{

  assignee : Array<number>
  description : string
  dueDate : Date
  metaId : string
  recurrencyDescriptor : RecurrencyDescriptor
  refId : string
  reminder : IReminder
  taskCategoryId : string
  taskId : string
  taskListId : string
  text : string
  toAll : boolean

  constructor(json :TaskInputBeanJSON){
    super(json);
    this.assignee = decodeArray(decodeNumber)(json.assignee);
    this.description = (json.description);
    this.dueDate = decodeDate(json.dueDate);
    this.metaId = (json.metaId);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.refId = (json.refId);
    this.reminder = decodeIReminder(json.reminder);
    this.taskCategoryId = (json.taskCategoryId);
    this.taskId = (json.taskId);
    this.taskListId = (json.taskListId);
    this.text = (json.text);
    this.toAll = decodeBoolean(json.toAll);

    this.onDecode(json);
  }
}

function decodeTaskInputBean(json :TaskInputBeanJSON){
  return json===undefined?undefined:new TaskInputBean(json)
}

function encodeTaskInputBean(obj : TaskInputBean) :TaskInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      assignee : encodeArray(encodeNumber)(obj.assignee),
      description : (obj.description),
      dueDate : encodeDate(obj.dueDate),
      metaId : (obj.metaId),
      refId : (obj.refId),
      reminder : encodeIReminder(obj.reminder),
      taskCategoryId : (obj.taskCategoryId),
      taskId : (obj.taskId),
      taskListId : (obj.taskListId),
      text : (obj.text),
      toAll : encodeBoolean(obj.toAll),
    } as TaskInputBeanJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor))
}

type TaskListSettingsBeanJSON = {
  taskListSorting : string | undefined 
}

export class TaskListSettingsBean extends ServerBeanPrototype{

  taskListSorting : string

  constructor(json :TaskListSettingsBeanJSON){
    super(json);
    this.taskListSorting = decodeEnum(json.taskListSorting);

    this.onDecode(json);
  }
}

function decodeTaskListSettingsBean(json :TaskListSettingsBeanJSON){
  return json===undefined?undefined:new TaskListSettingsBean(json)
}

function encodeTaskListSettingsBean(obj : TaskListSettingsBean) :TaskListSettingsBeanJSON {
    if(obj==null) return undefined
    return inline({
      taskListSorting : encodeEnum(obj.taskListSorting),
    } as TaskListSettingsBeanJSON)
}

type TaskSuggestionBeanJSON = {
  alternates : Array<string>
  categoryId : string | undefined 
  value : string
}

export class TaskSuggestionBean extends ServerBeanPrototype{

  alternates : Array<string>
  categoryId : number
  value : string

  constructor(json :TaskSuggestionBeanJSON){
    super(json);
    this.alternates = decodeArray(decodeString)(json.alternates);
    this.categoryId = decodeNumber(json.categoryId);
    this.value = (json.value);

    this.onDecode(json);
  }
}

function decodeTaskSuggestionBean(json :TaskSuggestionBeanJSON){
  return json===undefined?undefined:new TaskSuggestionBean(json)
}

function encodeTaskSuggestionBean(obj : TaskSuggestionBean) :TaskSuggestionBeanJSON {
    if(obj==null) return undefined
    return inline({
      alternates : encodeArray(encodeString)(obj.alternates),
      categoryId : encodeNumber(obj.categoryId),
      value : (obj.value),
    } as TaskSuggestionBeanJSON)
}

type TaskSuggestionSyncBeanJSON = {
  isSync : string
  listType : string
  locale : string
  suggestions : Array<string> | undefined 
  syncToken : string
}

export class TaskSuggestionSyncBean extends ServerBeanPrototype{

  isSync : boolean
  listType : string
  locale : string
  suggestions : Array<string>
  syncToken : string

  constructor(json :TaskSuggestionSyncBeanJSON){
    super(json);
    this.isSync = decodeboolean(json.isSync);
    this.listType = decodeEnum(json.listType);
    this.locale = (json.locale);
    this.suggestions = decodeArray(decodeString)(json.suggestions);
    this.syncToken = (json.syncToken);

    this.onDecode(json);
  }
}

function decodeTaskSuggestionSyncBean(json :TaskSuggestionSyncBeanJSON){
  return json===undefined?undefined:new TaskSuggestionSyncBean(json)
}

function encodeTaskSuggestionSyncBean(obj : TaskSuggestionSyncBean) :TaskSuggestionSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      isSync : encodeboolean(obj.isSync),
      listType : encodeEnum(obj.listType),
      locale : (obj.locale),
      suggestions : encodeArray(encodeString)(obj.suggestions),
      syncToken : (obj.syncToken),
    } as TaskSuggestionSyncBeanJSON)
}

type TaskSuggestionSyncBeanWCategoryJSON = {
  isSync : string
  listType : string
  locale : string
  suggestions : Array<TaskSuggestionBeanJSON> | undefined 
  syncToken : string
}

export class TaskSuggestionSyncBeanWCategory extends ServerBeanPrototype{

  isSync : boolean
  listType : string
  locale : string
  suggestions : Array<TaskSuggestionBean>
  syncToken : string

  constructor(json :TaskSuggestionSyncBeanWCategoryJSON){
    super(json);
    this.isSync = decodeboolean(json.isSync);
    this.listType = decodeEnum(json.listType);
    this.locale = (json.locale);
    this.suggestions = decodeArray(decodeTaskSuggestionBean)(json.suggestions);
    this.syncToken = (json.syncToken);

    this.onDecode(json);
  }
}

function decodeTaskSuggestionSyncBeanWCategory(json :TaskSuggestionSyncBeanWCategoryJSON){
  return json===undefined?undefined:new TaskSuggestionSyncBeanWCategory(json)
}

function encodeTaskSuggestionSyncBeanWCategory(obj : TaskSuggestionSyncBeanWCategory) :TaskSuggestionSyncBeanWCategoryJSON {
    if(obj==null) return undefined
    return inline({
      isSync : encodeboolean(obj.isSync),
      listType : encodeEnum(obj.listType),
      locale : (obj.locale),
      suggestions : encodeArray(encodeTaskSuggestionBean)(obj.suggestions),
      syncToken : (obj.syncToken),
    } as TaskSuggestionSyncBeanWCategoryJSON)
}

type TaskSyncBeanJSON = {
  deletedIds : Array<string>
  isSync : string
  syncToken : string
  updatedCreated : Array<TaskBeanJSON>
}

export class TaskSyncBean extends ServerBeanPrototype{

  deletedIds : Array<string>
  isSync : boolean
  syncToken : string
  updatedCreated : Array<TaskBean>

  constructor(json :TaskSyncBeanJSON){
    super(json);
    this.deletedIds = decodeArray(decodeString)(json.deletedIds);
    this.isSync = decodeboolean(json.isSync);
    this.syncToken = (json.syncToken);
    this.updatedCreated = decodeArray(decodeTaskBean)(json.updatedCreated);

    this.onDecode(json);
  }
}

function decodeTaskSyncBean(json :TaskSyncBeanJSON){
  return json===undefined?undefined:new TaskSyncBean(json)
}

function encodeTaskSyncBean(obj : TaskSyncBean) :TaskSyncBeanJSON {
    if(obj==null) return undefined
    return inline({
      deletedIds : encodeArray(encodeString)(obj.deletedIds),
      isSync : encodeboolean(obj.isSync),
      syncToken : (obj.syncToken),
      updatedCreated : encodeArray(encodeTaskBean)(obj.updatedCreated),
    } as TaskSyncBeanJSON)
}

type AccountActivityBeanJSON = {
  accountId : string | undefined 
  displayName : string | undefined 
  familyId : string | undefined 
  lastModifiedEvent : IEventJSON | undefined 
  lastStatus : IWallMessageJSON | undefined 
  location : ILocationJSON | undefined 
  pictureUrl : string | undefined 
}

export class AccountActivityBean extends ServerBeanPrototype{

  accountId : number
  displayName : string
  familyId : string
  lastModifiedEvent : IEvent
  lastStatus : IWallMessage
  location : ILocation
  pictureUrl : string

  constructor(json :AccountActivityBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.displayName = (json.displayName);
    this.familyId = (json.familyId);
    this.lastModifiedEvent = decodeIEvent(json.lastModifiedEvent);
    this.lastStatus = decodeIWallMessage(json.lastStatus);
    this.location = decodeILocation(json.location);
    this.pictureUrl = (json.pictureUrl);

    this.onDecode(json);
  }
}

function decodeAccountActivityBean(json :AccountActivityBeanJSON){
  return json===undefined?undefined:new AccountActivityBean(json)
}

function encodeAccountActivityBean(obj : AccountActivityBean) :AccountActivityBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      displayName : (obj.displayName),
      familyId : (obj.familyId),
      lastModifiedEvent : encodeIEvent(obj.lastModifiedEvent),
      lastStatus : encodeIWallMessage(obj.lastStatus),
      location : encodeILocation(obj.location),
      pictureUrl : (obj.pictureUrl),
    } as AccountActivityBeanJSON)
}

type WallMessageBeanJSON = {
  accountId : string
  bestMoment : string | undefined 
  comments : Array<ICommentJSON> | undefined 
  creationDate : string
  editable : string | undefined 
  event : IEventJSON | undefined 
  extra : FizJSONObject | undefined 
  familyId : string
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  modifDate : string
  moodMap : {[key:string]:Array<string>} | undefined 
  moodStarShortcut : string | undefined 
  nested : IHasMetaIdJSON | undefined 
  place : IPlaceJSON | undefined 
  postAccountId : string
  refAction : string | undefined 
  refId : string | undefined 
  refType : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sortingDate : string
  text : string | undefined 
  wallMessageId : string
}

export class WallMessageBean extends ServerBeanPrototype{

  accountId : number
  bestMoment : boolean
  comments : Array<IComment>
  creationDate : Date
  editable : boolean
  event : IEvent
  extra : FizJSONObject
  familyId : string
  medias : Array<IMedia>
  metaId : string
  modifDate : Date
  moodMap : Map<number,Array<string>>
  moodStarShortcut : boolean
  nested : IHasMetaId
  place : IPlace
  postAccountId : number
  refAction : string
  refId : string
  refType : string
  rights : FizRightBean
  sortingDate : Date
  text : string
  wallMessageId : string

  constructor(json :WallMessageBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.creationDate = decodeDate(json.creationDate);
    this.editable = decodeBoolean(json.editable);
    this.event = decodeIEvent(json.event);
    this.extra = decodeFizJSONObject(json.extra);
    this.familyId = (json.familyId);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.modifDate = decodeDate(json.modifDate);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.nested = decodeDynamic(json.nested) as IHasMetaId;
    this.place = decodeIPlace(json.place);
    this.postAccountId = decodeNumber(json.postAccountId);
    this.refAction = decodeEnum(json.refAction);
    this.refId = (json.refId);
    this.refType = decodeEnum(json.refType);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingDate = decodeDate(json.sortingDate);
    this.text = (json.text);
    this.wallMessageId = (json.wallMessageId);

    this.onDecode(json);
  }
}

function decodeWallMessageBean(json :WallMessageBeanJSON){
  return json===undefined?undefined:new WallMessageBean(json)
}

function encodeWallMessageBean(obj : WallMessageBean) :WallMessageBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      bestMoment : undefined,
      comments : undefined,
      creationDate : encodeDate(obj.creationDate),
      editable : encodeBoolean(obj.editable),
      event : encodeIEvent(obj.event),
      extra : encodeFizJSONObject(obj.extra),
      familyId : (obj.familyId),
      medias : encodeArray(encodeIMedia)(obj.medias),
      metaId : (obj.metaId),
      modifDate : encodeDate(obj.modifDate),
      moodMap : undefined,
      moodStarShortcut : undefined,
      nested : encodeDynamic(obj.nested),
      place : encodeIPlace(obj.place),
      postAccountId : encodeNumber(obj.postAccountId),
      refAction : encodeEnum(obj.refAction),
      refId : (obj.refId),
      refType : encodeEnum(obj.refType),
      rights : encodeFizRightBean(obj.rights),
      sortingDate : encodeDate(obj.sortingDate),
      text : (obj.text),
      wallMessageId : (obj.wallMessageId),
    } as WallMessageBeanJSON)
}

type OpenGraphDataBeanJSON = {
  adultContent : string | undefined 
  description : string | undefined 
  icons : Array<OpenGraphMediaJSON>
  images : Array<OpenGraphMediaJSON>
  isError : string | undefined 
  pollDate : string | undefined 
  recipe : RecipeInputBeanJSON | undefined 
  refUrl : string | undefined 
  siteName : string | undefined 
  title : string | undefined 
  type : string | undefined 
  url : string | undefined 
  videos : Array<OpenGraphMediaJSON>
}

export class OpenGraphDataBean extends ServerBeanPrototype{

  adultContent : boolean
  description : string
  icons : Array<OpenGraphMedia>
  images : Array<OpenGraphMedia>
  isError : boolean
  pollDate : Date
  recipe : RecipeInputBean
  refUrl : string
  siteName : string
  title : string
  type : string
  url : string
  videos : Array<OpenGraphMedia>

  constructor(json :OpenGraphDataBeanJSON){
    super(json);
    this.adultContent = decodeBoolean(json.adultContent);
    this.description = (json.description);
    this.icons = decodeArray(decodeOpenGraphMedia)(json.icons);
    this.images = decodeArray(decodeOpenGraphMedia)(json.images);
    this.isError = decodeBoolean(json.isError);
    this.pollDate = decodeDate(json.pollDate);
    this.recipe = decodeRecipeInputBean(json.recipe);
    this.refUrl = (json.refUrl);
    this.siteName = (json.siteName);
    this.title = (json.title);
    this.type = (json.type);
    this.url = (json.url);
    this.videos = decodeArray(decodeOpenGraphMedia)(json.videos);

    this.onDecode(json);
  }
}

function decodeOpenGraphDataBean(json :OpenGraphDataBeanJSON){
  return json===undefined?undefined:new OpenGraphDataBean(json)
}

function encodeOpenGraphDataBean(obj : OpenGraphDataBean) :OpenGraphDataBeanJSON {
    if(obj==null) return undefined
    return inline({
      adultContent : encodeBoolean(obj.adultContent),
      description : (obj.description),
      icons : encodeArray(encodeOpenGraphMedia)(obj.icons),
      images : encodeArray(encodeOpenGraphMedia)(obj.images),
      isError : encodeBoolean(obj.isError),
      pollDate : encodeDate(obj.pollDate),
      recipe : encodeRecipeInputBean(obj.recipe),
      refUrl : (obj.refUrl),
      siteName : (obj.siteName),
      title : (obj.title),
      type : (obj.type),
      url : (obj.url),
      videos : encodeArray(encodeOpenGraphMedia)(obj.videos),
    } as OpenGraphDataBeanJSON)
}

type OpenGraphMediaJSON = {
  autoplay : string | undefined 
  from : string | undefined 
  height : string | undefined 
  secureUrl : string | undefined 
  type : string | undefined 
  url : string | undefined 
  width : string | undefined 
}

export class OpenGraphMedia extends ServerBeanPrototype{

  autoplay : boolean
  from : string
  height : number
  secureUrl : string
  type : string
  url : string
  width : number

  constructor(json :OpenGraphMediaJSON){
    super(json);
    this.autoplay = decodeBoolean(json.autoplay);
    this.from = (json.from);
    this.height = decodeNumber(json.height);
    this.secureUrl = (json.secureUrl);
    this.type = (json.type);
    this.url = (json.url);
    this.width = decodeNumber(json.width);

    this.onDecode(json);
  }
}

function decodeOpenGraphMedia(json :OpenGraphMediaJSON){
  return json===undefined?undefined:new OpenGraphMedia(json)
}

function encodeOpenGraphMedia(obj : OpenGraphMedia) :OpenGraphMediaJSON {
    if(obj==null) return undefined
    return inline({
      autoplay : encodeBoolean(obj.autoplay),
      from : (obj.from),
      height : encodeNumber(obj.height),
      secureUrl : (obj.secureUrl),
      type : (obj.type),
      url : (obj.url),
      width : encodeNumber(obj.width),
    } as OpenGraphMediaJSON)
}

type ColorBeanJSON = {
  accountId : string | undefined 
  cc : string
  colorSystem : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sortingIndex : string
}

export class ColorBean extends ServerBeanPrototype{

  accountId : number
  cc : string
  colorSystem : string
  metaId : string
  name : string
  rights : FizRightBean
  sortingIndex : number

  constructor(json :ColorBeanJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.cc = (json.cc);
    this.colorSystem = decodeEnum(json.colorSystem);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingIndex = decodenumber(json.sortingIndex);

    this.onDecode(json);
  }
}

function decodeColorBean(json :ColorBeanJSON){
  return json===undefined?undefined:new ColorBean(json)
}

function encodeColorBean(obj : ColorBean) :ColorBeanJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      cc : (obj.cc),
      colorSystem : encodeEnum(obj.colorSystem),
      metaId : (obj.metaId),
      name : (obj.name),
      rights : undefined,
      sortingIndex : encodenumber(obj.sortingIndex),
    } as ColorBeanJSON)
}

type ColorInputBeanJSON = {
  cc : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
}

export class ColorInputBean extends ServerBeanPrototype{

  cc : string
  metaId : string
  name : string

  constructor(json :ColorInputBeanJSON){
    super(json);
    this.cc = (json.cc);
    this.metaId = (json.metaId);
    this.name = (json.name);

    this.onDecode(json);
  }
}

function decodeColorInputBean(json :ColorInputBeanJSON){
  return json===undefined?undefined:new ColorInputBean(json)
}

function encodeColorInputBean(obj : ColorInputBean) :ColorInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      cc : (obj.cc),
      metaId : (obj.metaId),
      name : (obj.name),
    } as ColorInputBeanJSON)
}

type IAccountJSON = {
  accountId : string
  creationDate : string | undefined 
  deleted : string
  identifiers : Array<IAccountIdentifierJSON>
  lastLoginDate : string | undefined 
  name : string
  termsChecked : string
  termsOrangeFamilyPlaceChecked : string
  termsProximusFamilyChecked : string | undefined 
}

export class IAccount extends ServerBeanPrototype{

  accountId : number
  creationDate : Date
  deleted : boolean
  identifiers : Array<IAccountIdentifier>
  lastLoginDate : Date
  name : string
  termsChecked : boolean
  termsOrangeFamilyPlaceChecked : boolean
  termsProximusFamilyChecked : boolean

  constructor(json :IAccountJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.creationDate = decodeDate(json.creationDate);
    this.deleted = decodeboolean(json.deleted);
    this.identifiers = decodeArray(decodeIAccountIdentifier)(json.identifiers);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.name = (json.name);
    this.termsChecked = decodeboolean(json.termsChecked);
    this.termsOrangeFamilyPlaceChecked = decodeboolean(json.termsOrangeFamilyPlaceChecked);
    this.termsProximusFamilyChecked = decodeBoolean(json.termsProximusFamilyChecked);

    this.onDecode(json);
  }
}

function decodeIAccount(json :IAccountJSON){
  return json===undefined?undefined:new IAccount(json)
}

function encodeIAccount(obj : IAccount) :IAccountJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      creationDate : encodeDate(obj.creationDate),
      deleted : encodeboolean(obj.deleted),
      identifiers : encodeArray(encodeIAccountIdentifier)(obj.identifiers),
      lastLoginDate : encodeDate(obj.lastLoginDate),
      name : (obj.name),
      termsChecked : encodeboolean(obj.termsChecked),
      termsOrangeFamilyPlaceChecked : encodeboolean(obj.termsOrangeFamilyPlaceChecked),
      termsProximusFamilyChecked : encodeBoolean(obj.termsProximusFamilyChecked),
    } as IAccountJSON)
}

type IAccountIdentifierJSON = {
  id : string
  type : string
  validated : string
  value : string
  verifiedPartner : string | undefined 
}

export class IAccountIdentifier extends ServerBeanPrototype{

  id : number
  type : string
  validated : boolean
  value : string
  verifiedPartner : string

  constructor(json :IAccountIdentifierJSON){
    super(json);
    this.id = decodeNumber(json.id);
    this.type = decodeEnum(json.type);
    this.validated = decodeBoolean(json.validated);
    this.value = (json.value);
    this.verifiedPartner = decodeEnum(json.verifiedPartner);

    this.onDecode(json);
  }
}

function decodeIAccountIdentifier(json :IAccountIdentifierJSON){
  return json===undefined?undefined:new IAccountIdentifier(json)
}

function encodeIAccountIdentifier(obj : IAccountIdentifier) :IAccountIdentifierJSON {
    if(obj==null) return undefined
    return inline({
      id : encodeNumber(obj.id),
      type : encodeEnum(obj.type),
      validated : encodeBoolean(obj.validated),
      value : (obj.value),
      verifiedPartner : encodeEnum(obj.verifiedPartner),
    } as IAccountIdentifierJSON)
}

type IExtendedFamilyJSON = {
  coverDefault : string | undefined 
  coverMedias : Array<IMediaJSON> | undefined 
  coverUri : string | undefined 
  deletedProfiles : {[key:string]:IProfileJSON}
  family_id : string
  invitations : Array<IInvitationJSON>
  isFirstFamily : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  members : Array<IExtendedFamilyMemberJSON>
  metaId : string | undefined 
  name : string
  pictureDefault : string | undefined 
  pictureUri : string | undefined 
  state : AccountStateBeanJSON | undefined 
  wallCounter : string | undefined 
}

export class IExtendedFamily extends ServerBeanPrototype{

  coverDefault : boolean
  coverMedias : Array<IMedia>
  coverUri : string
  deletedProfiles : Map<number,IProfile>
  family_id : number
  invitations : Array<IInvitation>
  isFirstFamily : boolean
  medias : Array<IMedia>
  members : Array<IExtendedFamilyMember>
  metaId : string
  name : string
  pictureDefault : boolean
  pictureUri : string
  state : AccountStateBean
  wallCounter : number

  constructor(json :IExtendedFamilyJSON){
    super(json);
    this.coverDefault = decodeBoolean(json.coverDefault);
    this.coverMedias = decodeArray(decodeIMedia)(json.coverMedias);
    this.coverUri = (json.coverUri);
    this.deletedProfiles = decodeMap(decodeNumber,decodeIProfile)(json.deletedProfiles);
    this.family_id = decodeNumber(json.family_id);
    this.invitations = decodeArray(decodeIInvitation)(json.invitations);
    this.isFirstFamily = decodeBoolean(json.isFirstFamily);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.members = decodeArray(decodeIExtendedFamilyMember)(json.members);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.pictureUri = (json.pictureUri);
    this.state = decodeAccountStateBean(json.state);
    this.wallCounter = decodeNumber(json.wallCounter);

    this.onDecode(json);
  }
}

function decodeIExtendedFamily(json :IExtendedFamilyJSON){
  return json===undefined?undefined:new IExtendedFamily(json)
}

function encodeIExtendedFamily(obj : IExtendedFamily) :IExtendedFamilyJSON {
    if(obj==null) return undefined
    return inline({
      coverDefault : encodeBoolean(obj.coverDefault),
      coverMedias : encodeArray(encodeIMedia)(obj.coverMedias),
      coverUri : (obj.coverUri),
      deletedProfiles : encodeMap(encodeNumber,encodeIProfile)(obj.deletedProfiles),
      family_id : encodeNumber(obj.family_id),
      invitations : encodeArray(encodeIInvitation)(obj.invitations),
      isFirstFamily : encodeBoolean(obj.isFirstFamily),
      medias : undefined,
      members : encodeArray(encodeIExtendedFamilyMember)(obj.members),
      metaId : (obj.metaId),
      name : (obj.name),
      pictureDefault : encodeBoolean(obj.pictureDefault),
      pictureUri : (obj.pictureUri),
      state : encodeAccountStateBean(obj.state),
      wallCounter : encodeNumber(obj.wallCounter),
    } as IExtendedFamilyJSON)
}

type IExtendedFamilyMemberJSON = {
  account : IAccountJSON | undefined 
  accountId : string | undefined 
  addresses : Array<IAddressJSON> | undefined 
  birthDate : string | undefined 
  birthDateNoYear : string | undefined 
  color : string | undefined 
  creationDate : string | undefined 
  customRole : string | undefined 
  deleted : string
  devices : Array<IDeviceJSON> | undefined 
  fWPremiumMemberSubscriber : string | undefined 
  familyId : string
  firstName : string | undefined 
  gender : string | undefined 
  identifiers : Array<IAccountIdentifierJSON>
  isAccountDeleted : string | undefined 
  isFirstFamily : string | undefined 
  isloggedaccount : string
  joinDate : string | undefined 
  lastLoginDate : string | undefined 
  lastName : string | undefined 
  locale : string | undefined 
  location : ILocationJSON | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  name : string
  panicButtonActivated : string | undefined 
  pictureDefault : string | undefined 
  profileFamilyId : string | undefined 
  right : string
  role : string | undefined 
  termsChecked : string
  termsOrangeFamilyPlaceChecked : string
  termsProximusFamilyChecked : string | undefined 
  timeZone : string | undefined 
}

export class IExtendedFamilyMember extends ServerBeanPrototype{

  account : IAccount
  accountId : number
  addresses : Array<IAddress>
  birthDate : Date
  birthDateNoYear : boolean
  color : string
  creationDate : Date
  customRole : string
  deleted : boolean
  devices : Array<IDevice>
  fWPremiumMemberSubscriber : boolean
  familyId : string
  firstName : string
  gender : string
  identifiers : Array<IAccountIdentifier>
  isAccountDeleted : boolean
  isFirstFamily : boolean
  isloggedaccount : boolean
  joinDate : Date
  lastLoginDate : Date
  lastName : string
  locale : string
  location : ILocation
  medias : Array<IMedia>
  metaId : string
  name : string
  panicButtonActivated : boolean
  pictureDefault : boolean
  profileFamilyId : number
  right : string
  role : string
  termsChecked : boolean
  termsOrangeFamilyPlaceChecked : boolean
  termsProximusFamilyChecked : boolean
  timeZone : string

  constructor(json :IExtendedFamilyMemberJSON){
    super(json);
    this.account = decodeIAccount(json.account);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.color = (json.color);
    this.creationDate = decodeDate(json.creationDate);
    this.customRole = (json.customRole);
    this.deleted = decodeboolean(json.deleted);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.fWPremiumMemberSubscriber = decodeBoolean(json.fWPremiumMemberSubscriber);
    this.familyId = (json.familyId);
    this.firstName = (json.firstName);
    this.gender = decodeEnum(json.gender);
    this.identifiers = decodeArray(decodeIAccountIdentifier)(json.identifiers);
    this.isAccountDeleted = decodeBoolean(json.isAccountDeleted);
    this.isFirstFamily = decodeBoolean(json.isFirstFamily);
    this.isloggedaccount = decodeBoolean(json.isloggedaccount);
    this.joinDate = decodeDate(json.joinDate);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.lastName = (json.lastName);
    this.locale = (json.locale);
    this.location = decodeILocation(json.location);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.panicButtonActivated = decodeBoolean(json.panicButtonActivated);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.profileFamilyId = decodeNumber(json.profileFamilyId);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);
    this.termsChecked = decodeboolean(json.termsChecked);
    this.termsOrangeFamilyPlaceChecked = decodeboolean(json.termsOrangeFamilyPlaceChecked);
    this.termsProximusFamilyChecked = decodeBoolean(json.termsProximusFamilyChecked);
    this.timeZone = (json.timeZone);

    this.onDecode(json);
  }
}

function decodeIExtendedFamilyMember(json :IExtendedFamilyMemberJSON){
  return json===undefined?undefined:new IExtendedFamilyMember(json)
}

function encodeIExtendedFamilyMember(obj : IExtendedFamilyMember) :IExtendedFamilyMemberJSON {
    if(obj==null) return undefined
    return inline({
      account : encodeIAccount(obj.account),
      accountId : encodeNumber(obj.accountId),
      addresses : encodeArray(encodeIAddress)(obj.addresses),
      birthDate : encodeDate(obj.birthDate),
      birthDateNoYear : encodeBoolean(obj.birthDateNoYear),
      color : (obj.color),
      creationDate : encodeDate(obj.creationDate),
      customRole : (obj.customRole),
      deleted : encodeboolean(obj.deleted),
      devices : encodeArray(encodeIDevice)(obj.devices),
      fWPremiumMemberSubscriber : encodeBoolean(obj.fWPremiumMemberSubscriber),
      familyId : (obj.familyId),
      firstName : (obj.firstName),
      gender : encodeEnum(obj.gender),
      identifiers : encodeArray(encodeIAccountIdentifier)(obj.identifiers),
      isAccountDeleted : encodeBoolean(obj.isAccountDeleted),
      isFirstFamily : encodeBoolean(obj.isFirstFamily),
      isloggedaccount : encodeBoolean(obj.isloggedaccount),
      joinDate : encodeDate(obj.joinDate),
      lastLoginDate : encodeDate(obj.lastLoginDate),
      lastName : (obj.lastName),
      locale : (obj.locale),
      location : encodeILocation(obj.location),
      medias : undefined,
      metaId : (obj.metaId),
      name : (obj.name),
      panicButtonActivated : encodeBoolean(obj.panicButtonActivated),
      pictureDefault : encodeBoolean(obj.pictureDefault),
      profileFamilyId : encodeNumber(obj.profileFamilyId),
      right : encodeEnum(obj.right),
      role : encodeEnum(obj.role),
      termsChecked : encodeboolean(obj.termsChecked),
      termsOrangeFamilyPlaceChecked : encodeboolean(obj.termsOrangeFamilyPlaceChecked),
      termsProximusFamilyChecked : encodeBoolean(obj.termsProximusFamilyChecked),
      timeZone : (obj.timeZone),
    } as IExtendedFamilyMemberJSON)
}

type IFamilyJSON = {
  coverDefault : string | undefined 
  coverMedias : Array<IMediaJSON> | undefined 
  coverUri : string | undefined 
  family_id : string
  medias : Array<IMediaJSON> | undefined 
  members : Array<IFamilyMemberJSON>
  metaId : string | undefined 
  name : string
  pictureDefault : string | undefined 
  pictureUri : string | undefined 
}

export class IFamily extends ServerBeanPrototype{

  coverDefault : boolean
  coverMedias : Array<IMedia>
  coverUri : string
  family_id : number
  medias : Array<IMedia>
  members : Array<IFamilyMember>
  metaId : string
  name : string
  pictureDefault : boolean
  pictureUri : string

  constructor(json :IFamilyJSON){
    super(json);
    this.coverDefault = decodeBoolean(json.coverDefault);
    this.coverMedias = decodeArray(decodeIMedia)(json.coverMedias);
    this.coverUri = (json.coverUri);
    this.family_id = decodeNumber(json.family_id);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.members = decodeArray(decodeIFamilyMember)(json.members);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.pictureUri = (json.pictureUri);

    this.onDecode(json);
  }
}

function decodeIFamily(json :IFamilyJSON){
  return json===undefined?undefined:new IFamily(json)
}

function encodeIFamily(obj : IFamily) :IFamilyJSON {
    if(obj==null) return undefined
    return inline({
      coverDefault : encodeBoolean(obj.coverDefault),
      coverMedias : encodeArray(encodeIMedia)(obj.coverMedias),
      coverUri : (obj.coverUri),
      family_id : encodeNumber(obj.family_id),
      medias : undefined,
      members : encodeArray(encodeIFamilyMember)(obj.members),
      metaId : (obj.metaId),
      name : (obj.name),
      pictureDefault : encodeBoolean(obj.pictureDefault),
      pictureUri : (obj.pictureUri),
    } as IFamilyJSON)
}

type IFamilyMemberJSON = {
  account : IAccountJSON
  customRole : string | undefined 
  familyId : string
  isFirstFamily : string | undefined 
  joinDate : string | undefined 
  lastLoginDate : string | undefined 
  metaId : string | undefined 
  right : string
  role : string | undefined 
}

export class IFamilyMember extends ServerBeanPrototype{

  account : IAccount
  customRole : string
  familyId : string
  isFirstFamily : boolean
  joinDate : Date
  lastLoginDate : Date
  metaId : string
  right : string
  role : string

  constructor(json :IFamilyMemberJSON){
    super(json);
    this.account = decodeIAccount(json.account);
    this.customRole = (json.customRole);
    this.familyId = (json.familyId);
    this.isFirstFamily = decodeBoolean(json.isFirstFamily);
    this.joinDate = decodeDate(json.joinDate);
    this.lastLoginDate = decodeDate(json.lastLoginDate);
    this.metaId = (json.metaId);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);

    this.onDecode(json);
  }
}

function decodeIFamilyMember(json :IFamilyMemberJSON){
  return json===undefined?undefined:new IFamilyMember(json)
}

function encodeIFamilyMember(obj : IFamilyMember) :IFamilyMemberJSON {
    if(obj==null) return undefined
    return inline({
      account : encodeIAccount(obj.account),
      customRole : (obj.customRole),
      familyId : (obj.familyId),
      isFirstFamily : encodeBoolean(obj.isFirstFamily),
      joinDate : encodeDate(obj.joinDate),
      lastLoginDate : encodeDate(obj.lastLoginDate),
      metaId : (obj.metaId),
      right : encodeEnum(obj.right),
      role : encodeEnum(obj.role),
    } as IFamilyMemberJSON)
}

type IInvitationJSON = {
  accountId : string
  creationdate : string
  customRole : string | undefined 
  editable : string | undefined 
  familyId : string
  firstname : string | undefined 
  invitationStatus : string
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  originalSms : string | undefined 
  ownerId : string
  pictureDefault : string | undefined 
  pictureURIs : Array<string> | undefined 
  reminderSet : string
  right : string
  role : string
  token : ITokenJSON | undefined 
  tokenId : string
}

export class IInvitation extends ServerBeanPrototype{

  accountId : number
  creationdate : Date
  customRole : string
  editable : boolean
  familyId : string
  firstname : string
  invitationStatus : string
  medias : Array<IMedia>
  metaId : string
  originalSms : string
  ownerId : number
  pictureDefault : boolean
  pictureURIs : Array<string>
  reminderSet : boolean
  right : string
  role : string
  token : IToken
  tokenId : number

  constructor(json :IInvitationJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.creationdate = decodeDate(json.creationdate);
    this.customRole = (json.customRole);
    this.editable = decodeBoolean(json.editable);
    this.familyId = (json.familyId);
    this.firstname = (json.firstname);
    this.invitationStatus = decodeEnum(json.invitationStatus);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.originalSms = (json.originalSms);
    this.ownerId = decodeNumber(json.ownerId);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.pictureURIs = decodeArray(decodeString)(json.pictureURIs);
    this.reminderSet = decodeboolean(json.reminderSet);
    this.right = decodeEnum(json.right);
    this.role = decodeEnum(json.role);
    this.token = decodeIToken(json.token);
    this.tokenId = decodeNumber(json.tokenId);

    this.onDecode(json);
  }
}

function decodeIInvitation(json :IInvitationJSON){
  return json===undefined?undefined:new IInvitation(json)
}

function encodeIInvitation(obj : IInvitation) :IInvitationJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      creationdate : encodeDate(obj.creationdate),
      customRole : (obj.customRole),
      editable : encodeBoolean(obj.editable),
      familyId : (obj.familyId),
      firstname : (obj.firstname),
      invitationStatus : encodeEnum(obj.invitationStatus),
      medias : undefined,
      metaId : (obj.metaId),
      originalSms : (obj.originalSms),
      ownerId : encodeNumber(obj.ownerId),
      pictureDefault : encodeBoolean(obj.pictureDefault),
      pictureURIs : encodeArray(encodeString)(obj.pictureURIs),
      reminderSet : encodeboolean(obj.reminderSet),
      right : encodeEnum(obj.right),
      role : encodeEnum(obj.role),
      token : encodeIToken(obj.token),
      tokenId : encodeNumber(obj.tokenId),
    } as IInvitationJSON)
}

type ITokenJSON = {
  accountId : string | undefined 
  accountIdentifierId : string | undefined 
  clickMaxCount : string | undefined 
  clickcount : string
  clientPartnerType : string | undefined 
  creationDate : string
  email : string | undefined 
  expirationDate : string | undefined 
  familyId : string | undefined 
  persistentNameRef : string | undefined 
  sms : string | undefined 
  smsInternational : string | undefined 
  tokenId : string
  tokenRefMetaId : string | undefined 
  type : string
}

export class IToken extends ServerBeanPrototype{

  accountId : number
  accountIdentifierId : number
  clickMaxCount : number
  clickcount : number
  clientPartnerType : string
  creationDate : Date
  email : string
  expirationDate : Date
  familyId : number
  persistentNameRef : string
  sms : string
  smsInternational : boolean
  tokenId : number
  tokenRefMetaId : string
  type : string

  constructor(json :ITokenJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.accountIdentifierId = decodeNumber(json.accountIdentifierId);
    this.clickMaxCount = decodeNumber(json.clickMaxCount);
    this.clickcount = decodenumber(json.clickcount);
    this.clientPartnerType = decodeEnum(json.clientPartnerType);
    this.creationDate = decodeDate(json.creationDate);
    this.email = (json.email);
    this.expirationDate = decodeDate(json.expirationDate);
    this.familyId = decodeNumber(json.familyId);
    this.persistentNameRef = (json.persistentNameRef);
    this.sms = (json.sms);
    this.smsInternational = decodeBoolean(json.smsInternational);
    this.tokenId = decodenumber(json.tokenId);
    this.tokenRefMetaId = (json.tokenRefMetaId);
    this.type = decodeEnum(json.type);

    this.onDecode(json);
  }
}

function decodeIToken(json :ITokenJSON){
  return json===undefined?undefined:new IToken(json)
}

function encodeIToken(obj : IToken) :ITokenJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      accountIdentifierId : encodeNumber(obj.accountIdentifierId),
      clickMaxCount : encodeNumber(obj.clickMaxCount),
      clickcount : encodenumber(obj.clickcount),
      clientPartnerType : encodeEnum(obj.clientPartnerType),
      creationDate : encodeDate(obj.creationDate),
      email : (obj.email),
      expirationDate : encodeDate(obj.expirationDate),
      familyId : encodeNumber(obj.familyId),
      persistentNameRef : (obj.persistentNameRef),
      sms : (obj.sms),
      smsInternational : encodeBoolean(obj.smsInternational),
      tokenId : encodenumber(obj.tokenId),
      tokenRefMetaId : (obj.tokenRefMetaId),
      type : encodeEnum(obj.type),
    } as ITokenJSON)
}

type IAddressJSON = {
  addressId : string | undefined 
  geocodedAddress : GeocodedAddressJSON
  metaId : string | undefined 
  placeType : string | undefined 
}

export class IAddress extends ServerBeanPrototype{

  addressId : string
  geocodedAddress : GeocodedAddress
  metaId : string
  placeType : string

  constructor(json :IAddressJSON){
    super(json);
    this.addressId = (json.addressId);
    this.geocodedAddress = decodeGeocodedAddress(json.geocodedAddress);
    this.metaId = (json.metaId);
    this.placeType = decodeEnum(json.placeType);

    this.onDecode(json);
  }
}

function decodeIAddress(json :IAddressJSON){
  return json===undefined?undefined:new IAddress(json)
}

function encodeIAddress(obj : IAddress) :IAddressJSON {
    if(obj==null) return undefined
    return inline({
      addressId : (obj.addressId),
      geocodedAddress : encodeGeocodedAddress(obj.geocodedAddress),
      metaId : (obj.metaId),
      placeType : encodeEnum(obj.placeType),
    } as IAddressJSON)
}

type IContactJSON = {
  accountId : string | undefined 
  addresses : Array<IAddressJSON> | undefined 
  birthDate : string | undefined 
  birthDateNoYear : string | undefined 
  comments : Array<ICommentJSON> | undefined 
  devices : Array<IDeviceJSON> | undefined 
  editable : string | undefined 
  familyId : string | undefined 
  firstName : string | undefined 
  function : string | undefined 
  gender : string | undefined 
  lastName : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  note : string | undefined 
  pictureDefault : string | undefined 
}

export class IContact extends ServerBeanPrototype{

  accountId : number
  addresses : Array<IAddress>
  birthDate : Date
  birthDateNoYear : boolean
  comments : Array<IComment>
  devices : Array<IDevice>
  editable : boolean
  familyId : string
  firstName : string
  function : string
  gender : string
  lastName : string
  medias : Array<IMedia>
  metaId : string
  note : string
  pictureDefault : boolean

  constructor(json :IContactJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.editable = decodeBoolean(json.editable);
    this.familyId = (json.familyId);
    this.firstName = (json.firstName);
    this.function = (json.function);
    this.gender = decodeEnum(json.gender);
    this.lastName = (json.lastName);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.note = (json.note);
    this.pictureDefault = decodeBoolean(json.pictureDefault);

    this.onDecode(json);
  }
}

function decodeIContact(json :IContactJSON){
  return json===undefined?undefined:new IContact(json)
}

function encodeIContact(obj : IContact) :IContactJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      addresses : encodeArray(encodeIAddress)(obj.addresses),
      birthDate : encodeDate(obj.birthDate),
      birthDateNoYear : encodeBoolean(obj.birthDateNoYear),
      comments : undefined,
      devices : encodeArray(encodeIDevice)(obj.devices),
      editable : undefined,
      familyId : undefined,
      firstName : (obj.firstName),
      function : (obj.function),
      gender : encodeEnum(obj.gender),
      lastName : (obj.lastName),
      medias : undefined,
      metaId : (obj.metaId),
      note : (obj.note),
      pictureDefault : undefined,
    } as IContactJSON)
}

type IDeviceJSON = {
  deviceId : string | undefined 
  deviceType : string
  value : string
}

export class IDevice extends ServerBeanPrototype{

  deviceId : string
  deviceType : string
  value : string

  constructor(json :IDeviceJSON){
    super(json);
    this.deviceId = (json.deviceId);
    this.deviceType = decodeEnum(json.deviceType);
    this.value = (json.value);

    this.onDecode(json);
  }
}

function decodeIDevice(json :IDeviceJSON){
  return json===undefined?undefined:new IDevice(json)
}

function encodeIDevice(obj : IDevice) :IDeviceJSON {
    if(obj==null) return undefined
    return inline({
      deviceId : (obj.deviceId),
      deviceType : encodeEnum(obj.deviceType),
      value : (obj.value),
    } as IDeviceJSON)
}

type IApiKeyJSON = {
  accessRightRuleset : string
  apiKeyClientType : string
  clientId : string
  clientSecret : string
  forcedPartner : string | undefined 
  name : string | undefined 
  oAuth2PasswordBasedAuthorized : string
  webAnonymousAuthorized : string
  webRedirectUrlPrefix : string | undefined 
}

export class IApiKey extends ServerBeanPrototype{

  accessRightRuleset : string
  apiKeyClientType : string
  clientId : string
  clientSecret : string
  forcedPartner : string
  name : string
  oAuth2PasswordBasedAuthorized : boolean
  webAnonymousAuthorized : boolean
  webRedirectUrlPrefix : string

  constructor(json :IApiKeyJSON){
    super(json);
    this.accessRightRuleset = decodeEnum(json.accessRightRuleset);
    this.apiKeyClientType = decodeEnum(json.apiKeyClientType);
    this.clientId = (json.clientId);
    this.clientSecret = (json.clientSecret);
    this.forcedPartner = decodeEnum(json.forcedPartner);
    this.name = (json.name);
    this.oAuth2PasswordBasedAuthorized = decodeboolean(json.oAuth2PasswordBasedAuthorized);
    this.webAnonymousAuthorized = decodeboolean(json.webAnonymousAuthorized);
    this.webRedirectUrlPrefix = (json.webRedirectUrlPrefix);

    this.onDecode(json);
  }
}

function decodeIApiKey(json :IApiKeyJSON){
  return json===undefined?undefined:new IApiKey(json)
}

function encodeIApiKey(obj : IApiKey) :IApiKeyJSON {
    if(obj==null) return undefined
    return inline({
      accessRightRuleset : encodeEnum(obj.accessRightRuleset),
      apiKeyClientType : encodeEnum(obj.apiKeyClientType),
      clientId : (obj.clientId),
      clientSecret : (obj.clientSecret),
      forcedPartner : encodeEnum(obj.forcedPartner),
      name : (obj.name),
      oAuth2PasswordBasedAuthorized : encodeboolean(obj.oAuth2PasswordBasedAuthorized),
      webAnonymousAuthorized : encodeboolean(obj.webAnonymousAuthorized),
      webRedirectUrlPrefix : (obj.webRedirectUrlPrefix),
    } as IApiKeyJSON)
}

type ICreditJSON = {
  accountId : string | undefined 
  autoRenewType : string | undefined 
  creationDate : string | undefined 
  creditStatus : string | undefined 
  creditStatusDetail : string | undefined 
  creditType : string | undefined 
  endDate : string | undefined 
  familyIds : Array<string> | undefined 
  metaId : string | undefined 
  paymentCancelDate : string | undefined 
  paymentCancelReason : string | undefined 
  paymentCancelReasonSurvey : string | undefined 
  paymentCancelReasonSurveyCustom : string | undefined 
  paymentDate : string | undefined 
  paymentKey : string | undefined 
  paymentOriginalStatus : string | undefined 
  paymentReceipt : string | undefined 
  paymentSKU : string | undefined 
  paymentStatus : string | undefined 
  paymentStatusActiveDate : string | undefined 
  paymentSubSKU : string | undefined 
  paymentType : string | undefined 
  paymentValue : string | undefined 
  periodType : string | undefined 
  startDate : string | undefined 
  text : string | undefined 
  value : string | undefined 
}

export class ICredit extends ServerBeanPrototype{

  accountId : number
  autoRenewType : string
  creationDate : Date
  creditStatus : string
  creditStatusDetail : string
  creditType : string
  endDate : Date
  familyIds : Array<number>
  metaId : string
  paymentCancelDate : Date
  paymentCancelReason : number
  paymentCancelReasonSurvey : number
  paymentCancelReasonSurveyCustom : string
  paymentDate : Date
  paymentKey : string
  paymentOriginalStatus : number
  paymentReceipt : string
  paymentSKU : string
  paymentStatus : number
  paymentStatusActiveDate : Date
  paymentSubSKU : string
  paymentType : string
  paymentValue : string
  periodType : string
  startDate : Date
  text : string
  value : number

  constructor(json :ICreditJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.autoRenewType = decodeEnum(json.autoRenewType);
    this.creationDate = decodeDate(json.creationDate);
    this.creditStatus = decodeEnum(json.creditStatus);
    this.creditStatusDetail = decodeEnum(json.creditStatusDetail);
    this.creditType = decodeEnum(json.creditType);
    this.endDate = decodeDate(json.endDate);
    this.familyIds = decodeArray(decodeNumber)(json.familyIds);
    this.metaId = (json.metaId);
    this.paymentCancelDate = decodeDate(json.paymentCancelDate);
    this.paymentCancelReason = decodeNumber(json.paymentCancelReason);
    this.paymentCancelReasonSurvey = decodeNumber(json.paymentCancelReasonSurvey);
    this.paymentCancelReasonSurveyCustom = (json.paymentCancelReasonSurveyCustom);
    this.paymentDate = decodeDate(json.paymentDate);
    this.paymentKey = (json.paymentKey);
    this.paymentOriginalStatus = decodeNumber(json.paymentOriginalStatus);
    this.paymentReceipt = (json.paymentReceipt);
    this.paymentSKU = (json.paymentSKU);
    this.paymentStatus = decodeNumber(json.paymentStatus);
    this.paymentStatusActiveDate = decodeDate(json.paymentStatusActiveDate);
    this.paymentSubSKU = (json.paymentSubSKU);
    this.paymentType = decodeEnum(json.paymentType);
    this.paymentValue = (json.paymentValue);
    this.periodType = decodeEnum(json.periodType);
    this.startDate = decodeDate(json.startDate);
    this.text = (json.text);
    this.value = decodeNumber(json.value);

    this.onDecode(json);
  }
}

function decodeICredit(json :ICreditJSON){
  return json===undefined?undefined:new ICredit(json)
}

function encodeICredit(obj : ICredit) :ICreditJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      autoRenewType : encodeEnum(obj.autoRenewType),
      creationDate : encodeDate(obj.creationDate),
      creditStatus : encodeEnum(obj.creditStatus),
      creditStatusDetail : encodeEnum(obj.creditStatusDetail),
      creditType : encodeEnum(obj.creditType),
      endDate : encodeDate(obj.endDate),
      familyIds : encodeArray(encodeNumber)(obj.familyIds),
      metaId : (obj.metaId),
      paymentCancelDate : encodeDate(obj.paymentCancelDate),
      paymentCancelReason : encodeNumber(obj.paymentCancelReason),
      paymentCancelReasonSurvey : encodeNumber(obj.paymentCancelReasonSurvey),
      paymentCancelReasonSurveyCustom : (obj.paymentCancelReasonSurveyCustom),
      paymentDate : encodeDate(obj.paymentDate),
      paymentKey : (obj.paymentKey),
      paymentOriginalStatus : encodeNumber(obj.paymentOriginalStatus),
      paymentReceipt : (obj.paymentReceipt),
      paymentSKU : (obj.paymentSKU),
      paymentStatus : encodeNumber(obj.paymentStatus),
      paymentStatusActiveDate : encodeDate(obj.paymentStatusActiveDate),
      paymentSubSKU : (obj.paymentSubSKU),
      paymentType : encodeEnum(obj.paymentType),
      paymentValue : (obj.paymentValue),
      periodType : encodeEnum(obj.periodType),
      startDate : encodeDate(obj.startDate),
      text : (obj.text),
      value : encodeNumber(obj.value),
    } as ICreditJSON)
}

type IPromoCodeJSON = {
  creationDate : string
  expirationDate : string
  lastUsageDate : string | undefined 
  maxUsageNumber : string
  promoCodeCampaign : IPromoCodeCampaignJSON
  usageNumber : string
  value : string
}

export class IPromoCode extends ServerBeanPrototype{

  creationDate : Date
  expirationDate : Date
  lastUsageDate : Date
  maxUsageNumber : number
  promoCodeCampaign : IPromoCodeCampaign
  usageNumber : number
  value : string

  constructor(json :IPromoCodeJSON){
    super(json);
    this.creationDate = decodeDate(json.creationDate);
    this.expirationDate = decodeDate(json.expirationDate);
    this.lastUsageDate = decodeDate(json.lastUsageDate);
    this.maxUsageNumber = decodenumber(json.maxUsageNumber);
    this.promoCodeCampaign = decodeIPromoCodeCampaign(json.promoCodeCampaign);
    this.usageNumber = decodenumber(json.usageNumber);
    this.value = (json.value);

    this.onDecode(json);
  }
}

function decodeIPromoCode(json :IPromoCodeJSON){
  return json===undefined?undefined:new IPromoCode(json)
}

function encodeIPromoCode(obj : IPromoCode) :IPromoCodeJSON {
    if(obj==null) return undefined
    return inline({
      creationDate : undefined,
      expirationDate : encodeDate(obj.expirationDate),
      lastUsageDate : undefined,
      maxUsageNumber : encodenumber(obj.maxUsageNumber),
      promoCodeCampaign : encodeIPromoCodeCampaign(obj.promoCodeCampaign),
      usageNumber : undefined,
      value : (obj.value),
    } as IPromoCodeJSON)
}

type IPromoCodeCampaignJSON = {
  creationDate : string
  creditDurationInDays : string | undefined 
  creditType : string | undefined 
  name : string
}

export class IPromoCodeCampaign extends ServerBeanPrototype{

  creationDate : Date
  creditDurationInDays : number
  creditType : string
  name : string

  constructor(json :IPromoCodeCampaignJSON){
    super(json);
    this.creationDate = decodeDate(json.creationDate);
    this.creditDurationInDays = decodeNumber(json.creditDurationInDays);
    this.creditType = decodeEnum(json.creditType);
    this.name = (json.name);

    this.onDecode(json);
  }
}

function decodeIPromoCodeCampaign(json :IPromoCodeCampaignJSON){
  return json===undefined?undefined:new IPromoCodeCampaign(json)
}

function encodeIPromoCodeCampaign(obj : IPromoCodeCampaign) :IPromoCodeCampaignJSON {
    if(obj==null) return undefined
    return inline({
      creationDate : undefined,
      creditDurationInDays : encodeNumber(obj.creditDurationInDays),
      creditType : encodeEnum(obj.creditType),
      name : (obj.name),
    } as IPromoCodeCampaignJSON)
}

type IPromoPushCampaignJSON = {
  active : string | undefined 
  android : string | undefined 
  creationDate : string
  deeplinkClassId : string | undefined 
  deeplinkClickMaxCount : string | undefined 
  deeplinkPartnerType : string | undefined 
  deeplinkRecycle : string | undefined 
  deeplinkValidationTimeHour : string | undefined 
  deeplinkWebUrl : string | undefined 
  iOS : string | undefined 
  launchpadSection : string | undefined 
  name : string
  promoPartnerType : string | undefined 
  pushJson : FizJSONObject | undefined 
  pushPremiumFeatureHighlight : string | undefined 
  pushScreenTarget : string | undefined 
  trackingName : string | undefined 
  url : string | undefined 
}

export class IPromoPushCampaign extends ServerBeanPrototype{

  active : boolean
  android : boolean
  creationDate : Date
  deeplinkClassId : string
  deeplinkClickMaxCount : number
  deeplinkPartnerType : string
  deeplinkRecycle : boolean
  deeplinkValidationTimeHour : number
  deeplinkWebUrl : string
  iOS : boolean
  launchpadSection : string
  name : string
  promoPartnerType : string
  pushJson : FizJSONObject
  pushPremiumFeatureHighlight : string
  pushScreenTarget : string
  trackingName : string
  url : string

  constructor(json :IPromoPushCampaignJSON){
    super(json);
    this.active = decodeBoolean(json.active);
    this.android = decodeBoolean(json.android);
    this.creationDate = decodeDate(json.creationDate);
    this.deeplinkClassId = (json.deeplinkClassId);
    this.deeplinkClickMaxCount = decodeNumber(json.deeplinkClickMaxCount);
    this.deeplinkPartnerType = decodeEnum(json.deeplinkPartnerType);
    this.deeplinkRecycle = decodeBoolean(json.deeplinkRecycle);
    this.deeplinkValidationTimeHour = decodeNumber(json.deeplinkValidationTimeHour);
    this.deeplinkWebUrl = (json.deeplinkWebUrl);
    this.iOS = decodeBoolean(json.iOS);
    this.launchpadSection = decodeEnum(json.launchpadSection);
    this.name = (json.name);
    this.promoPartnerType = decodeEnum(json.promoPartnerType);
    this.pushJson = decodeFizJSONObject(json.pushJson);
    this.pushPremiumFeatureHighlight = (json.pushPremiumFeatureHighlight);
    this.pushScreenTarget = decodeEnum(json.pushScreenTarget);
    this.trackingName = (json.trackingName);
    this.url = (json.url);

    this.onDecode(json);
  }
}

function decodeIPromoPushCampaign(json :IPromoPushCampaignJSON){
  return json===undefined?undefined:new IPromoPushCampaign(json)
}

function encodeIPromoPushCampaign(obj : IPromoPushCampaign) :IPromoPushCampaignJSON {
    if(obj==null) return undefined
    return inline({
      active : encodeBoolean(obj.active),
      android : encodeBoolean(obj.android),
      creationDate : undefined,
      deeplinkClassId : (obj.deeplinkClassId),
      deeplinkClickMaxCount : encodeNumber(obj.deeplinkClickMaxCount),
      deeplinkPartnerType : encodeEnum(obj.deeplinkPartnerType),
      deeplinkRecycle : encodeBoolean(obj.deeplinkRecycle),
      deeplinkValidationTimeHour : encodeNumber(obj.deeplinkValidationTimeHour),
      deeplinkWebUrl : (obj.deeplinkWebUrl),
      iOS : encodeBoolean(obj.iOS),
      launchpadSection : encodeEnum(obj.launchpadSection),
      name : (obj.name),
      promoPartnerType : encodeEnum(obj.promoPartnerType),
      pushJson : encodeFizJSONObject(obj.pushJson),
      pushPremiumFeatureHighlight : (obj.pushPremiumFeatureHighlight),
      pushScreenTarget : encodeEnum(obj.pushScreenTarget),
      trackingName : (obj.trackingName),
      url : (obj.url),
    } as IPromoPushCampaignJSON)
}

type ICommentJSON = {
  accountId : string
  bestMoment : string | undefined 
  commentId : string
  creationDate : string
  mood : string | undefined 
  moodMap : {[key:string]:Array<string>} | undefined 
  moodStarShortcut : string | undefined 
  rights : FizRightBeanJSON | undefined 
  text : string
  updatedDate : string | undefined 
}

export class IComment extends ServerBeanPrototype{

  accountId : number
  bestMoment : boolean
  commentId : string
  creationDate : Date
  mood : string
  moodMap : Map<number,Array<string>>
  moodStarShortcut : boolean
  rights : FizRightBean
  text : string
  updatedDate : Date

  constructor(json :ICommentJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.commentId = (json.commentId);
    this.creationDate = decodeDate(json.creationDate);
    this.mood = decodeEnum(json.mood);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.rights = decodeFizRightBean(json.rights);
    this.text = (json.text);
    this.updatedDate = decodeDate(json.updatedDate);

    this.onDecode(json);
  }
}

function decodeIComment(json :ICommentJSON){
  return json===undefined?undefined:new IComment(json)
}

function encodeIComment(obj : IComment) :ICommentJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      bestMoment : undefined,
      commentId : (obj.commentId),
      creationDate : encodeDate(obj.creationDate),
      mood : encodeEnum(obj.mood),
      moodMap : undefined,
      moodStarShortcut : undefined,
      rights : encodeFizRightBean(obj.rights),
      text : (obj.text),
      updatedDate : encodeDate(obj.updatedDate),
    } as ICommentJSON)
}

type IHasMetaIdJSON = {
  metaId : string | undefined 
}

export class IHasMetaId extends ServerBeanPrototype{

  metaId : string

  constructor(json :IHasMetaIdJSON){
    super(json);
    this.metaId = (json.metaId);

    this.onDecode(json);
  }
}

function decodeIHasMetaId(json :IHasMetaIdJSON){
  return json===undefined?undefined:new IHasMetaId(json)
}

function encodeIHasMetaId(obj : IHasMetaId) :IHasMetaIdJSON {
    if(obj==null) return undefined
    return inline({
      metaId : (obj.metaId),
    } as IHasMetaIdJSON)
}

type IDeviceConfigJSON = {
  MCC : string | undefined 
  MNC : string | undefined 
  applicationVersion : string | undefined 
  buildTimestamp : string | undefined 
  deviceId : string
  languageSystem : string | undefined 
  metaId : string | undefined 
  modelType : string | undefined 
  nativeAppId : string | undefined 
  notificationTokenId : string | undefined 
  partnerType : string | undefined 
  systemName : string | undefined 
  systemVersion : string | undefined 
}

export class IDeviceConfig extends ServerBeanPrototype{

  MCC : string
  MNC : string
  applicationVersion : string
  buildTimestamp : number
  deviceId : string
  languageSystem : string
  metaId : string
  modelType : string
  nativeAppId : string
  notificationTokenId : string
  partnerType : string
  systemName : string
  systemVersion : string

  constructor(json :IDeviceConfigJSON){
    super(json);
    this.MCC = (json.MCC);
    this.MNC = (json.MNC);
    this.applicationVersion = (json.applicationVersion);
    this.buildTimestamp = decodeNumber(json.buildTimestamp);
    this.deviceId = (json.deviceId);
    this.languageSystem = (json.languageSystem);
    this.metaId = (json.metaId);
    this.modelType = decodeEnum(json.modelType);
    this.nativeAppId = (json.nativeAppId);
    this.notificationTokenId = (json.notificationTokenId);
    this.partnerType = decodeEnum(json.partnerType);
    this.systemName = (json.systemName);
    this.systemVersion = (json.systemVersion);

    this.onDecode(json);
  }
}

function decodeIDeviceConfig(json :IDeviceConfigJSON){
  return json===undefined?undefined:new IDeviceConfig(json)
}

function encodeIDeviceConfig(obj : IDeviceConfig) :IDeviceConfigJSON {
    if(obj==null) return undefined
    return inline({
      MCC : (obj.MCC),
      MNC : (obj.MNC),
      applicationVersion : (obj.applicationVersion),
      buildTimestamp : encodeNumber(obj.buildTimestamp),
      deviceId : (obj.deviceId),
      languageSystem : (obj.languageSystem),
      metaId : (obj.metaId),
      modelType : encodeEnum(obj.modelType),
      nativeAppId : (obj.nativeAppId),
      notificationTokenId : (obj.notificationTokenId),
      partnerType : encodeEnum(obj.partnerType),
      systemName : (obj.systemName),
      systemVersion : (obj.systemVersion),
    } as IDeviceConfigJSON)
}

type IAttendeeJSON = {
  accountId : string
  attendeeResponse : string | undefined 
  attendeeStatus : string | undefined 
}

export class IAttendee extends ServerBeanPrototype{

  accountId : number
  attendeeResponse : string
  attendeeStatus : string

  constructor(json :IAttendeeJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.attendeeResponse = decodeEnum(json.attendeeResponse);
    this.attendeeStatus = decodeEnum(json.attendeeStatus);

    this.onDecode(json);
  }
}

function decodeIAttendee(json :IAttendeeJSON){
  return json===undefined?undefined:new IAttendee(json)
}

function encodeIAttendee(obj : IAttendee) :IAttendeeJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      attendeeResponse : encodeEnum(obj.attendeeResponse),
      attendeeStatus : encodeEnum(obj.attendeeStatus),
    } as IAttendeeJSON)
}

type IEventJSON = {
  accountId : string
  allDay : string
  attendeeIds : Array<string>
  bestMoment : string | undefined 
  birthDateNoYear : string | undefined 
  calendarId : string
  color : string | undefined 
  colorInfo : ColorBeanJSON | undefined 
  comments : Array<ICommentJSON> | undefined 
  description : string | undefined 
  editable : string | undefined 
  emoji : string | undefined 
  endDate : string | undefined 
  eventId : string
  eventMasterId : string
  eventType : string | undefined 
  externalImportId : string | undefined 
  familyId : string
  lastAction : string | undefined 
  lastActionAuthor : string | undefined 
  lastActionDate : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  modifDate : string
  moodMap : {[key:string]:Array<string>} | undefined 
  moodStarShortcut : string | undefined 
  occurenceIndex : string | undefined 
  placeId : string | undefined 
  private : string
  recurrencyExceptionOfId : string | undefined 
  refPersonId : string | undefined 
  refPersonName : string | undefined 
  reminder : IReminderJSON | undefined 
  reminderList : Array<IReminderJSON>
  startDate : string
  taskListId : string | undefined 
  text : string | undefined 
  timeZone : string | undefined 
  toAll : string
  where : string | undefined 
} & RecurrencyDescriptorJSON

export class IEvent extends ServerBeanPrototype{

  accountId : number
  allDay : boolean
  attendeeIds : Array<number>
  bestMoment : boolean
  birthDateNoYear : boolean
  calendarId : string
  color : string
  colorInfo : ColorBean
  comments : Array<IComment>
  description : string
  editable : boolean
  emoji : string
  endDate : Date
  eventId : string
  eventMasterId : string
  eventType : string
  externalImportId : string
  familyId : string
  lastAction : string
  lastActionAuthor : number
  lastActionDate : Date
  medias : Array<IMedia>
  metaId : string
  modifDate : Date
  moodMap : Map<number,Array<string>>
  moodStarShortcut : boolean
  occurenceIndex : number
  placeId : string
  private : boolean
  recurrencyDescriptor : RecurrencyDescriptor
  recurrencyExceptionOfId : string
  refPersonId : string
  refPersonName : string
  reminder : IReminder
  reminderList : Array<IReminder>
  startDate : Date
  taskListId : string
  text : string
  timeZone : string
  toAll : boolean
  where : string

  constructor(json :IEventJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.allDay = decodeBoolean(json.allDay);
    this.attendeeIds = decodeArray(decodeNumber)(json.attendeeIds);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.calendarId = (json.calendarId);
    this.color = (json.color);
    this.colorInfo = decodeColorBean(json.colorInfo);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.description = (json.description);
    this.editable = decodeBoolean(json.editable);
    this.emoji = (json.emoji);
    this.endDate = decodeDate(json.endDate);
    this.eventId = (json.eventId);
    this.eventMasterId = (json.eventMasterId);
    this.eventType = decodeEnum(json.eventType);
    this.externalImportId = (json.externalImportId);
    this.familyId = (json.familyId);
    this.lastAction = decodeEnum(json.lastAction);
    this.lastActionAuthor = decodeNumber(json.lastActionAuthor);
    this.lastActionDate = decodeDate(json.lastActionDate);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.modifDate = decodeDate(json.modifDate);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.occurenceIndex = decodeNumber(json.occurenceIndex);
    this.placeId = (json.placeId);
    this.private = decodeboolean(json.private);
    this.recurrencyDescriptor = decodeRecurrencyDescriptor(json);
    this.recurrencyExceptionOfId = (json.recurrencyExceptionOfId);
    this.refPersonId = (json.refPersonId);
    this.refPersonName = (json.refPersonName);
    this.reminder = decodeIReminder(json.reminder);
    this.reminderList = decodeArray(decodeIReminder)(json.reminderList);
    this.startDate = decodeDate(json.startDate);
    this.taskListId = (json.taskListId);
    this.text = (json.text);
    this.timeZone = (json.timeZone);
    this.toAll = decodeboolean(json.toAll);
    this.where = (json.where);

    this.onDecode(json);
  }
}

function decodeIEvent(json :IEventJSON){
  return json===undefined?undefined:new IEvent(json)
}

function encodeIEvent(obj : IEvent) :IEventJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      allDay : encodeBoolean(obj.allDay),
      attendeeIds : encodeArray(encodeNumber)(obj.attendeeIds),
      bestMoment : undefined,
      birthDateNoYear : encodeBoolean(obj.birthDateNoYear),
      calendarId : (obj.calendarId),
      color : (obj.color),
      colorInfo : encodeColorBean(obj.colorInfo),
      comments : undefined,
      description : (obj.description),
      editable : encodeBoolean(obj.editable),
      emoji : (obj.emoji),
      endDate : encodeDate(obj.endDate),
      eventId : (obj.eventId),
      eventMasterId : (obj.eventMasterId),
      eventType : encodeEnum(obj.eventType),
      externalImportId : (obj.externalImportId),
      familyId : (obj.familyId),
      lastAction : undefined,
      lastActionAuthor : undefined,
      lastActionDate : undefined,
      medias : undefined,
      metaId : (obj.metaId),
      modifDate : encodeDate(obj.modifDate),
      moodMap : undefined,
      moodStarShortcut : undefined,
      occurenceIndex : encodeNumber(obj.occurenceIndex),
      placeId : (obj.placeId),
      private : encodeboolean(obj.private),
      recurrencyExceptionOfId : undefined,
      refPersonId : (obj.refPersonId),
      refPersonName : (obj.refPersonName),
      reminder : encodeIReminder(obj.reminder),
      reminderList : encodeArray(encodeIReminder)(obj.reminderList),
      startDate : encodeDate(obj.startDate),
      taskListId : (obj.taskListId),
      text : (obj.text),
      timeZone : (obj.timeZone),
      toAll : encodeboolean(obj.toAll),
      where : (obj.where),
    } as IEventJSON, encodeRecurrencyDescriptor(obj.recurrencyDescriptor))
}

type IReminderJSON = {
  localId : string | undefined 
  reminderType : string | undefined 
  reminderUnit : string | undefined 
  reminderValue : string | undefined 
}

export class IReminder extends ServerBeanPrototype{

  localId : number
  reminderType : string
  reminderUnit : string
  reminderValue : number

  constructor(json :IReminderJSON){
    super(json);
    this.localId = decodeNumber(json.localId);
    this.reminderType = decodeEnum(json.reminderType);
    this.reminderUnit = decodeEnum(json.reminderUnit);
    this.reminderValue = decodeNumber(json.reminderValue);

    this.onDecode(json);
  }
}

function decodeIReminder(json :IReminderJSON){
  return json===undefined?undefined:new IReminder(json)
}

function encodeIReminder(obj : IReminder) :IReminderJSON {
    if(obj==null) return undefined
    return inline({
      localId : encodeNumber(obj.localId),
      reminderType : encodeEnum(obj.reminderType),
      reminderUnit : encodeEnum(obj.reminderUnit),
      reminderValue : encodeNumber(obj.reminderValue),
    } as IReminderJSON)
}

type IFilerInputBeanJSON = {
  color : string | undefined 
  metaId : string | undefined 
  name : string | undefined 
  parentFolderId : string | undefined 
}

export class IFilerInputBean extends ServerBeanPrototype{

  color : string
  metaId : string
  name : string
  parentFolderId : string

  constructor(json :IFilerInputBeanJSON){
    super(json);
    this.color = (json.color);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.parentFolderId = (json.parentFolderId);

    this.onDecode(json);
  }
}

function decodeIFilerInputBean(json :IFilerInputBeanJSON){
  return json===undefined?undefined:new IFilerInputBean(json)
}

function encodeIFilerInputBean(obj : IFilerInputBean) :IFilerInputBeanJSON {
    if(obj==null) return undefined
    return inline({
      color : (obj.color),
      metaId : (obj.metaId),
      name : (obj.name),
      parentFolderId : (obj.parentFolderId),
    } as IFilerInputBeanJSON)
}

type IIMMessageJSON = {
  creationDate : string
  externalId : string | undefined 
  fromId : string
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  text : string
  threadId : string
  type : string
}

export class IIMMessage extends ServerBeanPrototype{

  creationDate : Date
  externalId : string
  fromId : number
  medias : Array<IMedia>
  metaId : string
  text : string
  threadId : string
  type : string

  constructor(json :IIMMessageJSON){
    super(json);
    this.creationDate = decodeDate(json.creationDate);
    this.externalId = (json.externalId);
    this.fromId = decodeNumber(json.fromId);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.text = (json.text);
    this.threadId = (json.threadId);
    this.type = decodeEnum(json.type);

    this.onDecode(json);
  }
}

function decodeIIMMessage(json :IIMMessageJSON){
  return json===undefined?undefined:new IIMMessage(json)
}

function encodeIIMMessage(obj : IIMMessage) :IIMMessageJSON {
    if(obj==null) return undefined
    return inline({
      creationDate : encodeDate(obj.creationDate),
      externalId : (obj.externalId),
      fromId : encodeNumber(obj.fromId),
      medias : undefined,
      metaId : (obj.metaId),
      text : (obj.text),
      threadId : (obj.threadId),
      type : encodeEnum(obj.type),
    } as IIMMessageJSON)
}

type IIMParticipantJSON = {
  accountFirstname : string
  accountId : string
  accountMedias : Array<IMediaJSON> | undefined 
  accountPictureDefault : string | undefined 
  color : string | undefined 
  isInFamily : string
  isLogguedAccount : string | undefined 
  lastReadMessageDate : string | undefined 
  lastReceivedMessageDate : string | undefined 
  lastSentMessageDate : string | undefined 
  participantStatus : string
}

export class IIMParticipant extends ServerBeanPrototype{

  accountFirstname : string
  accountId : number
  accountMedias : Array<IMedia>
  accountPictureDefault : boolean
  color : string
  isInFamily : boolean
  isLogguedAccount : boolean
  lastReadMessageDate : Date
  lastReceivedMessageDate : Date
  lastSentMessageDate : Date
  participantStatus : string

  constructor(json :IIMParticipantJSON){
    super(json);
    this.accountFirstname = (json.accountFirstname);
    this.accountId = decodeNumber(json.accountId);
    this.accountMedias = decodeArray(decodeIMedia)(json.accountMedias);
    this.accountPictureDefault = decodeBoolean(json.accountPictureDefault);
    this.color = (json.color);
    this.isInFamily = decodeboolean(json.isInFamily);
    this.isLogguedAccount = decodeBoolean(json.isLogguedAccount);
    this.lastReadMessageDate = decodeDate(json.lastReadMessageDate);
    this.lastReceivedMessageDate = decodeDate(json.lastReceivedMessageDate);
    this.lastSentMessageDate = decodeDate(json.lastSentMessageDate);
    this.participantStatus = decodeEnum(json.participantStatus);

    this.onDecode(json);
  }
}

function decodeIIMParticipant(json :IIMParticipantJSON){
  return json===undefined?undefined:new IIMParticipant(json)
}

function encodeIIMParticipant(obj : IIMParticipant) :IIMParticipantJSON {
    if(obj==null) return undefined
    return inline({
      accountFirstname : (obj.accountFirstname),
      accountId : encodeNumber(obj.accountId),
      accountMedias : encodeArray(encodeIMedia)(obj.accountMedias),
      accountPictureDefault : encodeBoolean(obj.accountPictureDefault),
      color : (obj.color),
      isInFamily : encodeboolean(obj.isInFamily),
      isLogguedAccount : encodeBoolean(obj.isLogguedAccount),
      lastReadMessageDate : encodeDate(obj.lastReadMessageDate),
      lastReceivedMessageDate : encodeDate(obj.lastReceivedMessageDate),
      lastSentMessageDate : encodeDate(obj.lastSentMessageDate),
      participantStatus : encodeEnum(obj.participantStatus),
    } as IIMParticipantJSON)
}

type IIMThreadJSON = {
  isMultiFamily : string
  messageCount : string
  messageListModifDate : string
  metaId : string | undefined 
  participants : Array<IIMParticipantJSON>
  sortingDate : string
  unreadCount : string
}

export class IIMThread extends ServerBeanPrototype{

  isMultiFamily : boolean
  messageCount : number
  messageListModifDate : Date
  metaId : string
  participants : Array<IIMParticipant>
  sortingDate : Date
  unreadCount : number

  constructor(json :IIMThreadJSON){
    super(json);
    this.isMultiFamily = decodeboolean(json.isMultiFamily);
    this.messageCount = decodenumber(json.messageCount);
    this.messageListModifDate = decodeDate(json.messageListModifDate);
    this.metaId = (json.metaId);
    this.participants = decodeArray(decodeIIMParticipant)(json.participants);
    this.sortingDate = decodeDate(json.sortingDate);
    this.unreadCount = decodenumber(json.unreadCount);

    this.onDecode(json);
  }
}

function decodeIIMThread(json :IIMThreadJSON){
  return json===undefined?undefined:new IIMThread(json)
}

function encodeIIMThread(obj : IIMThread) :IIMThreadJSON {
    if(obj==null) return undefined
    return inline({
      isMultiFamily : encodeboolean(obj.isMultiFamily),
      messageCount : encodenumber(obj.messageCount),
      messageListModifDate : encodeDate(obj.messageListModifDate),
      metaId : (obj.metaId),
      participants : encodeArray(encodeIIMParticipant)(obj.participants),
      sortingDate : encodeDate(obj.sortingDate),
      unreadCount : encodenumber(obj.unreadCount),
    } as IIMThreadJSON)
}

type IMediaJSON = {
  accountId : string | undefined 
  bestMoment : string
  color : string | undefined 
  creationDate : string | undefined 
  datasize : string | undefined 
  durationMs : string | undefined 
  familyId : string | undefined 
  filerModifDate : string | undefined 
  mediaId : string | undefined 
  metaId : string | undefined 
  mimeType : string | undefined 
  moodMap : {[key:string]:Array<string>} | undefined 
  name : string | undefined 
  parentFolderId : string | undefined 
  pictureUrl : string
  pointedBy : string | undefined 
  pointedByWhat : string | undefined 
  readystate : string | undefined 
  resolutionX : string | undefined 
  resolutionY : string | undefined 
  rights : FizRightBeanJSON
}

export class IMedia extends ServerBeanPrototype{

  accountId : number
  bestMoment : boolean
  color : string
  creationDate : Date
  datasize : number
  durationMs : number
  familyId : string
  filerModifDate : Date
  mediaId : string
  metaId : string
  mimeType : string
  moodMap : Map<number,Array<string>>
  name : string
  parentFolderId : string
  pictureUrl : string
  pointedBy : string
  pointedByWhat : string
  readystate : string
  resolutionX : number
  resolutionY : number
  rights : FizRightBean

  constructor(json :IMediaJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeboolean(json.bestMoment);
    this.color = (json.color);
    this.creationDate = decodeDate(json.creationDate);
    this.datasize = decodeNumber(json.datasize);
    this.durationMs = decodeNumber(json.durationMs);
    this.familyId = (json.familyId);
    this.filerModifDate = decodeDate(json.filerModifDate);
    this.mediaId = (json.mediaId);
    this.metaId = (json.metaId);
    this.mimeType = (json.mimeType);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.name = (json.name);
    this.parentFolderId = (json.parentFolderId);
    this.pictureUrl = (json.pictureUrl);
    this.pointedBy = (json.pointedBy);
    this.pointedByWhat = decodeEnum(json.pointedByWhat);
    this.readystate = decodeEnum(json.readystate);
    this.resolutionX = decodeNumber(json.resolutionX);
    this.resolutionY = decodeNumber(json.resolutionY);
    this.rights = decodeFizRightBean(json.rights);

    this.onDecode(json);
  }
}

function decodeIMedia(json :IMediaJSON){
  return json===undefined?undefined:new IMedia(json)
}

function encodeIMedia(obj : IMedia) :IMediaJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      bestMoment : encodeboolean(obj.bestMoment),
      color : (obj.color),
      creationDate : encodeDate(obj.creationDate),
      datasize : encodeNumber(obj.datasize),
      durationMs : encodeNumber(obj.durationMs),
      familyId : (obj.familyId),
      filerModifDate : undefined,
      mediaId : (obj.mediaId),
      metaId : (obj.metaId),
      mimeType : (obj.mimeType),
      moodMap : encodeMap(encodeNumber,encodeArray(encodeEnum))(obj.moodMap),
      name : (obj.name),
      parentFolderId : (obj.parentFolderId),
      pictureUrl : (obj.pictureUrl),
      pointedBy : (obj.pointedBy),
      pointedByWhat : encodeEnum(obj.pointedByWhat),
      readystate : encodeEnum(obj.readystate),
      resolutionX : encodeNumber(obj.resolutionX),
      resolutionY : encodeNumber(obj.resolutionY),
      rights : undefined,
    } as IMediaJSON)
}

type ILocationJSON = {
  accountId : string
  address : GeocodedAddressJSON | undefined 
  authRequestPending : string
  authorized : string
  authorizedEndDate : string | undefined 
  deviceFlag : LocationDeviceFlagsJSON | undefined 
  familyId : string
  geolocSharing : string | undefined 
  geolocSharingEndDate : string | undefined 
  lastLocationDeviceId : string | undefined 
  lastPositionUpdateDate : string | undefined 
  lastRefreshRequestSentDate : string | undefined 
  locationState : string | undefined 
  mapURI : string | undefined 
  modifDate : string
  moveType : string
  placeId : string | undefined 
  wallMessage : IWallMessageJSON | undefined 
  wallMessageId : string | undefined 
}

export class ILocation extends ServerBeanPrototype{

  accountId : number
  address : GeocodedAddress
  authRequestPending : string
  authorized : string
  authorizedEndDate : Date
  deviceFlag : LocationDeviceFlags
  familyId : string
  geolocSharing : string
  geolocSharingEndDate : Date
  lastLocationDeviceId : string
  lastPositionUpdateDate : Date
  lastRefreshRequestSentDate : Date
  locationState : string
  mapURI : string
  modifDate : Date
  moveType : string
  placeId : string
  wallMessage : IWallMessage
  wallMessageId : string

  constructor(json :ILocationJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.address = decodeGeocodedAddress(json.address);
    this.authRequestPending = decodeEnum(json.authRequestPending);
    this.authorized = decodeEnum(json.authorized);
    this.authorizedEndDate = decodeDate(json.authorizedEndDate);
    this.deviceFlag = decodeLocationDeviceFlags(json.deviceFlag);
    this.familyId = (json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.geolocSharingEndDate = decodeDate(json.geolocSharingEndDate);
    this.lastLocationDeviceId = (json.lastLocationDeviceId);
    this.lastPositionUpdateDate = decodeDate(json.lastPositionUpdateDate);
    this.lastRefreshRequestSentDate = decodeDate(json.lastRefreshRequestSentDate);
    this.locationState = decodeEnum(json.locationState);
    this.mapURI = (json.mapURI);
    this.modifDate = decodeDate(json.modifDate);
    this.moveType = decodeEnum(json.moveType);
    this.placeId = (json.placeId);
    this.wallMessage = decodeIWallMessage(json.wallMessage);
    this.wallMessageId = (json.wallMessageId);

    this.onDecode(json);
  }
}

function decodeILocation(json :ILocationJSON){
  return json===undefined?undefined:new ILocation(json)
}

function encodeILocation(obj : ILocation) :ILocationJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      address : encodeGeocodedAddress(obj.address),
      authRequestPending : encodeEnum(obj.authRequestPending),
      authorized : encodeEnum(obj.authorized),
      authorizedEndDate : encodeDate(obj.authorizedEndDate),
      deviceFlag : encodeLocationDeviceFlags(obj.deviceFlag),
      familyId : (obj.familyId),
      geolocSharing : encodeEnum(obj.geolocSharing),
      geolocSharingEndDate : encodeDate(obj.geolocSharingEndDate),
      lastLocationDeviceId : (obj.lastLocationDeviceId),
      lastPositionUpdateDate : encodeDate(obj.lastPositionUpdateDate),
      lastRefreshRequestSentDate : encodeDate(obj.lastRefreshRequestSentDate),
      locationState : encodeEnum(obj.locationState),
      mapURI : (obj.mapURI),
      modifDate : encodeDate(obj.modifDate),
      moveType : encodeEnum(obj.moveType),
      placeId : (obj.placeId),
      wallMessage : encodeIWallMessage(obj.wallMessage),
      wallMessageId : (obj.wallMessageId),
    } as ILocationJSON)
}

type IPlaceJSON = {
  accountId : string
  address : GeocodedAddressJSON | undefined 
  contactId : string | undefined 
  editable : string | undefined 
  fWGeofencingIn : string | undefined 
  fWGeofencingOut : string | undefined 
  familyId : string
  geofencingActive : string | undefined 
  isTemporary : string
  mapURI : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  name : string
  placeId : string
  placeType : string | undefined 
  text : string | undefined 
  wifiMAC : string | undefined 
  wifiSSID : string | undefined 
}

export class IPlace extends ServerBeanPrototype{

  accountId : number
  address : GeocodedAddress
  contactId : string
  editable : boolean
  fWGeofencingIn : boolean
  fWGeofencingOut : boolean
  familyId : string
  geofencingActive : boolean
  isTemporary : boolean
  mapURI : string
  medias : Array<IMedia>
  metaId : string
  name : string
  placeId : string
  placeType : string
  text : string
  wifiMAC : string
  wifiSSID : string

  constructor(json :IPlaceJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.address = decodeGeocodedAddress(json.address);
    this.contactId = (json.contactId);
    this.editable = decodeBoolean(json.editable);
    this.fWGeofencingIn = decodeBoolean(json.fWGeofencingIn);
    this.fWGeofencingOut = decodeBoolean(json.fWGeofencingOut);
    this.familyId = (json.familyId);
    this.geofencingActive = decodeBoolean(json.geofencingActive);
    this.isTemporary = decodeboolean(json.isTemporary);
    this.mapURI = (json.mapURI);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.name = (json.name);
    this.placeId = (json.placeId);
    this.placeType = decodeEnum(json.placeType);
    this.text = (json.text);
    this.wifiMAC = (json.wifiMAC);
    this.wifiSSID = (json.wifiSSID);

    this.onDecode(json);
  }
}

function decodeIPlace(json :IPlaceJSON){
  return json===undefined?undefined:new IPlace(json)
}

function encodeIPlace(obj : IPlace) :IPlaceJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      address : encodeGeocodedAddress(obj.address),
      contactId : (obj.contactId),
      editable : encodeBoolean(obj.editable),
      fWGeofencingIn : encodeBoolean(obj.fWGeofencingIn),
      fWGeofencingOut : encodeBoolean(obj.fWGeofencingOut),
      familyId : (obj.familyId),
      geofencingActive : encodeBoolean(obj.geofencingActive),
      isTemporary : encodeboolean(obj.isTemporary),
      mapURI : (obj.mapURI),
      medias : undefined,
      metaId : (obj.metaId),
      name : (obj.name),
      placeId : (obj.placeId),
      placeType : encodeEnum(obj.placeType),
      text : (obj.text),
      wifiMAC : (obj.wifiMAC),
      wifiSSID : (obj.wifiSSID),
    } as IPlaceJSON)
}

type IPlaceGeofencingJSON = {
  familyId : string
  geolocSharing : string | undefined 
  in : string
  metaId : string | undefined 
  out : string
  place : IPlaceJSON | undefined 
  placeId : string
  publisherId : string
  rightFlag : string
  subscriberId : string
}

export class IPlaceGeofencing extends ServerBeanPrototype{

  familyId : string
  geolocSharing : string
  in : boolean
  metaId : string
  out : boolean
  place : IPlace
  placeId : string
  publisherId : number
  rightFlag : string
  subscriberId : number

  constructor(json :IPlaceGeofencingJSON){
    super(json);
    this.familyId = (json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.in = decodeboolean(json.in);
    this.metaId = (json.metaId);
    this.out = decodeboolean(json.out);
    this.place = decodeIPlace(json.place);
    this.placeId = (json.placeId);
    this.publisherId = decodeNumber(json.publisherId);
    this.rightFlag = decodeEnum(json.rightFlag);
    this.subscriberId = decodeNumber(json.subscriberId);

    this.onDecode(json);
  }
}

function decodeIPlaceGeofencing(json :IPlaceGeofencingJSON){
  return json===undefined?undefined:new IPlaceGeofencing(json)
}

function encodeIPlaceGeofencing(obj : IPlaceGeofencing) :IPlaceGeofencingJSON {
    if(obj==null) return undefined
    return inline({
      familyId : (obj.familyId),
      geolocSharing : encodeEnum(obj.geolocSharing),
      in : encodeboolean(obj.in),
      metaId : (obj.metaId),
      out : encodeboolean(obj.out),
      place : encodeIPlace(obj.place),
      placeId : (obj.placeId),
      publisherId : encodeNumber(obj.publisherId),
      rightFlag : encodeEnum(obj.rightFlag),
      subscriberId : encodeNumber(obj.subscriberId),
    } as IPlaceGeofencingJSON)
}

type IProfileJSON = {
  accountId : string | undefined 
  addresses : Array<IAddressJSON> | undefined 
  birthDate : string | undefined 
  birthDateNoYear : string | undefined 
  color : string | undefined 
  devices : Array<IDeviceJSON> | undefined 
  firstName : string | undefined 
  gender : string | undefined 
  isAccountDeleted : string | undefined 
  lastName : string | undefined 
  locale : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  pictureDefault : string | undefined 
  profileFamilyId : string | undefined 
  timeZone : string | undefined 
}

export class IProfile extends ServerBeanPrototype{

  accountId : number
  addresses : Array<IAddress>
  birthDate : Date
  birthDateNoYear : boolean
  color : string
  devices : Array<IDevice>
  firstName : string
  gender : string
  isAccountDeleted : boolean
  lastName : string
  locale : string
  medias : Array<IMedia>
  metaId : string
  pictureDefault : boolean
  profileFamilyId : number
  timeZone : string

  constructor(json :IProfileJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.addresses = decodeArray(decodeIAddress)(json.addresses);
    this.birthDate = decodeDate(json.birthDate);
    this.birthDateNoYear = decodeBoolean(json.birthDateNoYear);
    this.color = (json.color);
    this.devices = decodeArray(decodeIDevice)(json.devices);
    this.firstName = (json.firstName);
    this.gender = decodeEnum(json.gender);
    this.isAccountDeleted = decodeBoolean(json.isAccountDeleted);
    this.lastName = (json.lastName);
    this.locale = (json.locale);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.pictureDefault = decodeBoolean(json.pictureDefault);
    this.profileFamilyId = decodeNumber(json.profileFamilyId);
    this.timeZone = (json.timeZone);

    this.onDecode(json);
  }
}

function decodeIProfile(json :IProfileJSON){
  return json===undefined?undefined:new IProfile(json)
}

function encodeIProfile(obj : IProfile) :IProfileJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      addresses : encodeArray(encodeIAddress)(obj.addresses),
      birthDate : encodeDate(obj.birthDate),
      birthDateNoYear : encodeBoolean(obj.birthDateNoYear),
      color : (obj.color),
      devices : encodeArray(encodeIDevice)(obj.devices),
      firstName : (obj.firstName),
      gender : encodeEnum(obj.gender),
      isAccountDeleted : encodeBoolean(obj.isAccountDeleted),
      lastName : (obj.lastName),
      locale : (obj.locale),
      medias : undefined,
      metaId : (obj.metaId),
      pictureDefault : encodeBoolean(obj.pictureDefault),
      profileFamilyId : encodeNumber(obj.profileFamilyId),
      timeZone : (obj.timeZone),
    } as IProfileJSON)
}

type IBroadcastableJSON = {
}

export class IBroadcastable extends ServerBeanPrototype{


  constructor(json :IBroadcastableJSON){
    super(json);

    this.onDecode(json);
  }
}

function decodeIBroadcastable(json :IBroadcastableJSON){
  return json===undefined?undefined:new IBroadcastable(json)
}

function encodeIBroadcastable(obj : IBroadcastable) :IBroadcastableJSON {
    if(obj==null) return undefined
    return inline({
    } as IBroadcastableJSON)
}

type ISettingsPerFamilyJSON = {
  accountId : string | undefined 
  calendarFirstDayOfWeek : string | undefined 
  calendarWeekNb : string | undefined 
  dailyBriefHourOfDelivery : string | undefined 
  dailyBriefNothingPlannedActivated : string | undefined 
  dailyBriefPushActivated : string | undefined 
  defaultReminderType : string | undefined 
  defaultReminderUnit : string | undefined 
  defaultReminderValue : string | undefined 
  editable : string | undefined 
  familyId : string | undefined 
  geolocSharing : string | undefined 
  mealplannerFirstDayOfWeek : string | undefined 
  showDidYouKnow : string | undefined 
  showDishes : string | undefined 
  showSmartCard : string | undefined 
}

export class ISettingsPerFamily extends ServerBeanPrototype{

  accountId : number
  calendarFirstDayOfWeek : number
  calendarWeekNb : boolean
  dailyBriefHourOfDelivery : number
  dailyBriefNothingPlannedActivated : boolean
  dailyBriefPushActivated : boolean
  defaultReminderType : string
  defaultReminderUnit : string
  defaultReminderValue : number
  editable : boolean
  familyId : string
  geolocSharing : string
  mealplannerFirstDayOfWeek : number
  showDidYouKnow : boolean
  showDishes : boolean
  showSmartCard : boolean

  constructor(json :ISettingsPerFamilyJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.calendarFirstDayOfWeek = decodeNumber(json.calendarFirstDayOfWeek);
    this.calendarWeekNb = decodeBoolean(json.calendarWeekNb);
    this.dailyBriefHourOfDelivery = decodeNumber(json.dailyBriefHourOfDelivery);
    this.dailyBriefNothingPlannedActivated = decodeBoolean(json.dailyBriefNothingPlannedActivated);
    this.dailyBriefPushActivated = decodeBoolean(json.dailyBriefPushActivated);
    this.defaultReminderType = decodeEnum(json.defaultReminderType);
    this.defaultReminderUnit = decodeEnum(json.defaultReminderUnit);
    this.defaultReminderValue = decodeNumber(json.defaultReminderValue);
    this.editable = decodeBoolean(json.editable);
    this.familyId = (json.familyId);
    this.geolocSharing = decodeEnum(json.geolocSharing);
    this.mealplannerFirstDayOfWeek = decodeNumber(json.mealplannerFirstDayOfWeek);
    this.showDidYouKnow = decodeBoolean(json.showDidYouKnow);
    this.showDishes = decodeBoolean(json.showDishes);
    this.showSmartCard = decodeBoolean(json.showSmartCard);

    this.onDecode(json);
  }
}

function decodeISettingsPerFamily(json :ISettingsPerFamilyJSON){
  return json===undefined?undefined:new ISettingsPerFamily(json)
}

function encodeISettingsPerFamily(obj : ISettingsPerFamily) :ISettingsPerFamilyJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      calendarFirstDayOfWeek : encodeNumber(obj.calendarFirstDayOfWeek),
      calendarWeekNb : encodeBoolean(obj.calendarWeekNb),
      dailyBriefHourOfDelivery : encodeNumber(obj.dailyBriefHourOfDelivery),
      dailyBriefNothingPlannedActivated : encodeBoolean(obj.dailyBriefNothingPlannedActivated),
      dailyBriefPushActivated : encodeBoolean(obj.dailyBriefPushActivated),
      defaultReminderType : encodeEnum(obj.defaultReminderType),
      defaultReminderUnit : encodeEnum(obj.defaultReminderUnit),
      defaultReminderValue : encodeNumber(obj.defaultReminderValue),
      editable : encodeBoolean(obj.editable),
      familyId : (obj.familyId),
      geolocSharing : encodeEnum(obj.geolocSharing),
      mealplannerFirstDayOfWeek : encodeNumber(obj.mealplannerFirstDayOfWeek),
      showDidYouKnow : encodeBoolean(obj.showDidYouKnow),
      showDishes : encodeBoolean(obj.showDishes),
      showSmartCard : encodeBoolean(obj.showSmartCard),
    } as ISettingsPerFamilyJSON)
}

type ISyncBeanJSON<IHasMetaIdJSON> = {
}

export class ISyncBean<IHasMetaId> extends ServerBeanPrototype{


  constructor(json :ISyncBeanJSON<any> ,decodeIHasMetaId : objectDecoder<any,IHasMetaId>){
    super(json);

    this.onDecode(json);
  }
}

//this code need to be reviewed
function decodeISyncBean<JSON,BEAN>(decodeIHasMetaId :objectDecoder<JSON,BEAN>){
  return function(json :ISyncBeanJSON<JSON>){
    return json===undefined?undefined:new ISyncBean<BEAN>(json,decodeIHasMetaId)
  }
}

function encodeISyncBean<IHasMetaId>(encodeIHasMetaId : objectEncoder<IHasMetaId>){
  return function(obj :ISyncBean<IHasMetaId>){
    if(obj==null) return undefined
    return inline({
    } as ISyncBeanJSON<IHasMetaIdJSON>)
  }
}

type ITaskListJSON = {
  accountId : string | undefined 
  bestMoment : string | undefined 
  color : string | undefined 
  comments : Array<ICommentJSON> | undefined 
  completedHidden : string | undefined 
  creationDate : string | undefined 
  description : string | undefined 
  emoji : string | undefined 
  familyId : string | undefined 
  inputFile : Array<string> | undefined 
  lastAction : string | undefined 
  lastActionAuthor : string | undefined 
  lastActionDate : string | undefined 
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  moodMap : {[key:string]:Array<string>} | undefined 
  moodStarShortcut : string | undefined 
  name : string | undefined 
  remainingTaskNumber : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sharedMemberIds : Array<string> | undefined 
  sharedToAll : string | undefined 
  sortingIndex : string | undefined 
  suggestedId : string | undefined 
  systemId : string | undefined 
  taskCategoriesHidden : string | undefined 
  taskListType : string | undefined 
  taskSorting : string | undefined 
  totalTaskNumber : string | undefined 
}

export class ITaskList extends ServerBeanPrototype{

  accountId : number
  bestMoment : boolean
  color : string
  comments : Array<IComment>
  completedHidden : boolean
  creationDate : Date
  description : string
  emoji : string
  familyId : string
  inputFile : Array<FizFile>
  lastAction : string
  lastActionAuthor : number
  lastActionDate : Date
  medias : Array<IMedia>
  metaId : string
  moodMap : Map<number,Array<string>>
  moodStarShortcut : boolean
  name : string
  remainingTaskNumber : number
  rights : FizRightBean
  sharedMemberIds : Array<number>
  sharedToAll : boolean
  sortingIndex : number
  suggestedId : number
  systemId : number
  taskCategoriesHidden : boolean
  taskListType : string
  taskSorting : string
  totalTaskNumber : number

  constructor(json :ITaskListJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.color = (json.color);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.completedHidden = decodeBoolean(json.completedHidden);
    this.creationDate = decodeDate(json.creationDate);
    this.description = (json.description);
    this.emoji = (json.emoji);
    this.familyId = (json.familyId);
    this.inputFile = decodeArray(decodeFizFile)(json.inputFile);
    this.lastAction = decodeEnum(json.lastAction);
    this.lastActionAuthor = decodeNumber(json.lastActionAuthor);
    this.lastActionDate = decodeDate(json.lastActionDate);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.name = (json.name);
    this.remainingTaskNumber = decodeNumber(json.remainingTaskNumber);
    this.rights = decodeFizRightBean(json.rights);
    this.sharedMemberIds = decodeArray(decodeNumber)(json.sharedMemberIds);
    this.sharedToAll = decodeBoolean(json.sharedToAll);
    this.sortingIndex = decodeNumber(json.sortingIndex);
    this.suggestedId = decodeNumber(json.suggestedId);
    this.systemId = decodeNumber(json.systemId);
    this.taskCategoriesHidden = decodeBoolean(json.taskCategoriesHidden);
    this.taskListType = decodeEnum(json.taskListType);
    this.taskSorting = decodeEnum(json.taskSorting);
    this.totalTaskNumber = decodeNumber(json.totalTaskNumber);

    this.onDecode(json);
  }
}

function decodeITaskList(json :ITaskListJSON){
  return json===undefined?undefined:new ITaskList(json)
}

function encodeITaskList(obj : ITaskList) :ITaskListJSON {
    if(obj==null) return undefined
    return inline({
      accountId : undefined,
      bestMoment : undefined,
      color : (obj.color),
      comments : undefined,
      completedHidden : encodeBoolean(obj.completedHidden),
      creationDate : undefined,
      description : (obj.description),
      emoji : (obj.emoji),
      familyId : undefined,
      inputFile : encodeArray(encodeFizFile)(obj.inputFile),
      lastAction : undefined,
      lastActionAuthor : undefined,
      lastActionDate : undefined,
      medias : undefined,
      metaId : (obj.metaId),
      moodMap : undefined,
      moodStarShortcut : undefined,
      name : (obj.name),
      remainingTaskNumber : undefined,
      rights : undefined,
      sharedMemberIds : encodeArray(encodeNumber)(obj.sharedMemberIds),
      sharedToAll : encodeBoolean(obj.sharedToAll),
      sortingIndex : encodeNumber(obj.sortingIndex),
      suggestedId : undefined,
      systemId : encodeNumber(obj.systemId),
      taskCategoriesHidden : encodeBoolean(obj.taskCategoriesHidden),
      taskListType : encodeEnum(obj.taskListType),
      taskSorting : encodeEnum(obj.taskSorting),
      totalTaskNumber : undefined,
    } as ITaskListJSON)
}

type IWallMessageJSON = {
  accountId : string
  bestMoment : string | undefined 
  comments : Array<ICommentJSON> | undefined 
  creationDate : string
  editable : string | undefined 
  event : IEventJSON | undefined 
  extra : FizJSONObject | undefined 
  familyId : string
  medias : Array<IMediaJSON> | undefined 
  metaId : string | undefined 
  modifDate : string
  moodMap : {[key:string]:Array<string>} | undefined 
  moodStarShortcut : string | undefined 
  nested : IHasMetaIdJSON | undefined 
  place : IPlaceJSON | undefined 
  postAccountId : string
  refAction : string | undefined 
  refId : string | undefined 
  refType : string | undefined 
  rights : FizRightBeanJSON | undefined 
  sortingDate : string
  text : string | undefined 
  wallMessageId : string
}

export class IWallMessage extends ServerBeanPrototype{

  accountId : number
  bestMoment : boolean
  comments : Array<IComment>
  creationDate : Date
  editable : boolean
  event : IEvent
  extra : FizJSONObject
  familyId : string
  medias : Array<IMedia>
  metaId : string
  modifDate : Date
  moodMap : Map<number,Array<string>>
  moodStarShortcut : boolean
  nested : IHasMetaId
  place : IPlace
  postAccountId : number
  refAction : string
  refId : string
  refType : string
  rights : FizRightBean
  sortingDate : Date
  text : string
  wallMessageId : string

  constructor(json :IWallMessageJSON){
    super(json);
    this.accountId = decodeNumber(json.accountId);
    this.bestMoment = decodeBoolean(json.bestMoment);
    this.comments = decodeArray(decodeIComment)(json.comments);
    this.creationDate = decodeDate(json.creationDate);
    this.editable = decodeBoolean(json.editable);
    this.event = decodeIEvent(json.event);
    this.extra = decodeFizJSONObject(json.extra);
    this.familyId = (json.familyId);
    this.medias = decodeArray(decodeIMedia)(json.medias);
    this.metaId = (json.metaId);
    this.modifDate = decodeDate(json.modifDate);
    this.moodMap = decodeMap(decodeNumber,decodeArray(decodeEnum))(json.moodMap);
    this.moodStarShortcut = decodeBoolean(json.moodStarShortcut);
    this.nested = decodeDynamic(json.nested) as IHasMetaId;
    this.place = decodeIPlace(json.place);
    this.postAccountId = decodeNumber(json.postAccountId);
    this.refAction = decodeEnum(json.refAction);
    this.refId = (json.refId);
    this.refType = decodeEnum(json.refType);
    this.rights = decodeFizRightBean(json.rights);
    this.sortingDate = decodeDate(json.sortingDate);
    this.text = (json.text);
    this.wallMessageId = (json.wallMessageId);

    this.onDecode(json);
  }
}

function decodeIWallMessage(json :IWallMessageJSON){
  return json===undefined?undefined:new IWallMessage(json)
}

function encodeIWallMessage(obj : IWallMessage) :IWallMessageJSON {
    if(obj==null) return undefined
    return inline({
      accountId : encodeNumber(obj.accountId),
      bestMoment : undefined,
      comments : undefined,
      creationDate : encodeDate(obj.creationDate),
      editable : encodeBoolean(obj.editable),
      event : encodeIEvent(obj.event),
      extra : encodeFizJSONObject(obj.extra),
      familyId : (obj.familyId),
      medias : encodeArray(encodeIMedia)(obj.medias),
      metaId : (obj.metaId),
      modifDate : encodeDate(obj.modifDate),
      moodMap : undefined,
      moodStarShortcut : undefined,
      nested : encodeDynamic(obj.nested),
      place : encodeIPlace(obj.place),
      postAccountId : encodeNumber(obj.postAccountId),
      refAction : encodeEnum(obj.refAction),
      refId : (obj.refId),
      refType : encodeEnum(obj.refType),
      rights : encodeFizRightBean(obj.rights),
      sortingDate : encodeDate(obj.sortingDate),
      text : (obj.text),
      wallMessageId : (obj.wallMessageId),
    } as IWallMessageJSON)
}
const types = {
  ServerBeanPrototype,
   ServerError,
   AFizApiException : ServerError,
   AFizApiUnattendedException : ServerError,
   FizAccountDoesNotExistException : ServerError,
   "507" : ServerError,
   FizAccountNotFoundInSessionException : ServerError,
   "501" : ServerError,
   FizApiDuplicateModelException : ServerError,
   "63" : ServerError,
   FizApiInvalidParameterException : ServerError,
   "502" : ServerError,
   FizApiKeyInsufficientRightsException : ServerError,
   "509" : ServerError,
   FizApiModelDoesNotExistException : ServerError,
   "503" : ServerError,
   FizApiPremiumRequiredException : ServerError,
   "505" : ServerError,
   FizApiStringTooLongException : ServerError,
   "5020" : ServerError,
   FizApiUnattendedExceptionDefaultImpl : ServerError,
   "500" : ServerError,
   FizFamilyDoesNotExistException : ServerError,
   "510" : ServerError,
   FizPersistenceOptimisticLockException : ServerError,
   "508" : ServerError,
   FizSecurityException : ServerError,
   "506" : ServerError,
   AccessTokenBean,
   AccountBean,
   AccountIdentifierBean,
   AccountIdentifierInfo,
   AccountLoginInfo,
   AccountSecurityBean,
   AccountStateBean,
   "49" : ApplicationBlockedPopupBean,
   ApplicationBlockedPopupBean,
   "81" : CoverUriConfigurableBean,
   CoverUriConfigurableBean,
   "82" : CoverUriPhoneAndTabletBean,
   CoverUriPhoneAndTabletBean,
   DeepLinkAccessToken,
   ExtendedFamilyMemberBean,
   FamilyBean,
   FamilyMemberBean,
   FizAccountAlreadyExistsException : ServerError,
   "2" : ServerError,
   FizAccountAlreadyHasAFirstFamilyException : ServerError,
   "11" : ServerError,
   FizAccountAlreadyInThisFamilyException : ServerError,
   "12" : ServerError,
   FizAccountBlockedForPasswordException : ServerError,
   "26" : ServerError,
   FizAccountIdentifierNotValidatedException : ServerError,
   "4" : ServerError,
   FizAccountNotFoundException : ServerError,
   "1" : ServerError,
   FizApiAccIdentifierInvalidException : ServerError,
   "21" : ServerError,
   FizApiAccIdentifierNotvalidatedException : ServerError,
   "24" : ServerError,
   FizApiEmailInvalidException : ServerError,
   "17" : ServerError,
   FizApiMsisdnInvalidException : ServerError,
   "22" : ServerError,
   FizApiUserBlockedException : ServerError,
   "18" : ServerError,
   FizApplicationVersionIncompatibleException : ServerError,
   "14" : ServerError,
   FizAutologinTokenExpiredException : ServerError,
   "8" : ServerError,
   FizCredentialInvalidException : ServerError,
   "3" : ServerError,
   FizDeviceIdMismatchException : ServerError,
   "15" : ServerError,
   FizFamilyAlreadyExistWithThisNameException : ServerError,
   "13" : ServerError,
   FizInvalidTokenException : ServerError,
   "16" : ServerError,
   FizInvitationAlreadyExistException : ServerError,
   "19" : ServerError,
   ForgotPasswordResponseBean,
   "155667" : InvitationBean,
   InvitationBean,
   InvitationReceivedBean,
   InvitationSendingBean,
   "76" : PremiumPopupBean,
   PremiumPopupBean,
   "80" : PremiumPopupConfigurableContentBean,
   PremiumPopupConfigurableContentBean,
   ProfileBean,
   "78" : ProgrammaticAdsBean,
   ProgrammaticAdsBean,
   "48" : TokenAndAccountLogInfoBean,
   TokenAndAccountLogInfoBean,
   TokenBean,
   AddressBean,
   ContactBean,
   "-292618997" : ContactSyncBean,
   ContactSyncBean,
   DeviceBean,
   FizContactAlreadyExistsException : ServerError,
   "200" : ServerError,
   VcardImportPreviewBean,
   AdminRightBean,
   FizNotEnougthRightException : ServerError,
   "7" : ServerError,
   FizPremiumOngoingException : ServerError,
   "65" : ServerError,
   InboundEmailPreference,
   ApiKeyBean,
   FizApiKeyNotFoundException : ServerError,
   "10" : ServerError,
   PremiumRightBean,
   CreditBean,
   FizApiPromoCodeExpiredException : ServerError,
   "403" : ServerError,
   FizGPlayStoreCannotTalkToGoogleException : ServerError,
   "402" : ServerError,
   FizITunesCannotTalkToAppleException : ServerError,
   "401" : ServerError,
   "64" : ItunesReceiptStatusBean,
   ItunesReceiptStatusBean,
   PromoCodeBean,
   PromoCodeCampaignBean,
   PromoPushBean,
   PromoPushCampaignBean,
   "50" : PromoPushCampainDetailBean,
   PromoPushCampainDetailBean,
   SubscriptionTicketBean,
   TwoCheckoutPriceBean,
   TwoCheckoutPricePromoBean,
   TwoCheckoutUrlsBean2,
   "58" : BudgetBean,
   BudgetBean,
   "51" : BudgetCategoryBean,
   BudgetCategoryBean,
   "54" : BudgetCategoryInputBean,
   BudgetCategoryInputBean,
   "55" : BudgetCategorySyncBean,
   BudgetCategorySyncBean,
   "57" : BudgetInputBean,
   BudgetInputBean,
   "61" : BudgetSyncBean,
   BudgetSyncBean,
   "60" : BudgetTransactionBean,
   BudgetTransactionBean,
   "59" : BudgetTransactionInputBean,
   BudgetTransactionInputBean,
   "62" : BudgetTransactionSyncBean,
   BudgetTransactionSyncBean,
   "52" : PaymentMethodBean,
   PaymentMethodBean,
   "53" : PaymentMethodInputBean,
   PaymentMethodInputBean,
   "56" : PaymentMethodSyncBean,
   PaymentMethodSyncBean,
   CommentBean,
   "77" : CommentResultBean,
   CommentResultBean,
   FizApiClientSideOperationAlreadyPerformed : ServerError,
   "511" : ServerError,
   FizLimitReachedException : ServerError,
   "610" : ServerError,
   FizRightBean,
   FizRuntimeLimitReachedException : ServerError,
   "611" : ServerError,
   PaginatedCollection,
   PaginationRequest,
   SimplePaginatedCollection,
   SimplePaginationRequest,
   TokenUrlBean,
   DeviceConfigBean,
   FizTokenNeededException : ServerError,
   "31" : ServerError,
   AttendeeBean,
   "3100" : CalendarBean,
   CalendarBean,
   CalendarGroupBean,
   CalendarSharedBean,
   CalendarSubscriptionResponseBean,
   CalendarSuggestionBean,
   "42" : CalendarTimetableBean,
   CalendarTimetableBean,
   EventBean,
   "1660334400" : EventInputBean,
   EventInputBean,
   "68" : EventListAndCalendar,
   EventListAndCalendar,
   "706324869" : EventSyncBean,
   EventSyncBean,
   FizApiDistinctOccurenceIntersectException : ServerError,
   "23" : ServerError,
   FizApiIcalContentInvalidException : ServerError,
   "408" : ServerError,
   FizApiIcalUrlDuplicateException : ServerError,
   "406" : ServerError,
   FizApiIcalUrlInvalidException : ServerError,
   "405" : ServerError,
   FizApiTimetableEventWillBeDeletedException : ServerError,
   "407" : ServerError,
   IcalImportPreviewBean,
   IcalImportResultBean,
   RecurrencyDescriptor,
   ReminderBean,
   "39" : TimetableBean,
   TimetableBean,
   "41" : TimetableInputBean,
   TimetableInputBean,
   "40" : TimetableSyncBean,
   TimetableSyncBean,
   "3200" : ExternalImportBean,
   ExternalImportBean,
   "90" : ExternalImportSyncBean,
   ExternalImportSyncBean,
   "73" : FileSyncBean,
   FileSyncBean,
   "75" : FilerInputBean,
   FilerInputBean,
   "72" : FolderBean,
   FolderBean,
   "71" : FolderInputBean,
   FolderInputBean,
   "70" : FolderSyncBean,
   FolderSyncBean,
   GoogleCredentialBean,
   GoogleLinkableCalendarBean,
   "1618477554" : MessageSyncBean,
   MessageSyncBean,
   SyncRequest,
   "11000" : DashboardTileBean,
   DashboardTileBean,
   "11001" : DashboardTileInputBean,
   DashboardTileInputBean,
   "11002" : ExploreBean,
   ExploreBean,
   LaunchpadActivityBean,
   LaunchpadActivityItemBean,
   LaunchpadBean,
   LaunchpadConditionBean,
   LaunchpadEvent,
   WeatherBean,
   CleanResultBean,
   "37" : CategoryBean,
   CategoryBean,
   "36" : CategoryInputBean,
   CategoryInputBean,
   "8005" : DishBean,
   DishBean,
   "1533985075" : DishRangeBean,
   DishRangeBean,
   "8003" : DishSyncBean,
   DishSyncBean,
   "79" : IAGenerateRecipeParameters,
   IAGenerateRecipeParameters,
   "8006" : MealBean,
   MealBean,
   "8008" : MealInputBean,
   MealInputBean,
   MealPlannerSharedBean,
   MealSettingsBean,
   MealSettingsColumnBean,
   "8007" : MealSyncBean,
   MealSyncBean,
   "8004" : RecipeBean,
   RecipeBean,
   "8009" : RecipeExternalBean,
   RecipeExternalBean,
   "8010" : RecipeExternalSyncBean,
   RecipeExternalSyncBean,
   RecipeIngredientBean,
   RecipeInputBean,
   RecipePuByUrlResultBean,
   "8002" : RecipeSyncBean,
   RecipeSyncBean,
   ShoppingIngredientInputBean,
   FizMediaCorruptedException : ServerError,
   "602" : ServerError,
   FizMediaQuotaExceededException : ServerError,
   "601" : ServerError,
   MediaBean,
   MediaFilterFrontImage,
   MediaListBean,
   MediaQuota,
   OutlookCredentialBean,
   OutlookLinkableCalendarBean,
   FizApiAddressNotGeocodableException : ServerError,
   "28" : ServerError,
   FizGeofenceForThisPlaceDisabledException : ServerError,
   "29" : ServerError,
   FizGeolocDisabledException : ServerError,
   "27" : ServerError,
   FizGeolocSettingsDisabledException : ServerError,
   "30" : ServerError,
   GeocodedAddress,
   LocationBean,
   LocationDeviceFlags,
   PlaceBean,
   PlaceGeofencingBean,
   PlaceNearbyResult,
   "-1710402830" : PlaceSyncBean,
   PlaceSyncBean,
   "800" : BroadcastSignalMessage,
   BroadcastSignalMessage,
   "810" : CacheInvalidatedMessageBean,
   CacheInvalidatedMessageBean,
   "814" : DatabaseHealthStatusBean,
   DatabaseHealthStatusBean,
   "815" : DatabaseHealthStatusValue,
   DatabaseHealthStatusValue,
   "811" : PingPongPayloadBean,
   PingPongPayloadBean,
   "43" : PromoPushExtraPayload,
   PromoPushExtraPayload,
   "-1018410819" : PushMessageBean,
   PushMessageBean,
   "1720010054" : WebSocketPushMessage,
   WebSocketPushMessage,
   AiInboxResponseBean,
   SettingsBean,
   SettingsPerFamilyBean,
   "812" : ClusterNodeStatus,
   ClusterNodeStatus,
   "813" : ClusterStatus,
   ClusterStatus,
   StatusBean,
   SmsStubBean,
   AssigneeBean,
   "-346040587" : TaskBean,
   TaskBean,
   "47" : TaskCategoryBean,
   TaskCategoryBean,
   "46" : TaskCategoryInputBean,
   TaskCategoryInputBean,
   "66" : TaskCategorySyncBean,
   TaskCategorySyncBean,
   "67" : TaskInputBean,
   TaskInputBean,
   "38" : TaskListSettingsBean,
   TaskListSettingsBean,
   "8012" : TaskSuggestionBean,
   TaskSuggestionBean,
   "8011" : TaskSuggestionSyncBean,
   TaskSuggestionSyncBean,
   "8013" : TaskSuggestionSyncBeanWCategory,
   TaskSuggestionSyncBeanWCategory,
   "379942320" : TaskSyncBean,
   TaskSyncBean,
   "25" : AccountActivityBean,
   AccountActivityBean,
   WallMessageBean,
   FizAdultContentException : ServerError,
   "181818" : ServerError,
   OpenGraphDataBean,
   OpenGraphMedia,
   "35" : ColorBean,
   ColorBean,
   "34" : ColorInputBean,
   ColorInputBean,
   IAccount,
   IAccountIdentifier,
   IExtendedFamily,
   "1456840928" : IExtendedFamilyMember,
   IExtendedFamilyMember,
   "-1834734323" : IFamily,
   IFamily,
   "-1192827385" : IFamilyMember,
   IFamilyMember,
   "860376258" : IInvitation,
   IInvitation,
   IToken,
   "-1106903189" : IAddress,
   IAddress,
   "992315287" : IContact,
   IContact,
   IDevice,
   IApiKey,
   "-1905165150" : ICredit,
   ICredit,
   IPromoCode,
   IPromoCodeCampaign,
   "44" : IPromoPushCampaign,
   IPromoPushCampaign,
   "991187414" : IComment,
   IComment,
   "85571313" : IHasMetaId,
   IHasMetaId,
   IDeviceConfig,
   IAttendee,
   "-2137700399" : IEvent,
   IEvent,
   IReminder,
   "74" : IFilerInputBean,
   IFilerInputBean,
   "-883752934" : IIMMessage,
   IIMMessage,
   IIMParticipant,
   "1698643863" : IIMThread,
   IIMThread,
   "-2130819813" : IMedia,
   IMedia,
   ILocation,
   "-2127843778" : IPlace,
   IPlace,
   "-660611813" : IPlaceGeofencing,
   IPlaceGeofencing,
   "-268636896" : IProfile,
   IProfile,
   IBroadcastable,
   ISettingsPerFamily,
   "1896517879" : ISyncBean,
   ISyncBean,
   "854072108" : ITaskList,
   ITaskList,
   "8001" : IWallMessage,
   IWallMessage,
 };

  
registerMethod("accaddidentifier",["type","identifier","countryCode","validationmethod","password"], decodeStructure(decodeIAccount));
registerMethod("accaddidentifier2",["type","identifier","countryCode","validationmethod","password"], decodeStructure(decodeIAccountIdentifier));
registerMethod("accchangeaccountidentifier",["oldid","type","countryCode","oldidentifier","newidentifier","validationmethod","password"], decodeStructure(decodeIAccountIdentifier));
registerMethod("accchangepassword",["password","newpassword"], decodeStructure(decodeString));
registerMethod("acccheckpassword",["password"], decodeStructure(decodeboolean));
registerMethod("acccreatefamily",["name","role","customFamilyRole","cover"], decodeStructure(decodeNumber));
registerMethod("acccreatesubaccount",["role","customFamilyRole","firstname","birthday","timezone","locale","picture","homeAddress","workAddress"], decodeStructure(decodeNumber));
registerMethod("accdeeplink",["page","directWebPage"], decodeStructure(decodeString));
registerMethod("accgenerateDeepLoginLink",["page","webWanted","dev"], decodeStructure(decodeString));
registerMethod("accgetallfamily",["withStateBean"], decodeStructure(decodeIExtendedFamily));
registerMethod("accgetfamily",[], decodeStructure(decodeIFamily));
registerMethod("accgetloggedaccount",[], decodeStructure(decodeIAccount));
registerMethod("accgetpremium",[], decodeStructure(decodePremiumRightBean));
registerMethod("accgetsecuritystate",[], decodeStructure(decodeAccountSecurityBean));
registerMethod("accgetstate",["deviceId","modelType","applicationVersion","timezone","locale","buildTimestamp"], decodeStructure(decodeAccountStateBean));
registerMethod("accinvite",["identifier","password","role","customFamilyRole","firstname","mobile","birthday","timezone","locale","picture","homeAddress","workAddress"], decodeStructure(decodeNumber));
registerMethod("accremoveidentifier",["id","password"], decodeStructure(decodeIAccount));
registerMethod("accremoveidentifier2",["id","password"], decodeStructure(decodeIAccountIdentifier));
registerMethod("accsendaccountidentifiervalidationcode",["id","type","identifier","countryCode","validationmethod"], decodeStructure(decodeBoolean));
registerMethod("accsendwelcomeemail",[], decodeStructure(decodeBoolean));
registerMethod("accsetprofile",["accountId","pseudo","firstname","gender","role","customFamilyRole","mobile","email","birthday","timezone","locale","picture","homeAddress","workAddress","color","publishProfileChanged","customFirstName","customAvatar"], decodeStructure(decodeNumber));
registerMethod("accsetterms",["termsChecked","termsHtcChecked","termsOrangeFamilyPlaceChecked","termsSprintChecked","termsProximusFamilyChecked"], decodeStructure(decodeAccountLoginInfo));
registerMethod("accupdatefamily",["name","file","cover"], decodeStructure(decodeIFamily));
registerMethod("accvalidateaccountidentifierwithcode",["id","type","identifier","countryCode","code","autoacceptpendinginvite"], decodeStructure(decodeIAccount));
registerMethod("accvalidateaccountidentifierwithcode2",["id","type","identifier","countryCode","code","autoacceptpendinginvite"], decodeStructure(decodeIAccountIdentifier));
registerMethod("accvalidatechangeaccountidentifier",["oldid","type","countryCode","oldidentifier","newidentifier","code"], decodeStructure(decodeIAccountIdentifier));
  

registerMethod("adminchange",["right",{name:"accountid",encode:encodeArray(encodeNumber)}], decodeStructure(decodeAdminRightBean));
registerMethod("admindelete2",["deleteAuthoredPost"], decodeStructure(decodeBoolean));
registerMethod("admingetright",["accountId"], decodeStructure(decodeEnum));
registerMethod("adminlist",[], decodeStructure(decodeAdminRightBean));
registerMethod("adminremove",["accountId","deleteAuthoredPost"], decodeStructure(decodeBoolean));
registerMethod("adminwipefamily",[], decodeStructure(decodeBoolean));
  

registerMethod("albumall",["accountId","bestMoment","mood",{name:"pg",encode:encodePaginationRequest}], decodeStructure(decodeMediaListBean));
registerMethod("albumfrontbycreator",[], decodeStructure(decodeArray(decodeMediaFilterFrontImage)));
registerMethod("albumquota",[], decodeStructure(decodeMediaQuota));
  

registerMethod("budgetcategorydelete",[{name:"id",encode:encodeArray(encodeString)}], decodeStructure(decodeboolean));
registerMethod("budgetcategoryget",["id"], decodeStructure(decodeBudgetCategoryBean));
registerMethod("budgetcategorylist",["budgetTransactionType","locale"], decodeStructure(decodeArray(decodeBudgetCategoryBean)));
registerMethod("budgetcategoryput",[{encode:encodeBudgetCategoryInputBean},"prevId"], decodeStructure(decodeBudgetCategoryBean));
registerMethod("budgetcategorysync",["syncToken"], decodeStructure(decodeBudgetCategorySyncBean));
registerMethod("budgetclose",["metaId"], decodeStructure(decodeboolean));
registerMethod("budgetdelete",[{name:"id",encode:encodeArray(encodeString)}], decodeStructure(decodeBoolean));
registerMethod("budgetexportcsvurl",[{name:"id",encode:encodeArray(encodeString)},"from","to"], decodeStructure(decodeString));
registerMethod("budgetget",["id"], decodeStructure(decodeBudgetBean));
registerMethod("budgetlist",[], decodeStructure(decodeArray(decodeBudgetBean)));
registerMethod("budgetmarkaspaid",[{name:"metaId",encode:encodeArray(encodeString)},"value"], decodeStructure(decodeArray(decodeBudgetTransactionBean)));
registerMethod("budgetpaymentmethoddelete",[{name:"id",encode:encodeArray(encodeString)}], decodeStructure(decodeboolean));
registerMethod("budgetpaymentmethodget",["id"], decodeStructure(decodePaymentMethodBean));
registerMethod("budgetpaymentmethodlist",["locale"], decodeStructure(decodeArray(decodePaymentMethodBean)));
registerMethod("budgetpaymentmethodput",[{encode:encodePaymentMethodInputBean},"prevId"], decodeStructure(decodePaymentMethodBean));
registerMethod("budgetpaymentmethodsync",["syncToken"], decodeStructure(decodePaymentMethodSyncBean));
registerMethod("budgetput",[{encode:encodeBudgetInputBean}], decodeStructure(decodeBudgetBean));
registerMethod("budgetsync",["syncToken"], decodeStructure(decodeBudgetSyncBean));
registerMethod("budgettransactiondelete",["option",{name:"id",encode:encodeArray(encodeString)}], decodeStructure(decodeBoolean));
registerMethod("budgettransactiondeleteoption",["id"], decodeStructure(decodeArray(decodeEnum)));
registerMethod("budgettransactionget",["id"], decodeStructure(decodeBudgetTransactionBean));
registerMethod("budgettransactionlist",[], decodeStructure(decodeArray(decodeBudgetTransactionBean)));
registerMethod("budgettransactionput",["option",{encode:encodeBudgetTransactionInputBean},{name:"file",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeBudgetTransactionBean));
registerMethod("budgettransactionsync",["syncToken"], decodeStructure(decodeBudgetTransactionSyncBean));
registerMethod("budgettransactionupdateoption",[{encode:encodeBudgetTransactionInputBean}], decodeStructure(decodeArray(decodeEnum)));
  

registerMethod("colordelete",[{name:"id",encode:encodeArray(encodeString)}], decodeStructure(decodeboolean));
registerMethod("colorget",["id"], decodeStructure(decodeColorBean));
registerMethod("colorlist",[], decodeStructure(decodeArray(decodeColorBean)));
registerMethod("colorput",[{encode:encodeColorInputBean}], decodeStructure(decodeColorBean));
  

registerMethod("credit2checkouturl2",[], decodeStructure(decodeTwoCheckoutUrlsBean2));
registerMethod("creditget",[], decodeStructure(decodeArray(decodeICredit)));
registerMethod("creditgetPromoCode",["value"], decodeStructure(decodeIPromoCode));
registerMethod("creditgetfreesku",["creditType","paymentType","typeOfPeriod"], decodeStructure(decodeString));
registerMethod("creditgetmanualrenewalllink",["creditId"], decodeStructure(decodeString));
registerMethod("creditgoogleplaytoken",["deviceId","token","creditType","sku"], decodeStructure(decodeSubscriptionTicketBean));
registerMethod("credititunesIos7ticket",["deviceId","receipt"], decodeStructure(decodeSubscriptionTicketBean));
registerMethod("credititunesreceiptstatus",["deviceId","receipt",{name:"trialDurationProductIdList",encode:encodeArray(encodeString)}], decodeStructure(decodeItunesReceiptStatusBean));
registerMethod("credititunesticket",["deviceId","receipt"], decodeStructure(decodeSubscriptionTicketBean));
registerMethod("creditlistall",[], decodeStructure(decodeArray(decodeICredit)));
registerMethod("creditsetautorenewall",["creditId","auto"], decodeStructure(decodeICredit));
registerMethod("creditswitchfamily",["creditId","existingFamilyId","newFamilyId"], decodeStructure(decodeICredit));
registerMethod("creditusepromocode",["value"], decodeStructure(decodeICredit));
  

registerMethod("ctccomment",["contactId","text"], decodeStructure(decodeIComment));
registerMethod("ctcdelete",[{name:"contactIds",encode:encodeArray(encodeString)}], decodeStructure(decodeboolean));
registerMethod("ctcget",["contactId"], decodeStructure(decodeIContact));
registerMethod("ctclist",[], decodeStructure(decodeArray(decodeIContact)));
registerMethod("ctcput",[{encode:encodeIContact},{name:"pictures",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeIContact));
registerMethod("ctcsync",["syncToken","date"], decodeStructure(decodeContactSyncBean));
registerMethod("ctcvcardimport",["file","isPreview",{name:"indexes",encode:encodeArray(encodeNumber)}], decodeStructure(decodeVcardImportPreviewBean));
registerMethod("ctcvcardurl",["contactId"], decodeStructure(decodeString));
  

registerMethod("deviceackpush",[{name:"pushIds",encode:encodeArray(encodeString)}], decodeStructure(decodeBoolean));
registerMethod("devicecheckpush",[{encode:encodeDeviceConfigBean},"isBackground"], decodeStructure(decodeArray(decodePushMessageBean)));
registerMethod("devicedelete",["deviceId"], decodeStructure(decodeboolean));
registerMethod("devicelist",[], decodeStructure(decodeArray(decodeIDeviceConfig)));
registerMethod("devicelogout",[{name:"config",encode:encodeDeviceConfigBean}], decodeStructure(decodeboolean));
registerMethod("devicesetconfig",[{name:"config",encode:encodeDeviceConfigBean}], decodeStructure(decodeboolean));
  

registerMethod("evtaddComment",["eventId","text","mood","clientOpId"], decodeStructure(decodeCommentResultBean(decodeIEvent)));
registerMethod("evtcalcheckurl",["url"], decodeStructure(decodeboolean));
registerMethod("evtcaldelete",["metaId"], decodeStructure(decodeboolean));
registerMethod("evtcallist",["withtask","withmeal","withfolder","withAllFamilies","withExternal","withOnError","withSpecialDays"], decodeStructure(decodeCalendarGroupBean));
registerMethod("evtcalsubscribe2",["url"], decodeStructure(decodeCalendarSubscriptionResponseBean));
registerMethod("evtcalupdate",[{encode:encodeCalendarBean}], decodeStructure(decodeboolean));
registerMethod("evtcreate",[{encode:encodeEventInputBean}], decodeStructure(decodeIEvent));
registerMethod("evtdelete",["option",{name:"eventId",encode:encodeArray(encodeString)}], decodeStructure(decodeboolean));
registerMethod("evtdeleteoption",["eventId"], decodeStructure(decodeArray(decodeEnum)));
registerMethod("evtget",["eventId"], decodeStructure(decodeIEvent));
registerMethod("evtgetbirthday",["contactId"], decodeStructure(decodeIEvent));
registerMethod("evticalimport",["file","isPreview",{name:"indexes",encode:encodeArray(encodeNumber)}], decodeStructure(decodeIcalImportPreviewBean));
registerMethod("evticalurl",["calendarId","eventId"], decodeStructure(decodeString));
registerMethod("evticalvisibleurl",["refresh","calendarId","eventId"], decodeStructure(decodeString));
registerMethod("evticalvisibleurldelete",["calendarId"], decodeStructure(decodeboolean));
registerMethod("evtlistinterval",["from","to",{name:"accountId",encode:encodeArray(encodeNumber)},{name:"attendeeId",encode:encodeArray(encodeNumber)}], decodeStructure(decodeArray(decodeIEvent)));
registerMethod("evtlistinterval2",["from","to",{name:"accountId",encode:encodeArray(encodeNumber)},{name:"attendeeId",encode:encodeArray(encodeNumber)},{name:"calendarId",encode:encodeArray(encodeString)},"limit"], decodeStructure(decodeArray(decodeIEvent)));
registerMethod("evtlistintervalandcalendar",["from","to",{name:"accountId",encode:encodeArray(encodeNumber)},{name:"attendeeId",encode:encodeArray(encodeNumber)},{name:"calendarId",encode:encodeArray(encodeString)},"activeCalendar","limit","activeTimetable"], decodeStructure(decodeEventListAndCalendar));
registerMethod("evtnavigate",["eventId","offset",{name:"accountId",encode:encodeArray(encodeNumber)}], decodeStructure(decodeArray(decodeIEvent)));
registerMethod("evtncsync",["tokenValue","syncToken"], decodeStructure(decodeCalendarSharedBean));
registerMethod("evtsetexternalerror",["error"], decodeStructure(decodeboolean));
registerMethod("evtsharedlink",["timetableId","from","to"], decodeStructure(decodeTokenUrlBean));
registerMethod("evtsync",["syncToken","date","calendarId"], decodeStructure(decodeEventSyncBean));
registerMethod("evttimetableClose",["timetableId"], decodeStructure(decodeboolean));
registerMethod("evttimetableCopySlice",["timetableId","srcSliceNb","destSliceNb"], decodeStructure(decodeboolean));
registerMethod("evttimetableCopySliceByDate",["timetableId","startDate","endDate","targetStart"], decodeStructure(decodeArray(decodeIEvent)));
registerMethod("evttimetableCopySliceWResult",["timetableId","srcSliceNb","destSliceNb"], decodeStructure(decodeArray(decodeIEvent)));
registerMethod("evttimetableResetSlice",["timetableId","sliceNb"], decodeStructure(decodeboolean));
registerMethod("evttimetableResetSliceByDate",["timetableId","startDate","endDate"], decodeStructure(decodeArray(decodeString)));
registerMethod("evttimetableput",[{encode:encodeTimetableInputBean},"allowDeleteEvent"], decodeStructure(decodeTimetableBean));
registerMethod("evtupdate",["option",{encode:encodeEventInputBean}], decodeStructure(decodeIEvent));
registerMethod("evtupdateoption",[{encode:encodeEventInputBean}], decodeStructure(decodeArray(decodeEnum)));
  

registerMethod("famacceptinvitation",["iid","v","validationmethod"], decodeStructure(decodeboolean));
registerMethod("famblockinvite",["iid","v","block"], decodeStructure(decodeInvitationReceivedBean));
registerMethod("famcancelinvite",["invitationId","v"], decodeStructure(decodeboolean));
registerMethod("famgetinvitation",["iid","v"], decodeStructure(decodeInvitationReceivedBean));
registerMethod("famgetinvitationlinkbean",[], decodeStructure(decodeTokenUrlBean));
registerMethod("famlistfamily",["withStateBean"], decodeStructure(decodeArray(decodeIExtendedFamily)));
registerMethod("famlistinvite",[{name:"pg",encode:encodePaginationRequest}], decodeStructure(decodeArray(decodeIInvitation)));
registerMethod("famlogfamily",["familyId"], decodeStructure(decodeIFamily));
registerMethod("famresendinvite",["iid","deviceComposerUsed"], decodeStructure(decodeInvitationSendingBean));
registerMethod("famsendinvite",["email","phone","inviteeid","role","adminRight","customFamilyRole","firstname","picture","deviceComposerUsed","test"], decodeStructure(decodeInvitationSendingBean));
registerMethod("famsetfirst",["familyId"], decodeStructure(decodeboolean));
registerMethod("famshowincominginvite",[{name:"pg",encode:encodePaginationRequest}], decodeStructure(decodeArray(decodeInvitationReceivedBean)));
registerMethod("famupdateinvitation",["iid","email","phone","role","adminRight","customFamilyRole","firstname","picture"], decodeStructure(decodeIInvitation));
  

registerMethod("filerclose",["metaId"], decodeStructure(decodeboolean));
registerMethod("filerdeletefile",[{name:"id",encode:encodeArray(encodeString)}], decodeStructure(decodeBoolean));
registerMethod("filerdeletefolder",[{name:"id",encode:encodeArray(encodeString)}], decodeStructure(decodeBoolean));
registerMethod("filerduplicatefolder",["id","targetId"], decodeStructure(decodeFolderBean));
registerMethod("filergetfile",["id"], decodeStructure(decodeIMedia));
registerMethod("filergetfolder",["id"], decodeStructure(decodeFolderBean));
registerMethod("filerlistfile",[], decodeStructure(decodeArray(decodeIMedia)));
registerMethod("filerlistfolder",[], decodeStructure(decodeArray(decodeFolderBean)));
registerMethod("filerputfile",[{encode:encodeIFilerInputBean},"file"], decodeStructure(decodeIMedia));
registerMethod("filerputfolder",[{encode:encodeFolderInputBean}], decodeStructure(decodeFolderBean));
registerMethod("filersyncfile",["syncToken"], decodeStructure(decodeFileSyncBean));
registerMethod("filersyncfolder",["syncToken"], decodeStructure(decodeFolderSyncBean));
  

registerMethod("geoaddress",["address"], decodeStructure(decodeGeocodedAddress));
registerMethod("geoaddresswithcontext",["address","latitudeE6","longitudeE6","start","count"], decodeStructure(decodePaginatedCollection(decodeGeocodedAddress)));
registerMethod("geocheck",[{name:"geocodedAddress",encode:encodeGeocodedAddress}], decodeStructure(decodeGeocodedAddress));
registerMethod("geodetailedaddress",["country","state","zipCode","town","line"], decodeStructure(decodeGeocodedAddress));
registerMethod("georeverse",["latitudeE6","longitudeE6"], decodeStructure(decodeGeocodedAddress));
  

registerMethod("googleAuthUri",[], decodeStructure(decodeString));
registerMethod("googlegetcredential",["credentialId"], decodeStructure(decodeGoogleCredentialBean));
registerMethod("googlelogin",["code"], decodeStructure(decodeboolean));
registerMethod("googlelogin2",["code"], decodeStructure(decodeGoogleCredentialBean));
registerMethod("googlesavetoken",["tokenType","accessToken","refreshToken","expiresDate"], decodeStructure(decodeboolean));
registerMethod("googlesavetoken2",["tokenType","accessToken","refreshToken","expiresDate"], decodeStructure(decodeGoogleCredentialBean));
registerMethod("googleselectcalendar2",["credentialId",{name:"googleId",encode:encodeArray(encodeString)}], decodeStructure(decodeCalendarSubscriptionResponseBean));
  

registerMethod("imgetpremium",[], decodeStructure(decodePremiumRightBean));
registerMethod("immarkasread",["threadId","clientOpId"], decodeStructure(decodeIIMThread));
registerMethod("immessagelist2",["threadId",{name:"pg",encode:encodeSimplePaginationRequest}], decodeStructure(decodeSimplePaginatedCollection(decodeIIMMessage)));
registerMethod("immessagelistgrp",[{name:"threadId",encode:encodeArray(encodeString)},"count"], decodeStructure(decodeArray(decodeSimplePaginatedCollection(decodeIIMMessage))));
registerMethod("immessagesync",["threadId","syncToken","date"], decodeStructure(decodeMessageSyncBean));
registerMethod("immessagesyncgrp",[{name:"request",encode:encodeArray(encodeSyncRequest)}], decodeStructure(decodeArray(decodeMessageSyncBean)));
registerMethod("imnewthread",[{name:"to",encode:encodeArray(encodeNumber)},"clientOpId"], decodeStructure(decodeIIMThread));
registerMethod("imsend",["threadId",{name:"to",encode:encodeArray(encodeNumber)},"text","media","type","externalId","clientOpId"], decodeStructure(decodeIIMMessage));
registerMethod("imthreadlist",["filter","isLoggedFamily"], decodeStructure(decodeArray(decodeIIMThread)));
  

registerMethod("launchpadclick",["section","date"], decodeStructure(decodeboolean));
registerMethod("launchpadcondition",["activityWanted"], decodeStructure(decodeLaunchpadConditionBean));
registerMethod("launchpadget2",[{name:"address",encode:encodeGeocodedAddress},{name:"conditions",encode:encodeLaunchpadConditionBean},{name:"actions",encode:encodeArray(encodeEnum)}], decodeStructure(decodeLaunchpadBean));
registerMethod("launchpadget3",["token",{name:"address",encode:encodeGeocodedAddress},{name:"conditions",encode:encodeLaunchpadConditionBean}], decodeStructure(decodeLaunchpadBean));
registerMethod("launchpadgetexplore",["token"], decodeStructure(decodeExploreBean));
registerMethod("launchpadlisttiles",[], decodeStructure(decodeArray(decodeDashboardTileBean)));
registerMethod("launchpadmovetile",["tileId","prevId"], decodeStructure(decodeMap(decodeString,decodeNumber)));
registerMethod("launchpadseen",["screen","clear"], decodeStructure(decodeboolean));
registerMethod("launchpadupdatetile",[{encode:encodeDashboardTileInputBean}], decodeStructure(decodeDashboardTileBean));
  

registerMethod("locacceptpickmeup",["targetId"], decodeStructure(decodeBoolean));
registerMethod("localarmpanicbutton",[{name:"geocodedAddress",encode:encodeGeocodedAddress}], decodeStructure(decodeBoolean));
registerMethod("locclearAlarmpanicbutton",[], decodeStructure(decodeBoolean));
registerMethod("locget",["accountId"], decodeStructure(decodeILocation));
registerMethod("locgetbyplace",["placeId"], decodeStructure(decodeArray(decodeILocation)));
registerMethod("locgetdeviceflag",[], decodeStructure(decodeLocationDeviceFlags));
registerMethod("locgetgeofencingsforpublisher",["withPlace"], decodeStructure(decodeArray(decodeIPlaceGeofencing)));
registerMethod("locgetgeofencingsforsubscriber",["placeId"], decodeStructure(decodeMap(decodeNumber,decodeIPlaceGeofencing)));
registerMethod("locgetpositions2",[], decodeStructure(decodeArray(decodeILocation)));
registerMethod("lochistory",["date"], decodeStructure(decodePaginatedCollection(decodeILocation)));
registerMethod("locpublisfencing",["type","placeId","deviceId"], decodeStructure(decodeILocation));
registerMethod("locpublishaddress",["text","address","latitudeE6","longitudeE6","isTemporary",{name:"picture",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeIWallMessage));
registerMethod("locpublishauto",[{name:"geocodedAddress",encode:encodeGeocodedAddress},"deviceId","fromRequestAccountId"], decodeStructure(decodeILocation));
registerMethod("locpublishpickmeup",["targetId","address","latitudeE6","longitudeE6"], decodeStructure(decodeBoolean));
registerMethod("locpublishplacelocation",["text","placeId","moveType",{name:"picture",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeIWallMessage));
registerMethod("locrequestautotrack",["publisherId"], decodeStructure(decodeBoolean));
registerMethod("locrequestpositionrefresh",["accountId"], decodeStructure(decodeBoolean));
registerMethod("locrespondtogeorequest",[{name:"accept",encode:encodeMap(encodeNumber,encodeBoolean)},{name:"tempDuration",encode:encodeMap(encodeNumber,encodeNumber)},{name:"geocodedAddress",encode:encodeGeocodedAddress},"deviceId"], decodeStructure(decodeBoolean));
registerMethod("locsetdeviceflag",[{encode:encodeLocationDeviceFlags}], decodeStructure(decodeLocationDeviceFlags));
registerMethod("locsetgeofencingsettings",["placeId","publisherId","in","out"], decodeStructure(decodeIPlaceGeofencing));
registerMethod("locsetperuserauthflag",[{name:"flags",encode:encodeMap(encodeNumber,encodeEnum)},{name:"tempDuration",encode:encodeMap(encodeNumber,encodeNumber)},{name:"geocodedAddress",encode:encodeGeocodedAddress},"deviceId"], decodeStructure(decodeBoolean));
  

registerMethod("log2check",["type","identifier","countryCode","validated"], decodeStructure(decodeBoolean));
registerMethod("log2checkinvitation",["type","identifier","countryCode"], decodeStructure(decodeBoolean));
registerMethod("log2checkvalidationcode",["type","identifier","countryCode","code"], decodeStructure(decodeBoolean));
registerMethod("log2create",["type","identifier","countryCode","password","partnerType","validationmethod","locale"], decodeStructure(decodeAccountLoginInfo));
registerMethod("log2deeplink",["TK","fid"], decodeStructure(decodeAccountLoginInfo));
registerMethod("log2forgotpassword2",["identifier"], decodeStructure(decodeForgotPasswordResponseBean));
registerMethod("log2generateaccesstokeinbydeeplinktoken",["token","tokentype","deviceId"], decodeStructure(decodeAccessTokenBean));
registerMethod("log2generateaccesstokenbypassword",["type","identifier","countryCode","password","tokentype","deviceId"], decodeStructure(decodeAccessTokenBean));
registerMethod("log2generatedeeplinktokenaccesstoken",["token","tokentype","deviceId"], decodeStructure(decodeDeepLinkAccessToken));
registerMethod("log2get",[], decodeStructure(decodeArray(decodeIAccount)));
registerMethod("log2in",["type","identifier","countryCode","password","generateAutologinToken","clientId","clientSecret"], decodeStructure(decodeAccountLoginInfo));
registerMethod("log2loginByAutologinToken",["identifier","token"], decodeStructure(decodeAccountLoginInfo));
registerMethod("log2out",[], decodeStructure(decodeboolean));
registerMethod("log2renew",[], decodeStructure(decodeAccountLoginInfo));
registerMethod("log2sendaccountidentifiervalidationcode",["type","identifier","countryCode"], decodeStructure(decodeBoolean));
registerMethod("log2token",["token"], decodeStructure(decodeTokenAndAccountLogInfoBean));
registerMethod("log2validateidentifier",["type","identifier","countryCode","code","autoacceptpendinginvite"], decodeStructure(decodeAccountLoginInfo));
  

registerMethod("metaaddComment",["id","text","mood","clientOpId"], decodeStructure(decodeCommentResultBean(decodeIHasMetaId)));
registerMethod("metaaddpictures",["id",{name:"pictures",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeDynamic));
registerMethod("metadelete",[{name:"id",encode:encodeArray(encodeString)}], decodeStructure(decodeDynamic));
registerMethod("metaget",["id"], decodeStructure(decodeDynamic));
registerMethod("metalist",["id"], decodeStructure(decodeDynamic));
registerMethod("metamood",["id",{name:"add",encode:encodeArray(encodeEnum)},{name:"remove",encode:encodeArray(encodeEnum)},"clientOpId"], decodeStructure(decodeDynamic));
registerMethod("metapictures",["id",{name:"pictures",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeDynamic));
registerMethod("metasync",["id","listId","syncToken","date"], decodeStructure(decodeDynamic));
registerMethod("metaupdatetext",["id","text","clientOpId"], decodeStructure(decodeDynamic));
  

registerMethod("mpadditemtolist",[{name:"ingredients",encode:encodeArray(encodeShoppingIngredientInputBean)},"listId"], decodeStructure(decodeboolean));
registerMethod("mpcategorydelete",[{name:"id",encode:encodeArray(encodeString)}], decodeStructure(decodeboolean));
registerMethod("mpcategoryget",["id"], decodeStructure(decodeCategoryBean));
registerMethod("mpcategorylist",[], decodeStructure(decodeArray(decodeCategoryBean)));
registerMethod("mpcategoryput",[{encode:encodeCategoryInputBean},"prevId"], decodeStructure(decodeCategoryBean));
registerMethod("mpclear",["from","to"], decodeStructure(decodeboolean));
registerMethod("mpcopy",["from","to","targetFrom","clientOpId"], decodeStructure(decodeArray(decodeDishBean)));
registerMethod("mpcreate",[{name:"name",encode:encodeArray(encodeString)},"date","type","clientOpId"], decodeStructure(decodeArray(decodeDishBean)));
registerMethod("mpcreateByRecipeId",["recipeId","date","type","clientOpId"], decodeStructure(decodeDishBean));
registerMethod("mpgenerateIA",[{encode:encodeIAGenerateRecipeParameters}], decodeStructure(decodeRecipeInputBean));
registerMethod("mplistinterval",["from","to"], decodeStructure(decodeDishRangeBean));
registerMethod("mpmealput",[{encode:encodeMealInputBean}], decodeStructure(decodeMealBean));
registerMethod("mpmove",[{name:"metaId",encode:encodeArray(encodeString)},"date","type","clientOpId"], decodeStructure(decodeArray(decodeDishBean)));
registerMethod("mpncrecipe",["tokenvalue","recipeMetaId"], decodeStructure(decodeRecipeBean));
registerMethod("mpncshared",["tokenvalue"], decodeStructure(decodeMealPlannerSharedBean));
registerMethod("mprecipelink",["metaId"], decodeStructure(decodeTokenUrlBean));
registerMethod("mprecipeput",[{name:"recipe",encode:encodeRecipeInputBean},{name:"picture",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeRecipeBean));
registerMethod("mprecipeputbyid",["id","recipeCategories","recipeCategoryId"], decodeStructure(decodeRecipeBean));
registerMethod("mprecipeputbyurl",["url","recipeCategories","recipeCategoryId"], decodeStructure(decodeRecipePuByUrlResultBean));
registerMethod("mpsettingsget",[], decodeStructure(decodeMealSettingsBean));
registerMethod("mpsettingsset",[{name:"settings",encode:encodeMealSettingsBean}], decodeStructure(decodeMealSettingsBean));
registerMethod("mpsharedlink",["from","to"], decodeStructure(decodeTokenUrlBean));
  

registerMethod("outlookAuthUri",[], decodeStructure(decodeString));
registerMethod("outlookgetcredential",["credentialId"], decodeStructure(decodeOutlookCredentialBean));
registerMethod("outlooklogin",["code"], decodeStructure(decodeOutlookCredentialBean));
registerMethod("outlooksavetoken",["tokenType","accessToken","refreshToken","expiresDate","redirectUri","useSecret"], decodeStructure(decodeOutlookCredentialBean));
registerMethod("outlookselectcalendar2",["credentialId",{name:"outlookId",encode:encodeArray(encodeString)}], decodeStructure(decodeCalendarSubscriptionResponseBean));
registerMethod("outlooksync",["calendarId","syncToken"], decodeStructure(decodeEventSyncBean));
  

registerMethod("poicreate",["name",{name:"geocodedAddress",encode:encodeGeocodedAddress},"placeType","isTemporary","geofencingActive","contactId","text","wifiSSID","wifiMAC",{name:"picture",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeIPlace));
registerMethod("poicreatesimple",["name","address","placeType","isTemporary","geofencingActive","contactId","text","wifiSSID","wifiMAC",{name:"picture",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeIPlace));
registerMethod("poidelete",[{name:"placeId",encode:encodeArray(encodeString)}], decodeStructure(decodeboolean));
registerMethod("poiget",["placeId"], decodeStructure(decodeIPlace));
registerMethod("poigetall",[], decodeStructure(decodeArray(decodeIPlace)));
registerMethod("poinearby",["latitudeE6","longitudeE6"], decodeStructure(decodePlaceNearbyResult));
registerMethod("poisync",["syncToken","date"], decodeStructure(decodePlaceSyncBean));
registerMethod("poiupdate",["placeId","name",{name:"geocodedAddress",encode:encodeGeocodedAddress},"placeType","isTemporary","geofencingActive","contactId","text","wifiSSID","wifiMAC",{name:"picture",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeIPlace));
  

registerMethod("prfgetProfile",["oid"], decodeStructure(decodeIProfile));
registerMethod("prfgetProfiles",[], decodeStructure(decodeMap(decodeString,decodeIProfile)));
registerMethod("prfgetPublicProfiles",[{name:"oid",encode:encodeArray(encodeNumber)}], decodeStructure(decodeMap(decodeString,decodeIProfile)));
registerMethod("prfupdate",[{encode:encodeIProfile},{name:"picture",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeIProfile));
registerMethod("prfupdate2",["role","customFamilyRole",{encode:encodeIProfile},{name:"picture",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeIProfile));
  

registerMethod("settingsaiinboxcheck",["email"], decodeStructure(decodeAiInboxResponseBean));
registerMethod("settingsaiinboxsave",["email"], decodeStructure(decodeAiInboxResponseBean));
registerMethod("settingsfeedback",["type","score","comment"], decodeStructure(decodeboolean));
registerMethod("settingsget",[], decodeStructure(decodeSettingsBean));
registerMethod("settingsgetperfamily",["familyId"], decodeStructure(decodeISettingsPerFamily));
registerMethod("settingsset",["pushGlobal","pushForEvent","pushForMessage","pushForCheckin","pushForPicture","geoTrackingHistory","reminderNotificationEnabled","pushForTask","pushForStatus","pushForComment","pushForBestMoment","pushForTimetable","pushForBudget","pushForFiler","pushForSpecialDays","pushByEmail","promoAccept"], decodeStructure(decodeSettingsBean));
registerMethod("settingssetperfamily",[{encode:encodeISettingsPerFamily}], decodeStructure(decodeISettingsPerFamily));
registerMethod("settingsshutdowngeolocsharing",[], decodeStructure(decodeboolean));
  

registerMethod("statusget",[], decodeStructure(decodeStatusBean));
  

registerMethod("stublistsms",["number"], decodeStructure(decodeArray(decodeSmsStubBean)));
  

registerMethod("taskcategorydelete",[{name:"id",encode:encodeArray(encodeString)}], decodeStructure(decodeboolean));
registerMethod("taskcategoryget",["id"], decodeStructure(decodeTaskCategoryBean));
registerMethod("taskcategorylist",["tasklistType","locale","filterTasklistId"], decodeStructure(decodeArray(decodeTaskCategoryBean)));
registerMethod("taskcategoryput",[{encode:encodeTaskCategoryInputBean},"prevId","tasklistId","locale","hidden"], decodeStructure(decodeTaskCategoryBean));
registerMethod("taskcategorysync",["syncToken"], decodeStructure(decodeTaskCategorySyncBean));
registerMethod("taskcloselist",[], decodeStructure(decodeboolean));
registerMethod("taskcreate",["text","dueDate",{name:"assignee",encode:encodeArray(encodeNumber)},{name:"reminder",encode:encodeIReminder}], decodeStructure(decodeTaskBean));
registerMethod("taskcreate2",[{encode:encodeTaskInputBean},{name:"picture",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeTaskBean));
registerMethod("taskcreatelist",[{encode:encodeITaskList}], decodeStructure(decodeITaskList));
registerMethod("taskdelete",["taskId"], decodeStructure(decodeboolean));
registerMethod("taskdeletelist",["id"], decodeStructure(decodeBoolean));
registerMethod("taskduplicatelist",["id"], decodeStructure(decodeITaskList));
registerMethod("taskget",["taskId"], decodeStructure(decodeTaskBean));
registerMethod("taskgetsettings",[], decodeStructure(decodeTaskListSettingsBean));
registerMethod("taskgetsuggestedlist",[], decodeStructure(decodeITaskList));
registerMethod("taskgettasklists",[], decodeStructure(decodeArray(decodeITaskList)));
registerMethod("taskgettasksuggestions",["tasklistType","syncToken","locale"], decodeStructure(decodeTaskSuggestionSyncBean));
registerMethod("taskgettasksuggestionswcat",["tasklistType","syncToken","locale"], decodeStructure(decodeTaskSuggestionSyncBeanWCategory));
registerMethod("tasklist",["listId"], decodeStructure(decodeArray(decodeTaskBean)));
registerMethod("taskmark",["taskId","complete","completedDateForTesting"], decodeStructure(decodeTaskBean));
registerMethod("taskmetamark",[{name:"id",encode:encodeArray(encodeString)},"complete"], decodeStructure(decodeboolean));
registerMethod("taskmove",["taskId","taskListId","prevTaskId","taskCategoryId"], decodeStructure(decodeMap(decodeString,decodeNumber)));
registerMethod("taskmovelist",["id","prevId"], decodeStructure(decodeMap(decodeString,decodeNumber)));
registerMethod("taskrespondsuggested",["id","accept"], decodeStructure(decodeITaskList));
registerMethod("tasksync",["syncToken","date"], decodeStructure(decodeTaskSyncBean));
registerMethod("taskupdate",["taskId","text","dueDate",{name:"assignee",encode:encodeArray(encodeNumber)},{name:"reminder",encode:encodeIReminder}], decodeStructure(decodeTaskBean));
registerMethod("taskupdate2",[{encode:encodeTaskInputBean},{name:"picture",encode:encodeArray(encodeFizFile)}], decodeStructure(decodeTaskBean));
registerMethod("taskupdatelist",[{encode:encodeITaskList}], decodeStructure(decodeITaskList));
  

registerMethod("wallactivityById",["masterNested"], decodeStructure(decodeMap(decodeNumber,decodeAccountActivityBean)));
registerMethod("wallactivityget",["accountId","masterNested"], decodeStructure(decodeAccountActivityBean));
registerMethod("walladdComment",["wall_message_id","comment","mood","clientOpId"], decodeStructure(decodeCommentResultBean(decodeIWallMessage)));
registerMethod("wallbyids",[{name:"id",encode:encodeArray(encodeString)},"masterNested"], decodeStructure(decodeArray(decodeIWallMessage)));
registerMethod("walldelete",[{name:"wallMessageId",encode:encodeArray(encodeString)}], decodeStructure(decodeboolean));
registerMethod("walletags",[], decodeStructure(decodeMap(decodeEnum,decodeString)));
registerMethod("wallget",["date",{name:"accountId",encode:encodeArray(encodeNumber)},{name:"type",encode:encodeArray(encodeEnum)},"hasJoin","mood","bestMoment","afterId","nb","nested","masterNested","sortBy"], decodeStructure(decodeArray(decodeIWallMessage)));
registerMethod("walllastbyaccount",[{name:"filter",encode:encodeArray(encodeEnum)}], decodeStructure(decodeMap(decodeNumber,decodeIWallMessage)));
registerMethod("wallmood",["wall_message_id",{name:"add",encode:encodeArray(encodeEnum)},{name:"remove",encode:encodeArray(encodeEnum)},"clientOpId"], decodeStructure(decodeIWallMessage));
registerMethod("wallpublish",["tagline"], decodeStructure(decodeIWallMessage));
registerMethod("wallpublishmultiplepics",["description","picture","nbOfPicturesUpload","wallMessageClientId","clientPicId","finishupload",{name:"familyIds",encode:encodeArray(encodeString)},"comment"], decodeStructure(decodeIWallMessage));
registerMethod("wallpublishref",["tagline","refObjectType","refObjectId"], decodeStructure(decodeIWallMessage));
  

registerMethod("webapiurl",[], decodeStructure(decodeString));
registerMethod("webget",["var"], decodeStructure(decodeString));
registerMethod("webgetExternalWebUrl",["partnerType"], decodeStructure(decodeString));
registerMethod("webgetWebSocketUrl",[], decodeStructure(decodeString));
registerMethod("webiaimportemail",["email","from","ical"], decodeStructure(decodeIcalImportResultBean));
registerMethod("webjslog",["text"], decodeStructure(decodeboolean));
registerMethod("webog",["url","refresh"], decodeStructure(decodeOpenGraphDataBean));
registerMethod("webset",["var","value"], decodeStructure(decodeString));
  



  
const methodsTs = {
	async accaddidentifier(type :string, identifier :string, countryCode :string, validationmethod :string|undefined, password :string):Promise<IAccount> {
		const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'validationmethod': encodeEnum, 'password': encodeString};
		return executorTs('accaddidentifier', model, decodeStructure(decodeIAccount), arguments);
	},
	async accaddidentifier2(type :string, identifier :string, countryCode :string, validationmethod :string|undefined, password :string):Promise<IAccountIdentifier> {
		const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'validationmethod': encodeEnum, 'password': encodeString};
		return executorTs('accaddidentifier2', model, decodeStructure(decodeIAccountIdentifier), arguments);
	},
	async accchangeaccountidentifier(oldid :number|undefined, type :string|undefined, countryCode :string|undefined, oldidentifier :string|undefined, newidentifier :string, validationmethod :string|undefined, password :string):Promise<IAccountIdentifier> {
		const model = {'oldid': encodeNumber, 'type': encodeEnum, 'countryCode': encodeString, 'oldidentifier': encodeString, 'newidentifier': encodeString, 'validationmethod': encodeEnum, 'password': encodeString};
		return executorTs('accchangeaccountidentifier', model, decodeStructure(decodeIAccountIdentifier), arguments);
	},
	async accchangepassword(password ?:string, newpassword ?:string):Promise<string> {
		const model = {'password': encodeString, 'newpassword': encodeString};
		return executorTs('accchangepassword', model, decodeStructure(decodeString), arguments);
	},
	async acccheckpassword(password ?:string):Promise<boolean> {
		const model = {'password': encodeString};
		return executorTs('acccheckpassword', model, decodeStructure(decodeboolean), arguments);
	},
	async acccreatefamily(name :string, role ?:string, customFamilyRole ?:string, cover ?:FizFile):Promise<number> {
		const model = {'name': encodeString, 'role': encodeEnum, 'customFamilyRole': encodeString, 'cover': encodeFizFile};
		return executorTs('acccreatefamily', model, decodeStructure(decodeNumber), arguments);
	},
	async acccreatesubaccount(role :string, customFamilyRole :string|undefined, firstname :string, birthday ?:Date, timezone ?:string, locale ?:string, picture ?:FizFile, homeAddress ?:string, workAddress ?:string):Promise<number> {
		const model = {'role': encodeEnum, 'customFamilyRole': encodeString, 'firstname': encodeString, 'birthday': encodeDate, 'timezone': encodeString, 'locale': encodeString, 'picture': encodeFizFile, 'homeAddress': encodeString, 'workAddress': encodeString};
		return executorTs('acccreatesubaccount', model, decodeStructure(decodeNumber), arguments);
	},
	async accdeeplink(page ?:string, directWebPage ?:string):Promise<string> {
		const model = {'page': encodeEnum, 'directWebPage': encodeString};
		return executorTs('accdeeplink', model, decodeStructure(decodeString), arguments);
	},
	async accgenerateDeepLoginLink(page ?:string, webWanted ?:boolean, dev ?:boolean):Promise<string> {
		const model = {'page': encodeString, 'webWanted': encodeBoolean, 'dev': encodeBoolean};
		return executorTs('accgenerateDeepLoginLink', model, decodeStructure(decodeString), arguments);
	},
	async accgetallfamily(withStateBean ?:boolean):Promise<IExtendedFamily> {
		const model = {'withStateBean': encodeBoolean};
		return executorTs('accgetallfamily', model, decodeStructure(decodeIExtendedFamily), arguments);
	},
	async accgetfamily():Promise<IFamily> {
		const model = {};
		return executorTs('accgetfamily', model, decodeStructure(decodeIFamily), arguments);
	},
	async accgetloggedaccount():Promise<IAccount> {
		const model = {};
		return executorTs('accgetloggedaccount', model, decodeStructure(decodeIAccount), arguments);
	},
	async accgetpremium():Promise<PremiumRightBean> {
		const model = {};
		return executorTs('accgetpremium', model, decodeStructure(decodePremiumRightBean), arguments);
	},
	async accgetsecuritystate():Promise<AccountSecurityBean> {
		const model = {};
		return executorTs('accgetsecuritystate', model, decodeStructure(decodeAccountSecurityBean), arguments);
	},
	async accgetstate(deviceId :string, modelType :string, applicationVersion :string, timezone ?:string, locale ?:string, buildTimestamp ?:number):Promise<AccountStateBean> {
		const model = {'deviceId': encodeString, 'modelType': encodeEnum, 'applicationVersion': encodeString, 'timezone': encodeString, 'locale': encodeString, 'buildTimestamp': encodeNumber};
		return executorTs('accgetstate', model, decodeStructure(decodeAccountStateBean), arguments);
	},
	async accinvite(identifier :string, password :string|undefined, role :string, customFamilyRole :string|undefined, firstname :string, mobile ?:string, birthday ?:Date, timezone ?:string, locale ?:string, picture ?:FizFile, homeAddress ?:string, workAddress ?:string):Promise<number> {
		const model = {'identifier': encodeString, 'password': encodeString, 'role': encodeEnum, 'customFamilyRole': encodeString, 'firstname': encodeString, 'mobile': encodeString, 'birthday': encodeDate, 'timezone': encodeString, 'locale': encodeString, 'picture': encodeFizFile, 'homeAddress': encodeString, 'workAddress': encodeString};
		return executorTs('accinvite', model, decodeStructure(decodeNumber), arguments);
	},
	async accremoveidentifier(id :number, password :string):Promise<IAccount> {
		const model = {'id': encodeNumber, 'password': encodeString};
		return executorTs('accremoveidentifier', model, decodeStructure(decodeIAccount), arguments);
	},
	async accremoveidentifier2(id :number, password :string):Promise<IAccountIdentifier> {
		const model = {'id': encodeNumber, 'password': encodeString};
		return executorTs('accremoveidentifier2', model, decodeStructure(decodeIAccountIdentifier), arguments);
	},
	async accsendaccountidentifiervalidationcode(id :number|undefined, type :string|undefined, identifier :string|undefined, countryCode :string|undefined, validationmethod :string):Promise<boolean> {
		const model = {'id': encodeNumber, 'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'validationmethod': encodeEnum};
		return executorTs('accsendaccountidentifiervalidationcode', model, decodeStructure(decodeBoolean), arguments);
	},
	async accsendwelcomeemail():Promise<boolean> {
		const model = {};
		return executorTs('accsendwelcomeemail', model, decodeStructure(decodeBoolean), arguments);
	},
	async accsetprofile(accountId ?:number, pseudo ?:string, firstname ?:string, gender ?:string, role ?:string, customFamilyRole ?:string, mobile ?:string, email ?:string, birthday ?:Date, timezone ?:string, locale ?:string, picture ?:FizFile, homeAddress ?:string, workAddress ?:string, color ?:string, publishProfileChanged ?:boolean, customFirstName ?:string, customAvatar ?:FizFile):Promise<number> {
		const model = {'accountId': encodeNumber, 'pseudo': encodeString, 'firstname': encodeString, 'gender': encodeEnum, 'role': encodeEnum, 'customFamilyRole': encodeString, 'mobile': encodeString, 'email': encodeString, 'birthday': encodeDate, 'timezone': encodeString, 'locale': encodeString, 'picture': encodeFizFile, 'homeAddress': encodeString, 'workAddress': encodeString, 'color': encodeString, 'publishProfileChanged': encodeBoolean, 'customFirstName': encodeString, 'customAvatar': encodeFizFile};
		return executorTs('accsetprofile', model, decodeStructure(decodeNumber), arguments);
	},
	async accsetterms(termsChecked ?:boolean, termsHtcChecked ?:boolean, termsOrangeFamilyPlaceChecked ?:boolean, termsSprintChecked ?:boolean, termsProximusFamilyChecked ?:boolean):Promise<AccountLoginInfo> {
		const model = {'termsChecked': encodeBoolean, 'termsHtcChecked': encodeBoolean, 'termsOrangeFamilyPlaceChecked': encodeBoolean, 'termsSprintChecked': encodeBoolean, 'termsProximusFamilyChecked': encodeBoolean};
		return executorTs('accsetterms', model, decodeStructure(decodeAccountLoginInfo), arguments);
	},
	async accupdatefamily(name ?:string, file ?:FizFile, cover ?:FizFile):Promise<IFamily> {
		const model = {'name': encodeString, 'file': encodeFizFile, 'cover': encodeFizFile};
		return executorTs('accupdatefamily', model, decodeStructure(decodeIFamily), arguments);
	},
	async accvalidateaccountidentifierwithcode(id :number|undefined, type :string|undefined, identifier :string|undefined, countryCode :string|undefined, code :string, autoacceptpendinginvite ?:boolean):Promise<IAccount> {
		const model = {'id': encodeNumber, 'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'code': encodeString, 'autoacceptpendinginvite': encodeBoolean};
		return executorTs('accvalidateaccountidentifierwithcode', model, decodeStructure(decodeIAccount), arguments);
	},
	async accvalidateaccountidentifierwithcode2(id :number|undefined, type :string|undefined, identifier :string|undefined, countryCode :string|undefined, code :string, autoacceptpendinginvite ?:boolean):Promise<IAccountIdentifier> {
		const model = {'id': encodeNumber, 'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'code': encodeString, 'autoacceptpendinginvite': encodeBoolean};
		return executorTs('accvalidateaccountidentifierwithcode2', model, decodeStructure(decodeIAccountIdentifier), arguments);
	},
	async accvalidatechangeaccountidentifier(oldid :number|undefined, type :string|undefined, countryCode :string|undefined, oldidentifier :string|undefined, newidentifier :string, code :string):Promise<IAccountIdentifier> {
		const model = {'oldid': encodeNumber, 'type': encodeEnum, 'countryCode': encodeString, 'oldidentifier': encodeString, 'newidentifier': encodeString, 'code': encodeString};
		return executorTs('accvalidatechangeaccountidentifier', model, decodeStructure(decodeIAccountIdentifier), arguments);
	},
	async adminchange(right :string|undefined, accountid :Array<number>):Promise<AdminRightBean> {
		const model = {'right': encodeEnum, 'accountid': encodeArray(encodeNumber)};
		return executorTs('adminchange', model, decodeStructure(decodeAdminRightBean), arguments);
	},
	async admindelete2(deleteAuthoredPost :boolean):Promise<boolean> {
		const model = {'deleteAuthoredPost': encodeboolean};
		return executorTs('admindelete2', model, decodeStructure(decodeBoolean), arguments);
	},
	async admingetright(accountId ?:number):Promise<string> {
		const model = {'accountId': encodeNumber};
		return executorTs('admingetright', model, decodeStructure(decodeEnum), arguments);
	},
	async adminlist():Promise<AdminRightBean> {
		const model = {};
		return executorTs('adminlist', model, decodeStructure(decodeAdminRightBean), arguments);
	},
	async adminremove(accountId :number, deleteAuthoredPost :boolean):Promise<boolean> {
		const model = {'accountId': encodeNumber, 'deleteAuthoredPost': encodeboolean};
		return executorTs('adminremove', model, decodeStructure(decodeBoolean), arguments);
	},
	async adminwipefamily():Promise<boolean> {
		const model = {};
		return executorTs('adminwipefamily', model, decodeStructure(decodeBoolean), arguments);
	},
	async albumall(accountId ?:number, bestMoment ?:boolean, mood ?:string, pg ?:PaginationRequest):Promise<MediaListBean> {
		const model = {'accountId': encodeNumber, 'bestMoment': encodeBoolean, 'mood': encodeEnum, 'pg': encodePaginationRequest};
		return executorTs('albumall', model, decodeStructure(decodeMediaListBean), arguments);
	},
	async albumfrontbycreator():Promise<Array<MediaFilterFrontImage>> {
		const model = {};
		return executorTs('albumfrontbycreator', model, decodeStructure(decodeArray(decodeMediaFilterFrontImage)), arguments);
	},
	async albumquota():Promise<MediaQuota> {
		const model = {};
		return executorTs('albumquota', model, decodeStructure(decodeMediaQuota), arguments);
	},
	async budgetcategorydelete(id :Array<string>):Promise<boolean> {
		const model = {'id': encodeArray(encodeString)};
		return executorTs('budgetcategorydelete', model, decodeStructure(decodeboolean), arguments);
	},
	async budgetcategoryget(id :string):Promise<BudgetCategoryBean> {
		const model = {'id': encodeString};
		return executorTs('budgetcategoryget', model, decodeStructure(decodeBudgetCategoryBean), arguments);
	},
	async budgetcategorylist(budgetTransactionType ?:string, locale ?:string):Promise<Array<BudgetCategoryBean>> {
		const model = {'budgetTransactionType': encodeEnum, 'locale': encodeString};
		return executorTs('budgetcategorylist', model, decodeStructure(decodeArray(decodeBudgetCategoryBean)), arguments);
	},
	async budgetcategoryput(__inline :BudgetCategoryInputBean, prevId ?:string):Promise<BudgetCategoryBean> {
		const model = {'__inline': encodeBudgetCategoryInputBean, 'prevId': encodeString};
		return executorTs('budgetcategoryput', model, decodeStructure(decodeBudgetCategoryBean), arguments);
	},
	async budgetcategorysync(syncToken ?:string):Promise<BudgetCategorySyncBean> {
		const model = {'syncToken': encodeString};
		return executorTs('budgetcategorysync', model, decodeStructure(decodeBudgetCategorySyncBean), arguments);
	},
	async budgetclose(metaId ?:string):Promise<boolean> {
		const model = {'metaId': encodeString};
		return executorTs('budgetclose', model, decodeStructure(decodeboolean), arguments);
	},
	async budgetdelete(id :Array<string>):Promise<boolean> {
		const model = {'id': encodeArray(encodeString)};
		return executorTs('budgetdelete', model, decodeStructure(decodeBoolean), arguments);
	},
	async budgetexportcsvurl(id :Array<string>, from ?:Date, to ?:Date):Promise<string> {
		const model = {'id': encodeArray(encodeString), 'from': encodeDate, 'to': encodeDate};
		return executorTs('budgetexportcsvurl', model, decodeStructure(decodeString), arguments);
	},
	async budgetget(id :string):Promise<BudgetBean> {
		const model = {'id': encodeString};
		return executorTs('budgetget', model, decodeStructure(decodeBudgetBean), arguments);
	},
	async budgetlist():Promise<Array<BudgetBean>> {
		const model = {};
		return executorTs('budgetlist', model, decodeStructure(decodeArray(decodeBudgetBean)), arguments);
	},
	async budgetmarkaspaid(metaId :Array<string>, value ?:boolean):Promise<Array<BudgetTransactionBean>> {
		const model = {'metaId': encodeArray(encodeString), 'value': encodeBoolean};
		return executorTs('budgetmarkaspaid', model, decodeStructure(decodeArray(decodeBudgetTransactionBean)), arguments);
	},
	async budgetpaymentmethoddelete(id :Array<string>):Promise<boolean> {
		const model = {'id': encodeArray(encodeString)};
		return executorTs('budgetpaymentmethoddelete', model, decodeStructure(decodeboolean), arguments);
	},
	async budgetpaymentmethodget(id :string):Promise<PaymentMethodBean> {
		const model = {'id': encodeString};
		return executorTs('budgetpaymentmethodget', model, decodeStructure(decodePaymentMethodBean), arguments);
	},
	async budgetpaymentmethodlist(locale ?:string):Promise<Array<PaymentMethodBean>> {
		const model = {'locale': encodeString};
		return executorTs('budgetpaymentmethodlist', model, decodeStructure(decodeArray(decodePaymentMethodBean)), arguments);
	},
	async budgetpaymentmethodput(__inline :PaymentMethodInputBean, prevId ?:string):Promise<PaymentMethodBean> {
		const model = {'__inline': encodePaymentMethodInputBean, 'prevId': encodeString};
		return executorTs('budgetpaymentmethodput', model, decodeStructure(decodePaymentMethodBean), arguments);
	},
	async budgetpaymentmethodsync(syncToken ?:string):Promise<PaymentMethodSyncBean> {
		const model = {'syncToken': encodeString};
		return executorTs('budgetpaymentmethodsync', model, decodeStructure(decodePaymentMethodSyncBean), arguments);
	},
	async budgetput(__inline :BudgetInputBean):Promise<BudgetBean> {
		const model = {'__inline': encodeBudgetInputBean};
		return executorTs('budgetput', model, decodeStructure(decodeBudgetBean), arguments);
	},
	async budgetsync(syncToken ?:string):Promise<BudgetSyncBean> {
		const model = {'syncToken': encodeString};
		return executorTs('budgetsync', model, decodeStructure(decodeBudgetSyncBean), arguments);
	},
	async budgettransactiondelete(option :string|undefined, id :Array<string>):Promise<boolean> {
		const model = {'option': encodeEnum, 'id': encodeArray(encodeString)};
		return executorTs('budgettransactiondelete', model, decodeStructure(decodeBoolean), arguments);
	},
	async budgettransactiondeleteoption(id :string):Promise<Array<string>> {
		const model = {'id': encodeString};
		return executorTs('budgettransactiondeleteoption', model, decodeStructure(decodeArray(decodeEnum)), arguments);
	},
	async budgettransactionget(id :string):Promise<BudgetTransactionBean> {
		const model = {'id': encodeString};
		return executorTs('budgettransactionget', model, decodeStructure(decodeBudgetTransactionBean), arguments);
	},
	async budgettransactionlist():Promise<Array<BudgetTransactionBean>> {
		const model = {};
		return executorTs('budgettransactionlist', model, decodeStructure(decodeArray(decodeBudgetTransactionBean)), arguments);
	},
	async budgettransactionput(option :string|undefined, __inline :BudgetTransactionInputBean, file ?:Array<FizFile>):Promise<BudgetTransactionBean> {
		const model = {'option': encodeEnum, '__inline': encodeBudgetTransactionInputBean, 'file': encodeArray(encodeFizFile)};
		return executorTs('budgettransactionput', model, decodeStructure(decodeBudgetTransactionBean), arguments);
	},
	async budgettransactionsync(syncToken ?:string):Promise<BudgetTransactionSyncBean> {
		const model = {'syncToken': encodeString};
		return executorTs('budgettransactionsync', model, decodeStructure(decodeBudgetTransactionSyncBean), arguments);
	},
	async budgettransactionupdateoption(__inline :BudgetTransactionInputBean):Promise<Array<string>> {
		const model = {'__inline': encodeBudgetTransactionInputBean};
		return executorTs('budgettransactionupdateoption', model, decodeStructure(decodeArray(decodeEnum)), arguments);
	},
	async colordelete(id :Array<string>):Promise<boolean> {
		const model = {'id': encodeArray(encodeString)};
		return executorTs('colordelete', model, decodeStructure(decodeboolean), arguments);
	},
	async colorget(id :string):Promise<ColorBean> {
		const model = {'id': encodeString};
		return executorTs('colorget', model, decodeStructure(decodeColorBean), arguments);
	},
	async colorlist():Promise<Array<ColorBean>> {
		const model = {};
		return executorTs('colorlist', model, decodeStructure(decodeArray(decodeColorBean)), arguments);
	},
	async colorput(__inline :ColorInputBean):Promise<ColorBean> {
		const model = {'__inline': encodeColorInputBean};
		return executorTs('colorput', model, decodeStructure(decodeColorBean), arguments);
	},
	async credit2checkouturl2():Promise<TwoCheckoutUrlsBean2> {
		const model = {};
		return executorTs('credit2checkouturl2', model, decodeStructure(decodeTwoCheckoutUrlsBean2), arguments);
	},
	async creditget():Promise<Array<ICredit>> {
		const model = {};
		return executorTs('creditget', model, decodeStructure(decodeArray(decodeICredit)), arguments);
	},
	async creditgetPromoCode(value :string):Promise<IPromoCode> {
		const model = {'value': encodeString};
		return executorTs('creditgetPromoCode', model, decodeStructure(decodeIPromoCode), arguments);
	},
	async creditgetfreesku(creditType :string, paymentType :string, typeOfPeriod ?:string):Promise<string> {
		const model = {'creditType': encodeEnum, 'paymentType': encodeEnum, 'typeOfPeriod': encodeEnum};
		return executorTs('creditgetfreesku', model, decodeStructure(decodeString), arguments);
	},
	async creditgetmanualrenewalllink(creditId :string):Promise<string> {
		const model = {'creditId': encodeString};
		return executorTs('creditgetmanualrenewalllink', model, decodeStructure(decodeString), arguments);
	},
	async creditgoogleplaytoken(deviceId :string, token :string, creditType ?:string, sku ?:string):Promise<SubscriptionTicketBean> {
		const model = {'deviceId': encodeString, 'token': encodeString, 'creditType': encodeEnum, 'sku': encodeString};
		return executorTs('creditgoogleplaytoken', model, decodeStructure(decodeSubscriptionTicketBean), arguments);
	},
	async credititunesIos7ticket(deviceId :string, receipt :string):Promise<SubscriptionTicketBean> {
		const model = {'deviceId': encodeString, 'receipt': encodeString};
		return executorTs('credititunesIos7ticket', model, decodeStructure(decodeSubscriptionTicketBean), arguments);
	},
	async credititunesreceiptstatus(deviceId :string, receipt :string, trialDurationProductIdList ?:Array<string>):Promise<ItunesReceiptStatusBean> {
		const model = {'deviceId': encodeString, 'receipt': encodeString, 'trialDurationProductIdList': encodeArray(encodeString)};
		return executorTs('credititunesreceiptstatus', model, decodeStructure(decodeItunesReceiptStatusBean), arguments);
	},
	async credititunesticket(deviceId :string, receipt :string):Promise<SubscriptionTicketBean> {
		const model = {'deviceId': encodeString, 'receipt': encodeString};
		return executorTs('credititunesticket', model, decodeStructure(decodeSubscriptionTicketBean), arguments);
	},
	async creditlistall():Promise<Array<ICredit>> {
		const model = {};
		return executorTs('creditlistall', model, decodeStructure(decodeArray(decodeICredit)), arguments);
	},
	async creditsetautorenewall(creditId :string, auto :string):Promise<ICredit> {
		const model = {'creditId': encodeString, 'auto': encodeEnum};
		return executorTs('creditsetautorenewall', model, decodeStructure(decodeICredit), arguments);
	},
	async creditswitchfamily(creditId :string, existingFamilyId :string, newFamilyId :string):Promise<ICredit> {
		const model = {'creditId': encodeString, 'existingFamilyId': encodeString, 'newFamilyId': encodeString};
		return executorTs('creditswitchfamily', model, decodeStructure(decodeICredit), arguments);
	},
	async creditusepromocode(value :string):Promise<ICredit> {
		const model = {'value': encodeString};
		return executorTs('creditusepromocode', model, decodeStructure(decodeICredit), arguments);
	},
	async ctccomment(contactId :string, text :string):Promise<IComment> {
		const model = {'contactId': encodeString, 'text': encodeString};
		return executorTs('ctccomment', model, decodeStructure(decodeIComment), arguments);
	},
	async ctcdelete(contactIds :Array<string>):Promise<boolean> {
		const model = {'contactIds': encodeArray(encodeString)};
		return executorTs('ctcdelete', model, decodeStructure(decodeboolean), arguments);
	},
	async ctcget(contactId :string):Promise<IContact> {
		const model = {'contactId': encodeString};
		return executorTs('ctcget', model, decodeStructure(decodeIContact), arguments);
	},
	async ctclist():Promise<Array<IContact>> {
		const model = {};
		return executorTs('ctclist', model, decodeStructure(decodeArray(decodeIContact)), arguments);
	},
	async ctcput(__inline :IContact, pictures ?:Array<FizFile>):Promise<IContact> {
		const model = {'__inline': encodeIContact, 'pictures': encodeArray(encodeFizFile)};
		return executorTs('ctcput', model, decodeStructure(decodeIContact), arguments);
	},
	async ctcsync(syncToken ?:string, date ?:Date):Promise<ContactSyncBean> {
		const model = {'syncToken': encodeString, 'date': encodeDate};
		return executorTs('ctcsync', model, decodeStructure(decodeContactSyncBean), arguments);
	},
	async ctcvcardimport(file :FizFile, isPreview ?:boolean, indexes ?:Array<number>):Promise<VcardImportPreviewBean> {
		const model = {'file': encodeFizFile, 'isPreview': encodeBoolean, 'indexes': encodeArray(encodeNumber)};
		return executorTs('ctcvcardimport', model, decodeStructure(decodeVcardImportPreviewBean), arguments);
	},
	async ctcvcardurl(contactId ?:string):Promise<string> {
		const model = {'contactId': encodeString};
		return executorTs('ctcvcardurl', model, decodeStructure(decodeString), arguments);
	},
	async deviceackpush(pushIds :Array<string>):Promise<boolean> {
		const model = {'pushIds': encodeArray(encodeString)};
		return executorTs('deviceackpush', model, decodeStructure(decodeBoolean), arguments);
	},
	async devicecheckpush(__inline :DeviceConfigBean, isBackground ?:boolean):Promise<Array<PushMessageBean>> {
		const model = {'__inline': encodeDeviceConfigBean, 'isBackground': encodeBoolean};
		return executorTs('devicecheckpush', model, decodeStructure(decodeArray(decodePushMessageBean)), arguments);
	},
	async devicedelete(deviceId :string):Promise<boolean> {
		const model = {'deviceId': encodeString};
		return executorTs('devicedelete', model, decodeStructure(decodeboolean), arguments);
	},
	async devicelist():Promise<Array<IDeviceConfig>> {
		const model = {};
		return executorTs('devicelist', model, decodeStructure(decodeArray(decodeIDeviceConfig)), arguments);
	},
	async devicelogout(config :DeviceConfigBean):Promise<boolean> {
		const model = {'config': encodeDeviceConfigBean};
		return executorTs('devicelogout', model, decodeStructure(decodeboolean), arguments);
	},
	async devicesetconfig(config :DeviceConfigBean):Promise<boolean> {
		const model = {'config': encodeDeviceConfigBean};
		return executorTs('devicesetconfig', model, decodeStructure(decodeboolean), arguments);
	},
	async evtaddComment(eventId :string, text :string, mood ?:string, clientOpId ?:string):Promise<CommentResultBean<IEvent>> {
		const model = {'eventId': encodeString, 'text': encodeString, 'mood': encodeEnum, 'clientOpId': encodeString};
		return executorTs('evtaddComment', model, decodeStructure(decodeCommentResultBean(decodeIEvent)), arguments);
	},
	async evtcalcheckurl(url :string):Promise<boolean> {
		const model = {'url': encodeString};
		return executorTs('evtcalcheckurl', model, decodeStructure(decodeboolean), arguments);
	},
	async evtcaldelete(metaId :string):Promise<boolean> {
		const model = {'metaId': encodeString};
		return executorTs('evtcaldelete', model, decodeStructure(decodeboolean), arguments);
	},
	async evtcallist(withtask ?:boolean, withmeal ?:boolean, withfolder ?:boolean, withAllFamilies ?:boolean, withExternal ?:boolean, withOnError ?:boolean, withSpecialDays ?:boolean):Promise<CalendarGroupBean> {
		const model = {'withtask': encodeBoolean, 'withmeal': encodeBoolean, 'withfolder': encodeBoolean, 'withAllFamilies': encodeBoolean, 'withExternal': encodeBoolean, 'withOnError': encodeBoolean, 'withSpecialDays': encodeBoolean};
		return executorTs('evtcallist', model, decodeStructure(decodeCalendarGroupBean), arguments);
	},
	async evtcalsubscribe2(url :string):Promise<CalendarSubscriptionResponseBean> {
		const model = {'url': encodeString};
		return executorTs('evtcalsubscribe2', model, decodeStructure(decodeCalendarSubscriptionResponseBean), arguments);
	},
	async evtcalupdate(__inline :CalendarBean):Promise<boolean> {
		const model = {'__inline': encodeCalendarBean};
		return executorTs('evtcalupdate', model, decodeStructure(decodeboolean), arguments);
	},
	async evtcreate(__inline :EventInputBean):Promise<IEvent> {
		const model = {'__inline': encodeEventInputBean};
		return executorTs('evtcreate', model, decodeStructure(decodeIEvent), arguments);
	},
	async evtdelete(option :string|undefined, eventId :Array<string>):Promise<boolean> {
		const model = {'option': encodeEnum, 'eventId': encodeArray(encodeString)};
		return executorTs('evtdelete', model, decodeStructure(decodeboolean), arguments);
	},
	async evtdeleteoption(eventId :string):Promise<Array<string>> {
		const model = {'eventId': encodeString};
		return executorTs('evtdeleteoption', model, decodeStructure(decodeArray(decodeEnum)), arguments);
	},
	async evtget(eventId :string):Promise<IEvent> {
		const model = {'eventId': encodeString};
		return executorTs('evtget', model, decodeStructure(decodeIEvent), arguments);
	},
	async evtgetbirthday(contactId :string):Promise<IEvent> {
		const model = {'contactId': encodeString};
		return executorTs('evtgetbirthday', model, decodeStructure(decodeIEvent), arguments);
	},
	async evticalimport(file :FizFile, isPreview ?:boolean, indexes ?:Array<number>):Promise<IcalImportPreviewBean> {
		const model = {'file': encodeFizFile, 'isPreview': encodeBoolean, 'indexes': encodeArray(encodeNumber)};
		return executorTs('evticalimport', model, decodeStructure(decodeIcalImportPreviewBean), arguments);
	},
	async evticalurl(calendarId ?:string, eventId ?:string):Promise<string> {
		const model = {'calendarId': encodeString, 'eventId': encodeString};
		return executorTs('evticalurl', model, decodeStructure(decodeString), arguments);
	},
	async evticalvisibleurl(refresh ?:boolean, calendarId ?:string, eventId ?:string):Promise<string> {
		const model = {'refresh': encodeBoolean, 'calendarId': encodeString, 'eventId': encodeString};
		return executorTs('evticalvisibleurl', model, decodeStructure(decodeString), arguments);
	},
	async evticalvisibleurldelete(calendarId ?:string):Promise<boolean> {
		const model = {'calendarId': encodeString};
		return executorTs('evticalvisibleurldelete', model, decodeStructure(decodeboolean), arguments);
	},
	async evtlistinterval(from ?:Date, to ?:Date, accountId ?:Array<number>, attendeeId ?:Array<number>):Promise<Array<IEvent>> {
		const model = {'from': encodeDate, 'to': encodeDate, 'accountId': encodeArray(encodeNumber), 'attendeeId': encodeArray(encodeNumber)};
		return executorTs('evtlistinterval', model, decodeStructure(decodeArray(decodeIEvent)), arguments);
	},
	async evtlistinterval2(from ?:Date, to ?:Date, accountId ?:Array<number>, attendeeId ?:Array<number>, calendarId ?:Array<string>, limit ?:number):Promise<Array<IEvent>> {
		const model = {'from': encodeDate, 'to': encodeDate, 'accountId': encodeArray(encodeNumber), 'attendeeId': encodeArray(encodeNumber), 'calendarId': encodeArray(encodeString), 'limit': encodeNumber};
		return executorTs('evtlistinterval2', model, decodeStructure(decodeArray(decodeIEvent)), arguments);
	},
	async evtlistintervalandcalendar(from :Date, to :Date, accountId ?:Array<number>, attendeeId ?:Array<number>, calendarId ?:Array<string>, activeCalendar ?:boolean, limit ?:number, activeTimetable ?:boolean):Promise<EventListAndCalendar> {
		const model = {'from': encodeDate, 'to': encodeDate, 'accountId': encodeArray(encodeNumber), 'attendeeId': encodeArray(encodeNumber), 'calendarId': encodeArray(encodeString), 'activeCalendar': encodeBoolean, 'limit': encodeNumber, 'activeTimetable': encodeBoolean};
		return executorTs('evtlistintervalandcalendar', model, decodeStructure(decodeEventListAndCalendar), arguments);
	},
	async evtnavigate(eventId :string|undefined, offset :number, accountId ?:Array<number>):Promise<Array<IEvent>> {
		const model = {'eventId': encodeString, 'offset': encodenumber, 'accountId': encodeArray(encodeNumber)};
		return executorTs('evtnavigate', model, decodeStructure(decodeArray(decodeIEvent)), arguments);
	},
	async evtncsync(tokenValue :string, syncToken ?:string):Promise<CalendarSharedBean> {
		const model = {'tokenValue': encodeString, 'syncToken': encodeString};
		return executorTs('evtncsync', model, decodeStructure(decodeCalendarSharedBean), arguments);
	},
	async evtsetexternalerror(error ?:string):Promise<boolean> {
		const model = {'error': encodeString};
		return executorTs('evtsetexternalerror', model, decodeStructure(decodeboolean), arguments);
	},
	async evtsharedlink(timetableId :string, from ?:string, to ?:string):Promise<TokenUrlBean> {
		const model = {'timetableId': encodeString, 'from': encodeString, 'to': encodeString};
		return executorTs('evtsharedlink', model, decodeStructure(decodeTokenUrlBean), arguments);
	},
	async evtsync(syncToken ?:string, date ?:Date, calendarId ?:string):Promise<EventSyncBean> {
		const model = {'syncToken': encodeString, 'date': encodeDate, 'calendarId': encodeString};
		return executorTs('evtsync', model, decodeStructure(decodeEventSyncBean), arguments);
	},
	async evttimetableClose(timetableId ?:string):Promise<boolean> {
		const model = {'timetableId': encodeString};
		return executorTs('evttimetableClose', model, decodeStructure(decodeboolean), arguments);
	},
	async evttimetableCopySlice(timetableId :string, srcSliceNb :number, destSliceNb :number):Promise<boolean> {
		const model = {'timetableId': encodeString, 'srcSliceNb': encodenumber, 'destSliceNb': encodenumber};
		return executorTs('evttimetableCopySlice', model, decodeStructure(decodeboolean), arguments);
	},
	async evttimetableCopySliceByDate(timetableId :string, startDate :Date, endDate :Date, targetStart :Date):Promise<Array<IEvent>> {
		const model = {'timetableId': encodeString, 'startDate': encodeDate, 'endDate': encodeDate, 'targetStart': encodeDate};
		return executorTs('evttimetableCopySliceByDate', model, decodeStructure(decodeArray(decodeIEvent)), arguments);
	},
	async evttimetableCopySliceWResult(timetableId :string, srcSliceNb :number, destSliceNb :number):Promise<Array<IEvent>> {
		const model = {'timetableId': encodeString, 'srcSliceNb': encodenumber, 'destSliceNb': encodenumber};
		return executorTs('evttimetableCopySliceWResult', model, decodeStructure(decodeArray(decodeIEvent)), arguments);
	},
	async evttimetableResetSlice(timetableId :string, sliceNb :number):Promise<boolean> {
		const model = {'timetableId': encodeString, 'sliceNb': encodenumber};
		return executorTs('evttimetableResetSlice', model, decodeStructure(decodeboolean), arguments);
	},
	async evttimetableResetSliceByDate(timetableId :string, startDate :Date, endDate :Date):Promise<Array<string>> {
		const model = {'timetableId': encodeString, 'startDate': encodeDate, 'endDate': encodeDate};
		return executorTs('evttimetableResetSliceByDate', model, decodeStructure(decodeArray(decodeString)), arguments);
	},
	async evttimetableput(__inline :TimetableInputBean, allowDeleteEvent ?:boolean):Promise<TimetableBean> {
		const model = {'__inline': encodeTimetableInputBean, 'allowDeleteEvent': encodeBoolean};
		return executorTs('evttimetableput', model, decodeStructure(decodeTimetableBean), arguments);
	},
	async evtupdate(option :string|undefined, __inline :EventInputBean):Promise<IEvent> {
		const model = {'option': encodeEnum, '__inline': encodeEventInputBean};
		return executorTs('evtupdate', model, decodeStructure(decodeIEvent), arguments);
	},
	async evtupdateoption(__inline :EventInputBean):Promise<Array<string>> {
		const model = {'__inline': encodeEventInputBean};
		return executorTs('evtupdateoption', model, decodeStructure(decodeArray(decodeEnum)), arguments);
	},
	async famacceptinvitation(iid :string, v ?:string, validationmethod ?:string):Promise<boolean> {
		const model = {'iid': encodeString, 'v': encodeString, 'validationmethod': encodeEnum};
		return executorTs('famacceptinvitation', model, decodeStructure(decodeboolean), arguments);
	},
	async famblockinvite(iid :string, v :string|undefined, block :boolean):Promise<InvitationReceivedBean> {
		const model = {'iid': encodeString, 'v': encodeString, 'block': encodeboolean};
		return executorTs('famblockinvite', model, decodeStructure(decodeInvitationReceivedBean), arguments);
	},
	async famcancelinvite(invitationId :string, v ?:string):Promise<boolean> {
		const model = {'invitationId': encodeString, 'v': encodeString};
		return executorTs('famcancelinvite', model, decodeStructure(decodeboolean), arguments);
	},
	async famgetinvitation(iid :string, v ?:string):Promise<InvitationReceivedBean> {
		const model = {'iid': encodeString, 'v': encodeString};
		return executorTs('famgetinvitation', model, decodeStructure(decodeInvitationReceivedBean), arguments);
	},
	async famgetinvitationlinkbean():Promise<TokenUrlBean> {
		const model = {};
		return executorTs('famgetinvitationlinkbean', model, decodeStructure(decodeTokenUrlBean), arguments);
	},
	async famlistfamily(withStateBean ?:boolean):Promise<Array<IExtendedFamily>> {
		const model = {'withStateBean': encodeBoolean};
		return executorTs('famlistfamily', model, decodeStructure(decodeArray(decodeIExtendedFamily)), arguments);
	},
	async famlistinvite(pg ?:PaginationRequest):Promise<Array<IInvitation>> {
		const model = {'pg': encodePaginationRequest};
		return executorTs('famlistinvite', model, decodeStructure(decodeArray(decodeIInvitation)), arguments);
	},
	async famlogfamily(familyId :string):Promise<IFamily> {
		const model = {'familyId': encodeString};
		return executorTs('famlogfamily', model, decodeStructure(decodeIFamily), arguments);
	},
	async famresendinvite(iid :string, deviceComposerUsed ?:boolean):Promise<InvitationSendingBean> {
		const model = {'iid': encodeString, 'deviceComposerUsed': encodeBoolean};
		return executorTs('famresendinvite', model, decodeStructure(decodeInvitationSendingBean), arguments);
	},
	async famsendinvite(email ?:string, phone ?:string, inviteeid ?:number, role ?:string, adminRight ?:string, customFamilyRole ?:string, firstname ?:string, picture ?:FizFile, deviceComposerUsed ?:boolean, test ?:boolean):Promise<InvitationSendingBean> {
		const model = {'email': encodeString, 'phone': encodeString, 'inviteeid': encodeNumber, 'role': encodeEnum, 'adminRight': encodeEnum, 'customFamilyRole': encodeString, 'firstname': encodeString, 'picture': encodeFizFile, 'deviceComposerUsed': encodeBoolean, 'test': encodeBoolean};
		return executorTs('famsendinvite', model, decodeStructure(decodeInvitationSendingBean), arguments);
	},
	async famsetfirst(familyId :string):Promise<boolean> {
		const model = {'familyId': encodeString};
		return executorTs('famsetfirst', model, decodeStructure(decodeboolean), arguments);
	},
	async famshowincominginvite(pg ?:PaginationRequest):Promise<Array<InvitationReceivedBean>> {
		const model = {'pg': encodePaginationRequest};
		return executorTs('famshowincominginvite', model, decodeStructure(decodeArray(decodeInvitationReceivedBean)), arguments);
	},
	async famupdateinvitation(iid :string, email ?:string, phone ?:string, role ?:string, adminRight ?:string, customFamilyRole ?:string, firstname ?:string, picture ?:FizFile):Promise<IInvitation> {
		const model = {'iid': encodeString, 'email': encodeString, 'phone': encodeString, 'role': encodeEnum, 'adminRight': encodeEnum, 'customFamilyRole': encodeString, 'firstname': encodeString, 'picture': encodeFizFile};
		return executorTs('famupdateinvitation', model, decodeStructure(decodeIInvitation), arguments);
	},
	async filerclose(metaId ?:string):Promise<boolean> {
		const model = {'metaId': encodeString};
		return executorTs('filerclose', model, decodeStructure(decodeboolean), arguments);
	},
	async filerdeletefile(id :Array<string>):Promise<boolean> {
		const model = {'id': encodeArray(encodeString)};
		return executorTs('filerdeletefile', model, decodeStructure(decodeBoolean), arguments);
	},
	async filerdeletefolder(id :Array<string>):Promise<boolean> {
		const model = {'id': encodeArray(encodeString)};
		return executorTs('filerdeletefolder', model, decodeStructure(decodeBoolean), arguments);
	},
	async filerduplicatefolder(id :string, targetId :string):Promise<FolderBean> {
		const model = {'id': encodeString, 'targetId': encodeString};
		return executorTs('filerduplicatefolder', model, decodeStructure(decodeFolderBean), arguments);
	},
	async filergetfile(id :string):Promise<IMedia> {
		const model = {'id': encodeString};
		return executorTs('filergetfile', model, decodeStructure(decodeIMedia), arguments);
	},
	async filergetfolder(id :string):Promise<FolderBean> {
		const model = {'id': encodeString};
		return executorTs('filergetfolder', model, decodeStructure(decodeFolderBean), arguments);
	},
	async filerlistfile():Promise<Array<IMedia>> {
		const model = {};
		return executorTs('filerlistfile', model, decodeStructure(decodeArray(decodeIMedia)), arguments);
	},
	async filerlistfolder():Promise<Array<FolderBean>> {
		const model = {};
		return executorTs('filerlistfolder', model, decodeStructure(decodeArray(decodeFolderBean)), arguments);
	},
	async filerputfile(__inline :IFilerInputBean, file ?:FizFile):Promise<IMedia> {
		const model = {'__inline': encodeIFilerInputBean, 'file': encodeFizFile};
		return executorTs('filerputfile', model, decodeStructure(decodeIMedia), arguments);
	},
	async filerputfolder(__inline :FolderInputBean):Promise<FolderBean> {
		const model = {'__inline': encodeFolderInputBean};
		return executorTs('filerputfolder', model, decodeStructure(decodeFolderBean), arguments);
	},
	async filersyncfile(syncToken ?:string):Promise<FileSyncBean> {
		const model = {'syncToken': encodeString};
		return executorTs('filersyncfile', model, decodeStructure(decodeFileSyncBean), arguments);
	},
	async filersyncfolder(syncToken ?:string):Promise<FolderSyncBean> {
		const model = {'syncToken': encodeString};
		return executorTs('filersyncfolder', model, decodeStructure(decodeFolderSyncBean), arguments);
	},
	async geoaddress(address :string):Promise<GeocodedAddress> {
		const model = {'address': encodeString};
		return executorTs('geoaddress', model, decodeStructure(decodeGeocodedAddress), arguments);
	},
	async geoaddresswithcontext(address :string, latitudeE6 ?:number, longitudeE6 ?:number, start ?:number, count ?:number):Promise<PaginatedCollection<GeocodedAddress>> {
		const model = {'address': encodeString, 'latitudeE6': encodeNumber, 'longitudeE6': encodeNumber, 'start': encodeNumber, 'count': encodeNumber};
		return executorTs('geoaddresswithcontext', model, decodeStructure(decodePaginatedCollection(decodeGeocodedAddress)), arguments);
	},
	async geocheck(geocodedAddress :GeocodedAddress):Promise<GeocodedAddress> {
		const model = {'geocodedAddress': encodeGeocodedAddress};
		return executorTs('geocheck', model, decodeStructure(decodeGeocodedAddress), arguments);
	},
	async geodetailedaddress(country :string, state :string, zipCode :string, town :string, line :string):Promise<GeocodedAddress> {
		const model = {'country': encodeString, 'state': encodeString, 'zipCode': encodeString, 'town': encodeString, 'line': encodeString};
		return executorTs('geodetailedaddress', model, decodeStructure(decodeGeocodedAddress), arguments);
	},
	async georeverse(latitudeE6 :number, longitudeE6 :number):Promise<GeocodedAddress> {
		const model = {'latitudeE6': encodenumber, 'longitudeE6': encodenumber};
		return executorTs('georeverse', model, decodeStructure(decodeGeocodedAddress), arguments);
	},
	async googleAuthUri():Promise<string> {
		const model = {};
		return executorTs('googleAuthUri', model, decodeStructure(decodeString), arguments);
	},
	async googlegetcredential(credentialId :string):Promise<GoogleCredentialBean> {
		const model = {'credentialId': encodeString};
		return executorTs('googlegetcredential', model, decodeStructure(decodeGoogleCredentialBean), arguments);
	},
	async googlelogin(code :string):Promise<boolean> {
		const model = {'code': encodeString};
		return executorTs('googlelogin', model, decodeStructure(decodeboolean), arguments);
	},
	async googlelogin2(code :string):Promise<GoogleCredentialBean> {
		const model = {'code': encodeString};
		return executorTs('googlelogin2', model, decodeStructure(decodeGoogleCredentialBean), arguments);
	},
	async googlesavetoken(tokenType :string, accessToken :string, refreshToken :string, expiresDate :Date):Promise<boolean> {
		const model = {'tokenType': encodeEnum, 'accessToken': encodeString, 'refreshToken': encodeString, 'expiresDate': encodeDate};
		return executorTs('googlesavetoken', model, decodeStructure(decodeboolean), arguments);
	},
	async googlesavetoken2(tokenType :string, accessToken :string, refreshToken :string, expiresDate :Date):Promise<GoogleCredentialBean> {
		const model = {'tokenType': encodeEnum, 'accessToken': encodeString, 'refreshToken': encodeString, 'expiresDate': encodeDate};
		return executorTs('googlesavetoken2', model, decodeStructure(decodeGoogleCredentialBean), arguments);
	},
	async googleselectcalendar2(credentialId :string, googleId :Array<string>):Promise<CalendarSubscriptionResponseBean> {
		const model = {'credentialId': encodeString, 'googleId': encodeArray(encodeString)};
		return executorTs('googleselectcalendar2', model, decodeStructure(decodeCalendarSubscriptionResponseBean), arguments);
	},
	async imgetpremium():Promise<PremiumRightBean> {
		const model = {};
		return executorTs('imgetpremium', model, decodeStructure(decodePremiumRightBean), arguments);
	},
	async immarkasread(threadId :string, clientOpId ?:string):Promise<IIMThread> {
		const model = {'threadId': encodeString, 'clientOpId': encodeString};
		return executorTs('immarkasread', model, decodeStructure(decodeIIMThread), arguments);
	},
	async immessagelist2(threadId :string, pg ?:SimplePaginationRequest):Promise<SimplePaginatedCollection<IIMMessage>> {
		const model = {'threadId': encodeString, 'pg': encodeSimplePaginationRequest};
		return executorTs('immessagelist2', model, decodeStructure(decodeSimplePaginatedCollection(decodeIIMMessage)), arguments);
	},
	async immessagelistgrp(threadId :Array<string>, count ?:number):Promise<Array<SimplePaginatedCollection<IIMMessage>>> {
		const model = {'threadId': encodeArray(encodeString), 'count': encodeNumber};
		return executorTs('immessagelistgrp', model, decodeStructure(decodeArray(decodeSimplePaginatedCollection(decodeIIMMessage))), arguments);
	},
	async immessagesync(threadId :string, syncToken ?:string, date ?:Date):Promise<MessageSyncBean> {
		const model = {'threadId': encodeString, 'syncToken': encodeString, 'date': encodeDate};
		return executorTs('immessagesync', model, decodeStructure(decodeMessageSyncBean), arguments);
	},
	async immessagesyncgrp(request :Array<SyncRequest>):Promise<Array<MessageSyncBean>> {
		const model = {'request': encodeArray(encodeSyncRequest)};
		return executorTs('immessagesyncgrp', model, decodeStructure(decodeArray(decodeMessageSyncBean)), arguments);
	},
	async imnewthread(to :Array<number>, clientOpId ?:string):Promise<IIMThread> {
		const model = {'to': encodeArray(encodeNumber), 'clientOpId': encodeString};
		return executorTs('imnewthread', model, decodeStructure(decodeIIMThread), arguments);
	},
	async imsend(threadId ?:string, to ?:Array<number>, text ?:string, media ?:FizFile, type ?:string, externalId ?:string, clientOpId ?:string):Promise<IIMMessage> {
		const model = {'threadId': encodeString, 'to': encodeArray(encodeNumber), 'text': encodeString, 'media': encodeFizFile, 'type': encodeEnum, 'externalId': encodeString, 'clientOpId': encodeString};
		return executorTs('imsend', model, decodeStructure(decodeIIMMessage), arguments);
	},
	async imthreadlist(filter ?:string, isLoggedFamily ?:boolean):Promise<Array<IIMThread>> {
		const model = {'filter': encodeString, 'isLoggedFamily': encodeBoolean};
		return executorTs('imthreadlist', model, decodeStructure(decodeArray(decodeIIMThread)), arguments);
	},
	async launchpadclick(section :string, date ?:Date):Promise<boolean> {
		const model = {'section': encodeEnum, 'date': encodeDate};
		return executorTs('launchpadclick', model, decodeStructure(decodeboolean), arguments);
	},
	async launchpadcondition(activityWanted ?:boolean):Promise<LaunchpadConditionBean> {
		const model = {'activityWanted': encodeBoolean};
		return executorTs('launchpadcondition', model, decodeStructure(decodeLaunchpadConditionBean), arguments);
	},
	async launchpadget2(address ?:GeocodedAddress, conditions ?:LaunchpadConditionBean, actions ?:Array<string>):Promise<LaunchpadBean> {
		const model = {'address': encodeGeocodedAddress, 'conditions': encodeLaunchpadConditionBean, 'actions': encodeArray(encodeEnum)};
		return executorTs('launchpadget2', model, decodeStructure(decodeLaunchpadBean), arguments);
	},
	async launchpadget3(token ?:string, address ?:GeocodedAddress, conditions ?:LaunchpadConditionBean):Promise<LaunchpadBean> {
		const model = {'token': encodeString, 'address': encodeGeocodedAddress, 'conditions': encodeLaunchpadConditionBean};
		return executorTs('launchpadget3', model, decodeStructure(decodeLaunchpadBean), arguments);
	},
	async launchpadgetexplore(token ?:string):Promise<ExploreBean> {
		const model = {'token': encodeString};
		return executorTs('launchpadgetexplore', model, decodeStructure(decodeExploreBean), arguments);
	},
	async launchpadlisttiles():Promise<Array<DashboardTileBean>> {
		const model = {};
		return executorTs('launchpadlisttiles', model, decodeStructure(decodeArray(decodeDashboardTileBean)), arguments);
	},
	async launchpadmovetile(tileId :string, prevId :string):Promise<Map<string,number>> {
		const model = {'tileId': encodeString, 'prevId': encodeString};
		return executorTs('launchpadmovetile', model, decodeStructure(decodeMap(decodeString,decodeNumber)), arguments);
	},
	async launchpadseen(screen :string, clear ?:boolean):Promise<boolean> {
		const model = {'screen': encodeString, 'clear': encodeBoolean};
		return executorTs('launchpadseen', model, decodeStructure(decodeboolean), arguments);
	},
	async launchpadupdatetile(__inline :DashboardTileInputBean):Promise<DashboardTileBean> {
		const model = {'__inline': encodeDashboardTileInputBean};
		return executorTs('launchpadupdatetile', model, decodeStructure(decodeDashboardTileBean), arguments);
	},
	async locacceptpickmeup(targetId :number):Promise<boolean> {
		const model = {'targetId': encodeNumber};
		return executorTs('locacceptpickmeup', model, decodeStructure(decodeBoolean), arguments);
	},
	async localarmpanicbutton(geocodedAddress ?:GeocodedAddress):Promise<boolean> {
		const model = {'geocodedAddress': encodeGeocodedAddress};
		return executorTs('localarmpanicbutton', model, decodeStructure(decodeBoolean), arguments);
	},
	async locclearAlarmpanicbutton():Promise<boolean> {
		const model = {};
		return executorTs('locclearAlarmpanicbutton', model, decodeStructure(decodeBoolean), arguments);
	},
	async locget(accountId :number):Promise<ILocation> {
		const model = {'accountId': encodeNumber};
		return executorTs('locget', model, decodeStructure(decodeILocation), arguments);
	},
	async locgetbyplace(placeId :string):Promise<Array<ILocation>> {
		const model = {'placeId': encodeString};
		return executorTs('locgetbyplace', model, decodeStructure(decodeArray(decodeILocation)), arguments);
	},
	async locgetdeviceflag():Promise<LocationDeviceFlags> {
		const model = {};
		return executorTs('locgetdeviceflag', model, decodeStructure(decodeLocationDeviceFlags), arguments);
	},
	async locgetgeofencingsforpublisher(withPlace ?:boolean):Promise<Array<IPlaceGeofencing>> {
		const model = {'withPlace': encodeBoolean};
		return executorTs('locgetgeofencingsforpublisher', model, decodeStructure(decodeArray(decodeIPlaceGeofencing)), arguments);
	},
	async locgetgeofencingsforsubscriber(placeId :string):Promise<Map<number,IPlaceGeofencing>> {
		const model = {'placeId': encodeString};
		return executorTs('locgetgeofencingsforsubscriber', model, decodeStructure(decodeMap(decodeNumber,decodeIPlaceGeofencing)), arguments);
	},
	async locgetpositions2():Promise<Array<ILocation>> {
		const model = {};
		return executorTs('locgetpositions2', model, decodeStructure(decodeArray(decodeILocation)), arguments);
	},
	async lochistory(date ?:Date):Promise<PaginatedCollection<ILocation>> {
		const model = {'date': encodeDate};
		return executorTs('lochistory', model, decodeStructure(decodePaginatedCollection(decodeILocation)), arguments);
	},
	async locpublisfencing(type :string, placeId :string, deviceId ?:string):Promise<ILocation> {
		const model = {'type': encodeEnum, 'placeId': encodeString, 'deviceId': encodeString};
		return executorTs('locpublisfencing', model, decodeStructure(decodeILocation), arguments);
	},
	async locpublishaddress(text :string|undefined, address :string, latitudeE6 ?:number, longitudeE6 ?:number, isTemporary ?:boolean, picture ?:Array<FizFile>):Promise<IWallMessage> {
		const model = {'text': encodeString, 'address': encodeString, 'latitudeE6': encodeNumber, 'longitudeE6': encodeNumber, 'isTemporary': encodeBoolean, 'picture': encodeArray(encodeFizFile)};
		return executorTs('locpublishaddress', model, decodeStructure(decodeIWallMessage), arguments);
	},
	async locpublishauto(geocodedAddress :GeocodedAddress, deviceId :string, fromRequestAccountId ?:number):Promise<ILocation> {
		const model = {'geocodedAddress': encodeGeocodedAddress, 'deviceId': encodeString, 'fromRequestAccountId': encodeNumber};
		return executorTs('locpublishauto', model, decodeStructure(decodeILocation), arguments);
	},
	async locpublishpickmeup(targetId :number, address :string, latitudeE6 :number, longitudeE6 :number):Promise<boolean> {
		const model = {'targetId': encodeNumber, 'address': encodeString, 'latitudeE6': encodeNumber, 'longitudeE6': encodeNumber};
		return executorTs('locpublishpickmeup', model, decodeStructure(decodeBoolean), arguments);
	},
	async locpublishplacelocation(text :string|undefined, placeId :string, moveType :string, picture ?:Array<FizFile>):Promise<IWallMessage> {
		const model = {'text': encodeString, 'placeId': encodeString, 'moveType': encodeEnum, 'picture': encodeArray(encodeFizFile)};
		return executorTs('locpublishplacelocation', model, decodeStructure(decodeIWallMessage), arguments);
	},
	async locrequestautotrack(publisherId :number):Promise<boolean> {
		const model = {'publisherId': encodeNumber};
		return executorTs('locrequestautotrack', model, decodeStructure(decodeBoolean), arguments);
	},
	async locrequestpositionrefresh(accountId ?:number):Promise<boolean> {
		const model = {'accountId': encodeNumber};
		return executorTs('locrequestpositionrefresh', model, decodeStructure(decodeBoolean), arguments);
	},
	async locrespondtogeorequest(accept :Map<number,boolean>, tempDuration ?:Map<number,number>, geocodedAddress ?:GeocodedAddress, deviceId ?:string):Promise<boolean> {
		const model = {'accept': encodeMap(encodeNumber,encodeBoolean), 'tempDuration': encodeMap(encodeNumber,encodeNumber), 'geocodedAddress': encodeGeocodedAddress, 'deviceId': encodeString};
		return executorTs('locrespondtogeorequest', model, decodeStructure(decodeBoolean), arguments);
	},
	async locsetdeviceflag(__inline :LocationDeviceFlags):Promise<LocationDeviceFlags> {
		const model = {'__inline': encodeLocationDeviceFlags};
		return executorTs('locsetdeviceflag', model, decodeStructure(decodeLocationDeviceFlags), arguments);
	},
	async locsetgeofencingsettings(placeId :string, publisherId :number, IN ?:boolean, out ?:boolean):Promise<IPlaceGeofencing> {
		const model = {'placeId': encodeString, 'publisherId': encodeNumber, 'in': encodeBoolean, 'out': encodeBoolean};
		return executorTs('locsetgeofencingsettings', model, decodeStructure(decodeIPlaceGeofencing), arguments);
	},
	async locsetperuserauthflag(flags :Map<number,string>, tempDuration ?:Map<number,number>, geocodedAddress ?:GeocodedAddress, deviceId ?:string):Promise<boolean> {
		const model = {'flags': encodeMap(encodeNumber,encodeEnum), 'tempDuration': encodeMap(encodeNumber,encodeNumber), 'geocodedAddress': encodeGeocodedAddress, 'deviceId': encodeString};
		return executorTs('locsetperuserauthflag', model, decodeStructure(decodeBoolean), arguments);
	},
	async log2check(type :string|undefined, identifier :string, countryCode ?:string, validated ?:boolean):Promise<boolean> {
		const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'validated': encodeBoolean};
		return executorTs('log2check', model, decodeStructure(decodeBoolean), arguments);
	},
	async log2checkinvitation(type :string|undefined, identifier :string, countryCode ?:string):Promise<boolean> {
		const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString};
		return executorTs('log2checkinvitation', model, decodeStructure(decodeBoolean), arguments);
	},
	async log2checkvalidationcode(type :string|undefined, identifier :string, countryCode :string|undefined, code :string):Promise<boolean> {
		const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'code': encodeString};
		return executorTs('log2checkvalidationcode', model, decodeStructure(decodeBoolean), arguments);
	},
	async log2create(type :string|undefined, identifier :string, countryCode :string|undefined, password :string, partnerType ?:string, validationmethod ?:string, locale ?:string):Promise<AccountLoginInfo> {
		const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'password': encodeString, 'partnerType': encodeEnum, 'validationmethod': encodeEnum, 'locale': encodeString};
		return executorTs('log2create', model, decodeStructure(decodeAccountLoginInfo), arguments);
	},
	async log2deeplink(TK :string, fid ?:string):Promise<AccountLoginInfo> {
		const model = {'TK': encodeString, 'fid': encodeString};
		return executorTs('log2deeplink', model, decodeStructure(decodeAccountLoginInfo), arguments);
	},
	async log2forgotpassword2(identifier :string):Promise<ForgotPasswordResponseBean> {
		const model = {'identifier': encodeString};
		return executorTs('log2forgotpassword2', model, decodeStructure(decodeForgotPasswordResponseBean), arguments);
	},
	async log2generateaccesstokeinbydeeplinktoken(token :string, tokentype :string, deviceId :string):Promise<AccessTokenBean> {
		const model = {'token': encodeString, 'tokentype': encodeEnum, 'deviceId': encodeString};
		return executorTs('log2generateaccesstokeinbydeeplinktoken', model, decodeStructure(decodeAccessTokenBean), arguments);
	},
	async log2generateaccesstokenbypassword(type :string|undefined, identifier :string, countryCode :string|undefined, password :string, tokentype :string, deviceId :string):Promise<AccessTokenBean> {
		const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'password': encodeString, 'tokentype': encodeEnum, 'deviceId': encodeString};
		return executorTs('log2generateaccesstokenbypassword', model, decodeStructure(decodeAccessTokenBean), arguments);
	},
	async log2generatedeeplinktokenaccesstoken(token :string, tokentype :string, deviceId :string):Promise<DeepLinkAccessToken> {
		const model = {'token': encodeString, 'tokentype': encodeEnum, 'deviceId': encodeString};
		return executorTs('log2generatedeeplinktokenaccesstoken', model, decodeStructure(decodeDeepLinkAccessToken), arguments);
	},
	async log2get():Promise<Array<IAccount>> {
		const model = {};
		return executorTs('log2get', model, decodeStructure(decodeArray(decodeIAccount)), arguments);
	},
	async log2in(type :string|undefined, identifier :string, countryCode :string|undefined, password :string, generateAutologinToken ?:boolean, clientId ?:string, clientSecret ?:string):Promise<AccountLoginInfo> {
		const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'password': encodeString, 'generateAutologinToken': encodeBoolean, 'clientId': encodeString, 'clientSecret': encodeString};
		return executorTs('log2in', model, decodeStructure(decodeAccountLoginInfo), arguments);
	},
	async log2loginByAutologinToken(identifier :string, token :string):Promise<AccountLoginInfo> {
		const model = {'identifier': encodeString, 'token': encodeString};
		return executorTs('log2loginByAutologinToken', model, decodeStructure(decodeAccountLoginInfo), arguments);
	},
	async log2out():Promise<boolean> {
		const model = {};
		return executorTs('log2out', model, decodeStructure(decodeboolean), arguments);
	},
	async log2renew():Promise<AccountLoginInfo> {
		const model = {};
		return executorTs('log2renew', model, decodeStructure(decodeAccountLoginInfo), arguments);
	},
	async log2sendaccountidentifiervalidationcode(type :string|undefined, identifier :string, countryCode ?:string):Promise<boolean> {
		const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString};
		return executorTs('log2sendaccountidentifiervalidationcode', model, decodeStructure(decodeBoolean), arguments);
	},
	async log2token(token :string):Promise<TokenAndAccountLogInfoBean> {
		const model = {'token': encodeString};
		return executorTs('log2token', model, decodeStructure(decodeTokenAndAccountLogInfoBean), arguments);
	},
	async log2validateidentifier(type :string|undefined, identifier :string, countryCode :string|undefined, code :string, autoacceptpendinginvite ?:boolean):Promise<AccountLoginInfo> {
		const model = {'type': encodeEnum, 'identifier': encodeString, 'countryCode': encodeString, 'code': encodeString, 'autoacceptpendinginvite': encodeBoolean};
		return executorTs('log2validateidentifier', model, decodeStructure(decodeAccountLoginInfo), arguments);
	},
	async metaaddComment(id :string, text :string, mood ?:string, clientOpId ?:string):Promise<CommentResultBean<IHasMetaId>> {
		const model = {'id': encodeString, 'text': encodeString, 'mood': encodeEnum, 'clientOpId': encodeString};
		return executorTs('metaaddComment', model, decodeStructure(decodeCommentResultBean(decodeIHasMetaId)), arguments);
	},
	async metaaddpictures(id :string, pictures :Array<FizFile>):Promise<IHasMetaId> {
		const model = {'id': encodeString, 'pictures': encodeArray(encodeFizFile)};
		return executorTs('metaaddpictures', model, decodeStructure(decodeDynamic), arguments);
	},
	async metadelete(id :Array<string>):Promise<boolean> {
		const model = {'id': encodeArray(encodeString)};
		return executorTs('metadelete', model, decodeStructure(decodeDynamic), arguments);
	},
	async metaget(id :string):Promise<IHasMetaId> {
		const model = {'id': encodeString};
		return executorTs('metaget', model, decodeStructure(decodeDynamic), arguments);
	},
	async metalist(id :string):Promise<Array<IHasMetaId>> {
		const model = {'id': encodeEnum};
		return executorTs('metalist', model, decodeStructure(decodeDynamic), arguments);
	},
	async metamood(id :string, add ?:Array<string>, remove ?:Array<string>, clientOpId ?:string):Promise<IHasMetaId> {
		const model = {'id': encodeString, 'add': encodeArray(encodeEnum), 'remove': encodeArray(encodeEnum), 'clientOpId': encodeString};
		return executorTs('metamood', model, decodeStructure(decodeDynamic), arguments);
	},
	async metapictures(id :string, pictures :Array<FizFile>):Promise<IHasMetaId> {
		const model = {'id': encodeString, 'pictures': encodeArray(encodeFizFile)};
		return executorTs('metapictures', model, decodeStructure(decodeDynamic), arguments);
	},
	async metasync(id :string, listId ?:string, syncToken ?:string, date ?:Date):Promise<ISyncBean<IHasMetaId>> {
		const model = {'id': encodeEnum, 'listId': encodeString, 'syncToken': encodeString, 'date': encodeDate};
		return executorTs('metasync', model, decodeStructure(decodeDynamic), arguments);
	},
	async metaupdatetext(id :string, text :string, clientOpId ?:string):Promise<IHasMetaId> {
		const model = {'id': encodeString, 'text': encodeString, 'clientOpId': encodeString};
		return executorTs('metaupdatetext', model, decodeStructure(decodeDynamic), arguments);
	},
	async mpadditemtolist(ingredients :Array<ShoppingIngredientInputBean>, listId ?:string):Promise<boolean> {
		const model = {'ingredients': encodeArray(encodeShoppingIngredientInputBean), 'listId': encodeString};
		return executorTs('mpadditemtolist', model, decodeStructure(decodeboolean), arguments);
	},
	async mpcategorydelete(id :Array<string>):Promise<boolean> {
		const model = {'id': encodeArray(encodeString)};
		return executorTs('mpcategorydelete', model, decodeStructure(decodeboolean), arguments);
	},
	async mpcategoryget(id :string):Promise<CategoryBean> {
		const model = {'id': encodeString};
		return executorTs('mpcategoryget', model, decodeStructure(decodeCategoryBean), arguments);
	},
	async mpcategorylist():Promise<Array<CategoryBean>> {
		const model = {};
		return executorTs('mpcategorylist', model, decodeStructure(decodeArray(decodeCategoryBean)), arguments);
	},
	async mpcategoryput(__inline :CategoryInputBean, prevId ?:string):Promise<CategoryBean> {
		const model = {'__inline': encodeCategoryInputBean, 'prevId': encodeString};
		return executorTs('mpcategoryput', model, decodeStructure(decodeCategoryBean), arguments);
	},
	async mpclear(from :string, to :string):Promise<boolean> {
		const model = {'from': encodeString, 'to': encodeString};
		return executorTs('mpclear', model, decodeStructure(decodeboolean), arguments);
	},
	async mpcopy(from :string, to :string, targetFrom :string, clientOpId ?:string):Promise<Array<DishBean>> {
		const model = {'from': encodeString, 'to': encodeString, 'targetFrom': encodeString, 'clientOpId': encodeString};
		return executorTs('mpcopy', model, decodeStructure(decodeArray(decodeDishBean)), arguments);
	},
	async mpcreate(name :Array<string>, date :string, type :string, clientOpId ?:string):Promise<Array<DishBean>> {
		const model = {'name': encodeArray(encodeString), 'date': encodeString, 'type': encodeEnum, 'clientOpId': encodeString};
		return executorTs('mpcreate', model, decodeStructure(decodeArray(decodeDishBean)), arguments);
	},
	async mpcreateByRecipeId(recipeId :string, date :string, type :string, clientOpId ?:string):Promise<DishBean> {
		const model = {'recipeId': encodeString, 'date': encodeString, 'type': encodeEnum, 'clientOpId': encodeString};
		return executorTs('mpcreateByRecipeId', model, decodeStructure(decodeDishBean), arguments);
	},
	async mpgenerateIA(__inline :IAGenerateRecipeParameters):Promise<RecipeInputBean> {
		const model = {'__inline': encodeIAGenerateRecipeParameters};
		return executorTs('mpgenerateIA', model, decodeStructure(decodeRecipeInputBean), arguments);
	},
	async mplistinterval(from :string, to :string):Promise<DishRangeBean> {
		const model = {'from': encodeString, 'to': encodeString};
		return executorTs('mplistinterval', model, decodeStructure(decodeDishRangeBean), arguments);
	},
	async mpmealput(__inline :MealInputBean):Promise<MealBean> {
		const model = {'__inline': encodeMealInputBean};
		return executorTs('mpmealput', model, decodeStructure(decodeMealBean), arguments);
	},
	async mpmove(metaId :Array<string>, date :string, type :string, clientOpId ?:string):Promise<Array<DishBean>> {
		const model = {'metaId': encodeArray(encodeString), 'date': encodeString, 'type': encodeEnum, 'clientOpId': encodeString};
		return executorTs('mpmove', model, decodeStructure(decodeArray(decodeDishBean)), arguments);
	},
	async mpncrecipe(tokenvalue ?:string, recipeMetaId ?:string):Promise<RecipeBean> {
		const model = {'tokenvalue': encodeString, 'recipeMetaId': encodeString};
		return executorTs('mpncrecipe', model, decodeStructure(decodeRecipeBean), arguments);
	},
	async mpncshared(tokenvalue :string):Promise<MealPlannerSharedBean> {
		const model = {'tokenvalue': encodeString};
		return executorTs('mpncshared', model, decodeStructure(decodeMealPlannerSharedBean), arguments);
	},
	async mprecipelink(metaId :string):Promise<TokenUrlBean> {
		const model = {'metaId': encodeString};
		return executorTs('mprecipelink', model, decodeStructure(decodeTokenUrlBean), arguments);
	},
	async mprecipeput(recipe :RecipeInputBean, picture ?:Array<FizFile>):Promise<RecipeBean> {
		const model = {'recipe': encodeRecipeInputBean, 'picture': encodeArray(encodeFizFile)};
		return executorTs('mprecipeput', model, decodeStructure(decodeRecipeBean), arguments);
	},
	async mprecipeputbyid(id :string, recipeCategories ?:string, recipeCategoryId ?:string):Promise<RecipeBean> {
		const model = {'id': encodeString, 'recipeCategories': encodeEnum, 'recipeCategoryId': encodeString};
		return executorTs('mprecipeputbyid', model, decodeStructure(decodeRecipeBean), arguments);
	},
	async mprecipeputbyurl(url :string, recipeCategories ?:string, recipeCategoryId ?:string):Promise<RecipePuByUrlResultBean> {
		const model = {'url': encodeString, 'recipeCategories': encodeEnum, 'recipeCategoryId': encodeString};
		return executorTs('mprecipeputbyurl', model, decodeStructure(decodeRecipePuByUrlResultBean), arguments);
	},
	async mpsettingsget():Promise<MealSettingsBean> {
		const model = {};
		return executorTs('mpsettingsget', model, decodeStructure(decodeMealSettingsBean), arguments);
	},
	async mpsettingsset(settings :MealSettingsBean):Promise<MealSettingsBean> {
		const model = {'settings': encodeMealSettingsBean};
		return executorTs('mpsettingsset', model, decodeStructure(decodeMealSettingsBean), arguments);
	},
	async mpsharedlink(from :string, to :string):Promise<TokenUrlBean> {
		const model = {'from': encodeString, 'to': encodeString};
		return executorTs('mpsharedlink', model, decodeStructure(decodeTokenUrlBean), arguments);
	},
	async outlookAuthUri():Promise<string> {
		const model = {};
		return executorTs('outlookAuthUri', model, decodeStructure(decodeString), arguments);
	},
	async outlookgetcredential(credentialId :string):Promise<OutlookCredentialBean> {
		const model = {'credentialId': encodeString};
		return executorTs('outlookgetcredential', model, decodeStructure(decodeOutlookCredentialBean), arguments);
	},
	async outlooklogin(code :string):Promise<OutlookCredentialBean> {
		const model = {'code': encodeString};
		return executorTs('outlooklogin', model, decodeStructure(decodeOutlookCredentialBean), arguments);
	},
	async outlooksavetoken(tokenType :string, accessToken :string, refreshToken :string, expiresDate :Date, redirectUri :string, useSecret :boolean):Promise<OutlookCredentialBean> {
		const model = {'tokenType': encodeEnum, 'accessToken': encodeString, 'refreshToken': encodeString, 'expiresDate': encodeDate, 'redirectUri': encodeString, 'useSecret': encodeBoolean};
		return executorTs('outlooksavetoken', model, decodeStructure(decodeOutlookCredentialBean), arguments);
	},
	async outlookselectcalendar2(credentialId :string, outlookId ?:Array<string>):Promise<CalendarSubscriptionResponseBean> {
		const model = {'credentialId': encodeString, 'outlookId': encodeArray(encodeString)};
		return executorTs('outlookselectcalendar2', model, decodeStructure(decodeCalendarSubscriptionResponseBean), arguments);
	},
	async outlooksync(calendarId :string, syncToken ?:string):Promise<EventSyncBean> {
		const model = {'calendarId': encodeString, 'syncToken': encodeString};
		return executorTs('outlooksync', model, decodeStructure(decodeEventSyncBean), arguments);
	},
	async poicreate(name :string, geocodedAddress :GeocodedAddress, placeType :string, isTemporary ?:boolean, geofencingActive ?:boolean, contactId ?:string, text ?:string, wifiSSID ?:string, wifiMAC ?:string, picture ?:Array<FizFile>):Promise<IPlace> {
		const model = {'name': encodeString, 'geocodedAddress': encodeGeocodedAddress, 'placeType': encodeEnum, 'isTemporary': encodeBoolean, 'geofencingActive': encodeBoolean, 'contactId': encodeString, 'text': encodeString, 'wifiSSID': encodeString, 'wifiMAC': encodeString, 'picture': encodeArray(encodeFizFile)};
		return executorTs('poicreate', model, decodeStructure(decodeIPlace), arguments);
	},
	async poicreatesimple(name :string, address :string, placeType :string, isTemporary ?:boolean, geofencingActive ?:boolean, contactId ?:string, text ?:string, wifiSSID ?:string, wifiMAC ?:string, picture ?:Array<FizFile>):Promise<IPlace> {
		const model = {'name': encodeString, 'address': encodeString, 'placeType': encodeEnum, 'isTemporary': encodeBoolean, 'geofencingActive': encodeBoolean, 'contactId': encodeString, 'text': encodeString, 'wifiSSID': encodeString, 'wifiMAC': encodeString, 'picture': encodeArray(encodeFizFile)};
		return executorTs('poicreatesimple', model, decodeStructure(decodeIPlace), arguments);
	},
	async poidelete(placeId :Array<string>):Promise<boolean> {
		const model = {'placeId': encodeArray(encodeString)};
		return executorTs('poidelete', model, decodeStructure(decodeboolean), arguments);
	},
	async poiget(placeId :string):Promise<IPlace> {
		const model = {'placeId': encodeString};
		return executorTs('poiget', model, decodeStructure(decodeIPlace), arguments);
	},
	async poigetall():Promise<Array<IPlace>> {
		const model = {};
		return executorTs('poigetall', model, decodeStructure(decodeArray(decodeIPlace)), arguments);
	},
	async poinearby(latitudeE6 :number, longitudeE6 :number):Promise<PlaceNearbyResult> {
		const model = {'latitudeE6': encodenumber, 'longitudeE6': encodenumber};
		return executorTs('poinearby', model, decodeStructure(decodePlaceNearbyResult), arguments);
	},
	async poisync(syncToken ?:string, date ?:Date):Promise<PlaceSyncBean> {
		const model = {'syncToken': encodeString, 'date': encodeDate};
		return executorTs('poisync', model, decodeStructure(decodePlaceSyncBean), arguments);
	},
	async poiupdate(placeId :string, name ?:string, geocodedAddress ?:GeocodedAddress, placeType ?:string, isTemporary ?:boolean, geofencingActive ?:boolean, contactId ?:string, text ?:string, wifiSSID ?:string, wifiMAC ?:string, picture ?:Array<FizFile>):Promise<IPlace> {
		const model = {'placeId': encodeString, 'name': encodeString, 'geocodedAddress': encodeGeocodedAddress, 'placeType': encodeEnum, 'isTemporary': encodeBoolean, 'geofencingActive': encodeBoolean, 'contactId': encodeString, 'text': encodeString, 'wifiSSID': encodeString, 'wifiMAC': encodeString, 'picture': encodeArray(encodeFizFile)};
		return executorTs('poiupdate', model, decodeStructure(decodeIPlace), arguments);
	},
	async prfgetProfile(oid ?:number):Promise<IProfile> {
		const model = {'oid': encodeNumber};
		return executorTs('prfgetProfile', model, decodeStructure(decodeIProfile), arguments);
	},
	async prfgetProfiles():Promise<Map<string,IProfile>> {
		const model = {};
		return executorTs('prfgetProfiles', model, decodeStructure(decodeMap(decodeString,decodeIProfile)), arguments);
	},
	async prfgetPublicProfiles(oid :Array<number>):Promise<Map<string,IProfile>> {
		const model = {'oid': encodeArray(encodeNumber)};
		return executorTs('prfgetPublicProfiles', model, decodeStructure(decodeMap(decodeString,decodeIProfile)), arguments);
	},
	async prfupdate(__inline :IProfile, picture ?:Array<FizFile>):Promise<IProfile> {
		const model = {'__inline': encodeIProfile, 'picture': encodeArray(encodeFizFile)};
		return executorTs('prfupdate', model, decodeStructure(decodeIProfile), arguments);
	},
	async prfupdate2(role :string|undefined, customFamilyRole :string|undefined, __inline :IProfile, picture ?:Array<FizFile>):Promise<IProfile> {
		const model = {'role': encodeEnum, 'customFamilyRole': encodeString, '__inline': encodeIProfile, 'picture': encodeArray(encodeFizFile)};
		return executorTs('prfupdate2', model, decodeStructure(decodeIProfile), arguments);
	},
	async settingsaiinboxcheck(email ?:string):Promise<AiInboxResponseBean> {
		const model = {'email': encodeString};
		return executorTs('settingsaiinboxcheck', model, decodeStructure(decodeAiInboxResponseBean), arguments);
	},
	async settingsaiinboxsave(email ?:string):Promise<AiInboxResponseBean> {
		const model = {'email': encodeString};
		return executorTs('settingsaiinboxsave', model, decodeStructure(decodeAiInboxResponseBean), arguments);
	},
	async settingsfeedback(type :string, score ?:number, comment ?:string):Promise<boolean> {
		const model = {'type': encodeEnum, 'score': encodeNumber, 'comment': encodeString};
		return executorTs('settingsfeedback', model, decodeStructure(decodeboolean), arguments);
	},
	async settingsget():Promise<SettingsBean> {
		const model = {};
		return executorTs('settingsget', model, decodeStructure(decodeSettingsBean), arguments);
	},
	async settingsgetperfamily(familyId ?:string):Promise<ISettingsPerFamily> {
		const model = {'familyId': encodeString};
		return executorTs('settingsgetperfamily', model, decodeStructure(decodeISettingsPerFamily), arguments);
	},
	async settingsset(pushGlobal ?:boolean, pushForEvent ?:boolean, pushForMessage ?:boolean, pushForCheckin ?:boolean, pushForPicture ?:boolean, geoTrackingHistory ?:boolean, reminderNotificationEnabled ?:boolean, pushForTask ?:boolean, pushForStatus ?:boolean, pushForComment ?:boolean, pushForBestMoment ?:boolean, pushForTimetable ?:boolean, pushForBudget ?:boolean, pushForFiler ?:boolean, pushForSpecialDays ?:boolean, pushByEmail ?:string, promoAccept ?:boolean):Promise<SettingsBean> {
		const model = {'pushGlobal': encodeBoolean, 'pushForEvent': encodeBoolean, 'pushForMessage': encodeBoolean, 'pushForCheckin': encodeBoolean, 'pushForPicture': encodeBoolean, 'geoTrackingHistory': encodeBoolean, 'reminderNotificationEnabled': encodeBoolean, 'pushForTask': encodeBoolean, 'pushForStatus': encodeBoolean, 'pushForComment': encodeBoolean, 'pushForBestMoment': encodeBoolean, 'pushForTimetable': encodeBoolean, 'pushForBudget': encodeBoolean, 'pushForFiler': encodeBoolean, 'pushForSpecialDays': encodeBoolean, 'pushByEmail': encodeEnum, 'promoAccept': encodeBoolean};
		return executorTs('settingsset', model, decodeStructure(decodeSettingsBean), arguments);
	},
	async settingssetperfamily(__inline :ISettingsPerFamily):Promise<ISettingsPerFamily> {
		const model = {'__inline': encodeISettingsPerFamily};
		return executorTs('settingssetperfamily', model, decodeStructure(decodeISettingsPerFamily), arguments);
	},
	async settingsshutdowngeolocsharing():Promise<boolean> {
		const model = {};
		return executorTs('settingsshutdowngeolocsharing', model, decodeStructure(decodeboolean), arguments);
	},
	async statusget():Promise<StatusBean> {
		const model = {};
		return executorTs('statusget', model, decodeStructure(decodeStatusBean), arguments);
	},
	async stublistsms(number :string):Promise<Array<SmsStubBean>> {
		const model = {'number': encodeString};
		return executorTs('stublistsms', model, decodeStructure(decodeArray(decodeSmsStubBean)), arguments);
	},
	async taskcategorydelete(id :Array<string>):Promise<boolean> {
		const model = {'id': encodeArray(encodeString)};
		return executorTs('taskcategorydelete', model, decodeStructure(decodeboolean), arguments);
	},
	async taskcategoryget(id :string):Promise<TaskCategoryBean> {
		const model = {'id': encodeString};
		return executorTs('taskcategoryget', model, decodeStructure(decodeTaskCategoryBean), arguments);
	},
	async taskcategorylist(tasklistType ?:string, locale ?:string, filterTasklistId ?:string):Promise<Array<TaskCategoryBean>> {
		const model = {'tasklistType': encodeEnum, 'locale': encodeString, 'filterTasklistId': encodeString};
		return executorTs('taskcategorylist', model, decodeStructure(decodeArray(decodeTaskCategoryBean)), arguments);
	},
	async taskcategoryput(__inline :TaskCategoryInputBean, prevId ?:string, tasklistId ?:string, locale ?:string, hidden ?:boolean):Promise<TaskCategoryBean> {
		const model = {'__inline': encodeTaskCategoryInputBean, 'prevId': encodeString, 'tasklistId': encodeString, 'locale': encodeString, 'hidden': encodeBoolean};
		return executorTs('taskcategoryput', model, decodeStructure(decodeTaskCategoryBean), arguments);
	},
	async taskcategorysync(syncToken ?:string):Promise<TaskCategorySyncBean> {
		const model = {'syncToken': encodeString};
		return executorTs('taskcategorysync', model, decodeStructure(decodeTaskCategorySyncBean), arguments);
	},
	async taskcloselist():Promise<boolean> {
		const model = {};
		return executorTs('taskcloselist', model, decodeStructure(decodeboolean), arguments);
	},
	async taskcreate(text :string, dueDate ?:Date, assignee ?:Array<number>, reminder ?:IReminder):Promise<TaskBean> {
		const model = {'text': encodeString, 'dueDate': encodeDate, 'assignee': encodeArray(encodeNumber), 'reminder': encodeIReminder};
		return executorTs('taskcreate', model, decodeStructure(decodeTaskBean), arguments);
	},
	async taskcreate2(__inline :TaskInputBean, picture ?:Array<FizFile>):Promise<TaskBean> {
		const model = {'__inline': encodeTaskInputBean, 'picture': encodeArray(encodeFizFile)};
		return executorTs('taskcreate2', model, decodeStructure(decodeTaskBean), arguments);
	},
	async taskcreatelist(__inline :ITaskList):Promise<ITaskList> {
		const model = {'__inline': encodeITaskList};
		return executorTs('taskcreatelist', model, decodeStructure(decodeITaskList), arguments);
	},
	async taskdelete(taskId :string):Promise<boolean> {
		const model = {'taskId': encodeString};
		return executorTs('taskdelete', model, decodeStructure(decodeboolean), arguments);
	},
	async taskdeletelist(id :string):Promise<boolean> {
		const model = {'id': encodeString};
		return executorTs('taskdeletelist', model, decodeStructure(decodeBoolean), arguments);
	},
	async taskduplicatelist(id :string):Promise<ITaskList> {
		const model = {'id': encodeString};
		return executorTs('taskduplicatelist', model, decodeStructure(decodeITaskList), arguments);
	},
	async taskget(taskId :string):Promise<TaskBean> {
		const model = {'taskId': encodeString};
		return executorTs('taskget', model, decodeStructure(decodeTaskBean), arguments);
	},
	async taskgetsettings():Promise<TaskListSettingsBean> {
		const model = {};
		return executorTs('taskgetsettings', model, decodeStructure(decodeTaskListSettingsBean), arguments);
	},
	async taskgetsuggestedlist():Promise<ITaskList> {
		const model = {};
		return executorTs('taskgetsuggestedlist', model, decodeStructure(decodeITaskList), arguments);
	},
	async taskgettasklists():Promise<Array<ITaskList>> {
		const model = {};
		return executorTs('taskgettasklists', model, decodeStructure(decodeArray(decodeITaskList)), arguments);
	},
	async taskgettasksuggestions(tasklistType :string, syncToken ?:string, locale ?:string):Promise<TaskSuggestionSyncBean> {
		const model = {'tasklistType': encodeEnum, 'syncToken': encodeString, 'locale': encodeString};
		return executorTs('taskgettasksuggestions', model, decodeStructure(decodeTaskSuggestionSyncBean), arguments);
	},
	async taskgettasksuggestionswcat(tasklistType :string, syncToken ?:string, locale ?:string):Promise<TaskSuggestionSyncBeanWCategory> {
		const model = {'tasklistType': encodeEnum, 'syncToken': encodeString, 'locale': encodeString};
		return executorTs('taskgettasksuggestionswcat', model, decodeStructure(decodeTaskSuggestionSyncBeanWCategory), arguments);
	},
	async tasklist(listId ?:string):Promise<Array<TaskBean>> {
		const model = {'listId': encodeString};
		return executorTs('tasklist', model, decodeStructure(decodeArray(decodeTaskBean)), arguments);
	},
	async taskmark(taskId :string, complete :boolean, completedDateForTesting ?:Date):Promise<TaskBean> {
		const model = {'taskId': encodeString, 'complete': encodeBoolean, 'completedDateForTesting': encodeDate};
		return executorTs('taskmark', model, decodeStructure(decodeTaskBean), arguments);
	},
	async taskmetamark(id :Array<string>, complete :boolean):Promise<boolean> {
		const model = {'id': encodeArray(encodeString), 'complete': encodeBoolean};
		return executorTs('taskmetamark', model, decodeStructure(decodeboolean), arguments);
	},
	async taskmove(taskId :string, taskListId ?:string, prevTaskId ?:string, taskCategoryId ?:string):Promise<Map<string,number>> {
		const model = {'taskId': encodeString, 'taskListId': encodeString, 'prevTaskId': encodeString, 'taskCategoryId': encodeString};
		return executorTs('taskmove', model, decodeStructure(decodeMap(decodeString,decodeNumber)), arguments);
	},
	async taskmovelist(id :string, prevId ?:string):Promise<Map<string,number>> {
		const model = {'id': encodeString, 'prevId': encodeString};
		return executorTs('taskmovelist', model, decodeStructure(decodeMap(decodeString,decodeNumber)), arguments);
	},
	async taskrespondsuggested(id :number, accept :boolean):Promise<ITaskList> {
		const model = {'id': encodeNumber, 'accept': encodeBoolean};
		return executorTs('taskrespondsuggested', model, decodeStructure(decodeITaskList), arguments);
	},
	async tasksync(syncToken ?:string, date ?:Date):Promise<TaskSyncBean> {
		const model = {'syncToken': encodeString, 'date': encodeDate};
		return executorTs('tasksync', model, decodeStructure(decodeTaskSyncBean), arguments);
	},
	async taskupdate(taskId :string, text ?:string, dueDate ?:Date, assignee ?:Array<number>, reminder ?:IReminder):Promise<TaskBean> {
		const model = {'taskId': encodeString, 'text': encodeString, 'dueDate': encodeDate, 'assignee': encodeArray(encodeNumber), 'reminder': encodeIReminder};
		return executorTs('taskupdate', model, decodeStructure(decodeTaskBean), arguments);
	},
	async taskupdate2(__inline :TaskInputBean, picture ?:Array<FizFile>):Promise<TaskBean> {
		const model = {'__inline': encodeTaskInputBean, 'picture': encodeArray(encodeFizFile)};
		return executorTs('taskupdate2', model, decodeStructure(decodeTaskBean), arguments);
	},
	async taskupdatelist(__inline :ITaskList):Promise<ITaskList> {
		const model = {'__inline': encodeITaskList};
		return executorTs('taskupdatelist', model, decodeStructure(decodeITaskList), arguments);
	},
	async wallactivityById(masterNested ?:boolean):Promise<Map<number,AccountActivityBean>> {
		const model = {'masterNested': encodeBoolean};
		return executorTs('wallactivityById', model, decodeStructure(decodeMap(decodeNumber,decodeAccountActivityBean)), arguments);
	},
	async wallactivityget(accountId :number, masterNested ?:boolean):Promise<AccountActivityBean> {
		const model = {'accountId': encodeNumber, 'masterNested': encodeBoolean};
		return executorTs('wallactivityget', model, decodeStructure(decodeAccountActivityBean), arguments);
	},
	async walladdComment(wall_message_id :string, comment :string, mood ?:string, clientOpId ?:string):Promise<CommentResultBean<IWallMessage>> {
		const model = {'wall_message_id': encodeString, 'comment': encodeString, 'mood': encodeEnum, 'clientOpId': encodeString};
		return executorTs('walladdComment', model, decodeStructure(decodeCommentResultBean(decodeIWallMessage)), arguments);
	},
	async wallbyids(id ?:Array<string>, masterNested ?:boolean):Promise<Array<IWallMessage>> {
		const model = {'id': encodeArray(encodeString), 'masterNested': encodeBoolean};
		return executorTs('wallbyids', model, decodeStructure(decodeArray(decodeIWallMessage)), arguments);
	},
	async walldelete(wallMessageId :Array<string>):Promise<boolean> {
		const model = {'wallMessageId': encodeArray(encodeString)};
		return executorTs('walldelete', model, decodeStructure(decodeboolean), arguments);
	},
	async walletags():Promise<Map<string,string>> {
		const model = {};
		return executorTs('walletags', model, decodeStructure(decodeMap(decodeEnum,decodeString)), arguments);
	},
	async wallget(date ?:Date, accountId ?:Array<number>, type ?:Array<string>, hasJoin ?:boolean, mood ?:string, bestMoment ?:boolean, afterId ?:string, nb ?:number, nested ?:boolean, masterNested ?:boolean, sortBy ?:string):Promise<Array<IWallMessage>> {
		const model = {'date': encodeDate, 'accountId': encodeArray(encodeNumber), 'type': encodeArray(encodeEnum), 'hasJoin': encodeBoolean, 'mood': encodeEnum, 'bestMoment': encodeBoolean, 'afterId': encodeString, 'nb': encodeNumber, 'nested': encodeBoolean, 'masterNested': encodeBoolean, 'sortBy': encodeString};
		return executorTs('wallget', model, decodeStructure(decodeArray(decodeIWallMessage)), arguments);
	},
	async walllastbyaccount(filter ?:Array<string>):Promise<Map<number,IWallMessage>> {
		const model = {'filter': encodeArray(encodeEnum)};
		return executorTs('walllastbyaccount', model, decodeStructure(decodeMap(decodeNumber,decodeIWallMessage)), arguments);
	},
	async wallmood(wall_message_id :string, add ?:Array<string>, remove ?:Array<string>, clientOpId ?:string):Promise<IWallMessage> {
		const model = {'wall_message_id': encodeString, 'add': encodeArray(encodeEnum), 'remove': encodeArray(encodeEnum), 'clientOpId': encodeString};
		return executorTs('wallmood', model, decodeStructure(decodeIWallMessage), arguments);
	},
	async wallpublish(tagline :string):Promise<IWallMessage> {
		const model = {'tagline': encodeString};
		return executorTs('wallpublish', model, decodeStructure(decodeIWallMessage), arguments);
	},
	async wallpublishmultiplepics(description ?:string, picture ?:FizFile, nbOfPicturesUpload ?:number, wallMessageClientId ?:string, clientPicId ?:string, finishupload ?:boolean, familyIds ?:Array<string>, comment ?:string):Promise<IWallMessage> {
		const model = {'description': encodeString, 'picture': encodeFizFile, 'nbOfPicturesUpload': encodeNumber, 'wallMessageClientId': encodeString, 'clientPicId': encodeString, 'finishupload': encodeBoolean, 'familyIds': encodeArray(encodeString), 'comment': encodeString};
		return executorTs('wallpublishmultiplepics', model, decodeStructure(decodeIWallMessage), arguments);
	},
	async wallpublishref(tagline :string, refObjectType :string, refObjectId :string):Promise<IWallMessage> {
		const model = {'tagline': encodeString, 'refObjectType': encodeEnum, 'refObjectId': encodeString};
		return executorTs('wallpublishref', model, decodeStructure(decodeIWallMessage), arguments);
	},
	async webapiurl():Promise<string> {
		const model = {};
		return executorTs('webapiurl', model, decodeStructure(decodeString), arguments);
	},
	async webget(VAR :string):Promise<string> {
		const model = {'var': encodeString};
		return executorTs('webget', model, decodeStructure(decodeString), arguments);
	},
	async webgetExternalWebUrl(partnerType ?:string):Promise<string> {
		const model = {'partnerType': encodeEnum};
		return executorTs('webgetExternalWebUrl', model, decodeStructure(decodeString), arguments);
	},
	async webgetWebSocketUrl():Promise<string> {
		const model = {};
		return executorTs('webgetWebSocketUrl', model, decodeStructure(decodeString), arguments);
	},
	async webiaimportemail(email :string, from :string, ical :string):Promise<IcalImportResultBean> {
		const model = {'email': encodeString, 'from': encodeString, 'ical': encodeString};
		return executorTs('webiaimportemail', model, decodeStructure(decodeIcalImportResultBean), arguments);
	},
	async webjslog(text :string):Promise<boolean> {
		const model = {'text': encodeString};
		return executorTs('webjslog', model, decodeStructure(decodeboolean), arguments);
	},
	async webog(url :string, refresh ?:boolean):Promise<OpenGraphDataBean> {
		const model = {'url': encodeString, 'refresh': encodeBoolean};
		return executorTs('webog', model, decodeStructure(decodeOpenGraphDataBean), arguments);
	},
	async webset(VAR :string, value :string):Promise<string> {
		const model = {'var': encodeString, 'value': encodeString};
		return executorTs('webset', model, decodeStructure(decodeString), arguments);
	}
}


var executorTs;
function setExecutorTs(exe){
	executorTs = exe;
}  
export default {types,methods,methodsTs, setExecutorTs };